var Ag = Object.defineProperty, Ug = Object.defineProperties;
var Yg = Object.getOwnPropertyDescriptors;
var Jn = Object.getOwnPropertySymbols;
var Tu = Object.prototype.hasOwnProperty, Eu = Object.prototype.propertyIsEnumerable;
var qs = (r, e) => (e = Symbol[r]) ? e : Symbol.for("Symbol." + r), Fg = (r) => {
  throw TypeError(r);
};
var eo = (r, e, t) => e in r ? Ag(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, I = (r, e) => {
  for (var t in e || (e = {}))
    Tu.call(e, t) && eo(r, t, e[t]);
  if (Jn)
    for (var t of Jn(e))
      Eu.call(e, t) && eo(r, t, e[t]);
  return r;
}, M = (r, e) => Ug(r, Yg(e));
var Ze = (r, e) => {
  var t = {};
  for (var n in r)
    Tu.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && Jn)
    for (var n of Jn(r))
      e.indexOf(n) < 0 && Eu.call(r, n) && (t[n] = r[n]);
  return t;
};
var T = (r, e, t) => eo(r, typeof e != "symbol" ? e + "" : e, t);
var $ = (r, e, t) => new Promise((n, i) => {
  var s = (l) => {
    try {
      a(t.next(l));
    } catch (u) {
      i(u);
    }
  }, o = (l) => {
    try {
      a(t.throw(l));
    } catch (u) {
      i(u);
    }
  }, a = (l) => l.done ? n(l.value) : Promise.resolve(l.value).then(s, o);
  a((t = t.apply(r, e)).next());
}), Hg = function(r, e) {
  this[0] = r, this[1] = e;
};
var to = (r) => {
  var e = r[qs("asyncIterator")], t = !1, n, i = {};
  return e == null ? (e = r[qs("iterator")](), n = (s) => i[s] = (o) => e[s](o)) : (e = e.call(r), n = (s) => i[s] = (o) => {
    if (t) {
      if (t = !1, s === "throw") throw o;
      return o;
    }
    return t = !0, {
      done: !1,
      value: new Hg(new Promise((a) => {
        var l = e[s](o);
        l instanceof Object || Fg("Object expected"), a(l);
      }), 1)
    };
  }), i[qs("iterator")] = () => i, n("next"), "throw" in e ? n("throw") : i.throw = (s) => {
    throw s;
  }, "return" in e && n("return"), i;
};
function Jg(r, e) {
  for (var t = 0; t < e.length; t++) {
    const n = e[t];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in r)) {
          const s = Object.getOwnPropertyDescriptor(n, i);
          s && Object.defineProperty(r, i, s.get ? s : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }));
}
const Bg = {
  key: "_sid"
}, Dg = "rrweb/sequential-id@1", Kg = (r) => {
  const e = Bg;
  let t = 0;
  return {
    name: Dg,
    eventProcessor(n) {
      return Object.assign(n, {
        [e.key]: ++t
      }), n;
    },
    options: e
  };
};
function Li(r, e) {
  if (!!!r)
    throw new Error(e);
}
function zg(r) {
  return typeof r == "object" && r !== null;
}
function jg(r, e) {
  if (!!!r)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const Qg = /\r\n|[\n\r]/g;
function oa(r, e) {
  let t = 0, n = 1;
  for (const i of r.body.matchAll(Qg)) {
    if (typeof i.index == "number" || jg(!1), i.index >= e)
      break;
    t = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: e + 1 - t
  };
}
function $g(r) {
  return Th(
    r.source,
    oa(r.source, r.start)
  );
}
function Th(r, e) {
  const t = r.locationOffset.column - 1, n = "".padStart(t) + r.body, i = e.line - 1, s = r.locationOffset.line - 1, o = e.line + s, a = e.line === 1 ? t : 0, l = e.column + a, u = `${r.name}:${o}:${l}
`, c = n.split(/\r\n|[\n\r]/g), d = c[i];
  if (d.length > 120) {
    const h = Math.floor(l / 80), f = l % 80, m = [];
    for (let p = 0; p < d.length; p += 80)
      m.push(d.slice(p, p + 80));
    return u + Cu([
      [`${o} |`, m[0]],
      ...m.slice(1, h + 1).map((p) => ["|", p]),
      ["|", "^".padStart(f)],
      ["|", m[h + 1]]
    ]);
  }
  return u + Cu([
    // Lines specified like this: ["prefix", "string"],
    [`${o - 1} |`, c[i - 1]],
    [`${o} |`, d],
    ["|", "^".padStart(l)],
    [`${o + 1} |`, c[i + 1]]
  ]);
}
function Cu(r) {
  const e = r.filter(([n, i]) => i !== void 0), t = Math.max(...e.map(([n]) => n.length));
  return e.map(([n, i]) => n.padStart(t) + (i ? " " + i : "")).join(`
`);
}
function qg(r) {
  const e = r[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: r[1],
    positions: r[2],
    path: r[3],
    originalError: r[4],
    extensions: r[5]
  } : e;
}
class _l extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(e, ...t) {
    var n, i, s;
    const { nodes: o, source: a, positions: l, path: u, originalError: c, extensions: d } = qg(t);
    super(e), this.name = "GraphQLError", this.path = u != null ? u : void 0, this.originalError = c != null ? c : void 0, this.nodes = Zu(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const h = Zu(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((m) => m.loc).filter((m) => m != null)
    );
    this.source = a != null ? a : h == null || (i = h[0]) === null || i === void 0 ? void 0 : i.source, this.positions = l != null ? l : h == null ? void 0 : h.map((m) => m.start), this.locations = l && a ? l.map((m) => oa(a, m)) : h == null ? void 0 : h.map((m) => oa(m.source, m.start));
    const f = zg(
      c == null ? void 0 : c.extensions
    ) ? c == null ? void 0 : c.extensions : void 0;
    this.extensions = (s = d != null ? d : f) !== null && s !== void 0 ? s : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), c != null && c.stack ? Object.defineProperty(this, "stack", {
      value: c.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, _l) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (e += `

` + $g(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        e += `

` + Th(this.source, t);
    return e;
  }
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function Zu(r) {
  return r === void 0 || r.length === 0 ? void 0 : r;
}
function be(r, e, t) {
  return new _l(`Syntax Error: ${t}`, {
    source: r,
    positions: [e]
  });
}
class ey {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(e, t, n) {
    this.start = e.start, this.end = t.end, this.startToken = e, this.endToken = t, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Eh {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(e, t, n, i, s, o) {
    this.kind = e, this.start = t, this.end = n, this.line = i, this.column = s, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Ch = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, ty = new Set(Object.keys(Ch));
function Gu(r) {
  const e = r == null ? void 0 : r.kind;
  return typeof e == "string" && ty.has(e);
}
var dr;
(function(r) {
  r.QUERY = "query", r.MUTATION = "mutation", r.SUBSCRIPTION = "subscription";
})(dr || (dr = {}));
var aa;
(function(r) {
  r.QUERY = "QUERY", r.MUTATION = "MUTATION", r.SUBSCRIPTION = "SUBSCRIPTION", r.FIELD = "FIELD", r.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", r.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", r.INLINE_FRAGMENT = "INLINE_FRAGMENT", r.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", r.SCHEMA = "SCHEMA", r.SCALAR = "SCALAR", r.OBJECT = "OBJECT", r.FIELD_DEFINITION = "FIELD_DEFINITION", r.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", r.INTERFACE = "INTERFACE", r.UNION = "UNION", r.ENUM = "ENUM", r.ENUM_VALUE = "ENUM_VALUE", r.INPUT_OBJECT = "INPUT_OBJECT", r.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(aa || (aa = {}));
var X;
(function(r) {
  r.NAME = "Name", r.DOCUMENT = "Document", r.OPERATION_DEFINITION = "OperationDefinition", r.VARIABLE_DEFINITION = "VariableDefinition", r.SELECTION_SET = "SelectionSet", r.FIELD = "Field", r.ARGUMENT = "Argument", r.FRAGMENT_SPREAD = "FragmentSpread", r.INLINE_FRAGMENT = "InlineFragment", r.FRAGMENT_DEFINITION = "FragmentDefinition", r.VARIABLE = "Variable", r.INT = "IntValue", r.FLOAT = "FloatValue", r.STRING = "StringValue", r.BOOLEAN = "BooleanValue", r.NULL = "NullValue", r.ENUM = "EnumValue", r.LIST = "ListValue", r.OBJECT = "ObjectValue", r.OBJECT_FIELD = "ObjectField", r.DIRECTIVE = "Directive", r.NAMED_TYPE = "NamedType", r.LIST_TYPE = "ListType", r.NON_NULL_TYPE = "NonNullType", r.SCHEMA_DEFINITION = "SchemaDefinition", r.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", r.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", r.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", r.FIELD_DEFINITION = "FieldDefinition", r.INPUT_VALUE_DEFINITION = "InputValueDefinition", r.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", r.UNION_TYPE_DEFINITION = "UnionTypeDefinition", r.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", r.ENUM_VALUE_DEFINITION = "EnumValueDefinition", r.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", r.DIRECTIVE_DEFINITION = "DirectiveDefinition", r.SCHEMA_EXTENSION = "SchemaExtension", r.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", r.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", r.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", r.UNION_TYPE_EXTENSION = "UnionTypeExtension", r.ENUM_TYPE_EXTENSION = "EnumTypeExtension", r.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(X || (X = {}));
function la(r) {
  return r === 9 || r === 32;
}
function pn(r) {
  return r >= 48 && r <= 57;
}
function Zh(r) {
  return r >= 97 && r <= 122 || // A-Z
  r >= 65 && r <= 90;
}
function Gh(r) {
  return Zh(r) || r === 95;
}
function ry(r) {
  return Zh(r) || pn(r) || r === 95;
}
function ny(r) {
  var e;
  let t = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let o = 0; o < r.length; ++o) {
    var s;
    const a = r[o], l = iy(a);
    l !== a.length && (n = (s = n) !== null && s !== void 0 ? s : o, i = o, o !== 0 && l < t && (t = l));
  }
  return r.map((o, a) => a === 0 ? o : o.slice(t)).slice(
    (e = n) !== null && e !== void 0 ? e : 0,
    i + 1
  );
}
function iy(r) {
  let e = 0;
  for (; e < r.length && la(r.charCodeAt(e)); )
    ++e;
  return e;
}
function sy(r, e) {
  const t = r.replace(/"""/g, '\\"""'), n = t.split(/\r\n|[\n\r]/g), i = n.length === 1, s = n.length > 1 && n.slice(1).every((f) => f.length === 0 || la(f.charCodeAt(0))), o = t.endsWith('\\"""'), a = r.endsWith('"') && !o, l = r.endsWith("\\"), u = a || l, c = (
    // add leading and trailing new lines only if it improves readability
    !i || r.length > 70 || u || s || o
  );
  let d = "";
  const h = i && la(r.charCodeAt(0));
  return (c && !h || s) && (d += `
`), d += t, (c || u) && (d += `
`), '"""' + d + '"""';
}
var w;
(function(r) {
  r.SOF = "<SOF>", r.EOF = "<EOF>", r.BANG = "!", r.DOLLAR = "$", r.AMP = "&", r.PAREN_L = "(", r.PAREN_R = ")", r.SPREAD = "...", r.COLON = ":", r.EQUALS = "=", r.AT = "@", r.BRACKET_L = "[", r.BRACKET_R = "]", r.BRACE_L = "{", r.PIPE = "|", r.BRACE_R = "}", r.NAME = "Name", r.INT = "Int", r.FLOAT = "Float", r.STRING = "String", r.BLOCK_STRING = "BlockString", r.COMMENT = "Comment";
})(w || (w = {}));
class oy {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(e) {
    const t = new Eh(w.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== w.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const t = ly(this, e.end);
          e.next = t, t.prev = e, e = t;
        }
      while (e.kind === w.COMMENT);
    return e;
  }
}
function ay(r) {
  return r === w.BANG || r === w.DOLLAR || r === w.AMP || r === w.PAREN_L || r === w.PAREN_R || r === w.SPREAD || r === w.COLON || r === w.EQUALS || r === w.AT || r === w.BRACKET_L || r === w.BRACKET_R || r === w.BRACE_L || r === w.PIPE || r === w.BRACE_R;
}
function Nr(r) {
  return r >= 0 && r <= 55295 || r >= 57344 && r <= 1114111;
}
function Ts(r, e) {
  return Lh(r.charCodeAt(e)) && Nh(r.charCodeAt(e + 1));
}
function Lh(r) {
  return r >= 55296 && r <= 56319;
}
function Nh(r) {
  return r >= 56320 && r <= 57343;
}
function Ft(r, e) {
  const t = r.source.body.codePointAt(e);
  if (t === void 0)
    return w.EOF;
  if (t >= 32 && t <= 126) {
    const n = String.fromCodePoint(t);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function me(r, e, t, n, i) {
  const s = r.line, o = 1 + t - r.lineStart;
  return new Eh(e, t, n, s, o, i);
}
function ly(r, e) {
  const t = r.source.body, n = t.length;
  let i = e;
  for (; i < n; ) {
    const s = t.charCodeAt(i);
    switch (s) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++r.line, r.lineStart = i;
        continue;
      case 13:
        t.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++r.line, r.lineStart = i;
        continue;
      case 35:
        return uy(r, i);
      case 33:
        return me(r, w.BANG, i, i + 1);
      case 36:
        return me(r, w.DOLLAR, i, i + 1);
      case 38:
        return me(r, w.AMP, i, i + 1);
      case 40:
        return me(r, w.PAREN_L, i, i + 1);
      case 41:
        return me(r, w.PAREN_R, i, i + 1);
      case 46:
        if (t.charCodeAt(i + 1) === 46 && t.charCodeAt(i + 2) === 46)
          return me(r, w.SPREAD, i, i + 3);
        break;
      case 58:
        return me(r, w.COLON, i, i + 1);
      case 61:
        return me(r, w.EQUALS, i, i + 1);
      case 64:
        return me(r, w.AT, i, i + 1);
      case 91:
        return me(r, w.BRACKET_L, i, i + 1);
      case 93:
        return me(r, w.BRACKET_R, i, i + 1);
      case 123:
        return me(r, w.BRACE_L, i, i + 1);
      case 124:
        return me(r, w.PIPE, i, i + 1);
      case 125:
        return me(r, w.BRACE_R, i, i + 1);
      case 34:
        return t.charCodeAt(i + 1) === 34 && t.charCodeAt(i + 2) === 34 ? my(r, i) : dy(r, i);
    }
    if (pn(s) || s === 45)
      return cy(r, i, s);
    if (Gh(s))
      return gy(r, i);
    throw be(
      r.source,
      i,
      s === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Nr(s) || Ts(t, i) ? `Unexpected character: ${Ft(r, i)}.` : `Invalid character: ${Ft(r, i)}.`
    );
  }
  return me(r, w.EOF, n, n);
}
function uy(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1;
  for (; i < n; ) {
    const s = t.charCodeAt(i);
    if (s === 10 || s === 13)
      break;
    if (Nr(s))
      ++i;
    else if (Ts(t, i))
      i += 2;
    else
      break;
  }
  return me(
    r,
    w.COMMENT,
    e,
    i,
    t.slice(e + 1, i)
  );
}
function cy(r, e, t) {
  const n = r.source.body;
  let i = e, s = t, o = !1;
  if (s === 45 && (s = n.charCodeAt(++i)), s === 48) {
    if (s = n.charCodeAt(++i), pn(s))
      throw be(
        r.source,
        i,
        `Invalid number, unexpected digit after 0: ${Ft(
          r,
          i
        )}.`
      );
  } else
    i = ro(r, i, s), s = n.charCodeAt(i);
  if (s === 46 && (o = !0, s = n.charCodeAt(++i), i = ro(r, i, s), s = n.charCodeAt(i)), (s === 69 || s === 101) && (o = !0, s = n.charCodeAt(++i), (s === 43 || s === 45) && (s = n.charCodeAt(++i)), i = ro(r, i, s), s = n.charCodeAt(i)), s === 46 || Gh(s))
    throw be(
      r.source,
      i,
      `Invalid number, expected digit but got: ${Ft(
        r,
        i
      )}.`
    );
  return me(
    r,
    o ? w.FLOAT : w.INT,
    e,
    i,
    n.slice(e, i)
  );
}
function ro(r, e, t) {
  if (!pn(t))
    throw be(
      r.source,
      e,
      `Invalid number, expected digit but got: ${Ft(
        r,
        e
      )}.`
    );
  const n = r.source.body;
  let i = e + 1;
  for (; pn(n.charCodeAt(i)); )
    ++i;
  return i;
}
function dy(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1, s = i, o = "";
  for (; i < n; ) {
    const a = t.charCodeAt(i);
    if (a === 34)
      return o += t.slice(s, i), me(r, w.STRING, e, i + 1, o);
    if (a === 92) {
      o += t.slice(s, i);
      const l = t.charCodeAt(i + 1) === 117 ? t.charCodeAt(i + 2) === 123 ? hy(r, i) : fy(r, i) : py(r, i);
      o += l.value, i += l.size, s = i;
      continue;
    }
    if (a === 10 || a === 13)
      break;
    if (Nr(a))
      ++i;
    else if (Ts(t, i))
      i += 2;
    else
      throw be(
        r.source,
        i,
        `Invalid character within String: ${Ft(
          r,
          i
        )}.`
      );
  }
  throw be(r.source, i, "Unterminated string.");
}
function hy(r, e) {
  const t = r.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const s = t.charCodeAt(e + i++);
    if (s === 125) {
      if (i < 5 || !Nr(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | qr(s), n < 0)
      break;
  }
  throw be(
    r.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(
      e,
      e + i
    )}".`
  );
}
function fy(r, e) {
  const t = r.source.body, n = Lu(t, e + 2);
  if (Nr(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (Lh(n) && t.charCodeAt(e + 6) === 92 && t.charCodeAt(e + 7) === 117) {
    const i = Lu(t, e + 8);
    if (Nh(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw be(
    r.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(e, e + 6)}".`
  );
}
function Lu(r, e) {
  return qr(r.charCodeAt(e)) << 12 | qr(r.charCodeAt(e + 1)) << 8 | qr(r.charCodeAt(e + 2)) << 4 | qr(r.charCodeAt(e + 3));
}
function qr(r) {
  return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : -1;
}
function py(r, e) {
  const t = r.source.body;
  switch (t.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw be(
    r.source,
    e,
    `Invalid character escape sequence: "${t.slice(
      e,
      e + 2
    )}".`
  );
}
function my(r, e) {
  const t = r.source.body, n = t.length;
  let i = r.lineStart, s = e + 3, o = s, a = "";
  const l = [];
  for (; s < n; ) {
    const u = t.charCodeAt(s);
    if (u === 34 && t.charCodeAt(s + 1) === 34 && t.charCodeAt(s + 2) === 34) {
      a += t.slice(o, s), l.push(a);
      const c = me(
        r,
        w.BLOCK_STRING,
        e,
        s + 3,
        // Return a string of the lines joined with U+000A.
        ny(l).join(`
`)
      );
      return r.line += l.length - 1, r.lineStart = i, c;
    }
    if (u === 92 && t.charCodeAt(s + 1) === 34 && t.charCodeAt(s + 2) === 34 && t.charCodeAt(s + 3) === 34) {
      a += t.slice(o, s), o = s + 1, s += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      a += t.slice(o, s), l.push(a), u === 13 && t.charCodeAt(s + 1) === 10 ? s += 2 : ++s, a = "", o = s, i = s;
      continue;
    }
    if (Nr(u))
      ++s;
    else if (Ts(t, s))
      s += 2;
    else
      throw be(
        r.source,
        s,
        `Invalid character within String: ${Ft(
          r,
          s
        )}.`
      );
  }
  throw be(r.source, s, "Unterminated string.");
}
function gy(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1;
  for (; i < n; ) {
    const s = t.charCodeAt(i);
    if (ry(s))
      ++i;
    else
      break;
  }
  return me(
    r,
    w.NAME,
    e,
    i,
    t.slice(e, i)
  );
}
const yy = 10, Vh = 2;
function Rl(r) {
  return Es(r, []);
}
function Es(r, e) {
  switch (typeof r) {
    case "string":
      return JSON.stringify(r);
    case "function":
      return r.name ? `[function ${r.name}]` : "[function]";
    case "object":
      return by(r, e);
    default:
      return String(r);
  }
}
function by(r, e) {
  if (r === null)
    return "null";
  if (e.includes(r))
    return "[Circular]";
  const t = [...e, r];
  if (vy(r)) {
    const n = r.toJSON();
    if (n !== r)
      return typeof n == "string" ? n : Es(n, t);
  } else if (Array.isArray(r))
    return wy(r, t);
  return Sy(r, t);
}
function vy(r) {
  return typeof r.toJSON == "function";
}
function Sy(r, e) {
  const t = Object.entries(r);
  return t.length === 0 ? "{}" : e.length > Vh ? "[" + _y(r) + "]" : "{ " + t.map(
    ([i, s]) => i + ": " + Es(s, e)
  ).join(", ") + " }";
}
function wy(r, e) {
  if (r.length === 0)
    return "[]";
  if (e.length > Vh)
    return "[Array]";
  const t = Math.min(yy, r.length), n = r.length - t, i = [];
  for (let s = 0; s < t; ++s)
    i.push(Es(r[s], e));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function _y(r) {
  const e = Object.prototype.toString.call(r).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof r.constructor == "function") {
    const t = r.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return e;
}
const Ry = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(e, t) {
    return e instanceof t;
  } : function(e, t) {
    if (e instanceof t)
      return !0;
    if (typeof e == "object" && e !== null) {
      var n;
      const i = t.prototype[Symbol.toStringTag], s = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (n = e.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === s) {
        const o = Rl(e);
        throw new Error(`Cannot use ${i} "${o}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class xh {
  constructor(e, t = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || Li(!1, `Body must be a string. Received: ${Rl(e)}.`), this.body = e, this.name = t, this.locationOffset = n, this.locationOffset.line > 0 || Li(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Li(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function Iy(r) {
  return Ry(r, xh);
}
function Il(r, e) {
  return new Ty(r, e).parseDocument();
}
class Ty {
  constructor(e, t = {}) {
    const n = Iy(e) ? e : new xh(e);
    this._lexer = new oy(n), this._options = t, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const e = this.expectToken(w.NAME);
    return this.node(e, {
      kind: X.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: X.DOCUMENT,
      definitions: this.many(
        w.SOF,
        this.parseDefinition,
        w.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(w.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), t = e ? this._lexer.lookahead() : this._lexer.token;
    if (t.kind === w.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (e)
        throw be(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(t);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(w.BRACE_L))
      return this.node(e, {
        kind: X.OPERATION_DEFINITION,
        operation: dr.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseOperationType();
    let n;
    return this.peek(w.NAME) && (n = this.parseName()), this.node(e, {
      kind: X.OPERATION_DEFINITION,
      operation: t,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const e = this.expectToken(w.NAME);
    switch (e.value) {
      case "query":
        return dr.QUERY;
      case "mutation":
        return dr.MUTATION;
      case "subscription":
        return dr.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      w.PAREN_L,
      this.parseVariableDefinition,
      w.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: X.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(w.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(w.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(w.DOLLAR), this.node(e, {
      kind: X.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: X.SELECTION_SET,
      selections: this.many(
        w.BRACE_L,
        this.parseSelection,
        w.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(w.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const e = this._lexer.token, t = this.parseName();
    let n, i;
    return this.expectOptionalToken(w.COLON) ? (n = t, i = this.parseName()) : i = t, this.node(e, {
      kind: X.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(w.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(e) {
    const t = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(w.PAREN_L, t, w.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(e = !1) {
    const t = this._lexer.token, n = this.parseName();
    return this.expectToken(w.COLON), this.node(t, {
      kind: X.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(w.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(w.NAME) ? this.node(e, {
      kind: X.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: X.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const e = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: X.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: X.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(e) {
    const t = this._lexer.token;
    switch (t.kind) {
      case w.BRACKET_L:
        return this.parseList(e);
      case w.BRACE_L:
        return this.parseObject(e);
      case w.INT:
        return this.advanceLexer(), this.node(t, {
          kind: X.INT,
          value: t.value
        });
      case w.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: X.FLOAT,
          value: t.value
        });
      case w.STRING:
      case w.BLOCK_STRING:
        return this.parseStringLiteral();
      case w.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: X.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: X.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: X.NULL
            });
          default:
            return this.node(t, {
              kind: X.ENUM,
              value: t.value
            });
        }
      case w.DOLLAR:
        if (e)
          if (this.expectToken(w.DOLLAR), this._lexer.token.kind === w.NAME) {
            const n = this._lexer.token.value;
            throw be(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: X.STRING,
      value: e.value,
      block: e.kind === w.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(e) {
    const t = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: X.LIST,
      values: this.any(w.BRACKET_L, t, w.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(e) {
    const t = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: X.OBJECT,
      fields: this.any(w.BRACE_L, t, w.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(e) {
    const t = this._lexer.token, n = this.parseName();
    return this.expectToken(w.COLON), this.node(t, {
      kind: X.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(e) {
    const t = [];
    for (; this.peek(w.AT); )
      t.push(this.parseDirective(e));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(e) {
    const t = this._lexer.token;
    return this.expectToken(w.AT), this.node(t, {
      kind: X.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let t;
    if (this.expectOptionalToken(w.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(w.BRACKET_R), t = this.node(e, {
        kind: X.LIST_TYPE,
        type: n
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(w.BANG) ? this.node(e, {
      kind: X.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: X.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(w.STRING) || this.peek(w.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      w.BRACE_L,
      this.parseOperationTypeDefinition,
      w.BRACE_R
    );
    return this.node(e, {
      kind: X.SCHEMA_DEFINITION,
      description: t,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, t = this.parseOperationType();
    this.expectToken(w.COLON);
    const n = this.parseNamedType();
    return this.node(e, {
      kind: X.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: X.SCALAR_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(e, {
      kind: X.OBJECT_TYPE_DEFINITION,
      description: t,
      name: n,
      interfaces: i,
      directives: s,
      fields: o
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(w.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      w.BRACE_L,
      this.parseFieldDefinition,
      w.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(w.COLON);
    const s = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(e, {
      kind: X.FIELD_DEFINITION,
      description: t,
      name: n,
      arguments: i,
      type: s,
      directives: o
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      w.PAREN_L,
      this.parseInputValueDef,
      w.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseName();
    this.expectToken(w.COLON);
    const i = this.parseTypeReference();
    let s;
    this.expectOptionalToken(w.EQUALS) && (s = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(e, {
      kind: X.INPUT_VALUE_DEFINITION,
      description: t,
      name: n,
      type: i,
      defaultValue: s,
      directives: o
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(e, {
      kind: X.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: n,
      interfaces: i,
      directives: s,
      fields: o
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: X.UNION_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      types: s
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(w.EQUALS) ? this.delimitedMany(w.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: X.ENUM_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      values: s
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      w.BRACE_L,
      this.parseEnumValueDefinition,
      w.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: X.ENUM_VALUE_DEFINITION,
      description: t,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw be(
        this._lexer.source,
        this._lexer.token.start,
        `${Bn(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: X.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      fields: s
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      w.BRACE_L,
      this.parseInputValueDef,
      w.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === w.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), n = this.optionalMany(
      w.BRACE_L,
      this.parseOperationTypeDefinition,
      w.BRACE_R
    );
    if (t.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: X.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: X.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: X.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: n,
      directives: i,
      fields: s
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: X.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: n,
      directives: i,
      fields: s
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: X.UNION_TYPE_EXTENSION,
      name: t,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: X.ENUM_TYPE_EXTENSION,
      name: t,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: X.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(w.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), s = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(e, {
      kind: X.DIRECTIVE_DEFINITION,
      description: t,
      name: n,
      arguments: i,
      repeatable: s,
      locations: o
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(w.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(aa, t.value))
      return t;
    throw this.unexpected(e);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(e, t) {
    return this._options.noLocation !== !0 && (t.loc = new ey(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(e) {
    const t = this._lexer.token;
    if (t.kind === e)
      return this.advanceLexer(), t;
    throw be(
      this._lexer.source,
      t.start,
      `Expected ${Oh(e)}, found ${Bn(t)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(e) {
    const t = this._lexer.token;
    if (t.kind === w.NAME && t.value === e)
      this.advanceLexer();
    else
      throw be(
        this._lexer.source,
        t.start,
        `Expected "${e}", found ${Bn(t)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(e) {
    const t = this._lexer.token;
    return t.kind === w.NAME && t.value === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(e) {
    const t = e != null ? e : this._lexer.token;
    return be(
      this._lexer.source,
      t.start,
      `Unexpected ${Bn(t)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(e, t, n) {
    this.expectToken(e);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(t.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(e, t, n) {
    if (this.expectOptionalToken(e)) {
      const i = [];
      do
        i.push(t.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(e, t, n) {
    this.expectToken(e);
    const i = [];
    do
      i.push(t.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(e, t) {
    this.expectOptionalToken(e);
    const n = [];
    do
      n.push(t.call(this));
    while (this.expectOptionalToken(e));
    return n;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, t = this._lexer.advance();
    if (e !== void 0 && t.kind !== w.EOF && (++this._tokenCounter, this._tokenCounter > e))
      throw be(
        this._lexer.source,
        t.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
}
function Bn(r) {
  const e = r.value;
  return Oh(r.kind) + (e != null ? ` "${e}"` : "");
}
function Oh(r) {
  return ay(r) ? `"${r}"` : r;
}
function Ey(r) {
  return `"${r.replace(Cy, Zy)}"`;
}
const Cy = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function Zy(r) {
  return Gy[r.charCodeAt(0)];
}
const Gy = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Ly = Object.freeze({});
function Ny(r, e, t = Ch) {
  const n = /* @__PURE__ */ new Map();
  for (const y of Object.values(X))
    n.set(y, Vy(e, y));
  let i, s = Array.isArray(r), o = [r], a = -1, l = [], u = r, c, d;
  const h = [], f = [];
  do {
    a++;
    const y = a === o.length, _ = y && l.length !== 0;
    if (y) {
      if (c = f.length === 0 ? void 0 : h[h.length - 1], u = d, d = f.pop(), _)
        if (s) {
          u = u.slice();
          let C = 0;
          for (const [R, L] of l) {
            const k = R - C;
            L === null ? (u.splice(k, 1), C++) : u[k] = L;
          }
        } else {
          u = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(u)
          );
          for (const [C, R] of l)
            u[C] = R;
        }
      a = i.index, o = i.keys, l = i.edits, s = i.inArray, i = i.prev;
    } else if (d) {
      if (c = s ? a : o[a], u = d[c], u == null)
        continue;
      h.push(c);
    }
    let S;
    if (!Array.isArray(u)) {
      var m, p;
      Gu(u) || Li(!1, `Invalid AST Node: ${Rl(u)}.`);
      const C = y ? (m = n.get(u.kind)) === null || m === void 0 ? void 0 : m.leave : (p = n.get(u.kind)) === null || p === void 0 ? void 0 : p.enter;
      if (S = C == null ? void 0 : C.call(e, u, c, d, h, f), S === Ly)
        break;
      if (S === !1) {
        if (!y) {
          h.pop();
          continue;
        }
      } else if (S !== void 0 && (l.push([c, S]), !y))
        if (Gu(S))
          u = S;
        else {
          h.pop();
          continue;
        }
    }
    if (S === void 0 && _ && l.push([c, u]), y)
      h.pop();
    else {
      var g;
      i = {
        inArray: s,
        index: a,
        keys: o,
        edits: l,
        prev: i
      }, s = Array.isArray(u), o = s ? u : (g = t[u.kind]) !== null && g !== void 0 ? g : [], a = -1, l = [], d && f.push(d), d = u;
    }
  } while (i !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : r;
}
function Vy(r, e) {
  const t = r[e];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: r.enter,
    leave: r.leave
  };
}
function Wh(r) {
  return Ny(r, Oy);
}
const xy = 80, Oy = {
  Name: {
    leave: (r) => r.value
  },
  Variable: {
    leave: (r) => "$" + r.name
  },
  // Document
  Document: {
    leave: (r) => V(r.definitions, `

`)
  },
  OperationDefinition: {
    leave(r) {
      const e = J("(", V(r.variableDefinitions, ", "), ")"), t = V(
        [
          r.operation,
          V([r.name, e]),
          V(r.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + r.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: r, type: e, defaultValue: t, directives: n }) => r + ": " + e + J(" = ", t) + J(" ", V(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: r }) => Be(r)
  },
  Field: {
    leave({ alias: r, name: e, arguments: t, directives: n, selectionSet: i }) {
      const s = J("", r, ": ") + e;
      let o = s + J("(", V(t, ", "), ")");
      return o.length > xy && (o = s + J(`(
`, Ni(V(t, `
`)), `
)`)), V([o, V(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: r, directives: e }) => "..." + r + J(" ", V(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: r, directives: e, selectionSet: t }) => V(
      [
        "...",
        J("on ", r),
        V(e, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: r, typeCondition: e, variableDefinitions: t, directives: n, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${r}${J("(", V(t, ", "), ")")} on ${e} ${J("", V(n, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: r }) => r
  },
  FloatValue: {
    leave: ({ value: r }) => r
  },
  StringValue: {
    leave: ({ value: r, block: e }) => e ? sy(r) : Ey(r)
  },
  BooleanValue: {
    leave: ({ value: r }) => r ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: r }) => r
  },
  ListValue: {
    leave: ({ values: r }) => "[" + V(r, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: r }) => "{" + V(r, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: r, arguments: e }) => "@" + r + J("(", V(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: r }) => r
  },
  ListType: {
    leave: ({ type: r }) => "[" + r + "]"
  },
  NonNullType: {
    leave: ({ type: r }) => r + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: r, directives: e, operationTypes: t }) => J("", r, `
`) + V(["schema", V(e, " "), Be(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: r, type: e }) => r + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: r, name: e, directives: t }) => J("", r, `
`) + V(["scalar", e, V(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => J("", r, `
`) + V(
      [
        "type",
        e,
        J("implements ", V(t, " & ")),
        V(n, " "),
        Be(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: r, name: e, arguments: t, type: n, directives: i }) => J("", r, `
`) + e + (Nu(t) ? J(`(
`, Ni(V(t, `
`)), `
)`) : J("(", V(t, ", "), ")")) + ": " + n + J(" ", V(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: r, name: e, type: t, defaultValue: n, directives: i }) => J("", r, `
`) + V(
      [e + ": " + t, J("= ", n), V(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => J("", r, `
`) + V(
      [
        "interface",
        e,
        J("implements ", V(t, " & ")),
        V(n, " "),
        Be(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, types: n }) => J("", r, `
`) + V(
      ["union", e, V(t, " "), J("= ", V(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, values: n }) => J("", r, `
`) + V(["enum", e, V(t, " "), Be(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: r, name: e, directives: t }) => J("", r, `
`) + V([e, V(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, fields: n }) => J("", r, `
`) + V(["input", e, V(t, " "), Be(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: r, name: e, arguments: t, repeatable: n, locations: i }) => J("", r, `
`) + "directive @" + e + (Nu(t) ? J(`(
`, Ni(V(t, `
`)), `
)`) : J("(", V(t, ", "), ")")) + (n ? " repeatable" : "") + " on " + V(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: r, operationTypes: e }) => V(
      ["extend schema", V(r, " "), Be(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: r, directives: e }) => V(["extend scalar", r, V(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => V(
      [
        "extend type",
        r,
        J("implements ", V(e, " & ")),
        V(t, " "),
        Be(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => V(
      [
        "extend interface",
        r,
        J("implements ", V(e, " & ")),
        V(t, " "),
        Be(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: r, directives: e, types: t }) => V(
      [
        "extend union",
        r,
        V(e, " "),
        J("= ", V(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: r, directives: e, values: t }) => V(["extend enum", r, V(e, " "), Be(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: r, directives: e, fields: t }) => V(["extend input", r, V(e, " "), Be(t)], " ")
  }
};
function V(r, e = "") {
  var t;
  return (t = r == null ? void 0 : r.filter((n) => n).join(e)) !== null && t !== void 0 ? t : "";
}
function Be(r) {
  return J(`{
`, Ni(V(r, `
`)), `
}`);
}
function J(r, e, t = "") {
  return e != null && e !== "" ? r + e + t : "";
}
function Ni(r) {
  return J("  ", r.replace(/\n/g, `
  `));
}
function Nu(r) {
  var e;
  return (e = r == null ? void 0 : r.some((t) => t.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
const Tl = JSON, Wy = (r) => r.toUpperCase(), Xy = (r) => {
  const e = {};
  return r.forEach((t, n) => {
    e[n] = t;
  }), e;
}, ky = (r, e, t) => r.document ? r : {
  document: r,
  variables: e,
  requestHeaders: t,
  signal: void 0
}, Py = (r, e, t) => r.query ? r : {
  query: r,
  variables: e,
  requestHeaders: t,
  signal: void 0
}, My = (r, e) => r.documents ? r : {
  documents: r,
  requestHeaders: e,
  signal: void 0
}, Vu = (r) => {
  var n, i;
  let e;
  const t = r.definitions.filter((s) => s.kind === "OperationDefinition");
  return t.length === 1 && (e = (i = (n = t[0]) == null ? void 0 : n.name) == null ? void 0 : i.value), e;
}, no = (r) => {
  if (typeof r == "string") {
    let t;
    try {
      const n = Il(r);
      t = Vu(n);
    } catch (n) {
    }
    return { query: r, operationName: t };
  }
  const e = Vu(r);
  return { query: Wh(r), operationName: e };
};
class gr extends Error {
  constructor(e, t) {
    const n = `${gr.extractMessage(e)}: ${JSON.stringify({
      response: e,
      request: t
    })}`;
    super(n), Object.setPrototypeOf(this, gr.prototype), this.response = e, this.request = t, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, gr);
  }
  static extractMessage(e) {
    var t, n, i;
    return (i = (n = (t = e.errors) == null ? void 0 : t[0]) == null ? void 0 : n.message) != null ? i : `GraphQL Error (Code: ${e.status})`;
  }
}
var El = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Cl(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ua = { exports: {} };
(function(r, e) {
  var t = typeof self != "undefined" ? self : El, n = function() {
    function s() {
      this.fetch = !1, this.DOMException = t.DOMException;
    }
    return s.prototype = t, new s();
  }();
  (function(s) {
    (function(o) {
      var a = {
        searchParams: "URLSearchParams" in s,
        iterable: "Symbol" in s && "iterator" in Symbol,
        blob: "FileReader" in s && "Blob" in s && function() {
          try {
            return new Blob(), !0;
          } catch (b) {
            return !1;
          }
        }(),
        formData: "FormData" in s,
        arrayBuffer: "ArrayBuffer" in s
      };
      function l(b) {
        return b && DataView.prototype.isPrototypeOf(b);
      }
      if (a.arrayBuffer)
        var u = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], c = ArrayBuffer.isView || function(b) {
          return b && u.indexOf(Object.prototype.toString.call(b)) > -1;
        };
      function d(b) {
        if (typeof b != "string" && (b = String(b)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(b))
          throw new TypeError("Invalid character in header field name");
        return b.toLowerCase();
      }
      function h(b) {
        return typeof b != "string" && (b = String(b)), b;
      }
      function f(b) {
        var v = {
          next: function() {
            var W = b.shift();
            return { done: W === void 0, value: W };
          }
        };
        return a.iterable && (v[Symbol.iterator] = function() {
          return v;
        }), v;
      }
      function m(b) {
        this.map = {}, b instanceof m ? b.forEach(function(v, W) {
          this.append(W, v);
        }, this) : Array.isArray(b) ? b.forEach(function(v) {
          this.append(v[0], v[1]);
        }, this) : b && Object.getOwnPropertyNames(b).forEach(function(v) {
          this.append(v, b[v]);
        }, this);
      }
      m.prototype.append = function(b, v) {
        b = d(b), v = h(v);
        var W = this.map[b];
        this.map[b] = W ? W + ", " + v : v;
      }, m.prototype.delete = function(b) {
        delete this.map[d(b)];
      }, m.prototype.get = function(b) {
        return b = d(b), this.has(b) ? this.map[b] : null;
      }, m.prototype.has = function(b) {
        return this.map.hasOwnProperty(d(b));
      }, m.prototype.set = function(b, v) {
        this.map[d(b)] = h(v);
      }, m.prototype.forEach = function(b, v) {
        for (var W in this.map)
          this.map.hasOwnProperty(W) && b.call(v, this.map[W], W, this);
      }, m.prototype.keys = function() {
        var b = [];
        return this.forEach(function(v, W) {
          b.push(W);
        }), f(b);
      }, m.prototype.values = function() {
        var b = [];
        return this.forEach(function(v) {
          b.push(v);
        }), f(b);
      }, m.prototype.entries = function() {
        var b = [];
        return this.forEach(function(v, W) {
          b.push([W, v]);
        }), f(b);
      }, a.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
      function p(b) {
        if (b.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        b.bodyUsed = !0;
      }
      function g(b) {
        return new Promise(function(v, W) {
          b.onload = function() {
            v(b.result);
          }, b.onerror = function() {
            W(b.error);
          };
        });
      }
      function y(b) {
        var v = new FileReader(), W = g(v);
        return v.readAsArrayBuffer(b), W;
      }
      function _(b) {
        var v = new FileReader(), W = g(v);
        return v.readAsText(b), W;
      }
      function S(b) {
        for (var v = new Uint8Array(b), W = new Array(v.length), re = 0; re < v.length; re++)
          W[re] = String.fromCharCode(v[re]);
        return W.join("");
      }
      function C(b) {
        if (b.slice)
          return b.slice(0);
        var v = new Uint8Array(b.byteLength);
        return v.set(new Uint8Array(b)), v.buffer;
      }
      function R() {
        return this.bodyUsed = !1, this._initBody = function(b) {
          this._bodyInit = b, b ? typeof b == "string" ? this._bodyText = b : a.blob && Blob.prototype.isPrototypeOf(b) ? this._bodyBlob = b : a.formData && FormData.prototype.isPrototypeOf(b) ? this._bodyFormData = b : a.searchParams && URLSearchParams.prototype.isPrototypeOf(b) ? this._bodyText = b.toString() : a.arrayBuffer && a.blob && l(b) ? (this._bodyArrayBuffer = C(b.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(b) || c(b)) ? this._bodyArrayBuffer = C(b) : this._bodyText = b = Object.prototype.toString.call(b) : this._bodyText = "", this.headers.get("content-type") || (typeof b == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : a.searchParams && URLSearchParams.prototype.isPrototypeOf(b) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, a.blob && (this.blob = function() {
          var b = p(this);
          if (b)
            return b;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? p(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(y);
        }), this.text = function() {
          var b = p(this);
          if (b)
            return b;
          if (this._bodyBlob)
            return _(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(S(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, a.formData && (this.formData = function() {
          return this.text().then(E);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var L = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function k(b) {
        var v = b.toUpperCase();
        return L.indexOf(v) > -1 ? v : b;
      }
      function x(b, v) {
        v = v || {};
        var W = v.body;
        if (b instanceof x) {
          if (b.bodyUsed)
            throw new TypeError("Already read");
          this.url = b.url, this.credentials = b.credentials, v.headers || (this.headers = new m(b.headers)), this.method = b.method, this.mode = b.mode, this.signal = b.signal, !W && b._bodyInit != null && (W = b._bodyInit, b.bodyUsed = !0);
        } else
          this.url = String(b);
        if (this.credentials = v.credentials || this.credentials || "same-origin", (v.headers || !this.headers) && (this.headers = new m(v.headers)), this.method = k(v.method || this.method || "GET"), this.mode = v.mode || this.mode || null, this.signal = v.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && W)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(W);
      }
      x.prototype.clone = function() {
        return new x(this, { body: this._bodyInit });
      };
      function E(b) {
        var v = new FormData();
        return b.trim().split("&").forEach(function(W) {
          if (W) {
            var re = W.split("="), z = re.shift().replace(/\+/g, " "), F = re.join("=").replace(/\+/g, " ");
            v.append(decodeURIComponent(z), decodeURIComponent(F));
          }
        }), v;
      }
      function G(b) {
        var v = new m(), W = b.replace(/\r?\n[\t ]+/g, " ");
        return W.split(/\r?\n/).forEach(function(re) {
          var z = re.split(":"), F = z.shift().trim();
          if (F) {
            var oe = z.join(":").trim();
            v.append(F, oe);
          }
        }), v;
      }
      R.call(x.prototype);
      function O(b, v) {
        v || (v = {}), this.type = "default", this.status = v.status === void 0 ? 200 : v.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in v ? v.statusText : "OK", this.headers = new m(v.headers), this.url = v.url || "", this._initBody(b);
      }
      R.call(O.prototype), O.prototype.clone = function() {
        return new O(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new m(this.headers),
          url: this.url
        });
      }, O.error = function() {
        var b = new O(null, { status: 0, statusText: "" });
        return b.type = "error", b;
      };
      var q = [301, 302, 303, 307, 308];
      O.redirect = function(b, v) {
        if (q.indexOf(v) === -1)
          throw new RangeError("Invalid status code");
        return new O(null, { status: v, headers: { location: b } });
      }, o.DOMException = s.DOMException;
      try {
        new o.DOMException();
      } catch (b) {
        o.DOMException = function(v, W) {
          this.message = v, this.name = W;
          var re = Error(v);
          this.stack = re.stack;
        }, o.DOMException.prototype = Object.create(Error.prototype), o.DOMException.prototype.constructor = o.DOMException;
      }
      function le(b, v) {
        return new Promise(function(W, re) {
          var z = new x(b, v);
          if (z.signal && z.signal.aborted)
            return re(new o.DOMException("Aborted", "AbortError"));
          var F = new XMLHttpRequest();
          function oe() {
            F.abort();
          }
          F.onload = function() {
            var ce = {
              status: F.status,
              statusText: F.statusText,
              headers: G(F.getAllResponseHeaders() || "")
            };
            ce.url = "responseURL" in F ? F.responseURL : ce.headers.get("X-Request-URL");
            var He = "response" in F ? F.response : F.responseText;
            W(new O(He, ce));
          }, F.onerror = function() {
            re(new TypeError("Network request failed"));
          }, F.ontimeout = function() {
            re(new TypeError("Network request failed"));
          }, F.onabort = function() {
            re(new o.DOMException("Aborted", "AbortError"));
          }, F.open(z.method, z.url, !0), z.credentials === "include" ? F.withCredentials = !0 : z.credentials === "omit" && (F.withCredentials = !1), "responseType" in F && a.blob && (F.responseType = "blob"), z.headers.forEach(function(ce, He) {
            F.setRequestHeader(He, ce);
          }), z.signal && (z.signal.addEventListener("abort", oe), F.onreadystatechange = function() {
            F.readyState === 4 && z.signal.removeEventListener("abort", oe);
          }), F.send(typeof z._bodyInit == "undefined" ? null : z._bodyInit);
        });
      }
      return le.polyfill = !0, s.fetch || (s.fetch = le, s.Headers = m, s.Request = x, s.Response = O), o.Headers = m, o.Request = x, o.Response = O, o.fetch = le, Object.defineProperty(o, "__esModule", { value: !0 }), o;
    })({});
  })(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
  var i = n;
  e = i.fetch, e.default = i.fetch, e.fetch = i.fetch, e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response, r.exports = e;
})(ua, ua.exports);
var Di = ua.exports;
const Vi = /* @__PURE__ */ Cl(Di), Ay = /* @__PURE__ */ Jg({
  __proto__: null,
  default: Vi
}, [Di]), rr = (r) => {
  let e = {};
  return r && (typeof Headers != "undefined" && r instanceof Headers || Ay && Di.Headers && r instanceof Di.Headers ? e = Xy(r) : Array.isArray(r) ? r.forEach(([t, n]) => {
    t && n !== void 0 && (e[t] = n);
  }) : e = r), e;
}, xu = (r) => r.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), Uy = (r) => {
  if (!Array.isArray(r.query)) {
    const n = r, i = [`query=${encodeURIComponent(xu(n.query))}`];
    return r.variables && i.push(`variables=${encodeURIComponent(n.jsonSerializer.stringify(n.variables))}`), n.operationName && i.push(`operationName=${encodeURIComponent(n.operationName)}`), i.join("&");
  }
  if (typeof r.variables != "undefined" && !Array.isArray(r.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const e = r, t = r.query.reduce((n, i, s) => (n.push({
    query: xu(i),
    variables: e.variables ? e.jsonSerializer.stringify(e.variables[s]) : void 0
  }), n), []);
  return `query=${encodeURIComponent(e.jsonSerializer.stringify(t))}`;
}, Yy = (r) => (e) => $(void 0, null, function* () {
  var p;
  const { url: t, query: n, variables: i, operationName: s, fetch: o, fetchOptions: a, middleware: l } = e, u = I({}, e.headers);
  let c = "", d;
  r === "POST" ? (d = Hy(n, i, s, a.jsonSerializer), typeof d == "string" && (u["Content-Type"] = "application/json")) : c = Uy({
    query: n,
    variables: i,
    operationName: s,
    jsonSerializer: (p = a.jsonSerializer) != null ? p : Tl
  });
  const h = I({
    method: r,
    headers: u,
    body: d
  }, a);
  let f = t, m = h;
  if (l) {
    const g = yield Promise.resolve(l(M(I({}, h), { url: t, operationName: s, variables: i }))), { url: _ } = g, S = Ze(g, ["url"]);
    f = _, m = S;
  }
  return c && (f = `${f}?${c}`), yield o(f, m);
});
class Fy {
  constructor(e, t = {}) {
    this.url = e, this.requestConfig = t, this.rawRequest = (...n) => $(this, null, function* () {
      const [i, s, o] = n, a = Py(i, s, o), g = this.requestConfig, { headers: l, fetch: u = Vi, method: c = "POST", requestMiddleware: d, responseMiddleware: h } = g, f = Ze(g, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: m } = this;
      a.signal !== void 0 && (f.signal = a.signal);
      const { operationName: p } = no(a.query);
      return io({
        url: m,
        query: a.query,
        variables: a.variables,
        headers: I(I({}, rr(so(l))), rr(a.requestHeaders)),
        operationName: p,
        fetch: u,
        method: c,
        fetchOptions: f,
        middleware: d
      }).then((y) => (h && h(y), y)).catch((y) => {
        throw h && h(y), y;
      });
    });
  }
  request(e, ...t) {
    return $(this, null, function* () {
      const [n, i] = t, s = ky(e, n, i), p = this.requestConfig, { headers: o, fetch: a = Vi, method: l = "POST", requestMiddleware: u, responseMiddleware: c } = p, d = Ze(p, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: h } = this;
      s.signal !== void 0 && (d.signal = s.signal);
      const { query: f, operationName: m } = no(s.document);
      return io({
        url: h,
        query: f,
        variables: s.variables,
        headers: I(I({}, rr(so(o))), rr(s.requestHeaders)),
        operationName: m,
        fetch: a,
        method: l,
        fetchOptions: d,
        middleware: u
      }).then((g) => (c && c(g), g.data)).catch((g) => {
        throw c && c(g), g;
      });
    });
  }
  // prettier-ignore
  batchRequests(e, t) {
    var u;
    const n = My(e, t), l = this.requestConfig, { headers: i } = l, s = Ze(l, ["headers"]);
    n.signal !== void 0 && (s.signal = n.signal);
    const o = n.documents.map(({ document: c }) => no(c).query), a = n.documents.map(({ variables: c }) => c);
    return io({
      url: this.url,
      query: o,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: a,
      headers: I(I({}, rr(so(i))), rr(n.requestHeaders)),
      operationName: void 0,
      fetch: (u = this.requestConfig.fetch) != null ? u : Vi,
      method: this.requestConfig.method || "POST",
      fetchOptions: s,
      middleware: this.requestConfig.requestMiddleware
    }).then((c) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(c), c.data)).catch((c) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(c), c;
    });
  }
  setHeaders(e) {
    return this.requestConfig.headers = e, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(e, t) {
    const { headers: n } = this.requestConfig;
    return n ? n[e] = t : this.requestConfig.headers = { [e]: t }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(e) {
    return this.url = e, this;
  }
}
const io = (r) => $(void 0, null, function* () {
  var c, d;
  const { query: e, variables: t, fetchOptions: n } = r, i = Yy(Wy((c = r.method) != null ? c : "post")), s = Array.isArray(r.query), o = yield i(r), a = yield Jy(o, (d = n.jsonSerializer) != null ? d : Tl), l = Array.isArray(a) ? !a.some(({ data: f }) => !f) : !!a.data, u = Array.isArray(a) || !a.errors || Array.isArray(a.errors) && !a.errors.length || n.errorPolicy === "all" || n.errorPolicy === "ignore";
  if (o.ok && u && l) {
    const h = (Array.isArray(a), a), { errors: f } = h, m = Ze(h, ["errors"]), p = n.errorPolicy === "ignore" ? m : a;
    return M(I({}, s ? { data: p } : p), {
      headers: o.headers,
      status: o.status
    });
  } else {
    const f = typeof a == "string" ? {
      error: a
    } : a;
    throw new gr(
      // @ts-expect-error TODO
      M(I({}, f), { status: o.status, headers: o.headers }),
      { query: e, variables: t }
    );
  }
}), Hy = (r, e, t, n) => {
  const i = n != null ? n : Tl;
  if (!Array.isArray(r))
    return i.stringify({ query: r, variables: e, operationName: t });
  if (typeof e != "undefined" && !Array.isArray(e))
    throw new Error("Cannot create request body with given variable type, array expected");
  const s = r.reduce((o, a, l) => (o.push({ query: a, variables: e ? e[l] : void 0 }), o), []);
  return i.stringify(s);
}, Jy = (r, e) => $(void 0, null, function* () {
  let t;
  return r.headers.forEach((n, i) => {
    i.toLowerCase() === "content-type" && (t = n);
  }), t && (t.toLowerCase().startsWith("application/json") || t.toLowerCase().startsWith("application/graphql+json") || t.toLowerCase().startsWith("application/graphql-response+json")) ? e.parse(yield r.text()) : r.text();
}), so = (r) => typeof r == "function" ? r() : r;
var ca = { exports: {} };
(function(r, e) {
  e = r.exports = t, e.getSerialize = n;
  function t(i, s, o, a) {
    return JSON.stringify(i, n(s, a), o);
  }
  function n(i, s) {
    var o = [], a = [];
    return s == null && (s = function(l, u) {
      return o[0] === u ? "[Circular ~]" : "[Circular ~." + a.slice(0, o.indexOf(u)).join(".") + "]";
    }), function(l, u) {
      if (o.length > 0) {
        var c = o.indexOf(this);
        ~c ? o.splice(c + 1) : o.push(this), ~c ? a.splice(c, 1 / 0, l) : a.push(l), ~o.indexOf(u) && (u = s.call(this, l, u));
      } else o.push(u);
      return i == null ? u : i.call(this, l, u);
    };
  }
})(ca, ca.exports);
var By = ca.exports;
const Ut = /* @__PURE__ */ Cl(By);
var Dy = Object.defineProperty, Ky = (r, e, t) => e in r ? Dy(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, Z = (r, e, t) => Ky(r, typeof e != "symbol" ? e + "" : e, t), Ou, zy = Object.defineProperty, jy = (r, e, t) => e in r ? zy(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, Wu = (r, e, t) => jy(r, typeof e != "symbol" ? e + "" : e, t), ge = /* @__PURE__ */ ((r) => (r[r.Document = 0] = "Document", r[r.DocumentType = 1] = "DocumentType", r[r.Element = 2] = "Element", r[r.Text = 3] = "Text", r[r.CDATA = 4] = "CDATA", r[r.Comment = 5] = "Comment", r))(ge || {});
const Xu = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, ku = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, Dn = {}, Qy = () => !!globalThis.Zone;
function Zl(r) {
  if (Dn[r])
    return Dn[r];
  const e = globalThis[r], t = e.prototype, n = r in Xu ? Xu[r] : void 0, i = !!(n && // @ts-expect-error 2345
  n.every(
    (a) => {
      var l, u;
      return !!((u = (l = Object.getOwnPropertyDescriptor(t, a)) == null ? void 0 : l.get) != null && u.toString().includes("[native code]"));
    }
  )), s = r in ku ? ku[r] : void 0, o = !!(s && s.every(
    // @ts-expect-error 2345
    (a) => {
      var l;
      return typeof t[a] == "function" && ((l = t[a]) == null ? void 0 : l.toString().includes("[native code]"));
    }
  ));
  if (i && o && !Qy())
    return Dn[r] = e.prototype, e.prototype;
  try {
    const a = document.createElement("iframe");
    document.body.appendChild(a);
    const l = a.contentWindow;
    if (!l) return e.prototype;
    const u = l[r].prototype;
    return document.body.removeChild(a), u ? Dn[r] = u : t;
  } catch (a) {
    return t;
  }
}
const oo = {};
function Vt(r, e, t) {
  var n;
  const i = `${r}.${String(t)}`;
  if (oo[i])
    return oo[i].call(
      e
    );
  const s = Zl(r), o = (n = Object.getOwnPropertyDescriptor(
    s,
    t
  )) == null ? void 0 : n.get;
  return o ? (oo[i] = o, o.call(e)) : e[t];
}
const ao = {};
function Xh(r, e, t) {
  const n = `${r}.${String(t)}`;
  if (ao[n])
    return ao[n].bind(
      e
    );
  const s = Zl(r)[t];
  return typeof s != "function" ? e[t] : (ao[n] = s, s.bind(e));
}
function $y(r) {
  return Vt("Node", r, "childNodes");
}
function qy(r) {
  return Vt("Node", r, "parentNode");
}
function eb(r) {
  return Vt("Node", r, "parentElement");
}
function tb(r) {
  return Vt("Node", r, "textContent");
}
function rb(r, e) {
  return Xh("Node", r, "contains")(e);
}
function nb(r) {
  return Xh("Node", r, "getRootNode")();
}
function ib(r) {
  return !r || !("host" in r) ? null : Vt("ShadowRoot", r, "host");
}
function sb(r) {
  return r.styleSheets;
}
function ob(r) {
  return !r || !("shadowRoot" in r) ? null : Vt("Element", r, "shadowRoot");
}
function ab(r, e) {
  return Vt("Element", r, "querySelector")(e);
}
function lb(r, e) {
  return Vt("Element", r, "querySelectorAll")(e);
}
function ub() {
  return Zl("MutationObserver").constructor;
}
function cb(r, e, t) {
  try {
    if (!(e in r))
      return () => {
      };
    const n = r[e], i = t(n);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), r[e] = i, () => {
      r[e] = n;
    };
  } catch (n) {
    return () => {
    };
  }
}
const ve = {
  childNodes: $y,
  parentNode: qy,
  parentElement: eb,
  textContent: tb,
  contains: rb,
  getRootNode: nb,
  host: ib,
  styleSheets: sb,
  shadowRoot: ob,
  querySelector: ab,
  querySelectorAll: lb,
  mutationObserver: ub,
  patch: cb
};
function kh(r) {
  return r.nodeType === r.ELEMENT_NODE;
}
function nn(r) {
  const e = (
    // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    r && "host" in r && "mode" in r && ve.host(r) || null
  );
  return !!(e && "shadowRoot" in e && ve.shadowRoot(e) === r);
}
function sn(r) {
  return Object.prototype.toString.call(r) === "[object ShadowRoot]";
}
function db(r) {
  return r.includes(" background-clip: text;") && !r.includes(" -webkit-background-clip: text;") && (r = r.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), r;
}
function hb(r) {
  const { cssText: e } = r;
  if (e.split('"').length < 3) return e;
  const t = ["@import", `url(${JSON.stringify(r.href)})`];
  return r.layerName === "" ? t.push("layer") : r.layerName && t.push(`layer(${r.layerName})`), r.supportsText && t.push(`supports(${r.supportsText})`), r.media.length && t.push(r.media.mediaText), t.join(" ") + ";";
}
function da(r) {
  try {
    const e = r.rules || r.cssRules;
    if (!e)
      return null;
    let t = r.href;
    !t && r.ownerNode && r.ownerNode.ownerDocument && (t = r.ownerNode.ownerDocument.location.href);
    const n = Array.from(
      e,
      (i) => Ph(i, t)
    ).join("");
    return db(n);
  } catch (e) {
    return null;
  }
}
function Ph(r, e) {
  if (pb(r)) {
    let t;
    try {
      t = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      da(r.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      hb(r);
    } catch (n) {
      t = r.cssText;
    }
    return r.styleSheet.href ? ji(t, r.styleSheet.href) : t;
  } else {
    let t = r.cssText;
    return mb(r) && r.selectorText.includes(":") && (t = fb(t)), e ? ji(t, e) : t;
  }
}
function fb(r) {
  const e = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return r.replace(e, "$1\\$2");
}
function pb(r) {
  return "styleSheet" in r;
}
function mb(r) {
  return "selectorText" in r;
}
class Mh {
  constructor() {
    Wu(this, "idNodeMap", /* @__PURE__ */ new Map()), Wu(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(e) {
    var t;
    if (!e) return -1;
    const n = (t = this.getMeta(e)) == null ? void 0 : t.id;
    return n != null ? n : -1;
  }
  getNode(e) {
    return this.idNodeMap.get(e) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(e) {
    return this.nodeMetaMap.get(e) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(e) {
    const t = this.getId(e);
    this.idNodeMap.delete(t), e.childNodes && e.childNodes.forEach(
      (n) => this.removeNodeFromMap(n)
    );
  }
  has(e) {
    return this.idNodeMap.has(e);
  }
  hasNode(e) {
    return this.nodeMetaMap.has(e);
  }
  add(e, t) {
    const n = t.id;
    this.idNodeMap.set(n, e), this.nodeMetaMap.set(e, t);
  }
  replace(e, t) {
    const n = this.getNode(e);
    if (n) {
      const i = this.nodeMetaMap.get(n);
      i && this.nodeMetaMap.set(t, i);
    }
    this.idNodeMap.set(e, t);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function gb() {
  return new Mh();
}
function Ki({
  element: r,
  maskInputOptions: e,
  tagName: t,
  type: n,
  value: i,
  overwriteRecord: s,
  maskInputFn: o
}) {
  let a = i || "";
  return Yh({
    maskInputOptions: e,
    tagName: t,
    type: n,
    overwriteRecord: s
  }) && (o ? a = o(a, r) : a = "*".repeat(a.length)), a;
}
function vr(r) {
  return r.toLowerCase();
}
const Pu = "__rrweb_original__";
function yb(r) {
  const e = r.getContext("2d");
  if (!e) return !0;
  const t = 50;
  for (let n = 0; n < r.width; n += t)
    for (let i = 0; i < r.height; i += t) {
      const s = e.getImageData, o = Pu in s ? s[Pu] : s;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        o.call(
          e,
          n,
          i,
          Math.min(t, r.width - n),
          Math.min(t, r.height - i)
        ).data.buffer
      ).some((l) => l !== 0)) return !1;
    }
  return !0;
}
function zi(r) {
  const e = r.type;
  return r.hasAttribute("data-rr-is-password") ? "password" : e ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    vr(e)
  ) : null;
}
function Ah(r, e) {
  var s;
  let t;
  try {
    t = new URL(r, window.location.href);
  } catch (o) {
    return null;
  }
  const n = /\.([0-9a-z]+)(?:$)/i, i = t.pathname.match(n);
  return (s = i == null ? void 0 : i[1]) != null ? s : null;
}
function bb(r) {
  let e = "";
  return r.indexOf("//") > -1 ? e = r.split("/").slice(0, 3).join("/") : e = r.split("/")[0], e = e.split("?")[0], e;
}
const vb = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Sb = /^(?:[a-z+]+:)?\/\//i, wb = /^www\..*/i, _b = /^(data:)([^,]*),(.*)/i;
function ji(r, e) {
  return (r || "").replace(
    vb,
    (t, n, i, s, o, a) => {
      const l = i || o || a, u = n || s || "";
      if (!l)
        return t;
      if (Sb.test(l) || wb.test(l))
        return `url(${u}${l}${u})`;
      if (_b.test(l))
        return `url(${u}${l}${u})`;
      if (l[0] === "/")
        return `url(${u}${bb(e) + l}${u})`;
      const c = e.split("/"), d = l.split("/");
      c.pop();
      for (const h of d)
        h !== "." && (h === ".." ? c.pop() : c.push(h));
      return `url(${u}${c.join("/")}${u})`;
    }
  );
}
function Kn(r, e = !1) {
  return e ? r.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "") : r.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
}
function Rb(r, e, t = !1) {
  const n = Array.from(e.childNodes), i = [];
  let s = 0;
  if (n.length > 1 && r && typeof r == "string") {
    let o = Kn(r, t);
    const a = o.length / r.length;
    for (let l = 1; l < n.length; l++)
      if (n[l].textContent && typeof n[l].textContent == "string") {
        const u = Kn(
          n[l].textContent,
          t
        ), c = 100;
        let d = 3;
        for (; d < u.length && // keep consuming css identifiers (to get a decent chunk more quickly)
        (u[d].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
        u.indexOf(u.substring(0, d), 1) !== -1); d++)
          ;
        for (; d < u.length; d++) {
          let h = u.substring(0, d), f = o.split(h), m = -1;
          if (f.length === 2)
            m = f[0].length;
          else if (f.length > 2 && f[0] === "" && n[l - 1].textContent !== "")
            m = o.indexOf(h, 1);
          else if (f.length === 1) {
            if (h = h.substring(
              0,
              h.length - 1
            ), f = o.split(h), f.length <= 1)
              return i.push(r), i;
            d = c + 1;
          } else d === u.length - 1 && (m = o.indexOf(h));
          if (f.length >= 2 && d > c) {
            const p = n[l - 1].textContent;
            if (p && typeof p == "string") {
              const g = Kn(p).length;
              m = o.indexOf(h, g);
            }
            m === -1 && (m = f[0].length);
          }
          if (m !== -1) {
            let p = Math.floor(m / a);
            for (; p > 0 && p < r.length; ) {
              if (s += 1, s > 50 * n.length)
                return i.push(r), i;
              const g = Kn(
                r.substring(0, p),
                t
              );
              if (g.length === m) {
                i.push(r.substring(0, p)), r = r.substring(p), o = o.substring(m);
                break;
              } else g.length < m ? p += Math.max(
                1,
                Math.floor((m - g.length) / a)
              ) : p -= Math.max(
                1,
                Math.floor((g.length - m) * a)
              );
            }
            break;
          }
        }
      }
  }
  return i.push(r), i;
}
function Ib(r, e) {
  return Rb(r, e).join("/* rr_split */");
}
function Gl(r) {
  return r = r.replace(/[^ -~]+/g, ""), r = (r == null ? void 0 : r.split(" ").map((e) => Math.random().toString(20).substring(2, e.length)).join(" ")) || "", r;
}
function ha(r) {
  return r === "img" || r === "video" || r === "audio" || r === "source";
}
const Tb = new RegExp(
  /[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*/
), Eb = new RegExp(/[0-9]{9,16}/), Cb = new RegExp(/[0-9]{3}-?[0-9]{2}-?[0-9]{4}/), Zb = new RegExp(
  /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/
), Gb = new RegExp(/[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}/), Lb = new RegExp(
  /[0-9]{1,5}.?[0-9]{0,3}\s[a-zA-Z]{2,30}\s[a-zA-Z]{2,15}/
), Nb = new RegExp(/(?:[0-9]{1,3}.){3}[0-9]{1,3}/), Vb = [
  Tb,
  Eb,
  Cb,
  Zb,
  Gb,
  Lb,
  Nb
];
function Uh(r) {
  return r ? Vb.some((e) => e.test(r)) : !1;
}
const Yh = ({
  maskInputOptions: r,
  tagName: e,
  type: t,
  overwriteRecord: n
}) => {
  const i = t && t.toLowerCase();
  return n !== "true" && (!!r[e.toLowerCase()] || !!(i && r[i]));
};
let xb = 1;
const Ob = new RegExp("[^a-z0-9-_:]"), mn = -2;
function Fh() {
  return xb++;
}
function Wb(r) {
  if (r instanceof HTMLFormElement)
    return "form";
  const e = vr(r.tagName);
  return Ob.test(e) ? "div" : e;
}
let nr, Mu;
const Xb = /^[^ \t\n\r\u000c]+/, kb = /^[, \t\n\r\u000c]+/;
function Pb(r, e) {
  if (e.trim() === "")
    return e;
  let t = 0;
  function n(s) {
    let o;
    const a = s.exec(e.substring(t));
    return a ? (o = a[0], t += o.length, o) : "";
  }
  const i = [];
  for (; n(kb), !(t >= e.length); ) {
    let s = n(Xb);
    if (s.slice(-1) === ",")
      s = hr(r, s.substring(0, s.length - 1)), i.push(s);
    else {
      let o = "";
      s = hr(r, s);
      let a = !1;
      for (; ; ) {
        const l = e.charAt(t);
        if (l === "") {
          i.push((s + o).trim());
          break;
        } else if (a)
          l === ")" && (a = !1);
        else if (l === ",") {
          t += 1, i.push((s + o).trim());
          break;
        } else l === "(" && (a = !0);
        o += l, t += 1;
      }
    }
  }
  return i.join(", ");
}
const Au = /* @__PURE__ */ new WeakMap();
function hr(r, e) {
  return !e || e.trim() === "" ? e : Ll(r, e);
}
function Mb(r) {
  return !!(r.tagName === "svg" || r.ownerSVGElement);
}
function Ll(r, e) {
  let t = Au.get(r);
  if (t || (t = r.createElement("a"), Au.set(r, t)), !e)
    e = "";
  else if (e.startsWith("blob:") || e.startsWith("data:"))
    return e;
  return t.setAttribute("href", e), t.href;
}
function Hh(r, e, t, n) {
  return n && (t === "src" || t === "href" && !(e === "use" && n[0] === "#") || t === "xlink:href" && n[0] !== "#" || t === "background" && (e === "table" || e === "td" || e === "th") ? hr(r, n) : t === "srcset" ? Pb(r, n) : t === "style" ? ji(n, Ll(r)) : e === "object" && t === "data" ? hr(r, n) : n);
}
function Jh(r, e, t) {
  return (r === "video" || r === "audio") && e === "autoplay";
}
function Uu(r, e, t) {
  try {
    if (typeof e == "string") {
      if (r.classList.contains(e))
        return !0;
    } else
      for (let n = r.classList.length; n--; ) {
        const i = r.classList[n];
        if (e.test(i))
          return !0;
      }
    if (t)
      return r.matches(t);
  } catch (n) {
  }
  return !1;
}
function Qi(r, e, t) {
  if (!r) return !1;
  if (r.nodeType !== r.ELEMENT_NODE)
    return t ? Qi(ve.parentNode(r), e, t) : !1;
  for (let n = r.classList.length; n--; ) {
    const i = r.classList[n];
    if (e.test(i))
      return !0;
  }
  return t ? Qi(ve.parentNode(r), e, t) : !1;
}
function Bh(r, e, t, n) {
  let i;
  if (kh(r)) {
    if (i = r, !ve.childNodes(i).length)
      return !1;
  } else {
    if (ve.parentElement(r) === null)
      return !1;
    i = ve.parentElement(r);
  }
  try {
    if (typeof e == "string") {
      if (n) {
        if (i.closest(`.${e}`)) return !0;
      } else if (i.classList.contains(e)) return !0;
    } else if (Qi(i, e, n)) return !0;
    if (t) {
      if (n) {
        if (i.closest(t)) return !0;
      } else if (i.matches(t)) return !0;
    }
  } catch (s) {
  }
  return !1;
}
function Ab(r, e, t) {
  const n = r.contentWindow;
  if (!n)
    return;
  let i = !1, s;
  try {
    s = n.document.readyState;
  } catch (a) {
    return;
  }
  if (s !== "complete") {
    const a = setTimeout(() => {
      i || (e(), i = !0);
    }, t);
    r.addEventListener("load", () => {
      clearTimeout(a), i = !0, e();
    });
    return;
  }
  const o = "about:blank";
  if (n.location.href !== o || r.src === o || r.src === "")
    return setTimeout(e, 0), r.addEventListener("load", e);
  r.addEventListener("load", e);
}
function Ub(r, e, t) {
  let n = !1, i;
  try {
    i = r.sheet;
  } catch (o) {
    return;
  }
  if (i) return;
  const s = setTimeout(() => {
    n || (e(), n = !0);
  }, t);
  r.addEventListener("load", () => {
    clearTimeout(s), n = !0, e();
  });
}
function Yb(r, e) {
  const {
    doc: t,
    mirror: n,
    blockClass: i,
    blockSelector: s,
    needsMask: o,
    inlineStylesheet: a,
    maskInputOptions: l = {},
    maskTextClass: u,
    maskTextFn: c,
    maskInputFn: d,
    dataURLOptions: h = {},
    inlineImages: f,
    inlineVideos: m,
    recordCanvas: p,
    keepIframeSrcFn: g,
    newlyAddedElement: y = !1,
    cssCaptured: _ = !1,
    privacySetting: S
  } = e, C = Fb(t, n);
  switch (r.nodeType) {
    case r.DOCUMENT_NODE:
      return r.compatMode !== "CSS1Compat" ? {
        type: ge.Document,
        childNodes: [],
        compatMode: r.compatMode
        // probably "BackCompat"
      } : {
        type: ge.Document,
        childNodes: []
      };
    case r.DOCUMENT_TYPE_NODE:
      return {
        type: ge.DocumentType,
        name: r.name,
        publicId: r.publicId,
        systemId: r.systemId,
        rootId: C
      };
    case r.ELEMENT_NODE:
      return Jb(r, {
        doc: t,
        blockClass: i,
        blockSelector: s,
        inlineStylesheet: a,
        maskInputOptions: l,
        maskInputFn: d,
        maskTextClass: u,
        dataURLOptions: h,
        inlineImages: f,
        inlineVideos: m,
        recordCanvas: p,
        keepIframeSrcFn: g,
        newlyAddedElement: y,
        privacySetting: S,
        rootId: C
      });
    case r.TEXT_NODE:
      return Hb(r, {
        doc: t,
        needsMask: o,
        maskTextFn: c,
        privacySetting: S,
        rootId: C,
        cssCaptured: _
      });
    case r.CDATA_SECTION_NODE:
      return {
        type: ge.CDATA,
        textContent: "",
        rootId: C
      };
    case r.COMMENT_NODE:
      return {
        type: ge.Comment,
        textContent: ve.textContent(r) || "",
        rootId: C
      };
    default:
      return !1;
  }
}
function Fb(r, e) {
  if (!e.hasNode(r)) return;
  const t = e.getId(r);
  return t === 1 ? void 0 : t;
}
function Hb(r, e) {
  var t;
  const { needsMask: n, maskTextFn: i, privacySetting: s, rootId: o, cssCaptured: a } = e, l = ve.parentNode(r), u = l && l.tagName;
  let c = "";
  const d = u === "STYLE" ? !0 : void 0, h = u === "SCRIPT" ? !0 : void 0;
  h ? c = "SCRIPT_PLACEHOLDER" : a || (c = ve.textContent(r), d && c && (c = ji(c, Ll(e.doc)))), !d && !h && c && n && (c = i ? i(c, ve.parentElement(r)) : c.replace(/[\S]/g, "*"));
  const f = s === "strict", m = (t = r.parentElement) == null ? void 0 : t.getAttribute("data-hl-record"), p = s === "default" && Uh(c);
  return (f || p) && !m && u && !(/* @__PURE__ */ new Set([
    "HEAD",
    "TITLE",
    "STYLE",
    "SCRIPT",
    "HTML",
    "BODY",
    "NOSCRIPT"
  ])).has(u) && c && (c = Gl(c)), {
    type: ge.Text,
    textContent: c || "",
    rootId: o
  };
}
function Jb(r, e) {
  const {
    doc: t,
    blockClass: n,
    blockSelector: i,
    inlineStylesheet: s,
    maskInputOptions: o = {},
    maskInputFn: a,
    maskTextClass: l,
    dataURLOptions: u = {},
    inlineImages: c,
    inlineVideos: d,
    recordCanvas: h,
    keepIframeSrcFn: f,
    newlyAddedElement: m = !1,
    privacySetting: p,
    rootId: g
  } = e;
  let y = Uu(r, n, i);
  const _ = Uu(r, l, null), S = p === "strict";
  let C = Wb(r), R = {};
  const L = r.attributes.length;
  for (let E = 0; E < L; E++) {
    const G = r.attributes[E];
    Jh(C, G.name) || (R[G.name] = Hh(
      t,
      C,
      vr(G.name),
      G.value
    ));
  }
  if (C === "link" && s) {
    const E = Array.from(t.styleSheets).find((O) => O.href === r.href);
    let G = null;
    E && (G = da(E)), G && (delete R.rel, delete R.href, R._cssText = G);
  }
  if (C === "style" && r.sheet) {
    let E = da(
      r.sheet
    );
    E && (r.childNodes.length > 1 && (E = Ib(E, r)), R._cssText = E);
  }
  if (C === "input" || C === "textarea" || C === "select") {
    const E = r.value, G = r.checked;
    R.type !== "radio" && R.type !== "checkbox" && R.type !== "submit" && R.type !== "button" && E ? R.value = Ki({
      element: r,
      type: zi(r),
      tagName: C,
      value: E,
      overwriteRecord: r.getAttribute("data-hl-record"),
      maskInputOptions: o,
      maskInputFn: a
    }) : G && (R.checked = G);
  }
  if (C === "option" && (r.selected && !o.select ? R.selected = !0 : delete R.selected), C === "dialog" && r.open && (R.rr_open_mode = r.matches("dialog:modal") ? "modal" : "non-modal"), C === "canvas" && h) {
    if (r.__context === "2d")
      yb(r);
    else if (!("__context" in r)) {
      const E = r.toDataURL(
        u.type,
        u.quality
      ), G = t.createElement("canvas");
      G.width = r.width, G.height = r.height;
      const O = G.toDataURL(
        u.type,
        u.quality
      );
      E !== O && (R.rr_dataURL = E);
    }
  }
  if (C === "img" && c && !y && !_ && !S) {
    nr || (nr = t.createElement("canvas"), Mu = nr.getContext("2d"));
    const E = r, G = E.currentSrc || E.getAttribute("src") || "<unknown-src>", O = E.crossOrigin, q = () => {
      E.removeEventListener("load", q);
      try {
        nr.width = E.naturalWidth, nr.height = E.naturalHeight, Mu.drawImage(E, 0, 0), R.rr_dataURL = nr.toDataURL(
          u.type,
          u.quality
        );
      } catch (le) {
        if (E.crossOrigin !== "anonymous") {
          E.crossOrigin = "anonymous", E.complete && E.naturalWidth !== 0 ? q() : E.addEventListener("load", q);
          return;
        } else
          console.warn(
            `Cannot inline img src=${G}! Error: ${le}`
          );
      }
      E.crossOrigin === "anonymous" && (O ? R.crossOrigin = O : E.removeAttribute("crossorigin"));
    };
    E.complete && E.naturalWidth !== 0 ? q() : E.addEventListener("load", q);
  }
  if (C === "audio" || C === "video") {
    const E = R;
    E.rr_mediaState = r.paused ? "paused" : "played", E.rr_mediaCurrentTime = r.currentTime, E.rr_mediaPlaybackRate = r.playbackRate, E.rr_mediaMuted = r.muted, E.rr_mediaLoop = r.loop, E.rr_mediaVolume = r.volume;
  }
  if (m || (r.scrollLeft && (R.rr_scrollLeft = r.scrollLeft), r.scrollTop && (R.rr_scrollTop = r.scrollTop)), y || _ || S && ha(C)) {
    const { width: E, height: G } = r.getBoundingClientRect();
    R = {
      class: R.class,
      rr_width: `${E}px`,
      rr_height: `${G}px`
    };
  }
  S && ha(C) && (y = !0), C === "iframe" && !f(R.src) && (r.contentDocument || (R.rr_src = R.src), delete R.src);
  let k;
  try {
    customElements.get(C) && (k = !0);
  } catch (E) {
  }
  const x = (E) => {
    const { width: G, height: O } = E.getBoundingClientRect();
    R = {
      width: G,
      height: O,
      rr_width: `${G}px`,
      rr_height: `${O}px`,
      rr_inlined_video: !0,
      class: R.class,
      style: R.style
    }, C = "canvas";
    const q = t.createElement("canvas");
    q.width = r.width, q.height = r.height, R.rr_dataURL = q.toDataURL(
      u.type,
      u.quality
    );
  };
  if (C === "video") {
    const E = r;
    c && (E.src === "" || E.src.indexOf("blob:") !== -1) && x(E), d && E.src !== "" && E.src.indexOf("blob:") === -1 && x(E);
  }
  return {
    type: ge.Element,
    tagName: C,
    attributes: R,
    childNodes: [],
    isSVG: Mb(r) || void 0,
    needBlock: y,
    needMask: _,
    rootId: g,
    isCustom: k
  };
}
function ue(r) {
  return r == null ? "" : r.toLowerCase();
}
function Bb(r, e) {
  if (e.comment && r.type === ge.Comment)
    return !0;
  if (r.type === ge.Element) {
    if (e.script && // script tag
    (r.tagName === "script" || // (module)preload link
    r.tagName === "link" && (r.attributes.rel === "preload" && r.attributes.as === "script" || r.attributes.rel === "modulepreload") || // prefetch link
    r.tagName === "link" && r.attributes.rel === "prefetch" && typeof r.attributes.href == "string" && Ah(r.attributes.href) === "js"))
      return !0;
    if (e.headFavicon && (r.tagName === "link" && r.attributes.rel === "shortcut icon" || r.tagName === "meta" && (ue(r.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || ue(r.attributes.name) === "application-name" || ue(r.attributes.rel) === "icon" || ue(r.attributes.rel) === "apple-touch-icon" || ue(r.attributes.rel) === "shortcut icon")))
      return !0;
    if (r.tagName === "meta") {
      if (e.headMetaDescKeywords && ue(r.attributes.name).match(/^description|keywords$/))
        return !0;
      if (e.headMetaSocial && (ue(r.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      ue(r.attributes.name).match(/^(og|twitter):/) || ue(r.attributes.name) === "pinterest"))
        return !0;
      if (e.headMetaRobots && (ue(r.attributes.name) === "robots" || ue(r.attributes.name) === "googlebot" || ue(r.attributes.name) === "bingbot"))
        return !0;
      if (e.headMetaHttpEquiv && r.attributes["http-equiv"] !== void 0)
        return !0;
      if (e.headMetaAuthorship && (ue(r.attributes.name) === "author" || ue(r.attributes.name) === "generator" || ue(r.attributes.name) === "framework" || ue(r.attributes.name) === "publisher" || ue(r.attributes.name) === "progid" || ue(r.attributes.property).match(/^article:/) || ue(r.attributes.property).match(/^product:/)))
        return !0;
      if (e.headMetaVerification && (ue(r.attributes.name) === "google-site-verification" || ue(r.attributes.name) === "yandex-verification" || ue(r.attributes.name) === "csrf-token" || ue(r.attributes.name) === "p:domain_verify" || ue(r.attributes.name) === "verify-v1" || ue(r.attributes.name) === "verification" || ue(r.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function fr(r, e) {
  const {
    doc: t,
    mirror: n,
    blockClass: i,
    blockSelector: s,
    maskTextClass: o,
    maskTextSelector: a,
    skipChild: l = !1,
    inlineStylesheet: u = !0,
    maskInputOptions: c = {},
    maskTextFn: d,
    maskInputFn: h,
    slimDOMOptions: f,
    dataURLOptions: m = {},
    inlineImages: p = !1,
    inlineVideos: g = !1,
    recordCanvas: y = !1,
    onSerialize: _,
    onIframeLoad: S,
    iframeLoadTimeout: C = 5e3,
    onStylesheetLoad: R,
    stylesheetLoadTimeout: L = 5e3,
    keepIframeSrcFn: k = () => !1,
    newlyAddedElement: x = !1,
    cssCaptured: E = !1,
    privacySetting: G
  } = e;
  let { needsMask: O } = e, { preserveWhiteSpace: q = !0 } = e;
  O || (O = Bh(
    r,
    o,
    a,
    O === void 0
  ));
  const le = Yb(r, {
    doc: t,
    mirror: n,
    blockClass: i,
    blockSelector: s,
    needsMask: O,
    inlineStylesheet: u,
    maskInputOptions: c,
    maskTextClass: o,
    maskTextFn: d,
    maskInputFn: h,
    dataURLOptions: m,
    inlineImages: p,
    inlineVideos: g,
    recordCanvas: y,
    keepIframeSrcFn: k,
    newlyAddedElement: x,
    cssCaptured: E,
    privacySetting: G
  });
  if (!le)
    return console.warn(r, "not serialized"), null;
  let b;
  n.hasNode(r) ? b = n.getId(r) : Bb(le, f) || !q && le.type === ge.Text && !le.textContent.replace(/^\s+|\s+$/gm, "").length ? b = mn : b = Fh();
  const v = Object.assign(le, { id: b });
  if (n.add(r, v), b === mn)
    return null;
  _ && _(r);
  let W = !l, re = G, z = G === "strict";
  if (v.type === ge.Element) {
    if (W = W && !v.needBlock, z || (z = !!v.needBlock || !!v.needMask), re = z ? "strict" : re, z && ha(v.tagName)) {
      const ce = r.cloneNode();
      ce.src = "", n.add(ce, v);
    }
    delete v.needBlock, delete v.needMask;
    const oe = ve.shadowRoot(r);
    oe && sn(oe) && (v.isShadowHost = !0);
  }
  if ((v.type === ge.Document || v.type === ge.Element) && W) {
    f.headWhitespace && v.type === ge.Element && v.tagName === "head" && (q = !1);
    const oe = {
      doc: t,
      mirror: n,
      blockClass: i,
      blockSelector: s,
      needsMask: O,
      maskTextClass: o,
      maskTextSelector: a,
      skipChild: l,
      inlineStylesheet: u,
      maskInputOptions: c,
      maskTextFn: d,
      maskInputFn: h,
      slimDOMOptions: f,
      dataURLOptions: m,
      inlineImages: p,
      inlineVideos: g,
      recordCanvas: y,
      preserveWhiteSpace: q,
      onSerialize: _,
      onIframeLoad: S,
      iframeLoadTimeout: C,
      onStylesheetLoad: R,
      stylesheetLoadTimeout: L,
      keepIframeSrcFn: k,
      cssCaptured: !1,
      privacySetting: re
    };
    if (!(v.type === ge.Element && v.tagName === "textarea" && v.attributes.value !== void 0)) {
      v.type === ge.Element && v.attributes._cssText !== void 0 && typeof v.attributes._cssText == "string" && (oe.cssCaptured = !0);
      for (const He of Array.from(ve.childNodes(r))) {
        const vt = fr(He, oe);
        vt && v.childNodes.push(vt);
      }
    }
    let ce = null;
    if (kh(r) && (ce = ve.shadowRoot(r)))
      for (const He of Array.from(ve.childNodes(ce))) {
        const vt = fr(He, oe);
        vt && (sn(ce) && (vt.isShadow = !0), v.childNodes.push(vt));
      }
  }
  const F = ve.parentNode(r);
  return F && nn(F) && sn(F) && (v.isShadow = !0), v.type === ge.Element && v.tagName === "iframe" && Ab(
    r,
    () => {
      const oe = r.contentDocument;
      if (oe && S) {
        const ce = fr(oe, {
          doc: oe,
          mirror: n,
          blockClass: i,
          blockSelector: s,
          needsMask: O,
          maskTextClass: o,
          maskTextSelector: a,
          skipChild: !1,
          inlineStylesheet: u,
          maskInputOptions: c,
          maskTextFn: d,
          maskInputFn: h,
          slimDOMOptions: f,
          dataURLOptions: m,
          inlineImages: p,
          inlineVideos: g,
          recordCanvas: y,
          preserveWhiteSpace: q,
          onSerialize: _,
          onIframeLoad: S,
          iframeLoadTimeout: C,
          onStylesheetLoad: R,
          stylesheetLoadTimeout: L,
          keepIframeSrcFn: k,
          privacySetting: G
        });
        ce && S(
          r,
          ce
        );
      }
    },
    C
  ), v.type === ge.Element && v.tagName === "link" && typeof v.attributes.rel == "string" && (v.attributes.rel === "stylesheet" || v.attributes.rel === "preload" && typeof v.attributes.href == "string" && Ah(v.attributes.href) === "css") && Ub(
    r,
    () => {
      if (R) {
        const oe = fr(r, {
          doc: t,
          mirror: n,
          blockClass: i,
          blockSelector: s,
          needsMask: O,
          maskTextClass: o,
          maskTextSelector: a,
          skipChild: !1,
          inlineStylesheet: u,
          maskInputOptions: c,
          maskTextFn: d,
          maskInputFn: h,
          slimDOMOptions: f,
          dataURLOptions: m,
          inlineImages: p,
          inlineVideos: g,
          recordCanvas: y,
          preserveWhiteSpace: q,
          onSerialize: _,
          onIframeLoad: S,
          iframeLoadTimeout: C,
          onStylesheetLoad: R,
          stylesheetLoadTimeout: L,
          keepIframeSrcFn: k,
          privacySetting: G
        });
        oe && R(
          r,
          oe
        );
      }
    },
    L
  ), v;
}
function Db(r, e) {
  const {
    mirror: t = new Mh(),
    blockClass: n = "highlight-block",
    blockSelector: i = null,
    maskTextClass: s = "highlight-mask",
    maskTextSelector: o = null,
    inlineStylesheet: a = !0,
    inlineImages: l = !1,
    inlineVideos: u = !1,
    recordCanvas: c = !1,
    maskAllInputs: d = !1,
    maskTextFn: h,
    maskInputFn: f,
    slimDOM: m = !1,
    dataURLOptions: p,
    preserveWhiteSpace: g,
    onSerialize: y,
    onIframeLoad: _,
    iframeLoadTimeout: S,
    onStylesheetLoad: C,
    stylesheetLoadTimeout: R,
    keepIframeSrcFn: L = () => !1,
    privacySetting: k = "default"
  } = e || {};
  return fr(r, {
    doc: r,
    mirror: t,
    blockClass: n,
    blockSelector: i,
    maskTextClass: s,
    maskTextSelector: o,
    skipChild: !1,
    inlineStylesheet: a,
    maskInputOptions: d === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : d === !1 ? {
      password: !0
    } : d,
    maskTextFn: h,
    maskInputFn: f,
    slimDOMOptions: m || m === "all" ? (
      // if true: set of sensible options that should not throw away any information
      {
        script: !0,
        comment: !0,
        headFavicon: !0,
        headWhitespace: !0,
        headMetaDescKeywords: m === "all",
        // destructive
        headMetaSocial: !0,
        headMetaRobots: !0,
        headMetaHttpEquiv: !0,
        headMetaAuthorship: !0,
        headMetaVerification: !0
      }
    ) : m || {},
    dataURLOptions: p,
    inlineImages: l,
    inlineVideos: u,
    recordCanvas: c,
    preserveWhiteSpace: g,
    onSerialize: y,
    onIframeLoad: _,
    iframeLoadTimeout: S,
    onStylesheetLoad: C,
    stylesheetLoadTimeout: R,
    keepIframeSrcFn: L,
    newlyAddedElement: !1,
    privacySetting: k
  });
}
function Kb(r) {
  if (r.__esModule) return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var Nl = { exports: {} }, A = String, Dh = function() {
  return { isColorSupported: !1, reset: A, bold: A, dim: A, italic: A, underline: A, inverse: A, hidden: A, strikethrough: A, black: A, red: A, green: A, yellow: A, blue: A, magenta: A, cyan: A, white: A, gray: A, bgBlack: A, bgRed: A, bgGreen: A, bgYellow: A, bgBlue: A, bgMagenta: A, bgCyan: A, bgWhite: A, blackBright: A, redBright: A, greenBright: A, yellowBright: A, blueBright: A, magentaBright: A, cyanBright: A, whiteBright: A, bgBlackBright: A, bgRedBright: A, bgGreenBright: A, bgYellowBright: A, bgBlueBright: A, bgMagentaBright: A, bgCyanBright: A, bgWhiteBright: A };
};
Nl.exports = Dh();
Nl.exports.createColors = Dh;
var zb = Nl.exports;
const jb = {}, Qb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jb
}, Symbol.toStringTag, { value: "Module" })), ze = /* @__PURE__ */ Kb(Qb);
let Yu = zb, Fu = ze, fa = class Kh extends Error {
  constructor(e, t, n, i, s, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, s && (this.file = s), i && (this.source = i), o && (this.plugin = o), typeof t != "undefined" && typeof n != "undefined" && (typeof t == "number" ? (this.line = t, this.column = n) : (this.line = t.line, this.column = t.column, this.endLine = n.line, this.endColumn = n.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, Kh);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = Yu.isColorSupported);
    let n = (c) => c, i = (c) => c, s = (c) => c;
    if (e) {
      let { bold: c, gray: d, red: h } = Yu.createColors(!0);
      i = (f) => c(h(f)), n = (f) => d(f), Fu && (s = (f) => Fu(f));
    }
    let o = t.split(/\r?\n/), a = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, o.length), u = String(l).length;
    return o.slice(a, l).map((c, d) => {
      let h = a + 1 + d, f = " " + (" " + h).slice(-u) + " | ";
      if (h === this.line) {
        if (c.length > 160) {
          let p = 20, g = Math.max(0, this.column - p), y = Math.max(
            this.column + p,
            this.endColumn + p
          ), _ = c.slice(g, y), S = n(f.replace(/\d/g, " ")) + c.slice(0, Math.min(this.column - 1, p - 1)).replace(/[^\t]/g, " ");
          return i(">") + n(f) + s(_) + `
 ` + S + i("^");
        }
        let m = n(f.replace(/\d/g, " ")) + c.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return i(">") + n(f) + s(c) + `
 ` + m + i("^");
      }
      return " " + n(f) + s(c);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var Vl = fa;
fa.default = fa;
const Hu = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function $b(r) {
  return r[0].toUpperCase() + r.slice(1);
}
let pa = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let n = "@" + e.name, i = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName != "undefined" ? n += e.raws.afterName : i && (n += " "), e.nodes)
      this.block(e, n + i);
    else {
      let s = (e.raws.between || "") + (t ? ";" : "");
      this.builder(n + i + s, e);
    }
  }
  beforeAfter(e, t) {
    let n;
    e.type === "decl" ? n = this.raw(e, null, "beforeDecl") : e.type === "comment" ? n = this.raw(e, null, "beforeComment") : t === "before" ? n = this.raw(e, null, "beforeRule") : n = this.raw(e, null, "beforeClose");
    let i = e.parent, s = 0;
    for (; i && i.type !== "root"; )
      s += 1, i = i.parent;
    if (n.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let a = 0; a < s; a++) n += o;
    }
    return n;
  }
  block(e, t) {
    let n = this.raw(e, "between", "beforeOpen");
    this.builder(t + n + "{", e, "start");
    let i;
    e.nodes && e.nodes.length ? (this.body(e), i = this.raw(e, "after")) : i = this.raw(e, "after", "emptyBody"), i && this.builder(i), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let n = this.raw(e, "semicolon");
    for (let i = 0; i < e.nodes.length; i++) {
      let s = e.nodes[i], o = this.raw(s, "before");
      o && this.builder(o), this.stringify(s, t !== i || n);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), n = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + n + "*/", e);
  }
  decl(e, t) {
    let n = this.raw(e, "between", "colon"), i = e.prop + n + this.rawValue(e, "value");
    e.important && (i += e.raws.important || " !important"), t && (i += ";"), this.builder(i, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, n) {
    let i;
    if (n || (n = t), t && (i = e.raws[t], typeof i != "undefined"))
      return i;
    let s = e.parent;
    if (n === "before" && (!s || s.type === "root" && s.first === e || s && s.type === "document"))
      return "";
    if (!s) return Hu[n];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[n] != "undefined")
      return o.rawCache[n];
    if (n === "before" || n === "after")
      return this.beforeAfter(e, n);
    {
      let a = "raw" + $b(n);
      this[a] ? i = this[a](o, e) : o.walk((l) => {
        if (i = l.raws[t], typeof i != "undefined") return !1;
      });
    }
    return typeof i == "undefined" && (i = Hu[n]), o.rawCache[n] = i, i;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((n) => {
      if (n.nodes && n.nodes.length > 0 && typeof n.raws.after != "undefined")
        return t = n.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let n;
    return e.walkComments((i) => {
      if (typeof i.raws.before != "undefined")
        return n = i.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), typeof n == "undefined" ? n = this.raw(t, null, "beforeDecl") : n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeDecl(e, t) {
    let n;
    return e.walkDecls((i) => {
      if (typeof i.raws.before != "undefined")
        return n = i.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), typeof n == "undefined" ? n = this.raw(t, null, "beforeRule") : n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((n) => {
      if (n.type !== "decl" && (t = n.raws.between, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((n) => {
      if (n.nodes && (n.parent !== e || e.first !== n) && typeof n.raws.before != "undefined")
        return t = n.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((n) => {
      if (typeof n.raws.between != "undefined")
        return t = n.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((n) => {
      if (n.nodes && n.nodes.length === 0 && (t = n.raws.after, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((n) => {
      let i = n.parent;
      if (i && i !== e && i.parent && i.parent === e && typeof n.raws.before != "undefined") {
        let s = n.raws.before.split(`
`);
        return t = s[s.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((n) => {
      if (n.nodes && n.nodes.length && n.last.type === "decl" && (t = n.raws.semicolon, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let n = e[t], i = e.raws[t];
    return i && i.value === n ? i.raw : n;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var zh = pa;
pa.default = pa;
let qb = zh;
function ma(r, e) {
  new qb(e).stringify(r);
}
var Cs = ma;
ma.default = ma;
var Vn = {};
Vn.isClean = Symbol("isClean");
Vn.my = Symbol("my");
let ev = Vl, tv = zh, rv = Cs, { isClean: Wr, my: nv } = Vn;
function ga(r, e) {
  let t = new r.constructor();
  for (let n in r) {
    if (!Object.prototype.hasOwnProperty.call(r, n) || n === "proxyCache") continue;
    let i = r[n], s = typeof i;
    n === "parent" && s === "object" ? e && (t[n] = e) : n === "source" ? t[n] = i : Array.isArray(i) ? t[n] = i.map((o) => ga(o, t)) : (s === "object" && i !== null && (i = ga(i)), t[n] = i);
  }
  return t;
}
function Xr(r, e) {
  if (e && typeof e.offset != "undefined")
    return e.offset;
  let t = 1, n = 1, i = 0;
  for (let s = 0; s < r.length; s++) {
    if (n === e.line && t === e.column) {
      i = s;
      break;
    }
    r[s] === `
` ? (t = 1, n += 1) : t += 1;
  }
  return i;
}
let ya = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[Wr] = !1, this[nv] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let n of e[t])
          typeof n.clone == "function" ? this.append(n.clone()) : this.append(n);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = ga(this);
    for (let n in e)
      t[n] = e[n];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: n, start: i } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: i.column, line: i.line },
        { column: n.column, line: n.line },
        t
      );
    }
    return new ev(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, n) {
        return e[t] === n || (e[t] = n, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Wr] = !0;
  }
  markDirty() {
    if (this[Wr]) {
      this[Wr] = !1;
      let e = this;
      for (; e = e.parent; )
        e[Wr] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let n = "document" in this.source.input ? this.source.input.document : this.source.input.css, s = n.slice(
        Xr(n, this.source.start),
        Xr(n, this.source.end)
      ).indexOf(e.word);
      s !== -1 && (t = this.positionInside(s));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, n = this.source.start.line, i = "document" in this.source.input ? this.source.input.document : this.source.input.css, s = Xr(i, this.source.start), o = s + e;
    for (let a = s; a < o; a++)
      i[a] === `
` ? (t = 1, n += 1) : t += 1;
    return { column: t, line: n };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, n = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = i.slice(
        Xr(i, this.source.start),
        Xr(i, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (t = this.positionInside(o), n = this.positionInside(
        o + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? n = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? n = this.positionInside(e.endIndex) : e.index && (n = this.positionInside(e.index + 1));
    return (n.line < t.line || n.line === t.line && n.column <= t.column) && (n = { column: t.column + 1, line: t.line }), { end: n, start: t };
  }
  raw(e, t) {
    return new tv().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, n = !1;
      for (let i of e)
        i === this ? n = !0 : n ? (this.parent.insertAfter(t, i), t = i) : this.parent.insertBefore(t, i);
      n || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let n = {}, i = t == null;
    t = t || /* @__PURE__ */ new Map();
    let s = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let a = this[o];
      if (Array.isArray(a))
        n[o] = a.map((l) => typeof l == "object" && l.toJSON ? l.toJSON(null, t) : l);
      else if (typeof a == "object" && a.toJSON)
        n[o] = a.toJSON(null, t);
      else if (o === "source") {
        let l = t.get(a.input);
        l == null && (l = s, t.set(a.input, s), s++), n[o] = {
          end: a.end,
          inputId: l,
          start: a.start
        };
      } else
        n[o] = a;
    }
    return i && (n.inputs = [...t.keys()].map((o) => o.toJSON())), n;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = rv) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (n) => {
      t += n;
    }), t;
  }
  warn(e, t, n) {
    let i = { node: this };
    for (let s in n) i[s] = n[s];
    return e.warn(t, i);
  }
};
var Zs = ya;
ya.default = ya;
let iv = Zs, ba = class extends iv {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var Gs = ba;
ba.default = ba;
let sv = Zs, va = class extends sv {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value != "undefined" && typeof e.value != "string" && (e = M(I({}, e), { value: String(e.value) })), super(e), this.type = "decl";
  }
};
var Ls = va;
va.default = va;
let jh = Gs, Qh = Ls, ov = Zs, { isClean: $h, my: qh } = Vn, xl, ef, tf, Ol;
function rf(r) {
  return r.map((e) => (e.nodes && (e.nodes = rf(e.nodes)), delete e.source, e));
}
function nf(r) {
  if (r[$h] = !1, r.proxyOf.nodes)
    for (let e of r.proxyOf.nodes)
      nf(e);
}
let mt = class sf extends ov {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let t of e) {
      let n = this.normalize(t, this.last);
      for (let i of n) this.proxyOf.nodes.push(i);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), n, i;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (n = this.indexes[t], i = e(this.proxyOf.nodes[n], n), i !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], i;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...n) => e[t](
          ...n.map((i) => typeof i == "function" ? (s, o) => i(s.toProxy(), o) : i)
        ) : t === "every" || t === "some" ? (n) => e[t](
          (i, ...s) => n(i.toProxy(), ...s)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((n) => n.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, n) {
        return e[t] === n || (e[t] = n, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let n = this.index(e), i = this.normalize(t, this.proxyOf.nodes[n]).reverse();
    n = this.index(e);
    for (let o of i) this.proxyOf.nodes.splice(n + 1, 0, o);
    let s;
    for (let o in this.indexes)
      s = this.indexes[o], n < s && (this.indexes[o] = s + i.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let n = this.index(e), i = n === 0 ? "prepend" : !1, s = this.normalize(
      t,
      this.proxyOf.nodes[n],
      i
    ).reverse();
    n = this.index(e);
    for (let a of s) this.proxyOf.nodes.splice(n, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], n <= o && (this.indexes[a] = o + s.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = rf(ef(e).nodes);
    else if (typeof e == "undefined")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value == "undefined")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new Qh(e)];
    } else if (e.selector || e.selectors)
      e = [new Ol(e)];
    else if (e.name)
      e = [new xl(e)];
    else if (e.text)
      e = [new jh(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((i) => (i[qh] || sf.rebuild(i), i = i.proxyOf, i.parent && i.parent.removeChild(i), i[$h] && nf(i), i.raws || (i.raws = {}), typeof i.raws.before == "undefined" && t && typeof t.raws.before != "undefined" && (i.raws.before = t.raws.before.replace(/\S/g, "")), i.parent = this.proxyOf, i));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let n = this.normalize(t, this.first, "prepend").reverse();
      for (let i of n) this.proxyOf.nodes.unshift(i);
      for (let i in this.indexes)
        this.indexes[i] = this.indexes[i] + n.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let n in this.indexes)
      t = this.indexes[n], t >= e && (this.indexes[n] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, n) {
    return n || (n = t, t = {}), this.walkDecls((i) => {
      t.props && !t.props.includes(i.prop) || t.fast && !i.value.includes(t.fast) || (i.value = i.value.replace(e, n));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, n) => {
      let i;
      try {
        i = e(t, n);
      } catch (s) {
        throw t.addToError(s);
      }
      return i !== !1 && t.walk && (i = t.walk(e)), i;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "atrule" && e.test(n.name))
        return t(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "atrule" && n.name === e)
        return t(n, i);
    }) : (t = e, this.walk((n, i) => {
      if (n.type === "atrule")
        return t(n, i);
    }));
  }
  walkComments(e) {
    return this.walk((t, n) => {
      if (t.type === "comment")
        return e(t, n);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "decl" && e.test(n.prop))
        return t(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "decl" && n.prop === e)
        return t(n, i);
    }) : (t = e, this.walk((n, i) => {
      if (n.type === "decl")
        return t(n, i);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "rule" && e.test(n.selector))
        return t(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "rule" && n.selector === e)
        return t(n, i);
    }) : (t = e, this.walk((n, i) => {
      if (n.type === "rule")
        return t(n, i);
    }));
  }
};
mt.registerParse = (r) => {
  ef = r;
};
mt.registerRule = (r) => {
  Ol = r;
};
mt.registerAtRule = (r) => {
  xl = r;
};
mt.registerRoot = (r) => {
  tf = r;
};
var Kt = mt;
mt.default = mt;
mt.rebuild = (r) => {
  r.type === "atrule" ? Object.setPrototypeOf(r, xl.prototype) : r.type === "rule" ? Object.setPrototypeOf(r, Ol.prototype) : r.type === "decl" ? Object.setPrototypeOf(r, Qh.prototype) : r.type === "comment" ? Object.setPrototypeOf(r, jh.prototype) : r.type === "root" && Object.setPrototypeOf(r, tf.prototype), r[qh] = !0, r.nodes && r.nodes.forEach((e) => {
    mt.rebuild(e);
  });
};
let of = Kt, $i = class extends of {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var Wl = $i;
$i.default = $i;
of.registerAtRule($i);
let av = Kt, af, lf, gn = class extends av {
  constructor(e) {
    super(I({ type: "document" }, e)), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new af(new lf(), this, e).stringify();
  }
};
gn.registerLazyResult = (r) => {
  af = r;
};
gn.registerProcessor = (r) => {
  lf = r;
};
var Xl = gn;
gn.default = gn;
let lv = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", uv = (r = 21) => {
  let e = "", t = r | 0;
  for (; t--; )
    e += lv[Math.random() * 64 | 0];
  return e;
};
var cv = { nanoid: uv };
let { existsSync: dv, readFileSync: hv } = ze, { dirname: lo, join: fv } = ze, { SourceMapConsumer: Ju, SourceMapGenerator: Bu } = ze;
function pv(r) {
  return Buffer ? Buffer.from(r, "base64").toString() : window.atob(r);
}
let Sa = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let n = t.map ? t.map.prev : void 0, i = this.loadMap(t.from, n);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = lo(this.mapFile)), i && (this.text = i);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new Ju(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, n = /^data:application\/json;base64,/, i = /^data:application\/json;charset=utf-?8,/, s = /^data:application\/json,/, o = e.match(i) || e.match(s);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let a = e.match(t) || e.match(n);
    if (a)
      return pv(e.substr(a[0].length));
    let l = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + l);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let n = e.lastIndexOf(t.pop()), i = e.indexOf("*/", n);
    n > -1 && i > -1 && (this.annotation = this.getAnnotationURL(e.substring(n, i)));
  }
  loadFile(e) {
    if (this.root = lo(e), dv(e))
      return this.mapFile = e, hv(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let n = t(e);
        if (n) {
          let i = this.loadFile(n);
          if (!i)
            throw new Error(
              "Unable to load previous source map: " + n.toString()
            );
          return i;
        }
      } else {
        if (t instanceof Ju)
          return Bu.fromSourceMap(t).toString();
        if (t instanceof Bu)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let n = this.annotation;
        return e && (n = fv(lo(e), n)), this.loadFile(n);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var uf = Sa;
Sa.default = Sa;
let { nanoid: mv } = cv, { isAbsolute: wa, resolve: _a } = ze, { SourceMapConsumer: gv, SourceMapGenerator: yv } = ze, { fileURLToPath: Du, pathToFileURL: zn } = ze, Ku = Vl, bv = uf, uo = ze, co = Symbol("fromOffsetCache"), vv = !!(gv && yv), zu = !!(_a && wa), qi = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e == "undefined" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!zu || /^\w+:\/\//.test(t.from) || wa(t.from) ? this.file = t.from : this.file = _a(t.from)), zu && vv) {
      let n = new bv(this.css, t);
      if (n.text) {
        this.map = n;
        let i = n.consumer().file;
        !this.file && i && (this.file = this.mapResolve(i));
      }
    }
    this.file || (this.id = "<input css " + mv(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, n, i = {}) {
    let s, o, a;
    if (t && typeof t == "object") {
      let u = t, c = n;
      if (typeof u.offset == "number") {
        let d = this.fromOffset(u.offset);
        t = d.line, n = d.col;
      } else
        t = u.line, n = u.column;
      if (typeof c.offset == "number") {
        let d = this.fromOffset(c.offset);
        o = d.line, s = d.col;
      } else
        o = c.line, s = c.column;
    } else if (!n) {
      let u = this.fromOffset(t);
      t = u.line, n = u.col;
    }
    let l = this.origin(t, n, o, s);
    return l ? a = new Ku(
      e,
      l.endLine === void 0 ? l.line : { column: l.column, line: l.line },
      l.endLine === void 0 ? l.column : { column: l.endColumn, line: l.endLine },
      l.source,
      l.file,
      i.plugin
    ) : a = new Ku(
      e,
      o === void 0 ? t : { column: n, line: t },
      o === void 0 ? n : { column: s, line: o },
      this.css,
      this.file,
      i.plugin
    ), a.input = { column: n, endColumn: s, endLine: o, line: t, source: this.css }, this.file && (zn && (a.input.url = zn(this.file).toString()), a.input.file = this.file), a;
  }
  fromOffset(e) {
    let t, n;
    if (this[co])
      n = this[co];
    else {
      let s = this.css.split(`
`);
      n = new Array(s.length);
      let o = 0;
      for (let a = 0, l = s.length; a < l; a++)
        n[a] = o, o += s[a].length + 1;
      this[co] = n;
    }
    t = n[n.length - 1];
    let i = 0;
    if (e >= t)
      i = n.length - 1;
    else {
      let s = n.length - 2, o;
      for (; i < s; )
        if (o = i + (s - i >> 1), e < n[o])
          s = o - 1;
        else if (e >= n[o + 1])
          i = o + 1;
        else {
          i = o;
          break;
        }
    }
    return {
      col: e - n[i] + 1,
      line: i + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : _a(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, n, i) {
    if (!this.map) return !1;
    let s = this.map.consumer(), o = s.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let a;
    typeof n == "number" && (a = s.originalPositionFor({ column: i, line: n }));
    let l;
    wa(o.source) ? l = zn(o.source) : l = new URL(
      o.source,
      this.map.consumer().sourceRoot || zn(this.map.mapFile)
    );
    let u = {
      column: o.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: o.line,
      url: l.toString()
    };
    if (l.protocol === "file:")
      if (Du)
        u.file = Du(l);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let c = s.sourceContentFor(o.source);
    return c && (u.source = c), u;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = I({}, this.map), e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var Ns = qi;
qi.default = qi;
uo && uo.registerInput && uo.registerInput(qi);
let cf = Kt, df, hf, Sr = class extends cf {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, n) {
    let i = super.normalize(e);
    if (t) {
      if (n === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let s of i)
          s.raws.before = t.raws.before;
    }
    return i;
  }
  removeChild(e, t) {
    let n = this.index(e);
    return !t && n === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[n].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new df(new hf(), this, e).stringify();
  }
};
Sr.registerLazyResult = (r) => {
  df = r;
};
Sr.registerProcessor = (r) => {
  hf = r;
};
var xn = Sr;
Sr.default = Sr;
cf.registerRoot(Sr);
let yn = {
  comma(r) {
    return yn.split(r, [","], !0);
  },
  space(r) {
    let e = [" ", `
`, "	"];
    return yn.split(r, e);
  },
  split(r, e, t) {
    let n = [], i = "", s = !1, o = 0, a = !1, l = "", u = !1;
    for (let c of r)
      u ? u = !1 : c === "\\" ? u = !0 : a ? c === l && (a = !1) : c === '"' || c === "'" ? (a = !0, l = c) : c === "(" ? o += 1 : c === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(c) && (s = !0), s ? (i !== "" && n.push(i.trim()), i = "", s = !1) : i += c;
    return (t || i !== "") && n.push(i.trim()), n;
  }
};
var ff = yn;
yn.default = yn;
let pf = Kt, Sv = ff, es = class extends pf {
  get selectors() {
    return Sv.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, n = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(n);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var kl = es;
es.default = es;
pf.registerRule(es);
let wv = Wl, _v = Gs, Rv = Ls, Iv = Ns, Tv = uf, Ev = xn, Cv = kl;
function bn(r, e) {
  if (Array.isArray(r)) return r.map((o) => bn(o));
  let i = r, { inputs: t } = i, n = Ze(i, ["inputs"]);
  if (t) {
    e = [];
    for (let o of t) {
      let a = M(I({}, o), { __proto__: Iv.prototype });
      a.map && (a.map = M(I({}, a.map), {
        __proto__: Tv.prototype
      })), e.push(a);
    }
  }
  if (n.nodes && (n.nodes = r.nodes.map((o) => bn(o, e))), n.source) {
    let s = n.source, { inputId: o } = s, a = Ze(s, ["inputId"]);
    n.source = a, o != null && (n.source.input = e[o]);
  }
  if (n.type === "root")
    return new Ev(n);
  if (n.type === "decl")
    return new Rv(n);
  if (n.type === "rule")
    return new Cv(n);
  if (n.type === "comment")
    return new _v(n);
  if (n.type === "atrule")
    return new wv(n);
  throw new Error("Unknown node type: " + r.type);
}
var Zv = bn;
bn.default = bn;
let { dirname: xi, relative: mf, resolve: gf, sep: yf } = ze, { SourceMapConsumer: bf, SourceMapGenerator: Oi } = ze, { pathToFileURL: ju } = ze, Gv = Ns, Lv = !!(bf && Oi), Nv = !!(xi && gf && mf && yf), Vv = class {
  constructor(e, t, n, i) {
    this.stringify = e, this.mapOpts = n.map || {}, this.root = t, this.opts = n, this.css = i, this.originalCSS = i, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), n = e.root || xi(e.file), i;
      this.mapOpts.sourcesContent === !1 ? (i = new bf(e.text), i.sourcesContent && (i.sourcesContent = null)) : i = e.consumer(), this.map.applySourceMap(i, t, this.toUrl(this.path(n)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), Nv && Lv && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = Oi.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new Oi({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Oi({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, n = "<no source>", i = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, s, o;
    this.stringify(this.root, (a, l, u) => {
      if (this.css += a, l && u !== "end" && (i.generated.line = e, i.generated.column = t - 1, l.source && l.source.start ? (i.source = this.sourcePath(l), i.original.line = l.source.start.line, i.original.column = l.source.start.column - 1, this.map.addMapping(i)) : (i.source = n, i.original.line = 1, i.original.column = 0, this.map.addMapping(i))), o = a.match(/\n/g), o ? (e += o.length, s = a.lastIndexOf(`
`), t = a.length - s) : t += a.length, l && u !== "start") {
        let c = l.parent || { raws: {} };
        (!(l.type === "decl" || l.type === "atrule" && !l.nodes) || l !== c.last || c.raws.semicolon) && (l.source && l.source.end ? (i.source = this.sourcePath(l), i.original.line = l.source.end.line, i.original.column = l.source.end.column - 1, i.generated.line = e, i.generated.column = t - 2, this.map.addMapping(i)) : (i.source = n, i.original.line = 1, i.original.column = 0, i.generated.line = e, i.generated.column = t - 1, this.map.addMapping(i)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline != "undefined")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e != "undefined" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let n = this.opts.to ? xi(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (n = xi(gf(n, this.mapOpts.annotation)));
    let i = mf(n, e);
    return this.memoizedPaths.set(e, i), i;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new Gv(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let n = t.source.input.from;
          if (n && !e[n]) {
            e[n] = !0;
            let i = this.usesFileUrls ? this.toFileUrl(n) : this.toUrl(this.path(n));
            this.map.setSourceContent(i, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (ju) {
      let n = ju(e).toString();
      return this.memoizedFileURLs.set(e, n), n;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    yf === "\\" && (e = e.replace(/\\/g, "/"));
    let n = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, n), n;
  }
};
var vf = Vv;
const ho = 39, Qu = 34, jn = 92, $u = 47, Qn = 10, kr = 32, $n = 12, qn = 9, ei = 13, xv = 91, Ov = 93, Wv = 40, Xv = 41, kv = 123, Pv = 125, Mv = 59, Av = 42, Uv = 58, Yv = 64, ti = /[\t\n\f\r "#'()/;[\\\]{}]/g, ri = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, Fv = /.[\r\n"'(/\\]/, qu = /[\da-f]/i;
var Hv = function(e, t = {}) {
  let n = e.css.valueOf(), i = t.ignoreErrors, s, o, a, l, u, c, d, h, f, m, p = n.length, g = 0, y = [], _ = [];
  function S() {
    return g;
  }
  function C(x) {
    throw e.error("Unclosed " + x, g);
  }
  function R() {
    return _.length === 0 && g >= p;
  }
  function L(x) {
    if (_.length) return _.pop();
    if (g >= p) return;
    let E = x ? x.ignoreUnclosed : !1;
    switch (s = n.charCodeAt(g), s) {
      case Qn:
      case kr:
      case qn:
      case ei:
      case $n: {
        l = g;
        do
          l += 1, s = n.charCodeAt(l);
        while (s === kr || s === Qn || s === qn || s === ei || s === $n);
        c = ["space", n.slice(g, l)], g = l - 1;
        break;
      }
      case xv:
      case Ov:
      case kv:
      case Pv:
      case Uv:
      case Mv:
      case Xv: {
        let G = String.fromCharCode(s);
        c = [G, G, g];
        break;
      }
      case Wv: {
        if (m = y.length ? y.pop()[1] : "", f = n.charCodeAt(g + 1), m === "url" && f !== ho && f !== Qu && f !== kr && f !== Qn && f !== qn && f !== $n && f !== ei) {
          l = g;
          do {
            if (d = !1, l = n.indexOf(")", l + 1), l === -1)
              if (i || E) {
                l = g;
                break;
              } else
                C("bracket");
            for (h = l; n.charCodeAt(h - 1) === jn; )
              h -= 1, d = !d;
          } while (d);
          c = ["brackets", n.slice(g, l + 1), g, l], g = l;
        } else
          l = n.indexOf(")", g + 1), o = n.slice(g, l + 1), l === -1 || Fv.test(o) ? c = ["(", "(", g] : (c = ["brackets", o, g, l], g = l);
        break;
      }
      case ho:
      case Qu: {
        u = s === ho ? "'" : '"', l = g;
        do {
          if (d = !1, l = n.indexOf(u, l + 1), l === -1)
            if (i || E) {
              l = g + 1;
              break;
            } else
              C("string");
          for (h = l; n.charCodeAt(h - 1) === jn; )
            h -= 1, d = !d;
        } while (d);
        c = ["string", n.slice(g, l + 1), g, l], g = l;
        break;
      }
      case Yv: {
        ti.lastIndex = g + 1, ti.test(n), ti.lastIndex === 0 ? l = n.length - 1 : l = ti.lastIndex - 2, c = ["at-word", n.slice(g, l + 1), g, l], g = l;
        break;
      }
      case jn: {
        for (l = g, a = !0; n.charCodeAt(l + 1) === jn; )
          l += 1, a = !a;
        if (s = n.charCodeAt(l + 1), a && s !== $u && s !== kr && s !== Qn && s !== qn && s !== ei && s !== $n && (l += 1, qu.test(n.charAt(l)))) {
          for (; qu.test(n.charAt(l + 1)); )
            l += 1;
          n.charCodeAt(l + 1) === kr && (l += 1);
        }
        c = ["word", n.slice(g, l + 1), g, l], g = l;
        break;
      }
      default: {
        s === $u && n.charCodeAt(g + 1) === Av ? (l = n.indexOf("*/", g + 2) + 1, l === 0 && (i || E ? l = n.length : C("comment")), c = ["comment", n.slice(g, l + 1), g, l], g = l) : (ri.lastIndex = g + 1, ri.test(n), ri.lastIndex === 0 ? l = n.length - 1 : l = ri.lastIndex - 2, c = ["word", n.slice(g, l + 1), g, l], y.push(c), g = l);
        break;
      }
    }
    return g++, c;
  }
  function k(x) {
    _.push(x);
  }
  return {
    back: k,
    endOfFile: R,
    nextToken: L,
    position: S
  };
};
let Jv = Wl, Bv = Gs, Dv = Ls, Kv = xn, ec = kl, zv = Hv;
const tc = {
  empty: !0,
  space: !0
};
function jv(r) {
  for (let e = r.length - 1; e >= 0; e--) {
    let t = r[e], n = t[3] || t[2];
    if (n) return n;
  }
}
let Qv = class {
  constructor(e) {
    this.input = e, this.root = new Kv(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new Jv();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let n, i, s, o = !1, a = !1, l = [], u = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), n = e[0], n === "(" || n === "[" ? u.push(n === "(" ? ")" : "]") : n === "{" && u.length > 0 ? u.push("}") : n === u[u.length - 1] && u.pop(), u.length === 0)
        if (n === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (n === "{") {
          a = !0;
          break;
        } else if (n === "}") {
          if (l.length > 0) {
            for (s = l.length - 1, i = l[s]; i && i[0] === "space"; )
              i = l[--s];
            i && (t.source.end = this.getPosition(i[3] || i[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          l.push(e);
      else
        l.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(l), l.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(l), this.raw(t, "params", l), o && (e = l[l.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let n = 0, i;
    for (let s = t - 1; s >= 0 && (i = e[s], !(i[0] !== "space" && (n += 1, n === 2))); s--)
      ;
    throw this.input.error(
      "Missed semicolon",
      i[0] === "word" ? i[3] + 1 : i[2]
    );
  }
  colon(e) {
    let t = 0, n, i, s;
    for (let [o, a] of e.entries()) {
      if (i = a, s = i[0], s === "(" && (t += 1), s === ")" && (t -= 1), t === 0 && s === ":")
        if (!n)
          this.doubleColon(i);
        else {
          if (n[0] === "word" && n[1] === "progid")
            continue;
          return o;
        }
      n = i;
    }
    return !1;
  }
  comment(e) {
    let t = new Bv();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let n = e[1].slice(2, -2);
    if (/^\s*$/.test(n))
      t.text = "", t.raws.left = n, t.raws.right = "";
    else {
      let i = n.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = i[2], t.raws.left = i[1], t.raws.right = i[3];
    }
  }
  createTokenizer() {
    this.tokenizer = zv(this.input);
  }
  decl(e, t) {
    let n = new Dv();
    this.init(n, e[0][2]);
    let i = e[e.length - 1];
    for (i[0] === ";" && (this.semicolon = !0, e.pop()), n.source.end = this.getPosition(
      i[3] || i[2] || jv(e)
    ), n.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), n.raws.before += e.shift()[1];
    for (n.source.start = this.getPosition(e[0][2]), n.prop = ""; e.length; ) {
      let u = e[0][0];
      if (u === ":" || u === "space" || u === "comment")
        break;
      n.prop += e.shift()[1];
    }
    n.raws.between = "";
    let s;
    for (; e.length; )
      if (s = e.shift(), s[0] === ":") {
        n.raws.between += s[1];
        break;
      } else
        s[0] === "word" && /\w/.test(s[1]) && this.unknownWord([s]), n.raws.between += s[1];
    (n.prop[0] === "_" || n.prop[0] === "*") && (n.raws.before += n.prop[0], n.prop = n.prop.slice(1));
    let o = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let u = e.length - 1; u >= 0; u--) {
      if (s = e[u], s[1].toLowerCase() === "!important") {
        n.important = !0;
        let c = this.stringFrom(e, u);
        c = this.spacesFromEnd(e) + c, c !== " !important" && (n.raws.important = c);
        break;
      } else if (s[1].toLowerCase() === "important") {
        let c = e.slice(0), d = "";
        for (let h = u; h > 0; h--) {
          let f = c[h][0];
          if (d.trim().startsWith("!") && f !== "space")
            break;
          d = c.pop()[1] + d;
        }
        d.trim().startsWith("!") && (n.important = !0, n.raws.important = d, e = c);
      }
      if (s[0] !== "space" && s[0] !== "comment")
        break;
    }
    e.some((u) => u[0] !== "space" && u[0] !== "comment") && (n.raws.between += o.map((u) => u[1]).join(""), o = []), this.raw(n, "value", o.concat(e), t), n.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new ec();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, n = null, i = !1, s = null, o = [], a = e[1].startsWith("--"), l = [], u = e;
    for (; u; ) {
      if (n = u[0], l.push(u), n === "(" || n === "[")
        s || (s = u), o.push(n === "(" ? ")" : "]");
      else if (a && i && n === "{")
        s || (s = u), o.push("}");
      else if (o.length === 0)
        if (n === ";")
          if (i) {
            this.decl(l, a);
            return;
          } else
            break;
        else if (n === "{") {
          this.rule(l);
          return;
        } else if (n === "}") {
          this.tokenizer.back(l.pop()), t = !0;
          break;
        } else n === ":" && (i = !0);
      else n === o[o.length - 1] && (o.pop(), o.length === 0 && (s = null));
      u = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(s), t && i) {
      if (!a)
        for (; l.length && (u = l[l.length - 1][0], !(u !== "space" && u !== "comment")); )
          this.tokenizer.back(l.pop());
      this.decl(l, a);
    } else
      this.unknownWord(l);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, n, i) {
    let s, o, a = n.length, l = "", u = !0, c, d;
    for (let h = 0; h < a; h += 1)
      s = n[h], o = s[0], o === "space" && h === a - 1 && !i ? u = !1 : o === "comment" ? (d = n[h - 1] ? n[h - 1][0] : "empty", c = n[h + 1] ? n[h + 1][0] : "empty", !tc[d] && !tc[c] ? l.slice(-1) === "," ? u = !1 : l += s[1] : u = !1) : l += s[1];
    if (!u) {
      let h = n.reduce((f, m) => f + m[1], "");
      e.raws[t] = { raw: h, value: l };
    }
    e[t] = l;
  }
  rule(e) {
    e.pop();
    let t = new ec();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, n = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      n = e.pop()[1] + n;
    return n;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, n = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      n += e.shift()[1];
    return n;
  }
  spacesFromEnd(e) {
    let t, n = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      n = e.pop()[1] + n;
    return n;
  }
  stringFrom(e, t) {
    let n = "";
    for (let i = t; i < e.length; i++)
      n += e[i][1];
    return e.splice(t, e.length - t), n;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var $v = Qv;
let qv = Kt, e0 = Ns, t0 = $v;
function ts(r, e) {
  let t = new e0(r, e), n = new t0(t);
  try {
    n.parse();
  } catch (i) {
    throw process.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return n.root;
}
var Pl = ts;
ts.default = ts;
qv.registerParse(ts);
let Ra = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let n = t.node.rangeBy(t);
      this.line = n.start.line, this.column = n.start.column, this.endLine = n.end.line, this.endColumn = n.end.column;
    }
    for (let n in t) this[n] = t[n];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var Sf = Ra;
Ra.default = Ra;
let r0 = Sf, Ia = class {
  get content() {
    return this.css;
  }
  constructor(e, t, n) {
    this.processor = e, this.messages = [], this.root = t, this.opts = n, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let n = new r0(e, t);
    return this.messages.push(n), n;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var Ml = Ia;
Ia.default = Ia;
let rc = {};
var wf = function(e) {
  rc[e] || (rc[e] = !0, typeof console != "undefined" && console.warn && console.warn(e));
};
let n0 = Kt, i0 = Xl, s0 = vf, o0 = Pl, nc = Ml, a0 = xn, l0 = Cs, { isClean: $e, my: u0 } = Vn, c0 = wf;
const d0 = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, h0 = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, f0 = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, wr = 0;
function Pr(r) {
  return typeof r == "object" && typeof r.then == "function";
}
function _f(r) {
  let e = !1, t = d0[r.type];
  return r.type === "decl" ? e = r.prop.toLowerCase() : r.type === "atrule" && (e = r.name.toLowerCase()), e && r.append ? [
    t,
    t + "-" + e,
    wr,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : r.append ? [t, wr, t + "Exit"] : [t, t + "Exit"];
}
function ic(r) {
  let e;
  return r.type === "document" ? e = ["Document", wr, "DocumentExit"] : r.type === "root" ? e = ["Root", wr, "RootExit"] : e = _f(r), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: r,
    visitorIndex: 0,
    visitors: []
  };
}
function Ta(r) {
  return r[$e] = !1, r.nodes && r.nodes.forEach((e) => Ta(e)), r;
}
let Ea = {}, _r = class Rf {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, t, n) {
    this.stringified = !1, this.processed = !1;
    let i;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      i = Ta(t);
    else if (t instanceof Rf || t instanceof nc)
      i = Ta(t.root), t.map && (typeof n.map == "undefined" && (n.map = {}), n.map.inline || (n.map.inline = !1), n.map.prev = t.map);
    else {
      let s = o0;
      n.syntax && (s = n.syntax.parse), n.parser && (s = n.parser), s.parse && (s = s.parse);
      try {
        i = s(t, n);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      i && !i[u0] && n0.rebuild(i);
    }
    this.result = new nc(e, i, n), this.helpers = M(I({}, Ea), { postcss: Ea, result: this.result }), this.plugins = this.processor.plugins.map((s) => typeof s == "object" && s.prepare ? I(I({}, s), s.prepare(this.result)) : s);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let n = this.result.lastPlugin;
    try {
      if (t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = n.postcssPlugin, e.setMessage();
      else if (n.postcssVersion && process.env.NODE_ENV !== "production") {
        let i = n.postcssPlugin, s = n.postcssVersion, o = this.result.processor.version, a = s.split("."), l = o.split(".");
        (a[0] !== l[0] || parseInt(a[1]) > parseInt(l[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + o + ", but " + i + " uses " + s + ". Perhaps this is the source of the error below."
        );
      }
    } catch (i) {
      console && console.error && console.error(i);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, n, i) => {
      this.listeners[n] || (this.listeners[n] = []), this.listeners[n].push([t, i]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let n in t) {
          if (!h0[n] && /^[A-Z]/.test(n))
            throw new Error(
              `Unknown event ${n} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!f0[n])
            if (typeof t[n] == "object")
              for (let i in t[n])
                i === "*" ? e(t, n, t[n][i]) : e(
                  t,
                  n + "-" + i.toLowerCase(),
                  t[n][i]
                );
            else typeof t[n] == "function" && e(t, n, t[n]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  runAsync() {
    return $(this, null, function* () {
      this.plugin = 0;
      for (let e = 0; e < this.plugins.length; e++) {
        let t = this.plugins[e], n = this.runOnRoot(t);
        if (Pr(n))
          try {
            yield n;
          } catch (i) {
            throw this.handleError(i);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let e = this.result.root;
        for (; !e[$e]; ) {
          e[$e] = !0;
          let t = [ic(e)];
          for (; t.length > 0; ) {
            let n = this.visitTick(t);
            if (Pr(n))
              try {
                yield n;
              } catch (i) {
                let s = t[t.length - 1].node;
                throw this.handleError(i, s);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [t, n] of this.listeners.OnceExit) {
            this.result.lastPlugin = t;
            try {
              if (e.type === "document") {
                let i = e.nodes.map(
                  (s) => n(s, this.helpers)
                );
                yield Promise.all(i);
              } else
                yield n(e, this.helpers);
            } catch (i) {
              throw this.handleError(i);
            }
          }
      }
      return this.processed = !0, this.stringify();
    });
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (n) => e.Once(n, this.helpers)
          );
          return Pr(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = l0;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let i = new s0(t, this.result.root, this.result.opts).generate();
    return this.result.css = i[0], this.result.map = i[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (Pr(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[$e]; )
        e[$e] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || c0(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [n, i] of e) {
      this.result.lastPlugin = n;
      let s;
      try {
        s = i(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (Pr(s))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: n, visitors: i } = t;
    if (n.type !== "root" && n.type !== "document" && !n.parent) {
      e.pop();
      return;
    }
    if (i.length > 0 && t.visitorIndex < i.length) {
      let [o, a] = i[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === i.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return a(n.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, n);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, a;
      for (; a = n.nodes[n.indexes[o]]; )
        if (n.indexes[o] += 1, !a[$e]) {
          a[$e] = !0, e.push(ic(a));
          return;
        }
      t.iterator = 0, delete n.indexes[o];
    }
    let s = t.events;
    for (; t.eventIndex < s.length; ) {
      let o = s[t.eventIndex];
      if (t.eventIndex += 1, o === wr) {
        n.nodes && n.nodes.length && (n[$e] = !0, t.iterator = n.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[$e] = !0;
    let t = _f(e);
    for (let n of t)
      if (n === wr)
        e.nodes && e.each((i) => {
          i[$e] || this.walkSync(i);
        });
      else {
        let i = this.listeners[n];
        if (i && this.visitSync(i, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
_r.registerPostcss = (r) => {
  Ea = r;
};
var If = _r;
_r.default = _r;
a0.registerLazyResult(_r);
i0.registerLazyResult(_r);
let p0 = vf, m0 = Pl;
const g0 = Ml;
let y0 = Cs, b0 = wf, Ca = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = m0;
    try {
      e = t(this._css, this._opts);
    } catch (n) {
      this.error = n;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, n) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = n, this._map = void 0;
    let i, s = y0;
    this.result = new g0(this._processor, i, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let a = new p0(s, i, this._opts, t);
    if (a.isMap()) {
      let [l, u] = a.generate();
      l && (this.result.css = l), u && (this.result.map = u);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || b0(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var v0 = Ca;
Ca.default = Ca;
let S0 = Xl, w0 = If, _0 = v0, R0 = xn, vn = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let n of e)
      if (n.postcss === !0 ? n = n() : n.postcss && (n = n.postcss), typeof n == "object" && Array.isArray(n.plugins))
        t = t.concat(n.plugins);
      else if (typeof n == "object" && n.postcssPlugin)
        t.push(n);
      else if (typeof n == "function")
        t.push(n);
      else if (typeof n == "object" && (n.parse || n.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(n + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new _0(this, e, t) : new w0(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var I0 = vn;
vn.default = vn;
R0.registerProcessor(vn);
S0.registerProcessor(vn);
let Tf = Wl, Ef = Gs, T0 = Kt, E0 = Vl, Cf = Ls, Zf = Xl, C0 = Zv, Z0 = Ns, G0 = If, L0 = ff, N0 = Zs, V0 = Pl, Al = I0, x0 = Ml, Gf = xn, Lf = kl, O0 = Cs, W0 = Sf;
function ie(...r) {
  return r.length === 1 && Array.isArray(r[0]) && (r = r[0]), new Al(r);
}
ie.plugin = function(e, t) {
  let n = !1;
  function i(...o) {
    console && console.warn && !n && (n = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...o);
    return a.postcssPlugin = e, a.postcssVersion = new Al().version, a;
  }
  let s;
  return Object.defineProperty(i, "postcss", {
    get() {
      return s || (s = i()), s;
    }
  }), i.process = function(o, a, l) {
    return ie([i(l)]).process(o, a);
  }, i;
};
ie.stringify = O0;
ie.parse = V0;
ie.fromJSON = C0;
ie.list = L0;
ie.comment = (r) => new Ef(r);
ie.atRule = (r) => new Tf(r);
ie.decl = (r) => new Cf(r);
ie.rule = (r) => new Lf(r);
ie.root = (r) => new Gf(r);
ie.document = (r) => new Zf(r);
ie.CssSyntaxError = E0;
ie.Declaration = Cf;
ie.Container = T0;
ie.Processor = Al;
ie.Document = Zf;
ie.Comment = Ef;
ie.Warning = W0;
ie.AtRule = Tf;
ie.Result = x0;
ie.Input = Z0;
ie.Rule = Lf;
ie.Root = Gf;
ie.Node = N0;
G0.registerPostcss(ie);
ie.default = ie;
var X0 = Object.defineProperty, k0 = (r, e, t) => e in r ? X0(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, We = (r, e, t) => k0(r, typeof e != "symbol" ? e + "" : e, t);
function P0(r) {
  if (r.__esModule) return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var Ul = { exports: {} }, U = String, Nf = function() {
  return { isColorSupported: !1, reset: U, bold: U, dim: U, italic: U, underline: U, inverse: U, hidden: U, strikethrough: U, black: U, red: U, green: U, yellow: U, blue: U, magenta: U, cyan: U, white: U, gray: U, bgBlack: U, bgRed: U, bgGreen: U, bgYellow: U, bgBlue: U, bgMagenta: U, bgCyan: U, bgWhite: U, blackBright: U, redBright: U, greenBright: U, yellowBright: U, blueBright: U, magentaBright: U, cyanBright: U, whiteBright: U, bgBlackBright: U, bgRedBright: U, bgGreenBright: U, bgYellowBright: U, bgBlueBright: U, bgMagentaBright: U, bgCyanBright: U, bgWhiteBright: U };
};
Ul.exports = Nf();
Ul.exports.createColors = Nf;
var M0 = Ul.exports;
const A0 = {}, U0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A0
}, Symbol.toStringTag, { value: "Module" })), je = /* @__PURE__ */ P0(U0);
let sc = M0, oc = je, Za = class Vf extends Error {
  constructor(e, t, n, i, s, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, s && (this.file = s), i && (this.source = i), o && (this.plugin = o), typeof t != "undefined" && typeof n != "undefined" && (typeof t == "number" ? (this.line = t, this.column = n) : (this.line = t.line, this.column = t.column, this.endLine = n.line, this.endColumn = n.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, Vf);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = sc.isColorSupported);
    let n = (c) => c, i = (c) => c, s = (c) => c;
    if (e) {
      let { bold: c, gray: d, red: h } = sc.createColors(!0);
      i = (f) => c(h(f)), n = (f) => d(f), oc && (s = (f) => oc(f));
    }
    let o = t.split(/\r?\n/), a = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, o.length), u = String(l).length;
    return o.slice(a, l).map((c, d) => {
      let h = a + 1 + d, f = " " + (" " + h).slice(-u) + " | ";
      if (h === this.line) {
        if (c.length > 160) {
          let p = 20, g = Math.max(0, this.column - p), y = Math.max(
            this.column + p,
            this.endColumn + p
          ), _ = c.slice(g, y), S = n(f.replace(/\d/g, " ")) + c.slice(0, Math.min(this.column - 1, p - 1)).replace(/[^\t]/g, " ");
          return i(">") + n(f) + s(_) + `
 ` + S + i("^");
        }
        let m = n(f.replace(/\d/g, " ")) + c.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return i(">") + n(f) + s(c) + `
 ` + m + i("^");
      }
      return " " + n(f) + s(c);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var Yl = Za;
Za.default = Za;
const ac = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function Y0(r) {
  return r[0].toUpperCase() + r.slice(1);
}
let Ga = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let n = "@" + e.name, i = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName != "undefined" ? n += e.raws.afterName : i && (n += " "), e.nodes)
      this.block(e, n + i);
    else {
      let s = (e.raws.between || "") + (t ? ";" : "");
      this.builder(n + i + s, e);
    }
  }
  beforeAfter(e, t) {
    let n;
    e.type === "decl" ? n = this.raw(e, null, "beforeDecl") : e.type === "comment" ? n = this.raw(e, null, "beforeComment") : t === "before" ? n = this.raw(e, null, "beforeRule") : n = this.raw(e, null, "beforeClose");
    let i = e.parent, s = 0;
    for (; i && i.type !== "root"; )
      s += 1, i = i.parent;
    if (n.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let a = 0; a < s; a++) n += o;
    }
    return n;
  }
  block(e, t) {
    let n = this.raw(e, "between", "beforeOpen");
    this.builder(t + n + "{", e, "start");
    let i;
    e.nodes && e.nodes.length ? (this.body(e), i = this.raw(e, "after")) : i = this.raw(e, "after", "emptyBody"), i && this.builder(i), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let n = this.raw(e, "semicolon");
    for (let i = 0; i < e.nodes.length; i++) {
      let s = e.nodes[i], o = this.raw(s, "before");
      o && this.builder(o), this.stringify(s, t !== i || n);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), n = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + n + "*/", e);
  }
  decl(e, t) {
    let n = this.raw(e, "between", "colon"), i = e.prop + n + this.rawValue(e, "value");
    e.important && (i += e.raws.important || " !important"), t && (i += ";"), this.builder(i, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, n) {
    let i;
    if (n || (n = t), t && (i = e.raws[t], typeof i != "undefined"))
      return i;
    let s = e.parent;
    if (n === "before" && (!s || s.type === "root" && s.first === e || s && s.type === "document"))
      return "";
    if (!s) return ac[n];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[n] != "undefined")
      return o.rawCache[n];
    if (n === "before" || n === "after")
      return this.beforeAfter(e, n);
    {
      let a = "raw" + Y0(n);
      this[a] ? i = this[a](o, e) : o.walk((l) => {
        if (i = l.raws[t], typeof i != "undefined") return !1;
      });
    }
    return typeof i == "undefined" && (i = ac[n]), o.rawCache[n] = i, i;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((n) => {
      if (n.nodes && n.nodes.length > 0 && typeof n.raws.after != "undefined")
        return t = n.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let n;
    return e.walkComments((i) => {
      if (typeof i.raws.before != "undefined")
        return n = i.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), typeof n == "undefined" ? n = this.raw(t, null, "beforeDecl") : n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeDecl(e, t) {
    let n;
    return e.walkDecls((i) => {
      if (typeof i.raws.before != "undefined")
        return n = i.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
    }), typeof n == "undefined" ? n = this.raw(t, null, "beforeRule") : n && (n = n.replace(/\S/g, "")), n;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((n) => {
      if (n.type !== "decl" && (t = n.raws.between, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((n) => {
      if (n.nodes && (n.parent !== e || e.first !== n) && typeof n.raws.before != "undefined")
        return t = n.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((n) => {
      if (typeof n.raws.between != "undefined")
        return t = n.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((n) => {
      if (n.nodes && n.nodes.length === 0 && (t = n.raws.after, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((n) => {
      let i = n.parent;
      if (i && i !== e && i.parent && i.parent === e && typeof n.raws.before != "undefined") {
        let s = n.raws.before.split(`
`);
        return t = s[s.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((n) => {
      if (n.nodes && n.nodes.length && n.last.type === "decl" && (t = n.raws.semicolon, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let n = e[t], i = e.raws[t];
    return i && i.value === n ? i.raw : n;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var xf = Ga;
Ga.default = Ga;
let F0 = xf;
function La(r, e) {
  new F0(e).stringify(r);
}
var Vs = La;
La.default = La;
var On = {};
On.isClean = Symbol("isClean");
On.my = Symbol("my");
let H0 = Yl, J0 = xf, B0 = Vs, { isClean: Mr, my: D0 } = On;
function Na(r, e) {
  let t = new r.constructor();
  for (let n in r) {
    if (!Object.prototype.hasOwnProperty.call(r, n) || n === "proxyCache") continue;
    let i = r[n], s = typeof i;
    n === "parent" && s === "object" ? e && (t[n] = e) : n === "source" ? t[n] = i : Array.isArray(i) ? t[n] = i.map((o) => Na(o, t)) : (s === "object" && i !== null && (i = Na(i)), t[n] = i);
  }
  return t;
}
function Ar(r, e) {
  if (e && typeof e.offset != "undefined")
    return e.offset;
  let t = 1, n = 1, i = 0;
  for (let s = 0; s < r.length; s++) {
    if (n === e.line && t === e.column) {
      i = s;
      break;
    }
    r[s] === `
` ? (t = 1, n += 1) : t += 1;
  }
  return i;
}
let Va = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[Mr] = !1, this[D0] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let n of e[t])
          typeof n.clone == "function" ? this.append(n.clone()) : this.append(n);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = Na(this);
    for (let n in e)
      t[n] = e[n];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: n, start: i } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: i.column, line: i.line },
        { column: n.column, line: n.line },
        t
      );
    }
    return new H0(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, n) {
        return e[t] === n || (e[t] = n, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Mr] = !0;
  }
  markDirty() {
    if (this[Mr]) {
      this[Mr] = !1;
      let e = this;
      for (; e = e.parent; )
        e[Mr] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let n = "document" in this.source.input ? this.source.input.document : this.source.input.css, s = n.slice(
        Ar(n, this.source.start),
        Ar(n, this.source.end)
      ).indexOf(e.word);
      s !== -1 && (t = this.positionInside(s));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, n = this.source.start.line, i = "document" in this.source.input ? this.source.input.document : this.source.input.css, s = Ar(i, this.source.start), o = s + e;
    for (let a = s; a < o; a++)
      i[a] === `
` ? (t = 1, n += 1) : t += 1;
    return { column: t, line: n };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, n = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = i.slice(
        Ar(i, this.source.start),
        Ar(i, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (t = this.positionInside(o), n = this.positionInside(
        o + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? n = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? n = this.positionInside(e.endIndex) : e.index && (n = this.positionInside(e.index + 1));
    return (n.line < t.line || n.line === t.line && n.column <= t.column) && (n = { column: t.column + 1, line: t.line }), { end: n, start: t };
  }
  raw(e, t) {
    return new J0().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, n = !1;
      for (let i of e)
        i === this ? n = !0 : n ? (this.parent.insertAfter(t, i), t = i) : this.parent.insertBefore(t, i);
      n || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let n = {}, i = t == null;
    t = t || /* @__PURE__ */ new Map();
    let s = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let a = this[o];
      if (Array.isArray(a))
        n[o] = a.map((l) => typeof l == "object" && l.toJSON ? l.toJSON(null, t) : l);
      else if (typeof a == "object" && a.toJSON)
        n[o] = a.toJSON(null, t);
      else if (o === "source") {
        let l = t.get(a.input);
        l == null && (l = s, t.set(a.input, s), s++), n[o] = {
          end: a.end,
          inputId: l,
          start: a.start
        };
      } else
        n[o] = a;
    }
    return i && (n.inputs = [...t.keys()].map((o) => o.toJSON())), n;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = B0) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (n) => {
      t += n;
    }), t;
  }
  warn(e, t, n) {
    let i = { node: this };
    for (let s in n) i[s] = n[s];
    return e.warn(t, i);
  }
};
var xs = Va;
Va.default = Va;
let K0 = xs, xa = class extends K0 {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var Os = xa;
xa.default = xa;
let z0 = xs, Oa = class extends z0 {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value != "undefined" && typeof e.value != "string" && (e = M(I({}, e), { value: String(e.value) })), super(e), this.type = "decl";
  }
};
var Ws = Oa;
Oa.default = Oa;
let Of = Os, Wf = Ws, j0 = xs, { isClean: Xf, my: kf } = On, Fl, Pf, Mf, Hl;
function Af(r) {
  return r.map((e) => (e.nodes && (e.nodes = Af(e.nodes)), delete e.source, e));
}
function Uf(r) {
  if (r[Xf] = !1, r.proxyOf.nodes)
    for (let e of r.proxyOf.nodes)
      Uf(e);
}
let gt = class Yf extends j0 {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let t of e) {
      let n = this.normalize(t, this.last);
      for (let i of n) this.proxyOf.nodes.push(i);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), n, i;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (n = this.indexes[t], i = e(this.proxyOf.nodes[n], n), i !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], i;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...n) => e[t](
          ...n.map((i) => typeof i == "function" ? (s, o) => i(s.toProxy(), o) : i)
        ) : t === "every" || t === "some" ? (n) => e[t](
          (i, ...s) => n(i.toProxy(), ...s)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((n) => n.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, n) {
        return e[t] === n || (e[t] = n, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let n = this.index(e), i = this.normalize(t, this.proxyOf.nodes[n]).reverse();
    n = this.index(e);
    for (let o of i) this.proxyOf.nodes.splice(n + 1, 0, o);
    let s;
    for (let o in this.indexes)
      s = this.indexes[o], n < s && (this.indexes[o] = s + i.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let n = this.index(e), i = n === 0 ? "prepend" : !1, s = this.normalize(
      t,
      this.proxyOf.nodes[n],
      i
    ).reverse();
    n = this.index(e);
    for (let a of s) this.proxyOf.nodes.splice(n, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], n <= o && (this.indexes[a] = o + s.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = Af(Pf(e).nodes);
    else if (typeof e == "undefined")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value == "undefined")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new Wf(e)];
    } else if (e.selector || e.selectors)
      e = [new Hl(e)];
    else if (e.name)
      e = [new Fl(e)];
    else if (e.text)
      e = [new Of(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((i) => (i[kf] || Yf.rebuild(i), i = i.proxyOf, i.parent && i.parent.removeChild(i), i[Xf] && Uf(i), i.raws || (i.raws = {}), typeof i.raws.before == "undefined" && t && typeof t.raws.before != "undefined" && (i.raws.before = t.raws.before.replace(/\S/g, "")), i.parent = this.proxyOf, i));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let n = this.normalize(t, this.first, "prepend").reverse();
      for (let i of n) this.proxyOf.nodes.unshift(i);
      for (let i in this.indexes)
        this.indexes[i] = this.indexes[i] + n.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let n in this.indexes)
      t = this.indexes[n], t >= e && (this.indexes[n] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, n) {
    return n || (n = t, t = {}), this.walkDecls((i) => {
      t.props && !t.props.includes(i.prop) || t.fast && !i.value.includes(t.fast) || (i.value = i.value.replace(e, n));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, n) => {
      let i;
      try {
        i = e(t, n);
      } catch (s) {
        throw t.addToError(s);
      }
      return i !== !1 && t.walk && (i = t.walk(e)), i;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "atrule" && e.test(n.name))
        return t(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "atrule" && n.name === e)
        return t(n, i);
    }) : (t = e, this.walk((n, i) => {
      if (n.type === "atrule")
        return t(n, i);
    }));
  }
  walkComments(e) {
    return this.walk((t, n) => {
      if (t.type === "comment")
        return e(t, n);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "decl" && e.test(n.prop))
        return t(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "decl" && n.prop === e)
        return t(n, i);
    }) : (t = e, this.walk((n, i) => {
      if (n.type === "decl")
        return t(n, i);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((n, i) => {
      if (n.type === "rule" && e.test(n.selector))
        return t(n, i);
    }) : this.walk((n, i) => {
      if (n.type === "rule" && n.selector === e)
        return t(n, i);
    }) : (t = e, this.walk((n, i) => {
      if (n.type === "rule")
        return t(n, i);
    }));
  }
};
gt.registerParse = (r) => {
  Pf = r;
};
gt.registerRule = (r) => {
  Hl = r;
};
gt.registerAtRule = (r) => {
  Fl = r;
};
gt.registerRoot = (r) => {
  Mf = r;
};
var zt = gt;
gt.default = gt;
gt.rebuild = (r) => {
  r.type === "atrule" ? Object.setPrototypeOf(r, Fl.prototype) : r.type === "rule" ? Object.setPrototypeOf(r, Hl.prototype) : r.type === "decl" ? Object.setPrototypeOf(r, Wf.prototype) : r.type === "comment" ? Object.setPrototypeOf(r, Of.prototype) : r.type === "root" && Object.setPrototypeOf(r, Mf.prototype), r[kf] = !0, r.nodes && r.nodes.forEach((e) => {
    gt.rebuild(e);
  });
};
let Ff = zt, rs = class extends Ff {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var Jl = rs;
rs.default = rs;
Ff.registerAtRule(rs);
let Q0 = zt, Hf, Jf, Sn = class extends Q0 {
  constructor(e) {
    super(I({ type: "document" }, e)), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new Hf(new Jf(), this, e).stringify();
  }
};
Sn.registerLazyResult = (r) => {
  Hf = r;
};
Sn.registerProcessor = (r) => {
  Jf = r;
};
var Bl = Sn;
Sn.default = Sn;
let $0 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", q0 = (r = 21) => {
  let e = "", t = r | 0;
  for (; t--; )
    e += $0[Math.random() * 64 | 0];
  return e;
};
var eS = { nanoid: q0 };
let { existsSync: tS, readFileSync: rS } = je, { dirname: fo, join: nS } = je, { SourceMapConsumer: lc, SourceMapGenerator: uc } = je;
function iS(r) {
  return Buffer ? Buffer.from(r, "base64").toString() : window.atob(r);
}
let Wa = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let n = t.map ? t.map.prev : void 0, i = this.loadMap(t.from, n);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = fo(this.mapFile)), i && (this.text = i);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new lc(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, n = /^data:application\/json;base64,/, i = /^data:application\/json;charset=utf-?8,/, s = /^data:application\/json,/, o = e.match(i) || e.match(s);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let a = e.match(t) || e.match(n);
    if (a)
      return iS(e.substr(a[0].length));
    let l = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + l);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let n = e.lastIndexOf(t.pop()), i = e.indexOf("*/", n);
    n > -1 && i > -1 && (this.annotation = this.getAnnotationURL(e.substring(n, i)));
  }
  loadFile(e) {
    if (this.root = fo(e), tS(e))
      return this.mapFile = e, rS(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let n = t(e);
        if (n) {
          let i = this.loadFile(n);
          if (!i)
            throw new Error(
              "Unable to load previous source map: " + n.toString()
            );
          return i;
        }
      } else {
        if (t instanceof lc)
          return uc.fromSourceMap(t).toString();
        if (t instanceof uc)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let n = this.annotation;
        return e && (n = nS(fo(e), n)), this.loadFile(n);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Bf = Wa;
Wa.default = Wa;
let { nanoid: sS } = eS, { isAbsolute: Xa, resolve: ka } = je, { SourceMapConsumer: oS, SourceMapGenerator: aS } = je, { fileURLToPath: cc, pathToFileURL: ni } = je, dc = Yl, lS = Bf, po = je, mo = Symbol("fromOffsetCache"), uS = !!(oS && aS), hc = !!(ka && Xa), ns = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e == "undefined" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!hc || /^\w+:\/\//.test(t.from) || Xa(t.from) ? this.file = t.from : this.file = ka(t.from)), hc && uS) {
      let n = new lS(this.css, t);
      if (n.text) {
        this.map = n;
        let i = n.consumer().file;
        !this.file && i && (this.file = this.mapResolve(i));
      }
    }
    this.file || (this.id = "<input css " + sS(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, n, i = {}) {
    let s, o, a;
    if (t && typeof t == "object") {
      let u = t, c = n;
      if (typeof u.offset == "number") {
        let d = this.fromOffset(u.offset);
        t = d.line, n = d.col;
      } else
        t = u.line, n = u.column;
      if (typeof c.offset == "number") {
        let d = this.fromOffset(c.offset);
        o = d.line, s = d.col;
      } else
        o = c.line, s = c.column;
    } else if (!n) {
      let u = this.fromOffset(t);
      t = u.line, n = u.col;
    }
    let l = this.origin(t, n, o, s);
    return l ? a = new dc(
      e,
      l.endLine === void 0 ? l.line : { column: l.column, line: l.line },
      l.endLine === void 0 ? l.column : { column: l.endColumn, line: l.endLine },
      l.source,
      l.file,
      i.plugin
    ) : a = new dc(
      e,
      o === void 0 ? t : { column: n, line: t },
      o === void 0 ? n : { column: s, line: o },
      this.css,
      this.file,
      i.plugin
    ), a.input = { column: n, endColumn: s, endLine: o, line: t, source: this.css }, this.file && (ni && (a.input.url = ni(this.file).toString()), a.input.file = this.file), a;
  }
  fromOffset(e) {
    let t, n;
    if (this[mo])
      n = this[mo];
    else {
      let s = this.css.split(`
`);
      n = new Array(s.length);
      let o = 0;
      for (let a = 0, l = s.length; a < l; a++)
        n[a] = o, o += s[a].length + 1;
      this[mo] = n;
    }
    t = n[n.length - 1];
    let i = 0;
    if (e >= t)
      i = n.length - 1;
    else {
      let s = n.length - 2, o;
      for (; i < s; )
        if (o = i + (s - i >> 1), e < n[o])
          s = o - 1;
        else if (e >= n[o + 1])
          i = o + 1;
        else {
          i = o;
          break;
        }
    }
    return {
      col: e - n[i] + 1,
      line: i + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : ka(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, n, i) {
    if (!this.map) return !1;
    let s = this.map.consumer(), o = s.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let a;
    typeof n == "number" && (a = s.originalPositionFor({ column: i, line: n }));
    let l;
    Xa(o.source) ? l = ni(o.source) : l = new URL(
      o.source,
      this.map.consumer().sourceRoot || ni(this.map.mapFile)
    );
    let u = {
      column: o.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: o.line,
      url: l.toString()
    };
    if (l.protocol === "file:")
      if (cc)
        u.file = cc(l);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let c = s.sourceContentFor(o.source);
    return c && (u.source = c), u;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = I({}, this.map), e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var Xs = ns;
ns.default = ns;
po && po.registerInput && po.registerInput(ns);
let Df = zt, Kf, zf, Rr = class extends Df {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, n) {
    let i = super.normalize(e);
    if (t) {
      if (n === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let s of i)
          s.raws.before = t.raws.before;
    }
    return i;
  }
  removeChild(e, t) {
    let n = this.index(e);
    return !t && n === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[n].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new Kf(new zf(), this, e).stringify();
  }
};
Rr.registerLazyResult = (r) => {
  Kf = r;
};
Rr.registerProcessor = (r) => {
  zf = r;
};
var Wn = Rr;
Rr.default = Rr;
Df.registerRoot(Rr);
let wn = {
  comma(r) {
    return wn.split(r, [","], !0);
  },
  space(r) {
    let e = [" ", `
`, "	"];
    return wn.split(r, e);
  },
  split(r, e, t) {
    let n = [], i = "", s = !1, o = 0, a = !1, l = "", u = !1;
    for (let c of r)
      u ? u = !1 : c === "\\" ? u = !0 : a ? c === l && (a = !1) : c === '"' || c === "'" ? (a = !0, l = c) : c === "(" ? o += 1 : c === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(c) && (s = !0), s ? (i !== "" && n.push(i.trim()), i = "", s = !1) : i += c;
    return (t || i !== "") && n.push(i.trim()), n;
  }
};
var jf = wn;
wn.default = wn;
let Qf = zt, cS = jf, is = class extends Qf {
  get selectors() {
    return cS.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, n = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(n);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var Dl = is;
is.default = is;
Qf.registerRule(is);
let dS = Jl, hS = Os, fS = Ws, pS = Xs, mS = Bf, gS = Wn, yS = Dl;
function _n(r, e) {
  if (Array.isArray(r)) return r.map((o) => _n(o));
  let i = r, { inputs: t } = i, n = Ze(i, ["inputs"]);
  if (t) {
    e = [];
    for (let o of t) {
      let a = M(I({}, o), { __proto__: pS.prototype });
      a.map && (a.map = M(I({}, a.map), {
        __proto__: mS.prototype
      })), e.push(a);
    }
  }
  if (n.nodes && (n.nodes = r.nodes.map((o) => _n(o, e))), n.source) {
    let s = n.source, { inputId: o } = s, a = Ze(s, ["inputId"]);
    n.source = a, o != null && (n.source.input = e[o]);
  }
  if (n.type === "root")
    return new gS(n);
  if (n.type === "decl")
    return new fS(n);
  if (n.type === "rule")
    return new yS(n);
  if (n.type === "comment")
    return new hS(n);
  if (n.type === "atrule")
    return new dS(n);
  throw new Error("Unknown node type: " + r.type);
}
var bS = _n;
_n.default = _n;
let { dirname: Wi, relative: $f, resolve: qf, sep: ep } = je, { SourceMapConsumer: tp, SourceMapGenerator: Xi } = je, { pathToFileURL: fc } = je, vS = Xs, SS = !!(tp && Xi), wS = !!(Wi && qf && $f && ep), _S = class {
  constructor(e, t, n, i) {
    this.stringify = e, this.mapOpts = n.map || {}, this.root = t, this.opts = n, this.css = i, this.originalCSS = i, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), n = e.root || Wi(e.file), i;
      this.mapOpts.sourcesContent === !1 ? (i = new tp(e.text), i.sourcesContent && (i.sourcesContent = null)) : i = e.consumer(), this.map.applySourceMap(i, t, this.toUrl(this.path(n)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), wS && SS && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = Xi.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new Xi({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Xi({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, n = "<no source>", i = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, s, o;
    this.stringify(this.root, (a, l, u) => {
      if (this.css += a, l && u !== "end" && (i.generated.line = e, i.generated.column = t - 1, l.source && l.source.start ? (i.source = this.sourcePath(l), i.original.line = l.source.start.line, i.original.column = l.source.start.column - 1, this.map.addMapping(i)) : (i.source = n, i.original.line = 1, i.original.column = 0, this.map.addMapping(i))), o = a.match(/\n/g), o ? (e += o.length, s = a.lastIndexOf(`
`), t = a.length - s) : t += a.length, l && u !== "start") {
        let c = l.parent || { raws: {} };
        (!(l.type === "decl" || l.type === "atrule" && !l.nodes) || l !== c.last || c.raws.semicolon) && (l.source && l.source.end ? (i.source = this.sourcePath(l), i.original.line = l.source.end.line, i.original.column = l.source.end.column - 1, i.generated.line = e, i.generated.column = t - 2, this.map.addMapping(i)) : (i.source = n, i.original.line = 1, i.original.column = 0, i.generated.line = e, i.generated.column = t - 1, this.map.addMapping(i)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline != "undefined")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e != "undefined" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let n = this.opts.to ? Wi(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (n = Wi(qf(n, this.mapOpts.annotation)));
    let i = $f(n, e);
    return this.memoizedPaths.set(e, i), i;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new vS(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let n = t.source.input.from;
          if (n && !e[n]) {
            e[n] = !0;
            let i = this.usesFileUrls ? this.toFileUrl(n) : this.toUrl(this.path(n));
            this.map.setSourceContent(i, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (fc) {
      let n = fc(e).toString();
      return this.memoizedFileURLs.set(e, n), n;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    ep === "\\" && (e = e.replace(/\\/g, "/"));
    let n = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, n), n;
  }
};
var rp = _S;
const go = 39, pc = 34, ii = 92, mc = 47, si = 10, Ur = 32, oi = 12, ai = 9, li = 13, RS = 91, IS = 93, TS = 40, ES = 41, CS = 123, ZS = 125, GS = 59, LS = 42, NS = 58, VS = 64, ui = /[\t\n\f\r "#'()/;[\\\]{}]/g, ci = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, xS = /.[\r\n"'(/\\]/, gc = /[\da-f]/i;
var OS = function(e, t = {}) {
  let n = e.css.valueOf(), i = t.ignoreErrors, s, o, a, l, u, c, d, h, f, m, p = n.length, g = 0, y = [], _ = [];
  function S() {
    return g;
  }
  function C(x) {
    throw e.error("Unclosed " + x, g);
  }
  function R() {
    return _.length === 0 && g >= p;
  }
  function L(x) {
    if (_.length) return _.pop();
    if (g >= p) return;
    let E = x ? x.ignoreUnclosed : !1;
    switch (s = n.charCodeAt(g), s) {
      case si:
      case Ur:
      case ai:
      case li:
      case oi: {
        l = g;
        do
          l += 1, s = n.charCodeAt(l);
        while (s === Ur || s === si || s === ai || s === li || s === oi);
        c = ["space", n.slice(g, l)], g = l - 1;
        break;
      }
      case RS:
      case IS:
      case CS:
      case ZS:
      case NS:
      case GS:
      case ES: {
        let G = String.fromCharCode(s);
        c = [G, G, g];
        break;
      }
      case TS: {
        if (m = y.length ? y.pop()[1] : "", f = n.charCodeAt(g + 1), m === "url" && f !== go && f !== pc && f !== Ur && f !== si && f !== ai && f !== oi && f !== li) {
          l = g;
          do {
            if (d = !1, l = n.indexOf(")", l + 1), l === -1)
              if (i || E) {
                l = g;
                break;
              } else
                C("bracket");
            for (h = l; n.charCodeAt(h - 1) === ii; )
              h -= 1, d = !d;
          } while (d);
          c = ["brackets", n.slice(g, l + 1), g, l], g = l;
        } else
          l = n.indexOf(")", g + 1), o = n.slice(g, l + 1), l === -1 || xS.test(o) ? c = ["(", "(", g] : (c = ["brackets", o, g, l], g = l);
        break;
      }
      case go:
      case pc: {
        u = s === go ? "'" : '"', l = g;
        do {
          if (d = !1, l = n.indexOf(u, l + 1), l === -1)
            if (i || E) {
              l = g + 1;
              break;
            } else
              C("string");
          for (h = l; n.charCodeAt(h - 1) === ii; )
            h -= 1, d = !d;
        } while (d);
        c = ["string", n.slice(g, l + 1), g, l], g = l;
        break;
      }
      case VS: {
        ui.lastIndex = g + 1, ui.test(n), ui.lastIndex === 0 ? l = n.length - 1 : l = ui.lastIndex - 2, c = ["at-word", n.slice(g, l + 1), g, l], g = l;
        break;
      }
      case ii: {
        for (l = g, a = !0; n.charCodeAt(l + 1) === ii; )
          l += 1, a = !a;
        if (s = n.charCodeAt(l + 1), a && s !== mc && s !== Ur && s !== si && s !== ai && s !== li && s !== oi && (l += 1, gc.test(n.charAt(l)))) {
          for (; gc.test(n.charAt(l + 1)); )
            l += 1;
          n.charCodeAt(l + 1) === Ur && (l += 1);
        }
        c = ["word", n.slice(g, l + 1), g, l], g = l;
        break;
      }
      default: {
        s === mc && n.charCodeAt(g + 1) === LS ? (l = n.indexOf("*/", g + 2) + 1, l === 0 && (i || E ? l = n.length : C("comment")), c = ["comment", n.slice(g, l + 1), g, l], g = l) : (ci.lastIndex = g + 1, ci.test(n), ci.lastIndex === 0 ? l = n.length - 1 : l = ci.lastIndex - 2, c = ["word", n.slice(g, l + 1), g, l], y.push(c), g = l);
        break;
      }
    }
    return g++, c;
  }
  function k(x) {
    _.push(x);
  }
  return {
    back: k,
    endOfFile: R,
    nextToken: L,
    position: S
  };
};
let WS = Jl, XS = Os, kS = Ws, PS = Wn, yc = Dl, MS = OS;
const bc = {
  empty: !0,
  space: !0
};
function AS(r) {
  for (let e = r.length - 1; e >= 0; e--) {
    let t = r[e], n = t[3] || t[2];
    if (n) return n;
  }
}
let US = class {
  constructor(e) {
    this.input = e, this.root = new PS(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new WS();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let n, i, s, o = !1, a = !1, l = [], u = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), n = e[0], n === "(" || n === "[" ? u.push(n === "(" ? ")" : "]") : n === "{" && u.length > 0 ? u.push("}") : n === u[u.length - 1] && u.pop(), u.length === 0)
        if (n === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (n === "{") {
          a = !0;
          break;
        } else if (n === "}") {
          if (l.length > 0) {
            for (s = l.length - 1, i = l[s]; i && i[0] === "space"; )
              i = l[--s];
            i && (t.source.end = this.getPosition(i[3] || i[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          l.push(e);
      else
        l.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(l), l.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(l), this.raw(t, "params", l), o && (e = l[l.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let n = 0, i;
    for (let s = t - 1; s >= 0 && (i = e[s], !(i[0] !== "space" && (n += 1, n === 2))); s--)
      ;
    throw this.input.error(
      "Missed semicolon",
      i[0] === "word" ? i[3] + 1 : i[2]
    );
  }
  colon(e) {
    let t = 0, n, i, s;
    for (let [o, a] of e.entries()) {
      if (i = a, s = i[0], s === "(" && (t += 1), s === ")" && (t -= 1), t === 0 && s === ":")
        if (!n)
          this.doubleColon(i);
        else {
          if (n[0] === "word" && n[1] === "progid")
            continue;
          return o;
        }
      n = i;
    }
    return !1;
  }
  comment(e) {
    let t = new XS();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let n = e[1].slice(2, -2);
    if (/^\s*$/.test(n))
      t.text = "", t.raws.left = n, t.raws.right = "";
    else {
      let i = n.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = i[2], t.raws.left = i[1], t.raws.right = i[3];
    }
  }
  createTokenizer() {
    this.tokenizer = MS(this.input);
  }
  decl(e, t) {
    let n = new kS();
    this.init(n, e[0][2]);
    let i = e[e.length - 1];
    for (i[0] === ";" && (this.semicolon = !0, e.pop()), n.source.end = this.getPosition(
      i[3] || i[2] || AS(e)
    ), n.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), n.raws.before += e.shift()[1];
    for (n.source.start = this.getPosition(e[0][2]), n.prop = ""; e.length; ) {
      let u = e[0][0];
      if (u === ":" || u === "space" || u === "comment")
        break;
      n.prop += e.shift()[1];
    }
    n.raws.between = "";
    let s;
    for (; e.length; )
      if (s = e.shift(), s[0] === ":") {
        n.raws.between += s[1];
        break;
      } else
        s[0] === "word" && /\w/.test(s[1]) && this.unknownWord([s]), n.raws.between += s[1];
    (n.prop[0] === "_" || n.prop[0] === "*") && (n.raws.before += n.prop[0], n.prop = n.prop.slice(1));
    let o = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let u = e.length - 1; u >= 0; u--) {
      if (s = e[u], s[1].toLowerCase() === "!important") {
        n.important = !0;
        let c = this.stringFrom(e, u);
        c = this.spacesFromEnd(e) + c, c !== " !important" && (n.raws.important = c);
        break;
      } else if (s[1].toLowerCase() === "important") {
        let c = e.slice(0), d = "";
        for (let h = u; h > 0; h--) {
          let f = c[h][0];
          if (d.trim().startsWith("!") && f !== "space")
            break;
          d = c.pop()[1] + d;
        }
        d.trim().startsWith("!") && (n.important = !0, n.raws.important = d, e = c);
      }
      if (s[0] !== "space" && s[0] !== "comment")
        break;
    }
    e.some((u) => u[0] !== "space" && u[0] !== "comment") && (n.raws.between += o.map((u) => u[1]).join(""), o = []), this.raw(n, "value", o.concat(e), t), n.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new yc();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, n = null, i = !1, s = null, o = [], a = e[1].startsWith("--"), l = [], u = e;
    for (; u; ) {
      if (n = u[0], l.push(u), n === "(" || n === "[")
        s || (s = u), o.push(n === "(" ? ")" : "]");
      else if (a && i && n === "{")
        s || (s = u), o.push("}");
      else if (o.length === 0)
        if (n === ";")
          if (i) {
            this.decl(l, a);
            return;
          } else
            break;
        else if (n === "{") {
          this.rule(l);
          return;
        } else if (n === "}") {
          this.tokenizer.back(l.pop()), t = !0;
          break;
        } else n === ":" && (i = !0);
      else n === o[o.length - 1] && (o.pop(), o.length === 0 && (s = null));
      u = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(s), t && i) {
      if (!a)
        for (; l.length && (u = l[l.length - 1][0], !(u !== "space" && u !== "comment")); )
          this.tokenizer.back(l.pop());
      this.decl(l, a);
    } else
      this.unknownWord(l);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, n, i) {
    let s, o, a = n.length, l = "", u = !0, c, d;
    for (let h = 0; h < a; h += 1)
      s = n[h], o = s[0], o === "space" && h === a - 1 && !i ? u = !1 : o === "comment" ? (d = n[h - 1] ? n[h - 1][0] : "empty", c = n[h + 1] ? n[h + 1][0] : "empty", !bc[d] && !bc[c] ? l.slice(-1) === "," ? u = !1 : l += s[1] : u = !1) : l += s[1];
    if (!u) {
      let h = n.reduce((f, m) => f + m[1], "");
      e.raws[t] = { raw: h, value: l };
    }
    e[t] = l;
  }
  rule(e) {
    e.pop();
    let t = new yc();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, n = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      n = e.pop()[1] + n;
    return n;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, n = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      n += e.shift()[1];
    return n;
  }
  spacesFromEnd(e) {
    let t, n = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      n = e.pop()[1] + n;
    return n;
  }
  stringFrom(e, t) {
    let n = "";
    for (let i = t; i < e.length; i++)
      n += e[i][1];
    return e.splice(t, e.length - t), n;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var YS = US;
let FS = zt, HS = Xs, JS = YS;
function ss(r, e) {
  let t = new HS(r, e), n = new JS(t);
  try {
    n.parse();
  } catch (i) {
    throw process.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return n.root;
}
var Kl = ss;
ss.default = ss;
FS.registerParse(ss);
let Pa = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let n = t.node.rangeBy(t);
      this.line = n.start.line, this.column = n.start.column, this.endLine = n.end.line, this.endColumn = n.end.column;
    }
    for (let n in t) this[n] = t[n];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var np = Pa;
Pa.default = Pa;
let BS = np, Ma = class {
  get content() {
    return this.css;
  }
  constructor(e, t, n) {
    this.processor = e, this.messages = [], this.root = t, this.opts = n, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let n = new BS(e, t);
    return this.messages.push(n), n;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var zl = Ma;
Ma.default = Ma;
let vc = {};
var ip = function(e) {
  vc[e] || (vc[e] = !0, typeof console != "undefined" && console.warn && console.warn(e));
};
let DS = zt, KS = Bl, zS = rp, jS = Kl, Sc = zl, QS = Wn, $S = Vs, { isClean: qe, my: qS } = On, ew = ip;
const tw = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, rw = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, nw = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, Ir = 0;
function Yr(r) {
  return typeof r == "object" && typeof r.then == "function";
}
function sp(r) {
  let e = !1, t = tw[r.type];
  return r.type === "decl" ? e = r.prop.toLowerCase() : r.type === "atrule" && (e = r.name.toLowerCase()), e && r.append ? [
    t,
    t + "-" + e,
    Ir,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : r.append ? [t, Ir, t + "Exit"] : [t, t + "Exit"];
}
function wc(r) {
  let e;
  return r.type === "document" ? e = ["Document", Ir, "DocumentExit"] : r.type === "root" ? e = ["Root", Ir, "RootExit"] : e = sp(r), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: r,
    visitorIndex: 0,
    visitors: []
  };
}
function Aa(r) {
  return r[qe] = !1, r.nodes && r.nodes.forEach((e) => Aa(e)), r;
}
let Ua = {}, Tr = class op {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, t, n) {
    this.stringified = !1, this.processed = !1;
    let i;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      i = Aa(t);
    else if (t instanceof op || t instanceof Sc)
      i = Aa(t.root), t.map && (typeof n.map == "undefined" && (n.map = {}), n.map.inline || (n.map.inline = !1), n.map.prev = t.map);
    else {
      let s = jS;
      n.syntax && (s = n.syntax.parse), n.parser && (s = n.parser), s.parse && (s = s.parse);
      try {
        i = s(t, n);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      i && !i[qS] && DS.rebuild(i);
    }
    this.result = new Sc(e, i, n), this.helpers = M(I({}, Ua), { postcss: Ua, result: this.result }), this.plugins = this.processor.plugins.map((s) => typeof s == "object" && s.prepare ? I(I({}, s), s.prepare(this.result)) : s);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let n = this.result.lastPlugin;
    try {
      if (t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = n.postcssPlugin, e.setMessage();
      else if (n.postcssVersion && process.env.NODE_ENV !== "production") {
        let i = n.postcssPlugin, s = n.postcssVersion, o = this.result.processor.version, a = s.split("."), l = o.split(".");
        (a[0] !== l[0] || parseInt(a[1]) > parseInt(l[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + o + ", but " + i + " uses " + s + ". Perhaps this is the source of the error below."
        );
      }
    } catch (i) {
      console && console.error && console.error(i);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, n, i) => {
      this.listeners[n] || (this.listeners[n] = []), this.listeners[n].push([t, i]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let n in t) {
          if (!rw[n] && /^[A-Z]/.test(n))
            throw new Error(
              `Unknown event ${n} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!nw[n])
            if (typeof t[n] == "object")
              for (let i in t[n])
                i === "*" ? e(t, n, t[n][i]) : e(
                  t,
                  n + "-" + i.toLowerCase(),
                  t[n][i]
                );
            else typeof t[n] == "function" && e(t, n, t[n]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  runAsync() {
    return $(this, null, function* () {
      this.plugin = 0;
      for (let e = 0; e < this.plugins.length; e++) {
        let t = this.plugins[e], n = this.runOnRoot(t);
        if (Yr(n))
          try {
            yield n;
          } catch (i) {
            throw this.handleError(i);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let e = this.result.root;
        for (; !e[qe]; ) {
          e[qe] = !0;
          let t = [wc(e)];
          for (; t.length > 0; ) {
            let n = this.visitTick(t);
            if (Yr(n))
              try {
                yield n;
              } catch (i) {
                let s = t[t.length - 1].node;
                throw this.handleError(i, s);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [t, n] of this.listeners.OnceExit) {
            this.result.lastPlugin = t;
            try {
              if (e.type === "document") {
                let i = e.nodes.map(
                  (s) => n(s, this.helpers)
                );
                yield Promise.all(i);
              } else
                yield n(e, this.helpers);
            } catch (i) {
              throw this.handleError(i);
            }
          }
      }
      return this.processed = !0, this.stringify();
    });
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (n) => e.Once(n, this.helpers)
          );
          return Yr(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = $S;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let i = new zS(t, this.result.root, this.result.opts).generate();
    return this.result.css = i[0], this.result.map = i[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (Yr(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[qe]; )
        e[qe] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || ew(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [n, i] of e) {
      this.result.lastPlugin = n;
      let s;
      try {
        s = i(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (Yr(s))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: n, visitors: i } = t;
    if (n.type !== "root" && n.type !== "document" && !n.parent) {
      e.pop();
      return;
    }
    if (i.length > 0 && t.visitorIndex < i.length) {
      let [o, a] = i[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === i.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return a(n.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, n);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, a;
      for (; a = n.nodes[n.indexes[o]]; )
        if (n.indexes[o] += 1, !a[qe]) {
          a[qe] = !0, e.push(wc(a));
          return;
        }
      t.iterator = 0, delete n.indexes[o];
    }
    let s = t.events;
    for (; t.eventIndex < s.length; ) {
      let o = s[t.eventIndex];
      if (t.eventIndex += 1, o === Ir) {
        n.nodes && n.nodes.length && (n[qe] = !0, t.iterator = n.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[qe] = !0;
    let t = sp(e);
    for (let n of t)
      if (n === Ir)
        e.nodes && e.each((i) => {
          i[qe] || this.walkSync(i);
        });
      else {
        let i = this.listeners[n];
        if (i && this.visitSync(i, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
Tr.registerPostcss = (r) => {
  Ua = r;
};
var ap = Tr;
Tr.default = Tr;
QS.registerLazyResult(Tr);
KS.registerLazyResult(Tr);
let iw = rp, sw = Kl;
const ow = zl;
let aw = Vs, lw = ip, Ya = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = sw;
    try {
      e = t(this._css, this._opts);
    } catch (n) {
      this.error = n;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, n) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = n, this._map = void 0;
    let i, s = aw;
    this.result = new ow(this._processor, i, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let a = new iw(s, i, this._opts, t);
    if (a.isMap()) {
      let [l, u] = a.generate();
      l && (this.result.css = l), u && (this.result.map = u);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || lw(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var uw = Ya;
Ya.default = Ya;
let cw = Bl, dw = ap, hw = uw, fw = Wn, Rn = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let n of e)
      if (n.postcss === !0 ? n = n() : n.postcss && (n = n.postcss), typeof n == "object" && Array.isArray(n.plugins))
        t = t.concat(n.plugins);
      else if (typeof n == "object" && n.postcssPlugin)
        t.push(n);
      else if (typeof n == "function")
        t.push(n);
      else if (typeof n == "object" && (n.parse || n.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(n + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new hw(this, e, t) : new dw(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var pw = Rn;
Rn.default = Rn;
fw.registerProcessor(Rn);
cw.registerProcessor(Rn);
let lp = Jl, up = Os, mw = zt, gw = Yl, cp = Ws, dp = Bl, yw = bS, bw = Xs, vw = ap, Sw = jf, ww = xs, _w = Kl, jl = pw, Rw = zl, hp = Wn, fp = Dl, Iw = Vs, Tw = np;
function se(...r) {
  return r.length === 1 && Array.isArray(r[0]) && (r = r[0]), new jl(r);
}
se.plugin = function(e, t) {
  let n = !1;
  function i(...o) {
    console && console.warn && !n && (n = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...o);
    return a.postcssPlugin = e, a.postcssVersion = new jl().version, a;
  }
  let s;
  return Object.defineProperty(i, "postcss", {
    get() {
      return s || (s = i()), s;
    }
  }), i.process = function(o, a, l) {
    return se([i(l)]).process(o, a);
  }, i;
};
se.stringify = Iw;
se.parse = _w;
se.fromJSON = yw;
se.list = Sw;
se.comment = (r) => new up(r);
se.atRule = (r) => new lp(r);
se.decl = (r) => new cp(r);
se.rule = (r) => new fp(r);
se.root = (r) => new hp(r);
se.document = (r) => new dp(r);
se.CssSyntaxError = gw;
se.Declaration = cp;
se.Container = mw;
se.Processor = jl;
se.Document = dp;
se.Comment = up;
se.Warning = Tw;
se.AtRule = lp;
se.Result = Rw;
se.Input = bw;
se.Rule = fp;
se.Root = hp;
se.Node = ww;
vw.registerPostcss(se);
se.default = se;
class Ql {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  constructor(...e) {
    We(this, "parentElement", null), We(this, "parentNode", null), We(this, "ownerDocument"), We(this, "firstChild", null), We(this, "lastChild", null), We(this, "previousSibling", null), We(this, "nextSibling", null), We(this, "ELEMENT_NODE", 1), We(this, "TEXT_NODE", 3), We(this, "nodeType"), We(this, "nodeName"), We(this, "RRNodeType");
  }
  get childNodes() {
    const e = [];
    let t = this.firstChild;
    for (; t; )
      e.push(t), t = t.nextSibling;
    return e;
  }
  contains(e) {
    if (e instanceof Ql) {
      if (e.ownerDocument !== this.ownerDocument) return !1;
      if (e === this) return !0;
    } else return !1;
    for (; e.parentNode; ) {
      if (e.parentNode === this) return !0;
      e = e.parentNode;
    }
    return !1;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  appendChild(e) {
    throw new Error(
      "RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  insertBefore(e, t) {
    throw new Error(
      "RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeChild(e) {
    throw new Error(
      "RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  toString() {
    return "RRNode";
  }
}
const _c = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, Rc = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, di = {}, Ew = () => !!globalThis.Zone;
function $l(r) {
  if (di[r])
    return di[r];
  const e = globalThis[r], t = e.prototype, n = r in _c ? _c[r] : void 0, i = !!(n && // @ts-expect-error 2345
  n.every(
    (a) => {
      var l, u;
      return !!((u = (l = Object.getOwnPropertyDescriptor(t, a)) == null ? void 0 : l.get) != null && u.toString().includes("[native code]"));
    }
  )), s = r in Rc ? Rc[r] : void 0, o = !!(s && s.every(
    // @ts-expect-error 2345
    (a) => {
      var l;
      return typeof t[a] == "function" && ((l = t[a]) == null ? void 0 : l.toString().includes("[native code]"));
    }
  ));
  if (i && o && !Ew())
    return di[r] = e.prototype, e.prototype;
  try {
    const a = document.createElement("iframe");
    document.body.appendChild(a);
    const l = a.contentWindow;
    if (!l) return e.prototype;
    const u = l[r].prototype;
    return document.body.removeChild(a), u ? di[r] = u : t;
  } catch (a) {
    return t;
  }
}
const yo = {};
function xt(r, e, t) {
  var n;
  const i = `${r}.${String(t)}`;
  if (yo[i])
    return yo[i].call(
      e
    );
  const s = $l(r), o = (n = Object.getOwnPropertyDescriptor(
    s,
    t
  )) == null ? void 0 : n.get;
  return o ? (yo[i] = o, o.call(e)) : e[t];
}
const bo = {};
function pp(r, e, t) {
  const n = `${r}.${String(t)}`;
  if (bo[n])
    return bo[n].bind(
      e
    );
  const s = $l(r)[t];
  return typeof s != "function" ? e[t] : (bo[n] = s, s.bind(e));
}
function Cw(r) {
  return xt("Node", r, "childNodes");
}
function Zw(r) {
  return xt("Node", r, "parentNode");
}
function Gw(r) {
  return xt("Node", r, "parentElement");
}
function Lw(r) {
  return xt("Node", r, "textContent");
}
function Nw(r, e) {
  return pp("Node", r, "contains")(e);
}
function Vw(r) {
  return pp("Node", r, "getRootNode")();
}
function xw(r) {
  return !r || !("host" in r) ? null : xt("ShadowRoot", r, "host");
}
function Ow(r) {
  return r.styleSheets;
}
function Ww(r) {
  return !r || !("shadowRoot" in r) ? null : xt("Element", r, "shadowRoot");
}
function Xw(r, e) {
  return xt("Element", r, "querySelector")(e);
}
function kw(r, e) {
  return xt("Element", r, "querySelectorAll")(e);
}
function mp() {
  return $l("MutationObserver").constructor;
}
function jt(r, e, t) {
  try {
    if (!(e in r))
      return () => {
      };
    const n = r[e], i = t(n);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), r[e] = i, () => {
      r[e] = n;
    };
  } catch (n) {
    return () => {
    };
  }
}
const B = {
  childNodes: Cw,
  parentNode: Zw,
  parentElement: Gw,
  textContent: Lw,
  contains: Nw,
  getRootNode: Vw,
  host: xw,
  styleSheets: Ow,
  shadowRoot: Ww,
  querySelector: Xw,
  querySelectorAll: kw,
  mutationObserver: mp,
  patch: jt
};
function Ee(r, e, t = document) {
  const n = { capture: !0 };
  return t.addEventListener(r, e, n), () => t.removeEventListener(r, e, n);
}
const ar = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Ic = {
  map: {},
  getId() {
    return console.error(ar), -1;
  },
  getNode() {
    return console.error(ar), null;
  },
  removeNodeFromMap() {
    console.error(ar);
  },
  has() {
    return console.error(ar), !1;
  },
  reset() {
    console.error(ar);
  }
};
typeof window != "undefined" && window.Proxy && window.Reflect && (Ic = new Proxy(Ic, {
  get(r, e, t) {
    return e === "map" && console.error(ar), Reflect.get(r, e, t);
  }
}));
function In(r, e, t = {}) {
  let n = null, i = 0;
  return function(...s) {
    const o = Date.now();
    !i && t.leading === !1 && (i = o);
    const a = e - (o - i), l = this;
    a <= 0 || a > e ? (n && (clearTimeout(n), n = null), i = o, r.apply(l, s)) : !n && t.trailing !== !1 && (n = setTimeout(() => {
      i = t.leading === !1 ? 0 : Date.now(), n = null, r.apply(l, s);
    }, a));
  };
}
function ks(r, e, t, n, i = window) {
  const s = i.Object.getOwnPropertyDescriptor(r, e);
  return i.Object.defineProperty(
    r,
    e,
    n ? t : {
      set(o) {
        setTimeout(() => {
          t.set.call(this, o);
        }, 0), s && s.set && s.set.call(this, o);
      }
    }
  ), () => ks(r, e, s || {}, !0);
}
let os = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (os = () => (/* @__PURE__ */ new Date()).getTime());
function gp(r) {
  var e, t, n, i;
  const s = r.document;
  return {
    left: s.scrollingElement ? s.scrollingElement.scrollLeft : r.pageXOffset !== void 0 ? r.pageXOffset : s.documentElement.scrollLeft || (s == null ? void 0 : s.body) && ((e = B.parentElement(s.body)) == null ? void 0 : e.scrollLeft) || ((t = s == null ? void 0 : s.body) == null ? void 0 : t.scrollLeft) || 0,
    top: s.scrollingElement ? s.scrollingElement.scrollTop : r.pageYOffset !== void 0 ? r.pageYOffset : (s == null ? void 0 : s.documentElement.scrollTop) || (s == null ? void 0 : s.body) && ((n = B.parentElement(s.body)) == null ? void 0 : n.scrollTop) || ((i = s == null ? void 0 : s.body) == null ? void 0 : i.scrollTop) || 0
  };
}
function yp() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function bp() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function vp(r) {
  return r ? r.nodeType === r.ELEMENT_NODE ? r : B.parentElement(r) : null;
}
const Pw = (r) => {
  try {
    if (r instanceof HTMLElement)
      return r.tagName === "CANVAS";
  } catch (e) {
    return !1;
  }
  return !1;
};
function Se(r, e, t, n) {
  if (!r)
    return !1;
  const i = vp(r);
  if (!i)
    return !1;
  try {
    if (typeof e == "string") {
      if (i.classList.contains(e) || n && i.closest("." + e) !== null) return !0;
    } else if (Qi(i, e, n)) return !0;
  } catch (s) {
  }
  return !!(t && (i.matches(t) || n && i.closest(t) !== null));
}
function Mw(r, e) {
  return e.getId(r) !== -1;
}
function vo(r, e, t) {
  return r.tagName === "TITLE" && t.headTitleMutations ? !0 : e.getId(r) === mn;
}
function Sp(r, e) {
  if (nn(r))
    return !1;
  const t = e.getId(r);
  if (!e.has(t))
    return !0;
  const n = B.parentNode(r);
  return n && n.nodeType === r.DOCUMENT_NODE ? !1 : n ? Sp(n, e) : !0;
}
function Fa(r) {
  return !!r.changedTouches;
}
function Aw(r = window) {
  "NodeList" in r && !r.NodeList.prototype.forEach && (r.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in r && !r.DOMTokenList.prototype.forEach && (r.DOMTokenList.prototype.forEach = Array.prototype.forEach);
}
function wp(r, e) {
  return !!(r.nodeName === "IFRAME" && e.getMeta(r));
}
function _p(r, e) {
  return !!(r.nodeName === "LINK" && r.nodeType === r.ELEMENT_NODE && r.getAttribute && r.getAttribute("rel") === "stylesheet" && e.getMeta(r));
}
function Ha(r) {
  return r ? r instanceof Ql && "shadowRoot" in r ? !!r.shadowRoot : !!B.shadowRoot(r) : !1;
}
class Uw {
  constructor() {
    Z(this, "id", 1), Z(this, "styleIDMap", /* @__PURE__ */ new WeakMap()), Z(this, "idStyleMap", /* @__PURE__ */ new Map());
  }
  getId(e) {
    var t;
    return (t = this.styleIDMap.get(e)) != null ? t : -1;
  }
  has(e) {
    return this.styleIDMap.has(e);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(e, t) {
    if (this.has(e)) return this.getId(e);
    let n;
    return t === void 0 ? n = this.id++ : n = t, this.styleIDMap.set(e, n), this.idStyleMap.set(n, e), n;
  }
  getStyle(e) {
    return this.idStyleMap.get(e) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function Rp(r) {
  var e;
  let t = null;
  return "getRootNode" in r && ((e = B.getRootNode(r)) == null ? void 0 : e.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && B.host(B.getRootNode(r)) && (t = B.host(B.getRootNode(r))), t;
}
function Yw(r) {
  let e = r, t;
  for (; t = Rp(e); )
    e = t;
  return e;
}
function Fw(r) {
  const e = r.ownerDocument;
  if (!e) return !1;
  const t = Yw(r);
  return B.contains(e, t);
}
function Ip(r) {
  const e = r.ownerDocument;
  return e ? B.contains(e, r) || Fw(r) : !1;
}
var Q = /* @__PURE__ */ ((r) => (r[r.DomContentLoaded = 0] = "DomContentLoaded", r[r.Load = 1] = "Load", r[r.FullSnapshot = 2] = "FullSnapshot", r[r.IncrementalSnapshot = 3] = "IncrementalSnapshot", r[r.Meta = 4] = "Meta", r[r.Custom = 5] = "Custom", r[r.Plugin = 6] = "Plugin", r))(Q || {}), D = /* @__PURE__ */ ((r) => (r[r.Mutation = 0] = "Mutation", r[r.MouseMove = 1] = "MouseMove", r[r.MouseInteraction = 2] = "MouseInteraction", r[r.Scroll = 3] = "Scroll", r[r.ViewportResize = 4] = "ViewportResize", r[r.Input = 5] = "Input", r[r.TouchMove = 6] = "TouchMove", r[r.MediaInteraction = 7] = "MediaInteraction", r[r.StyleSheetRule = 8] = "StyleSheetRule", r[r.CanvasMutation = 9] = "CanvasMutation", r[r.Font = 10] = "Font", r[r.Log = 11] = "Log", r[r.Drag = 12] = "Drag", r[r.StyleDeclaration = 13] = "StyleDeclaration", r[r.Selection = 14] = "Selection", r[r.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", r[r.CustomElement = 16] = "CustomElement", r))(D || {}), Le = /* @__PURE__ */ ((r) => (r[r.MouseUp = 0] = "MouseUp", r[r.MouseDown = 1] = "MouseDown", r[r.Click = 2] = "Click", r[r.ContextMenu = 3] = "ContextMenu", r[r.DblClick = 4] = "DblClick", r[r.Focus = 5] = "Focus", r[r.Blur = 6] = "Blur", r[r.TouchStart = 7] = "TouchStart", r[r.TouchMove_Departed = 8] = "TouchMove_Departed", r[r.TouchEnd = 9] = "TouchEnd", r[r.TouchCancel = 10] = "TouchCancel", r))(Le || {}), St = /* @__PURE__ */ ((r) => (r[r.Mouse = 0] = "Mouse", r[r.Pen = 1] = "Pen", r[r.Touch = 2] = "Touch", r))(St || {}), Er = /* @__PURE__ */ ((r) => (r[r["2D"] = 0] = "2D", r[r.WebGL = 1] = "WebGL", r[r.WebGL2 = 2] = "WebGL2", r))(Er || {}), lr = /* @__PURE__ */ ((r) => (r[r.Play = 0] = "Play", r[r.Pause = 1] = "Pause", r[r.Seeked = 2] = "Seeked", r[r.VolumeChange = 3] = "VolumeChange", r[r.RateChange = 4] = "RateChange", r))(lr || {}), Tp = /* @__PURE__ */ ((r) => (r[r.Document = 0] = "Document", r[r.DocumentType = 1] = "DocumentType", r[r.Element = 2] = "Element", r[r.Text = 3] = "Text", r[r.CDATA = 4] = "CDATA", r[r.Comment = 5] = "Comment", r))(Tp || {});
function Tc(r) {
  return "__ln" in r;
}
class Hw {
  constructor() {
    Z(this, "length", 0), Z(this, "head", null), Z(this, "tail", null);
  }
  get(e) {
    if (e >= this.length)
      throw new Error("Position outside of list range");
    let t = this.head;
    for (let n = 0; n < e; n++)
      t = (t == null ? void 0 : t.next) || null;
    return t;
  }
  addNode(e) {
    const t = {
      value: e,
      previous: null,
      next: null
    };
    if (e.__ln = t, e.previousSibling && Tc(e.previousSibling)) {
      const n = e.previousSibling.__ln.next;
      t.next = n, t.previous = e.previousSibling.__ln, e.previousSibling.__ln.next = t, n && (n.previous = t);
    } else if (e.nextSibling && Tc(e.nextSibling) && e.nextSibling.__ln.previous) {
      const n = e.nextSibling.__ln.previous;
      t.previous = n, t.next = e.nextSibling.__ln, e.nextSibling.__ln.previous = t, n && (n.next = t);
    } else
      this.head && (this.head.previous = t), t.next = this.head, this.head = t;
    t.next === null && (this.tail = t), this.length++;
  }
  removeNode(e) {
    const t = e.__ln;
    this.head && (t.previous ? (t.previous.next = t.next, t.next ? t.next.previous = t.previous : this.tail = t.previous) : (this.head = t.next, this.head ? this.head.previous = null : this.tail = null), e.__ln && delete e.__ln, this.length--);
  }
}
const Ec = (r, e) => `${r}@${e}`;
class Jw {
  constructor() {
    Z(this, "frozen", !1), Z(this, "locked", !1), Z(this, "texts", []), Z(this, "attributes", []), Z(this, "attributeMap", /* @__PURE__ */ new WeakMap()), Z(this, "removes", []), Z(this, "mapRemoves", []), Z(this, "movedMap", {}), Z(this, "addedSet", /* @__PURE__ */ new Set()), Z(this, "movedSet", /* @__PURE__ */ new Set()), Z(this, "droppedSet", /* @__PURE__ */ new Set()), Z(this, "removesSubTreeCache", /* @__PURE__ */ new Set()), Z(this, "mutationCb"), Z(this, "blockClass"), Z(this, "blockSelector"), Z(this, "maskTextClass"), Z(this, "maskTextSelector"), Z(this, "inlineStylesheet"), Z(this, "maskInputOptions"), Z(this, "maskTextFn"), Z(this, "maskInputFn"), Z(this, "keepIframeSrcFn"), Z(this, "recordCanvas"), Z(this, "inlineImages"), Z(this, "inlineVideos"), Z(this, "privacySetting"), Z(this, "slimDOMOptions"), Z(this, "dataURLOptions"), Z(this, "doc"), Z(this, "mirror"), Z(this, "iframeManager"), Z(this, "stylesheetManager"), Z(this, "shadowDomManager"), Z(this, "canvasManager"), Z(this, "processedNodeManager"), Z(this, "unattachedDoc"), Z(this, "processMutations", (e) => {
      e.forEach(this.processMutation), this.emit();
    }), Z(this, "emit", () => {
      if (this.frozen || this.locked)
        return;
      const e = [], t = /* @__PURE__ */ new Set(), n = new Hw(), i = (l) => {
        let u = l, c = mn;
        for (; c === mn; )
          u = u && u.nextSibling, c = u && this.mirror.getId(u);
        return c;
      }, s = (l) => {
        const u = B.parentNode(l);
        if (!u || !Ip(l))
          return;
        let c = !1;
        if (l.nodeType === Node.TEXT_NODE) {
          const m = u.tagName;
          if (m === "TEXTAREA")
            return;
          m === "STYLE" && this.addedSet.has(u) && (c = !0);
        }
        const d = nn(u) ? this.mirror.getId(Rp(l)) : this.mirror.getId(u), h = i(l);
        if (d === -1 || h === -1)
          return n.addNode(l);
        const f = fr(l, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          inlineVideos: this.inlineVideos,
          privacySetting: this.privacySetting,
          onSerialize: (m) => {
            wp(m, this.mirror) && this.iframeManager.addIframe(m), _p(m, this.mirror) && this.stylesheetManager.trackLinkElement(
              m
            ), Ha(l) && this.shadowDomManager.addShadowRoot(B.shadowRoot(l), this.doc);
          },
          onIframeLoad: (m, p) => {
            this.iframeManager.attachIframe(m, p), this.shadowDomManager.observeAttachShadow(m);
          },
          onStylesheetLoad: (m, p) => {
            this.stylesheetManager.attachLinkElement(m, p);
          },
          cssCaptured: c
        });
        f && (e.push({
          parentId: d,
          nextId: h,
          node: f
        }), t.add(f.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const l of this.movedSet)
        Cc(this.removesSubTreeCache, l) && !this.movedSet.has(B.parentNode(l)) || s(l);
      for (const l of this.addedSet)
        !Zc(this.droppedSet, l) && !Cc(this.removesSubTreeCache, l) || Zc(this.movedSet, l) ? s(l) : this.droppedSet.add(l);
      let o = null;
      for (; n.length; ) {
        let l = null;
        if (o) {
          const u = this.mirror.getId(B.parentNode(o.value)), c = i(o.value);
          u !== -1 && c !== -1 && (l = o);
        }
        if (!l) {
          let u = n.tail;
          for (; u; ) {
            const c = u;
            if (u = u.previous, c) {
              const d = this.mirror.getId(B.parentNode(c.value));
              if (i(c.value) === -1) continue;
              if (d !== -1) {
                l = c;
                break;
              } else {
                const f = c.value, m = B.parentNode(f);
                if (m && m.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const p = B.host(m);
                  if (this.mirror.getId(p) !== -1) {
                    l = c;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!l) {
          for (; n.head; )
            n.removeNode(n.head.value);
          break;
        }
        o = l.previous, n.removeNode(l.value), s(l.value);
      }
      const a = {
        texts: this.texts.map((l) => {
          var u, c;
          const d = l.node, h = B.parentNode(d);
          h && h.tagName === "TEXTAREA" && this.genTextAreaValueMutation(h);
          let f = l.value;
          const m = this.privacySetting === "strict", p = this.privacySetting === "default" && Uh(f), g = (c = (u = l.node) == null ? void 0 : u.parentElement) == null ? void 0 : c.getAttribute("data-hl-record");
          return (m || p) && !g && f && (f = Gl(f)), {
            id: this.mirror.getId(d),
            value: f
          };
        }).filter((l) => !t.has(l.id)).filter((l) => this.mirror.has(l.id)),
        attributes: this.attributes.map((l) => {
          const { attributes: u } = l;
          if (typeof u.style == "string") {
            const c = JSON.stringify(l.styleDiff), d = JSON.stringify(l._unchangedStyles);
            c.length < u.style.length && (c + d).split("var(").length === u.style.split("var(").length && (u.style = l.styleDiff);
          }
          return {
            id: this.mirror.getId(l.node),
            attributes: u
          };
        }).filter((l) => !t.has(l.id)).filter((l) => this.mirror.has(l.id)),
        removes: this.removes,
        adds: e
      };
      !a.texts.length && !a.attributes.length && !a.removes.length && !a.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.removesSubTreeCache = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(a));
    }), Z(this, "genTextAreaValueMutation", (e) => {
      let t = this.attributeMap.get(e);
      t || (t = {
        node: e,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(t), this.attributeMap.set(e, t));
      const n = Array.from(
        B.childNodes(e),
        (i) => B.textContent(i) || ""
      ).join("");
      t.attributes.value = Ki({
        overwriteRecord: null,
        element: e,
        maskInputOptions: this.maskInputOptions,
        tagName: e.tagName,
        type: zi(e),
        value: n,
        maskInputFn: this.maskInputFn
      });
    }), Z(this, "processMutation", (e) => {
      if (!vo(e.target, this.mirror, this.slimDOMOptions))
        switch (e.type) {
          case "characterData": {
            const t = B.textContent(e.target);
            !Se(e.target, this.blockClass, this.blockSelector, !1) && t !== e.oldValue && this.texts.push({
              value: Bh(
                e.target,
                this.maskTextClass,
                this.maskTextSelector,
                !0
                // checkAncestors
              ) && t ? this.maskTextFn ? this.maskTextFn(t, vp(e.target)) : t.replace(/[\S]/g, "*") : t,
              node: e.target
            });
            break;
          }
          case "attributes": {
            const t = e.target;
            let n = e.attributeName, i = e.target.getAttribute(n);
            if (n === "value") {
              const o = zi(t);
              i = Ki({
                element: t,
                maskInputOptions: this.maskInputOptions,
                tagName: t.tagName,
                type: o,
                value: i,
                overwriteRecord: t.getAttribute("data-hl-record"),
                maskInputFn: this.maskInputFn
              });
            }
            if (Se(e.target, this.blockClass, this.blockSelector, !1) || i === e.oldValue)
              return;
            let s = this.attributeMap.get(e.target);
            if (t.tagName === "IFRAME" && n === "src" && !this.keepIframeSrcFn(i))
              if (!t.contentDocument)
                n = "rr_src";
              else
                return;
            if (s || (s = {
              node: e.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(s), this.attributeMap.set(e.target, s)), n === "type" && t.tagName === "INPUT" && (e.oldValue || "").toLowerCase() === "password" && t.setAttribute("data-rr-is-password", "true"), !Jh(t.tagName, n)) {
              if (e.target.tagName === "INPUT") {
                const a = e.target;
                if (a.type === "password") {
                  s.attributes.value = "*".repeat(a.value.length);
                  break;
                }
              }
              if (s.attributes[n] = Hh(
                this.doc,
                vr(t.tagName),
                vr(n),
                i
              ), n === "style") {
                if (!this.unattachedDoc)
                  try {
                    this.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch (l) {
                    this.unattachedDoc = this.doc;
                  }
                const a = this.unattachedDoc.createElement("span");
                e.oldValue && a.setAttribute("style", e.oldValue);
                for (const l of Array.from(t.style)) {
                  const u = t.style.getPropertyValue(l), c = t.style.getPropertyPriority(l);
                  u !== a.style.getPropertyValue(l) || c !== a.style.getPropertyPriority(l) ? c === "" ? s.styleDiff[l] = u : s.styleDiff[l] = [u, c] : s._unchangedStyles[l] = [u, c];
                }
                for (const l of Array.from(a.style))
                  t.style.getPropertyValue(l) === "" && (s.styleDiff[l] = !1);
              } else n === "open" && t.tagName === "DIALOG" && (t.matches("dialog:modal") ? s.attributes.rr_open_mode = "modal" : s.attributes.rr_open_mode = "non-modal");
            }
            break;
          }
          case "childList": {
            if (Se(e.target, this.blockClass, this.blockSelector, !0))
              return;
            if (e.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(e.target);
              return;
            }
            e.addedNodes.forEach((t) => this.genAdds(t, e.target)), e.removedNodes.forEach((t) => {
              const n = this.mirror.getId(t), i = nn(e.target) ? this.mirror.getId(B.host(e.target)) : this.mirror.getId(e.target);
              Se(e.target, this.blockClass, this.blockSelector, !1) || vo(t, this.mirror, this.slimDOMOptions) || !Mw(t, this.mirror) || (this.addedSet.has(t) ? (Ja(this.addedSet, t), this.droppedSet.add(t)) : this.addedSet.has(e.target) && n === -1 || Sp(e.target, this.mirror) || (this.movedSet.has(t) && this.movedMap[Ec(n, i)] ? Ja(this.movedSet, t) : (this.removes.push({
                parentId: i,
                id: n,
                isShadow: nn(e.target) && sn(e.target) ? !0 : void 0
              }), Bw(t, this.removesSubTreeCache))), this.mapRemoves.push(t));
            });
            break;
          }
        }
    }), Z(this, "genAdds", (e, t) => {
      if (!this.processedNodeManager.inOtherBuffer(e, this) && !(this.addedSet.has(e) || this.movedSet.has(e))) {
        if (this.mirror.hasNode(e)) {
          if (vo(e, this.mirror, this.slimDOMOptions))
            return;
          this.movedSet.add(e);
          let n = null;
          t && this.mirror.hasNode(t) && (n = this.mirror.getId(t)), n && n !== -1 && (this.movedMap[Ec(this.mirror.getId(e), n)] = !0);
        } else
          this.addedSet.add(e), this.droppedSet.delete(e);
        Se(e, this.blockClass, this.blockSelector, !1) || (B.childNodes(e).forEach((n) => this.genAdds(n)), Ha(e) && B.childNodes(B.shadowRoot(e)).forEach((n) => {
          this.processedNodeManager.add(n, this), this.genAdds(n, e);
        }));
      }
    });
  }
  init(e) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "inlineVideos",
      "privacySetting",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((t) => {
      this[t] = e[t];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function Ja(r, e) {
  r.delete(e), B.childNodes(e).forEach((t) => Ja(r, t));
}
function Bw(r, e) {
  const t = [r];
  for (; t.length; ) {
    const n = t.pop();
    e.has(n) || (e.add(n), B.childNodes(n).forEach((i) => t.push(i)));
  }
}
function Cc(r, e, t) {
  return r.size === 0 ? !1 : Dw(r, e);
}
function Dw(r, e, t) {
  const n = B.parentNode(e);
  return n ? r.has(n) : !1;
}
function Zc(r, e) {
  return r.size === 0 ? !1 : Ep(r, e);
}
function Ep(r, e) {
  const t = B.parentNode(e);
  return t ? r.has(t) ? !0 : Ep(r, t) : !1;
}
let on;
function Kw(r) {
  on = r;
}
function zw() {
  on = void 0;
}
const j = (r) => on ? (...t) => {
  try {
    return r(...t);
  } catch (n) {
    if (on && on(n) === !0)
      return;
    throw n;
  }
} : r, Mt = [];
function Xn(r) {
  try {
    if ("composedPath" in r) {
      const e = r.composedPath();
      if (e.length)
        return e[0];
    } else if ("path" in r && r.path.length)
      return r.path[0];
  } catch (e) {
  }
  return r && r.target;
}
function Cp(r, e) {
  const t = new Jw();
  Mt.push(t), t.init(r);
  const n = new (mp())(
    j(t.processMutations.bind(t))
  );
  return n.observe(e, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), n;
}
function jw({
  mousemoveCb: r,
  sampling: e,
  doc: t,
  mirror: n
}) {
  if (e.mousemove === !1)
    return () => {
    };
  const i = typeof e.mousemove == "number" ? e.mousemove : 50, s = typeof e.mousemoveCallback == "number" ? e.mousemoveCallback : 500;
  let o = [], a;
  const l = In(
    j(
      (d) => {
        const h = Date.now() - a;
        r(
          o.map((f) => (f.timeOffset -= h, f)),
          d
        ), o = [], a = null;
      }
    ),
    s
  ), u = j(
    In(
      j((d) => {
        const h = Xn(d), { clientX: f, clientY: m } = Fa(d) ? d.changedTouches[0] : d;
        a || (a = os()), o.push({
          x: f,
          y: m,
          id: n.getId(h),
          timeOffset: os() - a
        }), l(
          typeof DragEvent != "undefined" && d instanceof DragEvent ? D.Drag : d instanceof MouseEvent ? D.MouseMove : D.TouchMove
        );
      }),
      i,
      {
        trailing: !1
      }
    )
  ), c = [
    Ee("mousemove", u, t),
    Ee("touchmove", u, t),
    Ee("drag", u, t)
  ];
  return j(() => {
    c.forEach((d) => d());
  });
}
function Qw({
  mouseInteractionCb: r,
  doc: e,
  mirror: t,
  blockClass: n,
  blockSelector: i,
  sampling: s
}) {
  if (s.mouseInteraction === !1)
    return () => {
    };
  const o = s.mouseInteraction === !0 || s.mouseInteraction === void 0 ? {} : s.mouseInteraction, a = [];
  let l = null;
  const u = (c) => (d) => {
    const h = Xn(d);
    if (Se(h, n, i, !0) || // We ignore canvas elements for rage click detection because we cannot infer what inside the canvas is getting interacted with.
    Pw(h))
      return;
    let f = null, m = c;
    if ("pointerType" in d) {
      switch (d.pointerType) {
        case "mouse":
          f = St.Mouse;
          break;
        case "touch":
          f = St.Touch;
          break;
        case "pen":
          f = St.Pen;
          break;
      }
      f === St.Touch && (Le[c] === Le.MouseDown ? m = "TouchStart" : Le[c] === Le.MouseUp && (m = "TouchEnd"));
    } else Fa(d) && (f = St.Touch);
    f !== null ? (l = f, (m.startsWith("Touch") && f === St.Touch || m.startsWith("Mouse") && f === St.Mouse) && (f = null)) : Le[c] === Le.Click && (f = l, l = null);
    const p = Fa(d) ? d.changedTouches[0] : d;
    if (!p)
      return;
    const g = t.getId(h), { clientX: y, clientY: _ } = p;
    j(r)(I({
      type: Le[m],
      id: g,
      x: y,
      y: _
    }, f !== null && { pointerType: f }));
  };
  return Object.keys(Le).filter(
    (c) => Number.isNaN(Number(c)) && !c.endsWith("_Departed") && o[c] !== !1
  ).forEach((c) => {
    let d = vr(c);
    const h = u(c);
    if (window.PointerEvent)
      switch (Le[c]) {
        case Le.MouseDown:
        case Le.MouseUp:
          d = d.replace(
            "mouse",
            "pointer"
          );
          break;
        case Le.TouchStart:
        case Le.TouchEnd:
          return;
      }
    a.push(Ee(d, h, e));
  }), j(() => {
    a.forEach((c) => c());
  });
}
function Zp({
  scrollCb: r,
  doc: e,
  mirror: t,
  blockClass: n,
  blockSelector: i,
  sampling: s
}) {
  const o = j(
    In(
      j((a) => {
        const l = Xn(a);
        if (!l || Se(l, n, i, !0))
          return;
        const u = t.getId(l);
        if (l === e && e.defaultView) {
          const c = gp(e.defaultView);
          r({
            id: u,
            x: c.left,
            y: c.top
          });
        } else
          r({
            id: u,
            x: l.scrollLeft,
            y: l.scrollTop
          });
      }),
      s.scroll || 100
    )
  );
  return Ee("scroll", o, e);
}
function $w({ viewportResizeCb: r }, { win: e }) {
  let t = -1, n = -1;
  const i = j(
    In(
      j(() => {
        const s = yp(), o = bp();
        (t !== s || n !== o) && (r({
          width: Number(o),
          height: Number(s)
        }), t = s, n = o);
      }),
      200
    )
  );
  return Ee("resize", i, e);
}
const qw = ["INPUT", "TEXTAREA", "SELECT"], Gc = /* @__PURE__ */ new WeakMap();
function e_({
  inputCb: r,
  doc: e,
  mirror: t,
  blockClass: n,
  blockSelector: i,
  ignoreClass: s,
  ignoreSelector: o,
  maskInputOptions: a,
  maskInputFn: l,
  sampling: u,
  userTriggeredOnInput: c
}) {
  function d(_) {
    let S = Xn(_);
    const C = _.isTrusted, R = S && S.tagName;
    if (S && R === "OPTION" && (S = B.parentElement(S)), !S || !R || qw.indexOf(R) < 0 || Se(S, n, i, !0) || S.classList.contains(s) || o && S.matches(o))
      return;
    let L = S.value, k = !1;
    const x = zi(S) || "", E = S.getAttribute("data-hl-record");
    x === "radio" || x === "checkbox" ? k = S.checked : Yh({
      maskInputOptions: a,
      type: x,
      tagName: R,
      overwriteRecord: E
    }) && (L = Ki({
      element: S,
      maskInputOptions: a,
      tagName: R,
      type: x,
      value: L,
      overwriteRecord: E,
      maskInputFn: l
    })), h(
      S,
      c ? { text: L, isChecked: k, userTriggered: C } : { text: L, isChecked: k }
    );
    const G = S.name;
    x === "radio" && G && k && e.querySelectorAll(`input[type="radio"][name="${G}"]`).forEach((O) => {
      if (O !== S) {
        const q = O.value;
        h(
          O,
          c ? { text: q, isChecked: !k, userTriggered: !1 } : { text: q, isChecked: !k }
        );
      }
    });
  }
  function h(_, S) {
    const C = Gc.get(_);
    if (!C || C.text !== S.text || C.isChecked !== S.isChecked) {
      Gc.set(_, S);
      const R = t.getId(_);
      j(r)(M(I({}, S), {
        id: R
      }));
    }
  }
  const m = (u.input === "last" ? ["change"] : ["input", "change"]).map(
    (_) => Ee(_, j(d), e)
  ), p = e.defaultView;
  if (!p)
    return () => {
      m.forEach((_) => _());
    };
  const g = p.Object.getOwnPropertyDescriptor(
    p.HTMLInputElement.prototype,
    "value"
  ), y = [
    [p.HTMLInputElement.prototype, "value"],
    [p.HTMLInputElement.prototype, "checked"],
    [p.HTMLSelectElement.prototype, "value"],
    [p.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [p.HTMLSelectElement.prototype, "selectedIndex"],
    [p.HTMLOptionElement.prototype, "selected"]
  ];
  return g && g.set && m.push(
    ...y.map(
      (_) => ks(
        _[0],
        _[1],
        {
          set() {
            j(d)({
              target: this,
              isTrusted: !1
              // userTriggered to false as this could well be programmatic
            });
          }
        },
        !1,
        p
      )
    )
  ), j(() => {
    m.forEach((_) => _());
  });
}
function as(r) {
  const e = [];
  function t(n, i) {
    if (hi("CSSGroupingRule") && n.parentRule instanceof CSSGroupingRule || hi("CSSMediaRule") && n.parentRule instanceof CSSMediaRule || hi("CSSSupportsRule") && n.parentRule instanceof CSSSupportsRule || hi("CSSConditionRule") && n.parentRule instanceof CSSConditionRule) {
      const o = Array.from(
        n.parentRule.cssRules
      ).indexOf(n);
      i.unshift(o);
    } else if (n.parentStyleSheet) {
      const o = Array.from(n.parentStyleSheet.cssRules).indexOf(n);
      i.unshift(o);
    }
    return i;
  }
  return t(r, e);
}
function _t(r, e, t) {
  let n, i;
  return r ? (r.ownerNode ? n = e.getId(r.ownerNode) : i = t.getId(r), {
    styleId: i,
    id: n
  }) : {};
}
function t_({ styleSheetRuleCb: r, mirror: e, stylesheetManager: t }, { win: n }) {
  if (!n.CSSStyleSheet || !n.CSSStyleSheet.prototype)
    return () => {
    };
  const i = n.CSSStyleSheet.prototype.insertRule;
  n.CSSStyleSheet.prototype.insertRule = new Proxy(i, {
    apply: j(
      (c, d, h) => {
        const [f, m] = h, { id: p, styleId: g } = _t(
          d,
          e,
          t.styleMirror
        );
        return (p && p !== -1 || g && g !== -1) && r({
          id: p,
          styleId: g,
          adds: [{ rule: f, index: m }]
        }), c.apply(d, h);
      }
    )
  }), n.CSSStyleSheet.prototype.addRule = function(c, d, h = this.cssRules.length) {
    const f = `${c} { ${d} }`;
    return n.CSSStyleSheet.prototype.insertRule.apply(this, [f, h]);
  };
  const s = n.CSSStyleSheet.prototype.deleteRule;
  n.CSSStyleSheet.prototype.deleteRule = new Proxy(s, {
    apply: j(
      (c, d, h) => {
        const [f] = h, { id: m, styleId: p } = _t(
          d,
          e,
          t.styleMirror
        );
        return (m && m !== -1 || p && p !== -1) && r({
          id: m,
          styleId: p,
          removes: [{ index: f }]
        }), c.apply(d, h);
      }
    )
  }), n.CSSStyleSheet.prototype.removeRule = function(c) {
    return n.CSSStyleSheet.prototype.deleteRule.apply(this, [c]);
  };
  let o;
  n.CSSStyleSheet.prototype.replace && (o = n.CSSStyleSheet.prototype.replace, n.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: j(
      (c, d, h) => {
        const [f] = h, { id: m, styleId: p } = _t(
          d,
          e,
          t.styleMirror
        );
        return (m && m !== -1 || p && p !== -1) && r({
          id: m,
          styleId: p,
          replace: f
        }), c.apply(d, h);
      }
    )
  }));
  let a;
  n.CSSStyleSheet.prototype.replaceSync && (a = n.CSSStyleSheet.prototype.replaceSync, n.CSSStyleSheet.prototype.replaceSync = new Proxy(a, {
    apply: j(
      (c, d, h) => {
        const [f] = h, { id: m, styleId: p } = _t(
          d,
          e,
          t.styleMirror
        );
        return (m && m !== -1 || p && p !== -1) && r({
          id: m,
          styleId: p,
          replaceSync: f
        }), c.apply(d, h);
      }
    )
  }));
  const l = {};
  fi("CSSGroupingRule") ? l.CSSGroupingRule = n.CSSGroupingRule : (fi("CSSMediaRule") && (l.CSSMediaRule = n.CSSMediaRule), fi("CSSConditionRule") && (l.CSSConditionRule = n.CSSConditionRule), fi("CSSSupportsRule") && (l.CSSSupportsRule = n.CSSSupportsRule));
  const u = {};
  return Object.entries(l).forEach(([c, d]) => {
    u[c] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: d.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: d.prototype.deleteRule
    }, d.prototype.insertRule = new Proxy(
      u[c].insertRule,
      {
        apply: j(
          (h, f, m) => {
            const [p, g] = m, { id: y, styleId: _ } = _t(
              f.parentStyleSheet,
              e,
              t.styleMirror
            );
            return (y && y !== -1 || _ && _ !== -1) && r({
              id: y,
              styleId: _,
              adds: [
                {
                  rule: p,
                  index: [
                    ...as(f),
                    g || 0
                    // defaults to 0
                  ]
                }
              ]
            }), h.apply(f, m);
          }
        )
      }
    ), d.prototype.deleteRule = new Proxy(
      u[c].deleteRule,
      {
        apply: j(
          (h, f, m) => {
            const [p] = m, { id: g, styleId: y } = _t(
              f.parentStyleSheet,
              e,
              t.styleMirror
            );
            return (g && g !== -1 || y && y !== -1) && r({
              id: g,
              styleId: y,
              removes: [
                { index: [...as(f), p] }
              ]
            }), h.apply(f, m);
          }
        )
      }
    );
  }), j(() => {
    n.CSSStyleSheet.prototype.insertRule = i, n.CSSStyleSheet.prototype.deleteRule = s, o && (n.CSSStyleSheet.prototype.replace = o), a && (n.CSSStyleSheet.prototype.replaceSync = a), Object.entries(l).forEach(([c, d]) => {
      d.prototype.insertRule = u[c].insertRule, d.prototype.deleteRule = u[c].deleteRule;
    });
  });
}
function Gp({
  mirror: r,
  stylesheetManager: e
}, t) {
  var n, i, s;
  let o = null;
  t.nodeName === "#document" ? o = r.getId(t) : o = r.getId(B.host(t));
  const a = t.nodeName === "#document" ? (n = t.defaultView) == null ? void 0 : n.Document : (s = (i = t.ownerDocument) == null ? void 0 : i.defaultView) == null ? void 0 : s.ShadowRoot, l = a != null && a.prototype ? Object.getOwnPropertyDescriptor(
    a == null ? void 0 : a.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  return o === null || o === -1 || !a || !l ? () => {
  } : (Object.defineProperty(t, "adoptedStyleSheets", {
    configurable: l.configurable,
    enumerable: l.enumerable,
    get() {
      var u;
      return (u = l.get) == null ? void 0 : u.call(this);
    },
    set(u) {
      var c;
      const d = (c = l.set) == null ? void 0 : c.call(this, u);
      if (o !== null && o !== -1)
        try {
          e.adoptStyleSheets(u, o);
        } catch (h) {
        }
      return d;
    }
  }), j(() => {
    Object.defineProperty(t, "adoptedStyleSheets", {
      configurable: l.configurable,
      enumerable: l.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: l.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: l.set
    });
  }));
}
function r_({
  styleDeclarationCb: r,
  mirror: e,
  ignoreCSSAttributes: t,
  stylesheetManager: n
}, { win: i }) {
  const s = i.CSSStyleDeclaration.prototype.setProperty;
  i.CSSStyleDeclaration.prototype.setProperty = new Proxy(s, {
    apply: j(
      (a, l, u) => {
        var c;
        const [d, h, f] = u;
        if (t.has(d))
          return s.apply(l, [d, h, f]);
        const { id: m, styleId: p } = _t(
          (c = l.parentRule) == null ? void 0 : c.parentStyleSheet,
          e,
          n.styleMirror
        );
        return (m && m !== -1 || p && p !== -1) && r({
          id: m,
          styleId: p,
          set: {
            property: d,
            value: h,
            priority: f
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: as(l.parentRule)
        }), a.apply(l, u);
      }
    )
  });
  const o = i.CSSStyleDeclaration.prototype.removeProperty;
  return i.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: j(
      (a, l, u) => {
        var c;
        const [d] = u;
        if (t.has(d))
          return o.apply(l, [d]);
        const { id: h, styleId: f } = _t(
          (c = l.parentRule) == null ? void 0 : c.parentStyleSheet,
          e,
          n.styleMirror
        );
        return (h && h !== -1 || f && f !== -1) && r({
          id: h,
          styleId: f,
          remove: {
            property: d
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: as(l.parentRule)
        }), a.apply(l, u);
      }
    )
  }), j(() => {
    i.CSSStyleDeclaration.prototype.setProperty = s, i.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function n_({
  mediaInteractionCb: r,
  blockClass: e,
  blockSelector: t,
  mirror: n,
  sampling: i,
  doc: s
}) {
  const o = j(
    (l) => In(
      j((u) => {
        const c = Xn(u);
        if (!c || Se(c, e, t, !0))
          return;
        const { currentTime: d, volume: h, muted: f, playbackRate: m, loop: p } = c;
        r({
          type: l,
          id: n.getId(c),
          currentTime: d,
          volume: h,
          muted: f,
          playbackRate: m,
          loop: p
        });
      }),
      i.media || 500
    )
  ), a = [
    Ee("play", o(lr.Play), s),
    Ee("pause", o(lr.Pause), s),
    Ee("seeked", o(lr.Seeked), s),
    Ee("volumechange", o(lr.VolumeChange), s),
    Ee("ratechange", o(lr.RateChange), s)
  ];
  return j(() => {
    a.forEach((l) => l());
  });
}
function i_({ fontCb: r, doc: e }) {
  const t = e.defaultView;
  if (!t)
    return () => {
    };
  const n = [], i = /* @__PURE__ */ new WeakMap(), s = t.FontFace;
  t.FontFace = function(l, u, c) {
    const d = new s(l, u, c);
    return i.set(d, {
      family: l,
      buffer: typeof u != "string",
      descriptors: c,
      fontSource: typeof u == "string" ? u : JSON.stringify(Array.from(new Uint8Array(u)))
    }), d;
  };
  const o = jt(
    e.fonts,
    "add",
    function(a) {
      return function(l) {
        return setTimeout(
          j(() => {
            const u = i.get(l);
            u && (r(u), i.delete(l));
          }),
          0
        ), a.apply(this, [l]);
      };
    }
  );
  return n.push(() => {
    t.FontFace = s;
  }), n.push(o), j(() => {
    n.forEach((a) => a());
  });
}
function s_(r) {
  const { doc: e, mirror: t, blockClass: n, blockSelector: i, selectionCb: s } = r;
  let o = !0;
  const a = j(() => {
    const l = e.getSelection();
    if (!l || o && (l != null && l.isCollapsed)) return;
    o = l.isCollapsed || !1;
    const u = [], c = l.rangeCount || 0;
    for (let d = 0; d < c; d++) {
      const h = l.getRangeAt(d), { startContainer: f, startOffset: m, endContainer: p, endOffset: g } = h;
      Se(f, n, i, !0) || Se(p, n, i, !0) || u.push({
        start: t.getId(f),
        startOffset: m,
        end: t.getId(p),
        endOffset: g
      });
    }
    s({ ranges: u });
  });
  return a(), Ee("selectionchange", a);
}
function o_({
  doc: r,
  customElementCb: e
}) {
  const t = r.defaultView;
  return !t || !t.customElements ? () => {
  } : jt(
    t.customElements,
    "define",
    function(i) {
      return function(s, o, a) {
        try {
          e({
            define: {
              name: s
            }
          });
        } catch (l) {
          console.warn(`Custom element callback failed for ${s}`);
        }
        return i.apply(this, [s, o, a]);
      };
    }
  );
}
function a_(r, e) {
  const {
    mutationCb: t,
    mousemoveCb: n,
    mouseInteractionCb: i,
    scrollCb: s,
    viewportResizeCb: o,
    inputCb: a,
    mediaInteractionCb: l,
    styleSheetRuleCb: u,
    styleDeclarationCb: c,
    canvasMutationCb: d,
    fontCb: h,
    selectionCb: f,
    customElementCb: m
  } = r;
  r.mutationCb = (...p) => {
    e.mutation && e.mutation(...p), t(...p);
  }, r.mousemoveCb = (...p) => {
    e.mousemove && e.mousemove(...p), n(...p);
  }, r.mouseInteractionCb = (...p) => {
    e.mouseInteraction && e.mouseInteraction(...p), i(...p);
  }, r.scrollCb = (...p) => {
    e.scroll && e.scroll(...p), s(...p);
  }, r.viewportResizeCb = (...p) => {
    e.viewportResize && e.viewportResize(...p), o(...p);
  }, r.inputCb = (...p) => {
    e.input && e.input(...p), a(...p);
  }, r.mediaInteractionCb = (...p) => {
    e.mediaInteaction && e.mediaInteaction(...p), l(...p);
  }, r.styleSheetRuleCb = (...p) => {
    e.styleSheetRule && e.styleSheetRule(...p), u(...p);
  }, r.styleDeclarationCb = (...p) => {
    e.styleDeclaration && e.styleDeclaration(...p), c(...p);
  }, r.canvasMutationCb = (...p) => {
    e.canvasMutation && e.canvasMutation(...p), d(...p);
  }, r.fontCb = (...p) => {
    e.font && e.font(...p), h(...p);
  }, r.selectionCb = (...p) => {
    e.selection && e.selection(...p), f(...p);
  }, r.customElementCb = (...p) => {
    e.customElement && e.customElement(...p), m(...p);
  };
}
function l_(r, e = {}) {
  const t = r.doc.defaultView;
  if (!t)
    return () => {
    };
  a_(r, e);
  let n;
  r.recordDOM && (n = Cp(r, r.doc));
  const i = jw(r), s = Qw(r), o = Zp(r), a = $w(r, {
    win: t
  }), l = e_(r), u = n_(r);
  let c = () => {
  }, d = () => {
  }, h = () => {
  }, f = () => {
  };
  r.recordDOM && (c = t_(r, { win: t }), d = Gp(r, r.doc), h = r_(r, {
    win: t
  }), r.collectFonts && (f = i_(r)));
  const m = s_(r), p = o_(r), g = [];
  for (const y of r.plugins)
    g.push(
      y.observer(y.callback, t, y.options)
    );
  return j(() => {
    Mt.forEach((y) => y.reset()), n == null || n.disconnect(), i(), s(), o(), a(), l(), u(), c(), d(), h(), f(), m(), p(), g.forEach((y) => y());
  });
}
function hi(r) {
  return typeof window[r] != "undefined";
}
function fi(r) {
  return !!(typeof window[r] != "undefined" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[r].prototype && "insertRule" in window[r].prototype && "deleteRule" in window[r].prototype);
}
class Lc {
  constructor(e) {
    Z(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap()), Z(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap()), this.generateIdFn = e;
  }
  getId(e, t, n, i) {
    const s = n || this.getIdToRemoteIdMap(e), o = i || this.getRemoteIdToIdMap(e);
    let a = s.get(t);
    return a || (a = this.generateIdFn(), s.set(t, a), o.set(a, t)), a;
  }
  getIds(e, t) {
    const n = this.getIdToRemoteIdMap(e), i = this.getRemoteIdToIdMap(e);
    return t.map(
      (s) => this.getId(e, s, n, i)
    );
  }
  getRemoteId(e, t, n) {
    const i = n || this.getRemoteIdToIdMap(e);
    if (typeof t != "number") return t;
    const s = i.get(t);
    return s || -1;
  }
  getRemoteIds(e, t) {
    const n = this.getRemoteIdToIdMap(e);
    return t.map((i) => this.getRemoteId(e, i, n));
  }
  reset(e) {
    if (!e) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e);
  }
  getIdToRemoteIdMap(e) {
    let t = this.iframeIdToRemoteIdMap.get(e);
    return t || (t = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(e, t)), t;
  }
  getRemoteIdToIdMap(e) {
    let t = this.iframeRemoteIdToIdMap.get(e);
    return t || (t = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(e, t)), t;
  }
}
class u_ {
  constructor(e) {
    Z(this, "iframes", /* @__PURE__ */ new WeakMap()), Z(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap()), Z(this, "crossOriginIframeMirror", new Lc(Fh)), Z(this, "crossOriginIframeStyleMirror"), Z(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap()), Z(this, "mirror"), Z(this, "mutationCb"), Z(this, "wrappedEmit"), Z(this, "loadListener"), Z(this, "stylesheetManager"), Z(this, "recordCrossOriginIframes"), this.mutationCb = e.mutationCb, this.wrappedEmit = e.wrappedEmit, this.stylesheetManager = e.stylesheetManager, this.recordCrossOriginIframes = e.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Lc(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    ), this.mirror = e.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(e) {
    this.iframes.set(e, !0), e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e);
  }
  addLoadListener(e) {
    this.loadListener = e;
  }
  attachIframe(e, t) {
    var n, i;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(e),
          nextId: null,
          node: t
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && ((n = e.contentWindow) == null || n.addEventListener(
      "message",
      this.handleMessage.bind(this)
    )), (i = this.loadListener) == null || i.call(this, e), e.contentDocument && e.contentDocument.adoptedStyleSheets && e.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(
      e.contentDocument.adoptedStyleSheets,
      this.mirror.getId(e.contentDocument)
    );
  }
  handleMessage(e) {
    const t = e;
    if (t.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    t.origin !== t.data.origin)
      return;
    const n = e.source;
    if (!n) return;
    const i = this.crossOriginIframeMap.get(n);
    if (!i) return;
    const s = this.transformCrossOriginEvent(
      i,
      t.data.event
    );
    s && this.wrappedEmit(
      s,
      t.data.isCheckout
    );
  }
  transformCrossOriginEvent(e, t) {
    var n;
    switch (t.type) {
      case Q.FullSnapshot: {
        this.crossOriginIframeMirror.reset(e), this.crossOriginIframeStyleMirror.reset(e), this.replaceIdOnNode(t.data.node, e);
        const i = t.data.node.id;
        return this.crossOriginIframeRootIdMap.set(e, i), this.patchRootIdOnNode(t.data.node, i), {
          timestamp: t.timestamp,
          type: Q.IncrementalSnapshot,
          data: {
            source: D.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(e),
                nextId: null,
                node: t.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case Q.Meta:
      case Q.Load:
      case Q.DomContentLoaded:
        return !1;
      case Q.Plugin:
        return t;
      case Q.Custom:
        return this.replaceIds(
          t.data.payload,
          e,
          ["id", "parentId", "previousId", "nextId"]
        ), t;
      case Q.IncrementalSnapshot:
        switch (t.data.source) {
          case D.Mutation:
            return t.data.adds.forEach((i) => {
              this.replaceIds(i, e, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(i.node, e);
              const s = this.crossOriginIframeRootIdMap.get(e);
              s && this.patchRootIdOnNode(i.node, s);
            }), t.data.removes.forEach((i) => {
              this.replaceIds(i, e, ["parentId", "id"]);
            }), t.data.attributes.forEach((i) => {
              this.replaceIds(i, e, ["id"]);
            }), t.data.texts.forEach((i) => {
              this.replaceIds(i, e, ["id"]);
            }), t;
          case D.Drag:
          case D.TouchMove:
          case D.MouseMove:
            return t.data.positions.forEach((i) => {
              this.replaceIds(i, e, ["id"]);
            }), t;
          case D.ViewportResize:
            return !1;
          case D.MediaInteraction:
          case D.MouseInteraction:
          case D.Scroll:
          case D.CanvasMutation:
          case D.Input:
            return this.replaceIds(t.data, e, ["id"]), t;
          case D.StyleSheetRule:
          case D.StyleDeclaration:
            return this.replaceIds(t.data, e, ["id"]), this.replaceStyleIds(t.data, e, ["styleId"]), t;
          case D.Font:
            return t;
          case D.Selection:
            return t.data.ranges.forEach((i) => {
              this.replaceIds(i, e, ["start", "end"]);
            }), t;
          case D.AdoptedStyleSheet:
            return this.replaceIds(t.data, e, ["id"]), this.replaceStyleIds(t.data, e, ["styleIds"]), (n = t.data.styles) == null || n.forEach((i) => {
              this.replaceStyleIds(i, e, ["styleId"]);
            }), t;
        }
    }
    return !1;
  }
  replace(e, t, n, i) {
    for (const s of i)
      !Array.isArray(t[s]) && typeof t[s] != "number" || (Array.isArray(t[s]) ? t[s] = e.getIds(
        n,
        t[s]
      ) : t[s] = e.getId(n, t[s]));
    return t;
  }
  replaceIds(e, t, n) {
    return this.replace(this.crossOriginIframeMirror, e, t, n);
  }
  replaceStyleIds(e, t, n) {
    return this.replace(this.crossOriginIframeStyleMirror, e, t, n);
  }
  replaceIdOnNode(e, t) {
    this.replaceIds(e, t, ["id", "rootId"]), "childNodes" in e && e.childNodes.forEach((n) => {
      this.replaceIdOnNode(n, t);
    });
  }
  patchRootIdOnNode(e, t) {
    e.type !== Tp.Document && !e.rootId && (e.rootId = t), "childNodes" in e && e.childNodes.forEach((n) => {
      this.patchRootIdOnNode(n, t);
    });
  }
}
class c_ {
  constructor(e) {
    Z(this, "shadowDoms", /* @__PURE__ */ new WeakSet()), Z(this, "mutationCb"), Z(this, "scrollCb"), Z(this, "bypassOptions"), Z(this, "mirror"), Z(this, "restoreHandlers", []), this.mutationCb = e.mutationCb, this.scrollCb = e.scrollCb, this.bypassOptions = e.bypassOptions, this.mirror = e.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(e, t) {
    if (!sn(e) || this.shadowDoms.has(e)) return;
    this.shadowDoms.add(e);
    const n = Cp(
      M(I({}, this.bypassOptions), {
        doc: t,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      }),
      e
    );
    this.restoreHandlers.push(() => n.disconnect()), this.restoreHandlers.push(
      Zp(M(I({}, this.bypassOptions), {
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: e,
        mirror: this.mirror
      }))
    ), setTimeout(() => {
      e.adoptedStyleSheets && e.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(
        e.adoptedStyleSheets,
        this.mirror.getId(B.host(e))
      ), this.restoreHandlers.push(
        Gp(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          e
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(e) {
    !e.contentWindow || !e.contentDocument || this.patchAttachShadow(
      e.contentWindow.Element,
      e.contentDocument
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(e, t) {
    const n = this;
    this.restoreHandlers.push(
      jt(
        e.prototype,
        "attachShadow",
        function(i) {
          return function(s) {
            const o = i.call(this, s), a = B.shadowRoot(this);
            return a && Ip(this) && n.addShadowRoot(a, t), o;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((e) => {
      try {
        e();
      } catch (t) {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
var pr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", d_ = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256);
for (var pi = 0; pi < pr.length; pi++)
  d_[pr.charCodeAt(pi)] = pi;
var h_ = function(r) {
  var e = new Uint8Array(r), t, n = e.length, i = "";
  for (t = 0; t < n; t += 3)
    i += pr[e[t] >> 2], i += pr[(e[t] & 3) << 4 | e[t + 1] >> 4], i += pr[(e[t + 1] & 15) << 2 | e[t + 2] >> 6], i += pr[e[t + 2] & 63];
  return n % 3 === 2 ? i = i.substring(0, i.length - 1) + "=" : n % 3 === 1 && (i = i.substring(0, i.length - 2) + "=="), i;
};
const Nc = /* @__PURE__ */ new Map();
function f_(r, e) {
  let t = Nc.get(r);
  return t || (t = /* @__PURE__ */ new Map(), Nc.set(r, t)), t.has(e) || t.set(e, []), t.get(e);
}
const Lp = (r, e, t) => {
  if (!r || !(Vp(r, e) || typeof r == "object"))
    return;
  const n = r.constructor.name, i = f_(t, n);
  let s = i.indexOf(r);
  return s === -1 && (s = i.length, i.push(r)), s;
};
function ki(r, e, t) {
  if (r instanceof Array)
    return r.map((n) => ki(n, e, t));
  if (r === null)
    return r;
  if (r instanceof Float32Array || r instanceof Float64Array || r instanceof Int32Array || r instanceof Uint32Array || r instanceof Uint8Array || r instanceof Uint16Array || r instanceof Int16Array || r instanceof Int8Array || r instanceof Uint8ClampedArray)
    return {
      rr_type: r.constructor.name,
      args: [Object.values(r)]
    };
  if (
    // SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    r instanceof ArrayBuffer
  ) {
    const n = r.constructor.name, i = h_(r);
    return {
      rr_type: n,
      base64: i
    };
  } else {
    if (r instanceof DataView)
      return {
        rr_type: r.constructor.name,
        args: [
          ki(r.buffer, e, t),
          r.byteOffset,
          r.byteLength
        ]
      };
    if (r instanceof HTMLImageElement) {
      const n = r.constructor.name, { src: i } = r;
      return {
        rr_type: n,
        src: i
      };
    } else if (r instanceof HTMLCanvasElement) {
      const n = "HTMLImageElement", i = r.toDataURL();
      return {
        rr_type: n,
        src: i
      };
    } else {
      if (r instanceof ImageData)
        return {
          rr_type: r.constructor.name,
          args: [ki(r.data, e, t), r.width, r.height]
        };
      if (Vp(r, e) || typeof r == "object") {
        const n = r.constructor.name, i = Lp(r, e, t);
        return {
          rr_type: n,
          index: i
        };
      }
    }
  }
  return r;
}
const Np = (r, e, t) => r.map((n) => ki(n, e, t)), Vp = (r, e) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
  "WebGLVertexArrayObjectOES"
].filter(
  (i) => typeof e[i] == "function"
).find(
  (i) => r instanceof e[i]
);
function p_(r, e, t, n) {
  const i = [], s = Object.getOwnPropertyNames(
    e.CanvasRenderingContext2D.prototype
  );
  for (const o of s)
    try {
      if (typeof e.CanvasRenderingContext2D.prototype[o] != "function")
        continue;
      const a = jt(
        e.CanvasRenderingContext2D.prototype,
        o,
        function(l) {
          return function(...u) {
            return Se(this.canvas, t, n, !0) || setTimeout(() => {
              const c = Np(u, e, this);
              r(this.canvas, {
                type: Er["2D"],
                property: o,
                args: c
              });
            }, 0), l.apply(this, u);
          };
        }
      );
      i.push(a);
    } catch (a) {
      const l = ks(
        e.CanvasRenderingContext2D.prototype,
        o,
        {
          set(u) {
            r(this.canvas, {
              type: Er["2D"],
              property: o,
              args: [u],
              setter: !0
            });
          }
        }
      );
      i.push(l);
    }
  return () => {
    i.forEach((o) => o());
  };
}
function m_(r) {
  return r === "experimental-webgl" ? "webgl" : r;
}
function Vc(r, e, t, n) {
  const i = [];
  try {
    const s = jt(
      r.HTMLCanvasElement.prototype,
      "getContext",
      function(o) {
        return function(a, ...l) {
          if (!Se(this, e, t, !0)) {
            const u = m_(a);
            if ("__context" in this || (this.__context = u), n && ["webgl", "webgl2"].includes(u))
              if (l[0] && typeof l[0] == "object") {
                const c = l[0];
                c.preserveDrawingBuffer || (c.preserveDrawingBuffer = !0);
              } else
                l.splice(0, 1, {
                  preserveDrawingBuffer: !0
                });
          }
          return o.apply(this, [a, ...l]);
        };
      }
    );
    i.push(s);
  } catch (s) {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    i.forEach((s) => s());
  };
}
function xc(r, e, t, n, i, s) {
  const o = [], a = Object.getOwnPropertyNames(r);
  for (const l of a)
    if (
      //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
      ![
        "isContextLost",
        "canvas",
        "drawingBufferWidth",
        "drawingBufferHeight"
      ].includes(l)
    )
      try {
        if (typeof r[l] != "function")
          continue;
        const u = jt(
          r,
          l,
          function(c) {
            return function(...d) {
              const h = c.apply(this, d);
              if (Lp(h, s, this), "tagName" in this.canvas && !Se(
                this.canvas,
                n,
                i,
                !0
              )) {
                const f = Np(d, s, this), m = {
                  type: e,
                  property: l,
                  args: f
                };
                t(this.canvas, m);
              }
              return h;
            };
          }
        );
        o.push(u);
      } catch (u) {
        const c = ks(r, l, {
          set(d) {
            t(this.canvas, {
              type: e,
              property: l,
              args: [d],
              setter: !0
            });
          }
        });
        o.push(c);
      }
  return o;
}
function g_(r, e, t, n) {
  const i = [];
  return i.push(
    ...xc(
      e.WebGLRenderingContext.prototype,
      Er.WebGL,
      r,
      t,
      n,
      e
    )
  ), typeof e.WebGL2RenderingContext != "undefined" && i.push(
    ...xc(
      e.WebGL2RenderingContext.prototype,
      Er.WebGL2,
      r,
      t,
      n,
      e
    )
  ), () => {
    i.forEach((s) => s());
  };
}
const xp = "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", y_ = (r) => Uint8Array.from(atob(r), (e) => e.charCodeAt(0)), Oc = typeof self != "undefined" && self.Blob && new Blob([y_(xp)], { type: "text/javascript;charset=utf-8" });
function b_(r) {
  let e;
  try {
    if (e = Oc && (self.URL || self.webkitURL).createObjectURL(Oc), !e) throw "";
    const t = new Worker(e, {
      name: r == null ? void 0 : r.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), t;
  } catch (t) {
    return new Worker(
      "data:text/javascript;base64," + xp,
      {
        name: r == null ? void 0 : r.name
      }
    );
  } finally {
    e && (self.URL || self.webkitURL).revokeObjectURL(e);
  }
}
class v_ {
  constructor(e) {
    Z(this, "pendingCanvasMutations", /* @__PURE__ */ new Map()), Z(this, "rafStamps", { latestId: 0, invokeId: null }), Z(this, "mirror"), Z(this, "logger"), Z(this, "worker"), Z(this, "snapshotInProgressMap", /* @__PURE__ */ new Map()), Z(this, "lastSnapshotTime", /* @__PURE__ */ new Map()), Z(this, "options"), Z(this, "mutationCb"), Z(this, "resetObservers"), Z(this, "frozen", !1), Z(this, "locked", !1), Z(this, "processMutation", (d, h) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(d) || this.pendingCanvasMutations.set(d, []), this.pendingCanvasMutations.get(d).push(h);
    });
    const {
      sampling: t,
      win: n,
      blockClass: i,
      blockSelector: s,
      recordCanvas: o,
      recordLocalVideos: a,
      recordRemoteVideos: l,
      initialSnapshotDelay: u,
      dataURLOptions: c
    } = e;
    this.mutationCb = e.mutationCb, this.mirror = e.mirror, this.logger = e.logger, this.worker = new b_(), this.worker.onmessage = (d) => {
      const { id: h } = d.data;
      if (this.snapshotInProgressMap.set(h, !1), !("base64" in d.data)) {
        this.debug(null, "canvas worker received empty message", {
          id: h,
          data: d.data,
          status: d.data.status
        });
        return;
      }
      const { base64: f, type: m, dx: p, dy: g, dw: y, dh: _ } = d.data, S = {
        id: h,
        type: Er["2D"],
        commands: [
          {
            property: "clearRect",
            // wipe canvas
            args: [p, g, y, _]
          },
          {
            property: "drawImage",
            // draws (semi-transparent) image
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: f }],
                    type: m
                  }
                ]
              },
              p,
              g,
              y,
              _
            ]
          }
        ]
      };
      this.debug(null, "canvas worker recording mutation", S), this.mutationCb(S);
    }, this.options = e, o && t === "all" ? (this.debug(null, "initializing canvas mutation observer", { sampling: t }), this.initCanvasMutationObserver(n, i, s)) : o && typeof t == "number" && (this.debug(null, "initializing canvas fps observer", { sampling: t }), this.initCanvasFPSObserver(
      a,
      l,
      t,
      n,
      i,
      s,
      {
        initialSnapshotDelay: u,
        dataURLOptions: c
      },
      e.resizeFactor,
      e.maxSnapshotDimension
    ));
  }
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  debug(e, ...t) {
    if (!this.logger) return;
    const n = this.mirror.getId(e);
    let i = "[highlight-canvas-manager]";
    e && (i = `[highlight-canvas] [id:${n}]`, e.tagName.toLowerCase() === "canvas" && (i += ` [ctx:${e.__context}]`)), this.logger.debug(i, e, ...t);
  }
  snapshot(e) {
    return $(this, null, function* () {
      var t;
      const n = this.mirror.getId(e);
      if (this.snapshotInProgressMap.get(n)) {
        this.debug(e, "snapshotting already in progress for", n);
        return;
      }
      const i = 1e3 / (typeof this.options.samplingManual == "number" ? this.options.samplingManual : 1), s = this.lastSnapshotTime.get(n);
      if (!(s && (/* @__PURE__ */ new Date()).getTime() - s < i)) {
        if (this.debug(e, "starting snapshotting"), e.width === 0 || e.height === 0) {
          this.debug(e, "not yet ready", {
            width: e.width,
            height: e.height
          });
          return;
        }
        this.lastSnapshotTime.set(n, (/* @__PURE__ */ new Date()).getTime()), this.snapshotInProgressMap.set(n, !0);
        try {
          if (this.options.clearWebGLBuffer !== !1 && ["webgl", "webgl2"].includes(e.__context)) {
            const c = e.getContext(e.__context);
            ((t = c == null ? void 0 : c.getContextAttributes()) == null ? void 0 : t.preserveDrawingBuffer) === !1 && (c.clear(c.COLOR_BUFFER_BIT), this.debug(e, "cleared webgl canvas to load it into memory", {
              attributes: c == null ? void 0 : c.getContextAttributes()
            }));
          }
          if (e.width === 0 || e.height === 0) {
            this.debug(e, "not yet ready", {
              width: e.width,
              height: e.height
            });
            return;
          }
          let o = this.options.resizeFactor || 1;
          if (this.options.maxSnapshotDimension) {
            const c = Math.max(e.width, e.height);
            o = Math.min(o, this.options.maxSnapshotDimension / c);
          }
          const a = e.width * o, l = e.height * o, u = yield createImageBitmap(e, {
            resizeWidth: a,
            resizeHeight: l
          });
          this.debug(e, "created image bitmap", {
            width: u.width,
            height: u.height
          }), this.worker.postMessage(
            {
              id: n,
              bitmap: u,
              width: a,
              height: l,
              dx: 0,
              dy: 0,
              dw: e.width,
              dh: e.height,
              dataURLOptions: this.options.dataURLOptions,
              logDebug: !!this.logger
            },
            [u]
          ), this.debug(e, "sent message");
        } catch (o) {
          this.debug(e, "failed to snapshot", o);
        } finally {
          this.snapshotInProgressMap.set(n, !1);
        }
      }
    });
  }
  initCanvasFPSObserver(e, t, n, i, s, o, a, l, u) {
    const c = Vc(
      i,
      s,
      o,
      !0
    ), d = 1e3 / n;
    let h = 0, f;
    const m = /* @__PURE__ */ new Map(), p = (S, C) => {
      const R = [];
      S.querySelectorAll(C).forEach((x) => R.push(x));
      const L = document.createNodeIterator(S, Node.ELEMENT_NODE);
      let k;
      for (; k = L.nextNode(); )
        k != null && k.shadowRoot && R.push(...p(k.shadowRoot, C));
      return R;
    }, g = (S) => {
      const C = [];
      return p(i.document, "canvas").forEach((R) => {
        if (!Se(R, s, o, !0)) {
          this.debug(R, "discovered canvas"), C.push(R);
          const L = this.mirror.getId(R);
          m.has(L) || m.set(L, S);
        }
      }), C;
    }, y = (S) => {
      const C = [];
      return (e || t) && p(i.document, "video").forEach((R) => {
        if (!(!t && R.src !== "" && R.src.indexOf("blob:") === -1) && !(!e && (R.src === "" || R.src.indexOf("blob:") !== -1)) && !Se(R, s, o, !0)) {
          C.push(R);
          const L = this.mirror.getId(R);
          m.has(L) || m.set(L, S);
        }
      }), C;
    }, _ = (S) => $(this, null, function* () {
      if (h && S - h < d) {
        f = requestAnimationFrame(_);
        return;
      }
      h = S;
      const C = (L) => {
        const k = this.mirror.getId(L), x = m.get(k), E = !a.initialSnapshotDelay || S - x > a.initialSnapshotDelay;
        return this.debug(L, {
          delay: a.initialSnapshotDelay,
          delta: S - x,
          hadLoadingTime: E
        }), E;
      }, R = [];
      R.push(
        ...g(S).filter(C).map((L) => this.snapshot(L))
      ), R.push(
        ...y(S).filter(C).map((L) => $(this, null, function* () {
          this.debug(L, "starting video snapshotting");
          const k = this.mirror.getId(L);
          if (this.snapshotInProgressMap.get(k)) {
            this.debug(
              L,
              "video snapshotting already in progress for",
              k
            );
            return;
          }
          this.snapshotInProgressMap.set(k, !0);
          try {
            const { width: x, height: E } = L.getBoundingClientRect(), { actualWidth: G, actualHeight: O } = {
              actualWidth: L.videoWidth,
              actualHeight: L.videoHeight
            }, q = Math.max(G, O);
            if (q === 0) {
              this.debug(L, "not yet ready", {
                width: L.width,
                height: L.height,
                actualWidth: G,
                actualHeight: O,
                boxWidth: x,
                boxHeight: E
              });
              return;
            }
            let le = l || 1;
            u && (le = Math.min(le, u / q));
            const b = G * le, v = O * le, W = yield createImageBitmap(L, {
              resizeWidth: b,
              resizeHeight: v
            }), re = Math.max(x, E) / q, z = G * re, F = O * re, oe = (x - z) / 2, ce = (E - F) / 2;
            this.debug(L, "created image bitmap", {
              actualWidth: G,
              actualHeight: O,
              boxWidth: x,
              boxHeight: E,
              outputWidth: z,
              outputHeight: F,
              resizeWidth: b,
              resizeHeight: v,
              scale: le,
              outputScale: re,
              offsetX: oe,
              offsetY: ce
            }), this.worker.postMessage(
              {
                id: k,
                bitmap: W,
                width: b,
                height: v,
                dx: oe,
                dy: ce,
                dw: z,
                dh: F,
                dataURLOptions: a.dataURLOptions,
                logDebug: !!this.logger
              },
              [W]
            ), this.debug(L, "send message");
          } catch (x) {
            this.debug(L, "failed to snapshot", x);
          } finally {
            this.snapshotInProgressMap.set(k, !1);
          }
        }))
      ), yield Promise.all(R).catch(console.error), f = requestAnimationFrame(_);
    });
    f = requestAnimationFrame(_), this.resetObservers = () => {
      c(), f && cancelAnimationFrame(f);
    };
  }
  initCanvasMutationObserver(e, t, n) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const i = Vc(
      e,
      t,
      n,
      !1
    ), s = p_(
      this.processMutation.bind(this),
      e,
      t,
      n
    ), o = g_(
      this.processMutation.bind(this),
      e,
      t,
      n
    );
    this.resetObservers = () => {
      i(), s(), o();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const e = (t) => {
      this.rafStamps.latestId = t, requestAnimationFrame(e);
    };
    requestAnimationFrame(e);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach(
      (e, t) => {
        const n = this.mirror.getId(t);
        this.flushPendingCanvasMutationFor(t, n);
      }
    ), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(e, t) {
    if (this.frozen || this.locked)
      return;
    const n = this.pendingCanvasMutations.get(e);
    if (!n || t === -1) return;
    const i = n.map((o) => {
      const u = o, { type: a } = u;
      return Ze(u, ["type"]);
    }), { type: s } = n[0];
    this.mutationCb({ id: t, type: s, commands: i }), this.pendingCanvasMutations.delete(e);
  }
}
class S_ {
  constructor(e) {
    Z(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet()), Z(this, "mutationCb"), Z(this, "adoptedStyleSheetCb"), Z(this, "styleMirror", new Uw()), this.mutationCb = e.mutationCb, this.adoptedStyleSheetCb = e.adoptedStyleSheetCb;
  }
  attachLinkElement(e, t) {
    "_cssText" in t.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: t.id,
          attributes: t.attributes
        }
      ]
    }), this.trackLinkElement(e);
  }
  trackLinkElement(e) {
    this.trackedLinkElements.has(e) || (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
  }
  adoptStyleSheets(e, t) {
    if (e.length === 0) return;
    const n = {
      id: t,
      styleIds: []
    }, i = [];
    for (const s of e) {
      let o;
      this.styleMirror.has(s) ? o = this.styleMirror.getId(s) : (o = this.styleMirror.add(s), i.push({
        styleId: o,
        rules: Array.from(s.rules || CSSRule, (a, l) => ({
          rule: Ph(a, s.href),
          index: l
        }))
      })), n.styleIds.push(o);
    }
    i.length > 0 && (n.styles = i), this.adoptedStyleSheetCb(n);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(e) {
  }
}
class w_ {
  constructor() {
    Z(this, "nodeMap", /* @__PURE__ */ new WeakMap()), Z(this, "active", !1);
  }
  inOtherBuffer(e, t) {
    const n = this.nodeMap.get(e);
    return n && Array.from(n).some((i) => i !== t);
  }
  add(e, t) {
    this.active || (this.active = !0, requestAnimationFrame(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(e, (this.nodeMap.get(e) || /* @__PURE__ */ new Set()).add(t));
  }
  destroy() {
  }
}
let fe, Pi, an, ls = !1;
try {
  if (Array.from([1], (r) => r * 2)[0] !== 2) {
    const r = document.createElement("iframe");
    document.body.appendChild(r), Array.from = ((Ou = r.contentWindow) == null ? void 0 : Ou.Array.from) || Array.from, document.body.removeChild(r);
  }
} catch (r) {
  console.debug("Unable to override Array.from", r);
}
const De = gb();
function ft(r = {}) {
  var e, t, n, i, s, o, a, l;
  const {
    emit: u,
    checkoutEveryNms: c,
    checkoutEveryNth: d,
    blockClass: h = "highlight-block",
    blockSelector: f = null,
    ignoreClass: m = "highlight-ignore",
    ignoreSelector: p = null,
    maskTextClass: g = "highlight-mask",
    maskTextSelector: y = null,
    inlineStylesheet: _ = !0,
    maskAllInputs: S,
    maskInputOptions: C,
    slimDOMOptions: R,
    maskInputFn: L,
    maskTextFn: k = Gl,
    hooks: x,
    packFn: E,
    sampling: G = {},
    mousemoveWait: O,
    recordDOM: q = !0,
    recordCanvas: le = !1,
    recordCrossOriginIframes: b = !1,
    recordAfter: v = r.recordAfter === "DOMContentLoaded" ? r.recordAfter : "load",
    userTriggeredOnInput: W = !1,
    collectFonts: re = !1,
    inlineImages: z = !1,
    inlineVideos: F = !1,
    plugins: oe,
    keepIframeSrcFn: ce = () => !1,
    privacySetting: He = "default",
    ignoreCSSAttributes: vt = /* @__PURE__ */ new Set([]),
    errorHandler: kg,
    logger: Pg
  } = r, Un = I(I({}, r.dataURLOptions), (t = (e = r.sampling) == null ? void 0 : e.canvas) == null ? void 0 : t.dataURLOptions);
  Kw(kg);
  const Yn = b ? window.parent === window : !0;
  let Or = !1;
  if (!Yn)
    try {
      window.parent.document && (Or = !1);
    } catch (te) {
      Or = !0;
    }
  if (Yn && !u)
    throw new Error("emit function is required");
  if (!Yn && !Or)
    return () => {
    };
  O !== void 0 && G.mousemove === void 0 && (G.mousemove = O), De.reset();
  const Ks = S === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : C !== void 0 ? C : { password: !0 }, zs = R === !0 || R === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: R === "all",
    headMetaDescKeywords: R === "all",
    headTitleMutations: R === "all"
  } : R || {};
  Aw();
  let wu, js = 0;
  const _u = (te) => {
    for (const Je of oe || [])
      Je.eventProcessor && (te = Je.eventProcessor(te));
    return E && // Disable packing events which will be emitted to parent frames.
    !Or && (te = E(te)), te;
  };
  fe = (te, Je) => {
    var de;
    const he = te;
    if (he.timestamp = os(), (de = Mt[0]) != null && de.isFrozen() && he.type !== Q.FullSnapshot && !(he.type === Q.IncrementalSnapshot && he.data.source === D.Mutation) && Mt.forEach((Qe) => Qe.unfreeze()), Yn)
      u == null || u(_u(he), Je);
    else if (Or) {
      const Qe = {
        type: "rrweb",
        event: _u(he),
        origin: window.location.origin,
        isCheckout: Je
      };
      window.parent.postMessage(Qe, "*");
    }
    if (he.type === Q.FullSnapshot)
      wu = he, js = 0;
    else if (he.type === Q.IncrementalSnapshot) {
      if (he.data.source === D.Mutation && he.data.isAttachIframe)
        return;
      js++;
      const Qe = d && js >= d, ae = c && he.timestamp - wu.timestamp > c;
      (Qe || ae) && Pi(!0);
    }
  };
  const Fn = (te) => {
    fe({
      type: Q.IncrementalSnapshot,
      data: I({
        source: D.Mutation
      }, te)
    });
  }, Ru = (te) => fe({
    type: Q.IncrementalSnapshot,
    data: I({
      source: D.Scroll
    }, te)
  }), Iu = (te) => fe({
    type: Q.IncrementalSnapshot,
    data: I({
      source: D.CanvasMutation
    }, te)
  }), Mg = (te) => fe({
    type: Q.IncrementalSnapshot,
    data: I({
      source: D.AdoptedStyleSheet
    }, te)
  }), Ot = new S_({
    mutationCb: Fn,
    adoptedStyleSheetCb: Mg
  }), Wt = new u_({
    mirror: De,
    mutationCb: Fn,
    stylesheetManager: Ot,
    recordCrossOriginIframes: b,
    wrappedEmit: fe
  });
  for (const te of oe || [])
    te.getMirror && te.getMirror({
      nodeMirror: De,
      crossOriginIframeMirror: Wt.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: Wt.crossOriginIframeStyleMirror
    });
  const Qs = new w_();
  an = new v_({
    recordCanvas: le,
    recordLocalVideos: z,
    recordRemoteVideos: F,
    mutationCb: Iu,
    win: window,
    blockClass: h,
    blockSelector: f,
    mirror: De,
    sampling: (n = G == null ? void 0 : G.canvas) == null ? void 0 : n.fps,
    samplingManual: (i = G == null ? void 0 : G.canvas) == null ? void 0 : i.fpsManual,
    clearWebGLBuffer: (s = G == null ? void 0 : G.canvas) == null ? void 0 : s.clearWebGLBuffer,
    initialSnapshotDelay: (o = G == null ? void 0 : G.canvas) == null ? void 0 : o.initialSnapshotDelay,
    dataURLOptions: Un,
    resizeFactor: (a = G == null ? void 0 : G.canvas) == null ? void 0 : a.resizeFactor,
    maxSnapshotDimension: (l = G == null ? void 0 : G.canvas) == null ? void 0 : l.maxSnapshotDimension,
    logger: Pg
  });
  const Hn = new c_({
    mutationCb: Fn,
    scrollCb: Ru,
    bypassOptions: {
      blockClass: h,
      blockSelector: f,
      maskTextClass: g,
      maskTextSelector: y,
      inlineStylesheet: _,
      maskInputOptions: Ks,
      dataURLOptions: Un,
      maskTextFn: k,
      maskInputFn: L,
      recordCanvas: le,
      inlineImages: z,
      inlineVideos: F,
      privacySetting: He,
      sampling: G,
      slimDOMOptions: zs,
      iframeManager: Wt,
      stylesheetManager: Ot,
      canvasManager: an,
      keepIframeSrcFn: ce,
      processedNodeManager: Qs
    },
    mirror: De
  });
  Pi = (te = !1) => {
    if (!q)
      return;
    fe(
      {
        type: Q.Meta,
        data: {
          href: window.location.href,
          width: bp(),
          height: yp()
        }
      },
      te
    ), Ot.reset(), Hn.init(), Mt.forEach((de) => de.lock());
    const Je = Db(document, {
      mirror: De,
      blockClass: h,
      blockSelector: f,
      maskTextClass: g,
      maskTextSelector: y,
      inlineStylesheet: _,
      maskAllInputs: Ks,
      maskTextFn: k,
      maskInputFn: L,
      slimDOM: zs,
      dataURLOptions: Un,
      recordCanvas: le,
      inlineImages: z,
      inlineVideos: F,
      privacySetting: He,
      onSerialize: (de) => {
        wp(de, De) && Wt.addIframe(de), _p(de, De) && Ot.trackLinkElement(de), Ha(de) && Hn.addShadowRoot(B.shadowRoot(de), document);
      },
      onIframeLoad: (de, he) => {
        Wt.attachIframe(de, he), Hn.observeAttachShadow(de);
      },
      onStylesheetLoad: (de, he) => {
        Ot.attachLinkElement(de, he);
      },
      keepIframeSrcFn: ce
    });
    if (!Je)
      return console.warn("Failed to snapshot the document");
    fe(
      {
        type: Q.FullSnapshot,
        data: {
          node: Je,
          initialOffset: gp(window)
        }
      },
      te
    ), Mt.forEach((de) => de.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && Ot.adoptStyleSheets(
      document.adoptedStyleSheets,
      De.getId(document)
    );
  };
  try {
    const te = [], Je = (he) => {
      var Qe;
      return j(l_)(
        {
          mutationCb: Fn,
          mousemoveCb: (ae, $s) => fe({
            type: Q.IncrementalSnapshot,
            data: {
              source: $s,
              positions: ae
            }
          }),
          mouseInteractionCb: (ae) => fe({
            type: Q.IncrementalSnapshot,
            data: I({
              source: D.MouseInteraction
            }, ae)
          }),
          scrollCb: Ru,
          viewportResizeCb: (ae) => fe({
            type: Q.IncrementalSnapshot,
            data: I({
              source: D.ViewportResize
            }, ae)
          }),
          inputCb: (ae) => fe({
            type: Q.IncrementalSnapshot,
            data: I({
              source: D.Input
            }, ae)
          }),
          mediaInteractionCb: (ae) => fe({
            type: Q.IncrementalSnapshot,
            data: I({
              source: D.MediaInteraction
            }, ae)
          }),
          styleSheetRuleCb: (ae) => fe({
            type: Q.IncrementalSnapshot,
            data: I({
              source: D.StyleSheetRule
            }, ae)
          }),
          styleDeclarationCb: (ae) => fe({
            type: Q.IncrementalSnapshot,
            data: I({
              source: D.StyleDeclaration
            }, ae)
          }),
          canvasMutationCb: Iu,
          fontCb: (ae) => fe({
            type: Q.IncrementalSnapshot,
            data: I({
              source: D.Font
            }, ae)
          }),
          selectionCb: (ae) => {
            fe({
              type: Q.IncrementalSnapshot,
              data: I({
                source: D.Selection
              }, ae)
            });
          },
          customElementCb: (ae) => {
            fe({
              type: Q.IncrementalSnapshot,
              data: I({
                source: D.CustomElement
              }, ae)
            });
          },
          blockClass: h,
          ignoreClass: m,
          ignoreSelector: p,
          maskTextClass: g,
          maskTextSelector: y,
          maskInputOptions: Ks,
          inlineStylesheet: _,
          sampling: G,
          recordDOM: q,
          recordCanvas: le,
          inlineImages: z,
          inlineVideos: F,
          userTriggeredOnInput: W,
          collectFonts: re,
          doc: he,
          maskInputFn: L,
          maskTextFn: k,
          keepIframeSrcFn: ce,
          blockSelector: f,
          slimDOMOptions: zs,
          dataURLOptions: Un,
          mirror: De,
          iframeManager: Wt,
          stylesheetManager: Ot,
          shadowDomManager: Hn,
          processedNodeManager: Qs,
          canvasManager: an,
          ignoreCSSAttributes: vt,
          privacySetting: He,
          plugins: ((Qe = oe == null ? void 0 : oe.filter((ae) => ae.observer)) == null ? void 0 : Qe.map((ae) => ({
            observer: ae.observer,
            options: ae.options,
            callback: ($s) => fe({
              type: Q.Plugin,
              data: {
                plugin: ae.name,
                payload: $s
              }
            })
          }))) || []
        },
        x
      );
    };
    Wt.addLoadListener((he) => {
      try {
        te.push(Je(he.contentDocument));
      } catch (Qe) {
        console.warn(Qe);
      }
    });
    const de = () => {
      Pi(), te.push(Je(document)), ls = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? de() : (te.push(
      Ee("DOMContentLoaded", () => {
        fe({
          type: Q.DomContentLoaded,
          data: {}
        }), v === "DOMContentLoaded" && de();
      })
    ), te.push(
      Ee(
        "load",
        () => {
          fe({
            type: Q.Load,
            data: {}
          }), v === "load" && de();
        },
        window
      )
    )), () => {
      te.forEach((he) => he()), Qs.destroy(), ls = !1, zw();
    };
  } catch (te) {
    console.warn(te);
  }
}
ft.addCustomEvent = (r, e) => {
  ls && fe({
    type: Q.Custom,
    data: {
      tag: r,
      payload: e
    }
  });
};
ft.freezePage = () => {
  Mt.forEach((r) => r.freeze());
};
ft.takeFullSnapshot = (r) => {
  if (!ls)
    throw new Error("please take full snapshot after start recording");
  Pi(r);
};
ft.snapshotCanvas = (r) => $(void 0, null, function* () {
  if (!an)
    throw new Error("canvas manager is not initialized");
  yield an.snapshot(r);
});
ft.mirror = De;
var Wc;
(function(r) {
  r[r.NotStarted = 0] = "NotStarted", r[r.Running = 1] = "Running", r[r.Stopped = 2] = "Stopped";
})(Wc || (Wc = {}));
const { addCustomEvent: Xc } = ft;
var us = function() {
  return us = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, us.apply(this, arguments);
}, Mi = /* @__PURE__ */ new Map(), Ba = /* @__PURE__ */ new Map(), Op = !0, cs = !1;
function Wp(r) {
  return r.replace(/[\s,]+/g, " ").trim();
}
function __(r) {
  return Wp(r.source.body.substring(r.start, r.end));
}
function R_(r) {
  var e = /* @__PURE__ */ new Set(), t = [];
  return r.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, s = __(n.loc), o = Ba.get(i);
      o && !o.has(s) ? Op && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || Ba.set(i, o = /* @__PURE__ */ new Set()), o.add(s), e.has(s) || (e.add(s), t.push(n));
    } else
      t.push(n);
  }), us(us({}, r), { definitions: t });
}
function I_(r) {
  var e = new Set(r.definitions);
  e.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var s = n[i];
      s && typeof s == "object" && e.add(s);
    });
  });
  var t = r.loc;
  return t && (delete t.startToken, delete t.endToken), r;
}
function T_(r) {
  var e = Wp(r);
  if (!Mi.has(e)) {
    var t = Il(r, {
      experimentalFragmentVariables: cs,
      allowLegacyFragmentVariables: cs
    });
    if (!t || t.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Mi.set(e, I_(R_(t)));
  }
  return Mi.get(e);
}
function Oe(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  typeof r == "string" && (r = [r]);
  var n = r[0];
  return e.forEach(function(i, s) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += r[s + 1];
  }), T_(n);
}
function E_() {
  Mi.clear(), Ba.clear();
}
function C_() {
  Op = !1;
}
function Z_() {
  cs = !0;
}
function G_() {
  cs = !1;
}
var Fr = {
  gql: Oe,
  resetCaches: E_,
  disableFragmentWarnings: C_,
  enableExperimentalFragmentVariables: Z_,
  disableExperimentalFragmentVariables: G_
};
(function(r) {
  r.gql = Fr.gql, r.resetCaches = Fr.resetCaches, r.disableFragmentWarnings = Fr.disableFragmentWarnings, r.enableExperimentalFragmentVariables = Fr.enableExperimentalFragmentVariables, r.disableExperimentalFragmentVariables = Fr.disableExperimentalFragmentVariables;
})(Oe || (Oe = {}));
Oe.default = Oe;
var kc;
(function(r) {
  r.BillingQuotaExceeded = "BillingQuotaExceeded";
})(kc || (kc = {}));
const Xp = Oe`
	mutation PushPayload(
		$session_secure_id: String!
		$payload_id: ID!
		$events: ReplayEventsInput!
		$messages: String!
		$resources: String!
		$web_socket_events: String!
		$errors: [ErrorObjectInput]!
		$is_beacon: Boolean
		$has_session_unloaded: Boolean
		$highlight_logs: String
	) {
		pushPayload(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			events: $events
			messages: $messages
			resources: $resources
			web_socket_events: $web_socket_events
			errors: $errors
			is_beacon: $is_beacon
			has_session_unloaded: $has_session_unloaded
			highlight_logs: $highlight_logs
		)
	}
`, L_ = Oe`
	mutation PushPayloadCompressed(
		$session_secure_id: String!
		$payload_id: ID!
		$data: String!
	) {
		pushPayloadCompressed(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			data: $data
		)
	}
`, N_ = Oe`
	mutation identifySession(
		$session_secure_id: String!
		$user_identifier: String!
		$user_object: Any
	) {
		identifySession(
			session_secure_id: $session_secure_id
			user_identifier: $user_identifier
			user_object: $user_object
		)
	}
`, V_ = Oe`
	mutation addSessionProperties(
		$session_secure_id: String!
		$properties_object: Any
	) {
		addSessionProperties(
			session_secure_id: $session_secure_id
			properties_object: $properties_object
		)
	}
`, x_ = Oe`
	mutation pushMetrics($metrics: [MetricInput]!) {
		pushMetrics(metrics: $metrics)
	}
`, O_ = Oe`
	mutation addSessionFeedback(
		$session_secure_id: String!
		$user_name: String
		$user_email: String
		$verbatim: String!
		$timestamp: Timestamp!
	) {
		addSessionFeedback(
			session_secure_id: $session_secure_id
			user_name: $user_name
			user_email: $user_email
			verbatim: $verbatim
			timestamp: $timestamp
		)
	}
`, W_ = Oe`
	mutation initializeSession(
		$session_secure_id: String!
		$organization_verbose_id: String!
		$enable_strict_privacy: Boolean!
		$privacy_setting: String!
		$enable_recording_network_contents: Boolean!
		$clientVersion: String!
		$firstloadVersion: String!
		$clientConfig: String!
		$environment: String!
		$id: String!
		$appVersion: String
		$serviceName: String!
		$client_id: String!
		$network_recording_domains: [String!]
		$disable_session_recording: Boolean
	) {
		initializeSession(
			session_secure_id: $session_secure_id
			organization_verbose_id: $organization_verbose_id
			enable_strict_privacy: $enable_strict_privacy
			enable_recording_network_contents: $enable_recording_network_contents
			clientVersion: $clientVersion
			firstloadVersion: $firstloadVersion
			clientConfig: $clientConfig
			environment: $environment
			appVersion: $appVersion
			serviceName: $serviceName
			fingerprint: $id
			client_id: $client_id
			network_recording_domains: $network_recording_domains
			disable_session_recording: $disable_session_recording
			privacy_setting: $privacy_setting
		) {
			secure_id
			project_id
		}
	}
`, X_ = Oe`
	query Ignore($id: ID!) {
		ignore(id: $id)
	}
`, k_ = (r, e, t, n) => r();
function P_(r, e = k_) {
  return {
    PushPayload(t, n) {
      return e((i) => r.request(Xp, t, I(I({}, n), i)), "PushPayload", "mutation", t);
    },
    PushPayloadCompressed(t, n) {
      return e((i) => r.request(L_, t, I(I({}, n), i)), "PushPayloadCompressed", "mutation", t);
    },
    identifySession(t, n) {
      return e((i) => r.request(N_, t, I(I({}, n), i)), "identifySession", "mutation", t);
    },
    addSessionProperties(t, n) {
      return e((i) => r.request(V_, t, I(I({}, n), i)), "addSessionProperties", "mutation", t);
    },
    pushMetrics(t, n) {
      return e((i) => r.request(x_, t, I(I({}, n), i)), "pushMetrics", "mutation", t);
    },
    addSessionFeedback(t, n) {
      return e((i) => r.request(O_, t, I(I({}, n), i)), "addSessionFeedback", "mutation", t);
    },
    initializeSession(t, n) {
      return e((i) => r.request(W_, t, I(I({}, n), i)), "initializeSession", "mutation", t);
    },
    Ignore(t, n) {
      return e((i) => r.request(X_, t, I(I({}, n), i)), "Ignore", "query", t);
    }
  };
}
function M_(r, e, t) {
  try {
    if (!(e in r))
      return () => {
      };
    const n = r[e], i = t(n);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), r[e] = i, () => {
      r[e] = n;
    };
  } catch (n) {
    return () => {
    };
  }
}
function A_(r) {
  if (!r || !r.outerHTML)
    return "";
  let e = "";
  for (; r.parentElement; ) {
    let t = r.localName;
    if (!t)
      break;
    t = t.toLowerCase();
    let n = r.parentElement, i = [];
    if (n.children && n.children.length > 0)
      for (let s = 0; s < n.children.length; s++) {
        let o = n.children[s];
        o.localName && o.localName.toLowerCase && o.localName.toLowerCase() === t && i.push(o);
      }
    i.length > 1 && (t += ":eq(" + i.indexOf(r) + ")"), e = t + (e ? ">" + e : ""), r = n;
  }
  return e;
}
function Da(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function kp(r, e) {
  if (e === 0)
    return !0;
  const t = Object.keys(r);
  for (const n of t)
    if (Da(r[n]) && kp(r[n], e - 1))
      return !0;
  return !1;
}
function So(r, e) {
  const t = {
    numOfKeysLimit: 50,
    depthOfLimit: 4
  };
  Object.assign(t, e);
  const n = [], i = [];
  return JSON.stringify(r, function(a, l) {
    if (n.length > 0) {
      const u = n.indexOf(this);
      ~u ? n.splice(u + 1) : n.push(this), ~u ? i.splice(u, 1 / 0, a) : i.push(a), ~n.indexOf(l) && (n[0] === l ? l = "[Circular ~]" : l = "[Circular ~." + i.slice(0, n.indexOf(l)).join(".") + "]");
    } else
      n.push(l);
    if (l == null)
      return l;
    if (s(l))
      return o(l);
    if (l instanceof Event) {
      const u = {};
      for (const c in l) {
        const d = l[c];
        Array.isArray(d) ? u[c] = A_(d.length ? d[0] : null) : u[c] = d;
      }
      return u;
    } else {
      if (l instanceof Node)
        return l instanceof HTMLElement ? l ? l.outerHTML : "" : l.nodeName;
      if (l instanceof Error)
        return l.name + ": " + l.message;
    }
    return l;
  });
  function s(a) {
    return Da(a) && Object.keys(a).length > t.numOfKeysLimit || typeof a == "function" ? !0 : a instanceof Event && a.isTrusted === !1 ? Object.keys(a).length === 1 : !!(Da(a) && kp(a, t.depthOfLimit));
  }
  function o(a) {
    let l = a.toString();
    return t.stringLengthLimit && l.length > t.stringLengthLimit && (l = `${l.slice(0, t.stringLengthLimit)}...`), l;
  }
}
function U_() {
  var r = document.createElement("canvas");
  return r.getContext && r.getContext("2d") ? r.toDataURL("image/webp").indexOf("data:image/webp") == 0 : !1;
}
function Y_() {
  return U_() ? {
    type: "image/webp",
    quality: 0.9
  } : {
    type: "image/jpeg",
    quality: 0.6
  };
}
var Pp = { exports: {} }, wo = { exports: {} }, Pc;
function F_() {
  return Pc || (Pc = 1, function(r, e) {
    (function(t, n) {
      r.exports = n();
    })(El, function() {
      function t(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var s = ["isConstructor", "isEval", "isNative", "isToplevel"], o = ["columnNumber", "lineNumber"], a = ["fileName", "functionName", "source"], l = ["args"], u = ["evalOrigin"], c = s.concat(o, a, l, u);
      function d(p) {
        if (p)
          for (var g = 0; g < c.length; g++)
            p[c[g]] !== void 0 && this["set" + n(c[g])](p[c[g]]);
      }
      d.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof d)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new d(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", g = this.getLineNumber() || "", y = this.getColumnNumber() || "", _ = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + g + ":" + y + ")" : "[eval]:" + g + ":" + y : _ ? _ + " (" + p + ":" + g + ":" + y + ")" : p + ":" + g + ":" + y;
        }
      }, d.fromString = function(g) {
        var y = g.indexOf("("), _ = g.lastIndexOf(")"), S = g.substring(0, y), C = g.substring(y + 1, _).split(","), R = g.substring(_ + 1);
        if (R.indexOf("@") === 0)
          var L = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(R, ""), k = L[1], x = L[2], E = L[3];
        return new d({
          functionName: S,
          args: C || void 0,
          fileName: k,
          lineNumber: x || void 0,
          columnNumber: E || void 0
        });
      };
      for (var h = 0; h < s.length; h++)
        d.prototype["get" + n(s[h])] = i(s[h]), d.prototype["set" + n(s[h])] = /* @__PURE__ */ function(p) {
          return function(g) {
            this[p] = !!g;
          };
        }(s[h]);
      for (var f = 0; f < o.length; f++)
        d.prototype["get" + n(o[f])] = i(o[f]), d.prototype["set" + n(o[f])] = /* @__PURE__ */ function(p) {
          return function(g) {
            if (!t(g))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(g);
          };
        }(o[f]);
      for (var m = 0; m < a.length; m++)
        d.prototype["get" + n(a[m])] = i(a[m]), d.prototype["set" + n(a[m])] = /* @__PURE__ */ function(p) {
          return function(g) {
            this[p] = String(g);
          };
        }(a[m]);
      return d;
    });
  }(wo)), wo.exports;
}
(function(r, e) {
  (function(t, n) {
    r.exports = n(F_());
  })(El, function(n) {
    var i = /(^|@)\S+:\d+/, s = /^\s*at .*(\S+:\d+|\(native\))/m, o = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(l) {
        if (typeof l.stacktrace != "undefined" || typeof l["opera#sourceloc"] != "undefined")
          return this.parseOpera(l);
        if (l.stack && l.stack.match(s))
          return this.parseV8OrIE(l);
        if (l.stack)
          return this.parseFFOrSafari(l);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(l) {
        if (l.indexOf(":") === -1)
          return [l];
        var u = /(.+?)(?::(\d+))?(?::(\d+))?$/, c = u.exec(l.replace(/[()]/g, ""));
        return [c[1], c[2] || void 0, c[3] || void 0];
      },
      parseV8OrIE: function(l) {
        var u = l.stack.split(`
`).filter(function(c) {
          return !!c.match(s);
        }, this);
        return u.map(function(c) {
          c.indexOf("(eval ") > -1 && (c = c.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var d = c.replace(/^\s+/, "").replace(/\(eval code/g, "("), h = d.match(/ (\((.+):(\d+):(\d+)\)$)/);
          d = h ? d.replace(h[0], "") : d;
          var f = d.split(/\s+/).slice(1), m = this.extractLocation(h ? h[1] : f.pop()), p = f.join(" ") || void 0, g = ["eval", "<anonymous>"].indexOf(m[0]) > -1 ? void 0 : m[0];
          return new n({
            functionName: p,
            fileName: g,
            lineNumber: m[1],
            columnNumber: m[2],
            source: c
          });
        }, this);
      },
      parseFFOrSafari: function(l) {
        var u = l.stack.split(`
`).filter(function(c) {
          return !c.match(o);
        }, this);
        return u.map(function(c) {
          if (c.indexOf(" > eval") > -1 && (c = c.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), c.indexOf("@") === -1 && c.indexOf(":") === -1)
            return new n({
              functionName: c
            });
          var d = /((.*".+"[^@]*)?[^@]*)(?:@)/, h = c.match(d), f = h && h[1] ? h[1] : void 0, m = this.extractLocation(c.replace(d, ""));
          return new n({
            functionName: f,
            fileName: m[0],
            lineNumber: m[1],
            columnNumber: m[2],
            source: c
          });
        }, this);
      },
      parseOpera: function(l) {
        return !l.stacktrace || l.message.indexOf(`
`) > -1 && l.message.split(`
`).length > l.stacktrace.split(`
`).length ? this.parseOpera9(l) : l.stack ? this.parseOpera11(l) : this.parseOpera10(l);
      },
      parseOpera9: function(l) {
        for (var u = /Line (\d+).*script (?:in )?(\S+)/i, c = l.message.split(`
`), d = [], h = 2, f = c.length; h < f; h += 2) {
          var m = u.exec(c[h]);
          m && d.push(new n({
            fileName: m[2],
            lineNumber: m[1],
            source: c[h]
          }));
        }
        return d;
      },
      parseOpera10: function(l) {
        for (var u = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, c = l.stacktrace.split(`
`), d = [], h = 0, f = c.length; h < f; h += 2) {
          var m = u.exec(c[h]);
          m && d.push(
            new n({
              functionName: m[3] || void 0,
              fileName: m[2],
              lineNumber: m[1],
              source: c[h]
            })
          );
        }
        return d;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(l) {
        var u = l.stack.split(`
`).filter(function(c) {
          return !!c.match(i) && !c.match(/^Error created at/);
        }, this);
        return u.map(function(c) {
          var d = c.split("@"), h = this.extractLocation(d.pop()), f = d.shift() || "", m = f.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          f.match(/\(([^)]*)\)/) && (p = f.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var g = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: m,
            args: g,
            fileName: h[0],
            lineNumber: h[1],
            columnNumber: h[2],
            source: c
          });
        }, this);
      }
    };
  });
})(Pp);
var H_ = Pp.exports;
const Mc = /* @__PURE__ */ Cl(H_);
function ds(r) {
  try {
    return Mc.parse(r);
  } catch (e) {
    try {
      return Mc.parse(new Error());
    } catch (t) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: e,
        secondaryError: t
      }), [];
    }
  }
}
function J_(r, e) {
  const t = e.logger;
  let n;
  n = window[t];
  const i = [];
  if (e.level.includes("error") && window) {
    const o = (a) => {
      const { message: l, error: u } = a;
      let c = [];
      u && (c = ds(u));
      const d = [
        So(l, e.stringifyOptions)
      ];
      r({
        type: "Error",
        trace: c,
        time: Date.now(),
        value: d
      });
    };
    window.addEventListener("error", o), i.push(() => {
      window && window.removeEventListener("error", o);
    });
  }
  for (const o of e.level)
    i.push(s(n, o));
  return () => {
    i.forEach((o) => o());
  };
  function s(o, a) {
    return o[a] ? M_(o, a, (l) => (...u) => {
      l.apply(this, u);
      try {
        const c = ds(new Error()), d = e.serializeConsoleAttributes ? u.map((h) => typeof h == "object" ? So(h, e.stringifyOptions) : h) : u.filter((h) => typeof h != "object").map((h) => `${h}`);
        r({
          type: a,
          trace: c.slice(1),
          value: d,
          attributes: So(u.filter((h) => typeof h == "object").reduce((h, f) => I(I({}, h), f), {}), e.stringifyOptions),
          time: Date.now()
        });
      } catch (c) {
        l("highlight logger error:", c, ...u);
      }
    }) : () => {
    };
  }
}
function _o(r, e, t, n) {
  var a, l, u, c;
  let i = ds(n != null ? n : e), s = {};
  e instanceof Error && (e = e.message, e.cause && (s = { "exception.cause": e.cause }));
  const o = D_(i);
  r({
    event: Ut(e),
    type: "window.onerror",
    url: window.location.href,
    source: t != null ? t : "",
    lineNumber: (a = o[0]) != null && a.lineNumber ? (l = o[0]) == null ? void 0 : l.lineNumber : 0,
    columnNumber: (u = o[0]) != null && u.columnNumber ? (c = o[0]) == null ? void 0 : c.columnNumber : 0,
    stackTrace: o,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: s ? Ut(s) : void 0
  });
}
const B_ = (r, { enablePromisePatch: e }) => {
  if (typeof window == "undefined")
    return () => {
    };
  const t = window.onerror = (o, a, l, u, c) => {
    _o(r, o, a, c);
  }, n = window.onunhandledrejection = (o) => {
    if (o.reason) {
      const a = o.promise;
      a.getStack ? _o(r, o.reason, o.type, a.getStack()) : _o(r, o.reason, o.type);
    }
  }, i = window.Promise, s = class extends i {
    constructor(l) {
      super(l);
      T(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const l = typeof window.Zone == "undefined";
      return e && l;
    }
  };
  return s.shouldPatch() && (window.Promise = s), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = t;
  };
}, D_ = (r) => {
  var t, n;
  if (r.length === 0)
    return r;
  const e = r[0];
  return (t = e.fileName) != null && t.includes("highlight.run") || (n = e.fileName) != null && n.includes("highlight.io") || e.functionName === "new highlightPromise" ? r.slice(1) : r;
}, Ac = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Uc = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var K_ = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, At = "1.9.0", Yc = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function z_(r) {
  var e = /* @__PURE__ */ new Set([r]), t = /* @__PURE__ */ new Set(), n = r.match(Yc);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(l) {
      return l === r;
    };
  function s(a) {
    return t.add(a), !1;
  }
  function o(a) {
    return e.add(a), !0;
  }
  return function(l) {
    if (e.has(l))
      return !0;
    if (t.has(l))
      return !1;
    var u = l.match(Yc);
    if (!u)
      return s(l);
    var c = {
      major: +u[1],
      minor: +u[2],
      patch: +u[3],
      prerelease: u[4]
    };
    return c.prerelease != null || i.major !== c.major ? s(l) : i.major === 0 ? i.minor === c.minor && i.patch <= c.patch ? o(l) : s(l) : i.minor <= c.minor ? o(l) : s(l);
  };
}
var j_ = z_(At), Q_ = At.split(".")[0], Tn = Symbol.for("opentelemetry.js.api." + Q_), En = K_;
function kn(r, e, t, n) {
  var i;
  n === void 0 && (n = !1);
  var s = En[Tn] = (i = En[Tn]) !== null && i !== void 0 ? i : {
    version: At
  };
  if (!n && s[r]) {
    var o = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + r);
    return t.error(o.stack || o.message), !1;
  }
  if (s.version !== At) {
    var o = new Error("@opentelemetry/api: Registration of version v" + s.version + " for " + r + " does not match previously registered API v" + At);
    return t.error(o.stack || o.message), !1;
  }
  return s[r] = e, t.debug("@opentelemetry/api: Registered a global for " + r + " v" + At + "."), !0;
}
function Ht(r) {
  var e, t, n = (e = En[Tn]) === null || e === void 0 ? void 0 : e.version;
  if (!(!n || !j_(n)))
    return (t = En[Tn]) === null || t === void 0 ? void 0 : t[r];
}
function Pn(r, e) {
  e.debug("@opentelemetry/api: Unregistering a global for " + r + " v" + At + ".");
  var t = En[Tn];
  t && delete t[r];
}
var $_ = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, q_ = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, eR = (
  /** @class */
  function() {
    function r(e) {
      this._namespace = e.namespace || "DiagComponentLogger";
    }
    return r.prototype.debug = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      return Hr("debug", this._namespace, e);
    }, r.prototype.error = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      return Hr("error", this._namespace, e);
    }, r.prototype.info = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      return Hr("info", this._namespace, e);
    }, r.prototype.warn = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      return Hr("warn", this._namespace, e);
    }, r.prototype.verbose = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      return Hr("verbose", this._namespace, e);
    }, r;
  }()
);
function Hr(r, e, t) {
  var n = Ht("diag");
  if (n)
    return t.unshift(e), n[r].apply(n, q_([], $_(t), !1));
}
var pe;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.ERROR = 30] = "ERROR", r[r.WARN = 50] = "WARN", r[r.INFO = 60] = "INFO", r[r.DEBUG = 70] = "DEBUG", r[r.VERBOSE = 80] = "VERBOSE", r[r.ALL = 9999] = "ALL";
})(pe || (pe = {}));
function tR(r, e) {
  r < pe.NONE ? r = pe.NONE : r > pe.ALL && (r = pe.ALL), e = e || {};
  function t(n, i) {
    var s = e[n];
    return typeof s == "function" && r >= i ? s.bind(e) : function() {
    };
  }
  return {
    error: t("error", pe.ERROR),
    warn: t("warn", pe.WARN),
    info: t("info", pe.INFO),
    debug: t("debug", pe.DEBUG),
    verbose: t("verbose", pe.VERBOSE)
  };
}
var rR = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, nR = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, iR = "diag", at = (
  /** @class */
  function() {
    function r() {
      function e(i) {
        return function() {
          for (var s = [], o = 0; o < arguments.length; o++)
            s[o] = arguments[o];
          var a = Ht("diag");
          if (a)
            return a[i].apply(a, nR([], rR(s), !1));
        };
      }
      var t = this, n = function(i, s) {
        var o, a, l;
        if (s === void 0 && (s = { logLevel: pe.INFO }), i === t) {
          var u = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return t.error((o = u.stack) !== null && o !== void 0 ? o : u.message), !1;
        }
        typeof s == "number" && (s = {
          logLevel: s
        });
        var c = Ht("diag"), d = tR((a = s.logLevel) !== null && a !== void 0 ? a : pe.INFO, i);
        if (c && !s.suppressOverrideMessage) {
          var h = (l = new Error().stack) !== null && l !== void 0 ? l : "<failed to generate stacktrace>";
          c.warn("Current logger will be overwritten from " + h), d.warn("Current logger will overwrite one already registered from " + h);
        }
        return kn("diag", d, t, !0);
      };
      t.setLogger = n, t.disable = function() {
        Pn(iR, t);
      }, t.createComponentLogger = function(i) {
        return new eR(i);
      }, t.verbose = e("verbose"), t.debug = e("debug"), t.info = e("info"), t.warn = e("warn"), t.error = e("error");
    }
    return r.instance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r;
  }()
), sR = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, oR = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, aR = (
  /** @class */
  function() {
    function r(e) {
      this._entries = e ? new Map(e) : /* @__PURE__ */ new Map();
    }
    return r.prototype.getEntry = function(e) {
      var t = this._entries.get(e);
      if (t)
        return Object.assign({}, t);
    }, r.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(e) {
        var t = sR(e, 2), n = t[0], i = t[1];
        return [n, i];
      });
    }, r.prototype.setEntry = function(e, t) {
      var n = new r(this._entries);
      return n._entries.set(e, t), n;
    }, r.prototype.removeEntry = function(e) {
      var t = new r(this._entries);
      return t._entries.delete(e), t;
    }, r.prototype.removeEntries = function() {
      for (var e, t, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var s = new r(this._entries);
      try {
        for (var o = oR(n), a = o.next(); !a.done; a = o.next()) {
          var l = a.value;
          s._entries.delete(l);
        }
      } catch (u) {
        e = { error: u };
      } finally {
        try {
          a && !a.done && (t = o.return) && t.call(o);
        } finally {
          if (e) throw e.error;
        }
      }
      return s;
    }, r.prototype.clear = function() {
      return new r();
    }, r;
  }()
), lR = Symbol("BaggageEntryMetadata"), uR = at.instance();
function cR(r) {
  return r === void 0 && (r = {}), new aR(new Map(Object.entries(r)));
}
function dR(r) {
  return typeof r != "string" && (uR.error("Cannot create baggage metadata from unknown type: " + typeof r), r = ""), {
    __TYPE__: lR,
    toString: function() {
      return r;
    }
  };
}
function ql(r) {
  return Symbol.for(r);
}
var hR = (
  /** @class */
  /* @__PURE__ */ function() {
    function r(e) {
      var t = this;
      t._currentContext = e ? new Map(e) : /* @__PURE__ */ new Map(), t.getValue = function(n) {
        return t._currentContext.get(n);
      }, t.setValue = function(n, i) {
        var s = new r(t._currentContext);
        return s._currentContext.set(n, i), s;
      }, t.deleteValue = function(n) {
        var i = new r(t._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return r;
  }()
), Xt = new hR(), Qt = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), fR = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.createGauge = function(e, t) {
      return _R;
    }, r.prototype.createHistogram = function(e, t) {
      return RR;
    }, r.prototype.createCounter = function(e, t) {
      return wR;
    }, r.prototype.createUpDownCounter = function(e, t) {
      return IR;
    }, r.prototype.createObservableGauge = function(e, t) {
      return ER;
    }, r.prototype.createObservableCounter = function(e, t) {
      return TR;
    }, r.prototype.createObservableUpDownCounter = function(e, t) {
      return CR;
    }, r.prototype.addBatchObservableCallback = function(e, t) {
    }, r.prototype.removeBatchObservableCallback = function(e) {
    }, r;
  }()
), Ps = (
  /** @class */
  /* @__PURE__ */ function() {
    function r() {
    }
    return r;
  }()
), pR = (
  /** @class */
  function(r) {
    Qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.add = function(t, n) {
    }, e;
  }(Ps)
), mR = (
  /** @class */
  function(r) {
    Qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.add = function(t, n) {
    }, e;
  }(Ps)
), gR = (
  /** @class */
  function(r) {
    Qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.record = function(t, n) {
    }, e;
  }(Ps)
), yR = (
  /** @class */
  function(r) {
    Qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.record = function(t, n) {
    }, e;
  }(Ps)
), eu = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.addCallback = function(e) {
    }, r.prototype.removeCallback = function(e) {
    }, r;
  }()
), bR = (
  /** @class */
  function(r) {
    Qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(eu)
), vR = (
  /** @class */
  function(r) {
    Qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(eu)
), SR = (
  /** @class */
  function(r) {
    Qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(eu)
), Mp = new fR(), wR = new pR(), _R = new gR(), RR = new yR(), IR = new mR(), TR = new bR(), ER = new vR(), CR = new SR();
function ZR() {
  return Mp;
}
var Gt;
(function(r) {
  r[r.INT = 0] = "INT", r[r.DOUBLE = 1] = "DOUBLE";
})(Gt || (Gt = {}));
var GR = {
  get: function(r, e) {
    if (r != null)
      return r[e];
  },
  keys: function(r) {
    return r == null ? [] : Object.keys(r);
  }
}, LR = {
  set: function(r, e, t) {
    r != null && (r[e] = t);
  }
}, NR = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, VR = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, xR = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.active = function() {
      return Xt;
    }, r.prototype.with = function(e, t, n) {
      for (var i = [], s = 3; s < arguments.length; s++)
        i[s - 3] = arguments[s];
      return t.call.apply(t, VR([n], NR(i), !1));
    }, r.prototype.bind = function(e, t) {
      return t;
    }, r.prototype.enable = function() {
      return this;
    }, r.prototype.disable = function() {
      return this;
    }, r;
  }()
), OR = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, WR = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, Ro = "context", XR = new xR(), Ms = (
  /** @class */
  function() {
    function r() {
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalContextManager = function(e) {
      return kn(Ro, e, at.instance());
    }, r.prototype.active = function() {
      return this._getContextManager().active();
    }, r.prototype.with = function(e, t, n) {
      for (var i, s = [], o = 3; o < arguments.length; o++)
        s[o - 3] = arguments[o];
      return (i = this._getContextManager()).with.apply(i, WR([e, t, n], OR(s), !1));
    }, r.prototype.bind = function(e, t) {
      return this._getContextManager().bind(e, t);
    }, r.prototype._getContextManager = function() {
      return Ht(Ro) || XR;
    }, r.prototype.disable = function() {
      this._getContextManager().disable(), Pn(Ro, at.instance());
    }, r;
  }()
), yt;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.SAMPLED = 1] = "SAMPLED";
})(yt || (yt = {}));
var Ap = "0000000000000000", Up = "00000000000000000000000000000000", Yp = {
  traceId: Up,
  spanId: Ap,
  traceFlags: yt.NONE
}, ln = (
  /** @class */
  function() {
    function r(e) {
      e === void 0 && (e = Yp), this._spanContext = e;
    }
    return r.prototype.spanContext = function() {
      return this._spanContext;
    }, r.prototype.setAttribute = function(e, t) {
      return this;
    }, r.prototype.setAttributes = function(e) {
      return this;
    }, r.prototype.addEvent = function(e, t) {
      return this;
    }, r.prototype.addLink = function(e) {
      return this;
    }, r.prototype.addLinks = function(e) {
      return this;
    }, r.prototype.setStatus = function(e) {
      return this;
    }, r.prototype.updateName = function(e) {
      return this;
    }, r.prototype.end = function(e) {
    }, r.prototype.isRecording = function() {
      return !1;
    }, r.prototype.recordException = function(e, t) {
    }, r;
  }()
), tu = ql("OpenTelemetry Context Key SPAN");
function ru(r) {
  return r.getValue(tu) || void 0;
}
function kR() {
  return ru(Ms.getInstance().active());
}
function nu(r, e) {
  return r.setValue(tu, e);
}
function PR(r) {
  return r.deleteValue(tu);
}
function MR(r, e) {
  return nu(r, new ln(e));
}
function Fp(r) {
  var e;
  return (e = ru(r)) === null || e === void 0 ? void 0 : e.spanContext();
}
var AR = /^([0-9a-f]{32})$/i, UR = /^[0-9a-f]{16}$/i;
function Hp(r) {
  return AR.test(r) && r !== Up;
}
function YR(r) {
  return UR.test(r) && r !== Ap;
}
function As(r) {
  return Hp(r.traceId) && YR(r.spanId);
}
function FR(r) {
  return new ln(r);
}
var Io = Ms.getInstance(), Jp = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.startSpan = function(e, t, n) {
      n === void 0 && (n = Io.active());
      var i = !!(t != null && t.root);
      if (i)
        return new ln();
      var s = n && Fp(n);
      return HR(s) && As(s) ? new ln(s) : new ln();
    }, r.prototype.startActiveSpan = function(e, t, n, i) {
      var s, o, a;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? a = t : arguments.length === 3 ? (s = t, a = n) : (s = t, o = n, a = i);
        var l = o != null ? o : Io.active(), u = this.startSpan(e, s, l), c = nu(l, u);
        return Io.with(c, a, void 0, u);
      }
    }, r;
  }()
);
function HR(r) {
  return typeof r == "object" && typeof r.spanId == "string" && typeof r.traceId == "string" && typeof r.traceFlags == "number";
}
var JR = new Jp(), BR = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this._provider = e, this.name = t, this.version = n, this.options = i;
    }
    return r.prototype.startSpan = function(e, t, n) {
      return this._getTracer().startSpan(e, t, n);
    }, r.prototype.startActiveSpan = function(e, t, n, i) {
      var s = this._getTracer();
      return Reflect.apply(s.startActiveSpan, s, arguments);
    }, r.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var e = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return e ? (this._delegate = e, this._delegate) : JR;
    }, r;
  }()
), DR = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getTracer = function(e, t, n) {
      return new Jp();
    }, r;
  }()
), KR = new DR(), Fc = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getTracer = function(e, t, n) {
      var i;
      return (i = this.getDelegateTracer(e, t, n)) !== null && i !== void 0 ? i : new BR(this, e, t, n);
    }, r.prototype.getDelegate = function() {
      var e;
      return (e = this._delegate) !== null && e !== void 0 ? e : KR;
    }, r.prototype.setDelegate = function(e) {
      this._delegate = e;
    }, r.prototype.getDelegateTracer = function(e, t, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(e, t, n);
    }, r;
  }()
), hs;
(function(r) {
  r[r.NOT_RECORD = 0] = "NOT_RECORD", r[r.RECORD = 1] = "RECORD", r[r.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(hs || (hs = {}));
var Cn;
(function(r) {
  r[r.INTERNAL = 0] = "INTERNAL", r[r.SERVER = 1] = "SERVER", r[r.CLIENT = 2] = "CLIENT", r[r.PRODUCER = 3] = "PRODUCER", r[r.CONSUMER = 4] = "CONSUMER";
})(Cn || (Cn = {}));
var Ka;
(function(r) {
  r[r.UNSET = 0] = "UNSET", r[r.OK = 1] = "OK", r[r.ERROR = 2] = "ERROR";
})(Ka || (Ka = {}));
var K = Ms.getInstance(), N = at.instance(), zR = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getMeter = function(e, t, n) {
      return Mp;
    }, r;
  }()
), jR = new zR(), To = "metrics", QR = (
  /** @class */
  function() {
    function r() {
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalMeterProvider = function(e) {
      return kn(To, e, at.instance());
    }, r.prototype.getMeterProvider = function() {
      return Ht(To) || jR;
    }, r.prototype.getMeter = function(e, t, n) {
      return this.getMeterProvider().getMeter(e, t, n);
    }, r.prototype.disable = function() {
      Pn(To, at.instance());
    }, r;
  }()
), Vr = QR.getInstance(), $R = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.inject = function(e, t) {
    }, r.prototype.extract = function(e, t) {
      return e;
    }, r.prototype.fields = function() {
      return [];
    }, r;
  }()
), iu = ql("OpenTelemetry Baggage Key");
function Bp(r) {
  return r.getValue(iu) || void 0;
}
function qR() {
  return Bp(Ms.getInstance().active());
}
function eI(r, e) {
  return r.setValue(iu, e);
}
function tI(r) {
  return r.deleteValue(iu);
}
var Eo = "propagation", rI = new $R(), nI = (
  /** @class */
  function() {
    function r() {
      this.createBaggage = cR, this.getBaggage = Bp, this.getActiveBaggage = qR, this.setBaggage = eI, this.deleteBaggage = tI;
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalPropagator = function(e) {
      return kn(Eo, e, at.instance());
    }, r.prototype.inject = function(e, t, n) {
      return n === void 0 && (n = LR), this._getGlobalPropagator().inject(e, t, n);
    }, r.prototype.extract = function(e, t, n) {
      return n === void 0 && (n = GR), this._getGlobalPropagator().extract(e, t, n);
    }, r.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, r.prototype.disable = function() {
      Pn(Eo, at.instance());
    }, r.prototype._getGlobalPropagator = function() {
      return Ht(Eo) || rI;
    }, r;
  }()
), ke = nI.getInstance(), Co = "trace", iI = (
  /** @class */
  function() {
    function r() {
      this._proxyTracerProvider = new Fc(), this.wrapSpanContext = FR, this.isSpanContextValid = As, this.deleteSpan = PR, this.getSpan = ru, this.getActiveSpan = kR, this.getSpanContext = Fp, this.setSpan = nu, this.setSpanContext = MR;
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalTracerProvider = function(e) {
      var t = kn(Co, this._proxyTracerProvider, at.instance());
      return t && this._proxyTracerProvider.setDelegate(e), t;
    }, r.prototype.getTracerProvider = function() {
      return Ht(Co) || this._proxyTracerProvider;
    }, r.prototype.getTracer = function(e, t) {
      return this.getTracerProvider().getTracer(e, t);
    }, r.prototype.disable = function() {
      Pn(Co, at.instance()), this._proxyTracerProvider = new Fc();
    }, r;
  }()
), ee = iI.getInstance(), Dp = ql("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Kp(r) {
  return r.setValue(Dp, !0);
}
function su(r) {
  return r.getValue(Dp) === !0;
}
var sI = "=", za = ";", ja = ",", Zo = "baggage", oI = 180, aI = 4096, lI = 8192, uI = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
};
function cI(r) {
  return r.reduce(function(e, t) {
    var n = "" + e + (e !== "" ? ja : "") + t;
    return n.length > lI ? e : n;
  }, "");
}
function dI(r) {
  return r.getAllEntries().map(function(e) {
    var t = uI(e, 2), n = t[0], i = t[1], s = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (s += za + i.metadata.toString()), s;
  });
}
function hI(r) {
  var e = r.split(za);
  if (!(e.length <= 0)) {
    var t = e.shift();
    if (t) {
      var n = t.indexOf(sI);
      if (!(n <= 0)) {
        var i = decodeURIComponent(t.substring(0, n).trim()), s = decodeURIComponent(t.substring(n + 1).trim()), o;
        return e.length > 0 && (o = dR(e.join(za))), { key: i, value: s, metadata: o };
      }
    }
  }
}
var zp = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.inject = function(e, t, n) {
      var i = ke.getBaggage(e);
      if (!(!i || su(e))) {
        var s = dI(i).filter(function(a) {
          return a.length <= aI;
        }).slice(0, oI), o = cI(s);
        o.length > 0 && n.set(t, Zo, o);
      }
    }, r.prototype.extract = function(e, t, n) {
      var i = n.get(t, Zo), s = Array.isArray(i) ? i.join(ja) : i;
      if (!s)
        return e;
      var o = {};
      if (s.length === 0)
        return e;
      var a = s.split(ja);
      return a.forEach(function(l) {
        var u = hI(l);
        if (u) {
          var c = { value: u.value };
          u.metadata && (c.metadata = u.metadata), o[u.key] = c;
        }
      }), Object.entries(o).length === 0 ? e : ke.setBaggage(e, ke.createBaggage(o));
    }, r.prototype.fields = function() {
      return [Zo];
    }, r;
  }()
), jp = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, fI = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
};
function Ai(r) {
  var e, t, n = {};
  if (typeof r != "object" || r == null)
    return n;
  try {
    for (var i = jp(Object.entries(r)), s = i.next(); !s.done; s = i.next()) {
      var o = fI(s.value, 2), a = o[0], l = o[1];
      if (!pI(a)) {
        N.warn("Invalid attribute key: " + a);
        continue;
      }
      if (!Qp(l)) {
        N.warn("Invalid attribute value set for key: " + a);
        continue;
      }
      Array.isArray(l) ? n[a] = l.slice() : n[a] = l;
    }
  } catch (u) {
    e = { error: u };
  } finally {
    try {
      s && !s.done && (t = i.return) && t.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
function pI(r) {
  return typeof r == "string" && r.length > 0;
}
function Qp(r) {
  return r == null ? !0 : Array.isArray(r) ? mI(r) : $p(r);
}
function mI(r) {
  var e, t, n;
  try {
    for (var i = jp(r), s = i.next(); !s.done; s = i.next()) {
      var o = s.value;
      if (o != null) {
        if (!n) {
          if ($p(o)) {
            n = typeof o;
            continue;
          }
          return !1;
        }
        if (typeof o !== n)
          return !1;
      }
    }
  } catch (a) {
    e = { error: a };
  } finally {
    try {
      s && !s.done && (t = i.return) && t.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return !0;
}
function $p(r) {
  switch (typeof r) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function gI() {
  return function(r) {
    N.error(yI(r));
  };
}
function yI(r) {
  return typeof r == "string" ? r : JSON.stringify(bI(r));
}
function bI(r) {
  for (var e = {}, t = r; t !== null; )
    Object.getOwnPropertyNames(t).forEach(function(n) {
      if (!e[n]) {
        var i = t[n];
        i && (e[n] = String(i));
      }
    }), t = Object.getPrototypeOf(t);
  return e;
}
var vI = gI();
function Lt(r) {
  try {
    vI(r);
  } catch (e) {
  }
}
var nt;
(function(r) {
  r.AlwaysOff = "always_off", r.AlwaysOn = "always_on", r.ParentBasedAlwaysOff = "parentbased_always_off", r.ParentBasedAlwaysOn = "parentbased_always_on", r.ParentBasedTraceIdRatio = "parentbased_traceidratio", r.TraceIdRatio = "traceidratio";
})(nt || (nt = {}));
var SI = ",", wI = ["OTEL_SDK_DISABLED"];
function _I(r) {
  return wI.indexOf(r) > -1;
}
var RI = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function II(r) {
  return RI.indexOf(r) > -1;
}
var TI = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function EI(r) {
  return TI.indexOf(r) > -1;
}
var Ui = 1 / 0, Yi = 128, CI = 128, ZI = 128, qp = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: pe.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ui,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Yi,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ui,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Yi,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ui,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Yi,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: CI,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: ZI,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: nt.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function GI(r, e, t) {
  if (typeof t[r] != "undefined") {
    var n = String(t[r]);
    e[r] = n.toLowerCase() === "true";
  }
}
function LI(r, e, t, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof t[r] != "undefined") {
    var s = Number(t[r]);
    isNaN(s) || (s < n ? e[r] = n : s > i ? e[r] = i : e[r] = s);
  }
}
function NI(r, e, t, n) {
  n === void 0 && (n = SI);
  var i = t[r];
  typeof i == "string" && (e[r] = i.split(n).map(function(s) {
    return s.trim();
  }));
}
var VI = {
  ALL: pe.ALL,
  VERBOSE: pe.VERBOSE,
  DEBUG: pe.DEBUG,
  INFO: pe.INFO,
  WARN: pe.WARN,
  ERROR: pe.ERROR,
  NONE: pe.NONE
};
function xI(r, e, t) {
  var n = t[r];
  if (typeof n == "string") {
    var i = VI[n.toUpperCase()];
    i != null && (e[r] = i);
  }
}
function em(r) {
  var e = {};
  for (var t in qp) {
    var n = t;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        xI(n, e, r);
        break;
      default:
        if (_I(n))
          GI(n, e, r);
        else if (II(n))
          LI(n, e, r);
        else if (EI(n))
          NI(n, e, r);
        else {
          var i = r[n];
          typeof i != "undefined" && i !== null && (e[n] = String(i));
        }
    }
  }
  return e;
}
var un = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Cr() {
  var r = em(un);
  return Object.assign({}, qp, r);
}
function OI() {
  return em(un);
}
function Hc(r) {
  return r >= 48 && r <= 57 ? r - 48 : r >= 97 && r <= 102 ? r - 87 : r - 55;
}
function ou(r) {
  for (var e = new Uint8Array(r.length / 2), t = 0, n = 0; n < r.length; n += 2) {
    var i = Hc(r.charCodeAt(n)), s = Hc(r.charCodeAt(n + 1));
    e[t++] = i << 4 | s;
  }
  return e;
}
var Me = performance, WI = "1.30.1", XI = "process.runtime.name", kI = "telemetry.sdk.name", PI = "telemetry.sdk.language", MI = "telemetry.sdk.version", AI = XI, UI = kI, YI = PI, FI = MI, HI = "webjs", JI = HI, ir, Go = (ir = {}, ir[UI] = "opentelemetry", ir[AI] = "browser", ir[YI] = JI, ir[FI] = WI, ir), BI = 9, DI = 6, KI = Math.pow(10, DI), fs = Math.pow(10, BI);
function Pe(r) {
  var e = r / 1e3, t = Math.trunc(e), n = Math.round(r % 1e3 * KI);
  return [t, n];
}
function au() {
  var r = Me.timeOrigin;
  if (typeof r != "number") {
    var e = Me;
    r = e.timing && e.timing.fetchStart;
  }
  return r;
}
function Jt(r) {
  var e = Pe(au()), t = Pe(typeof r == "number" ? r : Me.now());
  return tm(e, t);
}
function cn(r) {
  if (lu(r))
    return r;
  if (typeof r == "number")
    return r < au() ? Jt(r) : Pe(r);
  if (r instanceof Date)
    return Pe(r.getTime());
  throw TypeError("Invalid input type");
}
function zI(r, e) {
  var t = e[0] - r[0], n = e[1] - r[1];
  return n < 0 && (t -= 1, n += fs), [t, n];
}
function ht(r) {
  return r[0] * fs + r[1];
}
function mi(r) {
  return r[0] * 1e6 + r[1] / 1e3;
}
function lu(r) {
  return Array.isArray(r) && r.length === 2 && typeof r[0] == "number" && typeof r[1] == "number";
}
function Jc(r) {
  return lu(r) || typeof r == "number" || r instanceof Date;
}
function tm(r, e) {
  var t = [r[0] + e[0], r[1] + e[1]];
  return t[1] >= fs && (t[1] -= fs, t[0] += 1), t;
}
var xe;
(function(r) {
  r[r.SUCCESS = 0] = "SUCCESS", r[r.FAILED = 1] = "FAILED";
})(xe || (xe = {}));
var jI = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, rm = (
  /** @class */
  function() {
    function r(e) {
      e === void 0 && (e = {});
      var t;
      this._propagators = (t = e.propagators) !== null && t !== void 0 ? t : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return r.prototype.inject = function(e, t, n) {
      var i, s;
      try {
        for (var o = jI(this._propagators), a = o.next(); !a.done; a = o.next()) {
          var l = a.value;
          try {
            l.inject(e, t, n);
          } catch (u) {
            N.warn("Failed to inject with " + l.constructor.name + ". Err: " + u.message);
          }
        }
      } catch (u) {
        i = { error: u };
      } finally {
        try {
          a && !a.done && (s = o.return) && s.call(o);
        } finally {
          if (i) throw i.error;
        }
      }
    }, r.prototype.extract = function(e, t, n) {
      return this._propagators.reduce(function(i, s) {
        try {
          return s.extract(i, t, n);
        } catch (o) {
          N.warn("Failed to extract with " + s.constructor.name + ". Err: " + o.message);
        }
        return i;
      }, e);
    }, r.prototype.fields = function() {
      return this._fields.slice();
    }, r;
  }()
), Qa = "[_0-9a-z-*/]", QI = "[a-z]" + Qa + "{0,255}", $I = "[a-z0-9]" + Qa + "{0,240}@[a-z]" + Qa + "{0,13}", qI = new RegExp("^(?:" + QI + "|" + $I + ")$"), eT = /^[ -~]{0,255}[!-~]$/, tT = /,|=/;
function rT(r) {
  return qI.test(r);
}
function nT(r) {
  return eT.test(r) && !tT.test(r);
}
var Bc = 32, iT = 512, Dc = ",", Kc = "=", sT = (
  /** @class */
  function() {
    function r(e) {
      this._internalState = /* @__PURE__ */ new Map(), e && this._parse(e);
    }
    return r.prototype.set = function(e, t) {
      var n = this._clone();
      return n._internalState.has(e) && n._internalState.delete(e), n._internalState.set(e, t), n;
    }, r.prototype.unset = function(e) {
      var t = this._clone();
      return t._internalState.delete(e), t;
    }, r.prototype.get = function(e) {
      return this._internalState.get(e);
    }, r.prototype.serialize = function() {
      var e = this;
      return this._keys().reduce(function(t, n) {
        return t.push(n + Kc + e.get(n)), t;
      }, []).join(Dc);
    }, r.prototype._parse = function(e) {
      e.length > iT || (this._internalState = e.split(Dc).reverse().reduce(function(t, n) {
        var i = n.trim(), s = i.indexOf(Kc);
        if (s !== -1) {
          var o = i.slice(0, s), a = i.slice(s + 1, n.length);
          rT(o) && nT(a) && t.set(o, a);
        }
        return t;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Bc && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Bc))));
    }, r.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, r.prototype._clone = function() {
      var e = new r();
      return e._internalState = new Map(this._internalState), e;
    }, r;
  }()
), Fi = "traceparent", Lo = "tracestate", oT = "00", aT = "(?!ff)[\\da-f]{2}", lT = "(?![0]{32})[\\da-f]{32}", uT = "(?![0]{16})[\\da-f]{16}", cT = "[\\da-f]{2}", dT = new RegExp("^\\s?(" + aT + ")-(" + lT + ")-(" + uT + ")-(" + cT + ")(-.*)?\\s?$");
function hT(r) {
  var e = dT.exec(r);
  return !e || e[1] === "00" && e[5] ? null : {
    traceId: e[2],
    spanId: e[3],
    traceFlags: parseInt(e[4], 16)
  };
}
var nm = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.inject = function(e, t, n) {
      var i = ee.getSpanContext(e);
      if (!(!i || su(e) || !As(i))) {
        var s = oT + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || yt.NONE).toString(16);
        n.set(t, Fi, s), i.traceState && n.set(t, Lo, i.traceState.serialize());
      }
    }, r.prototype.extract = function(e, t, n) {
      var i = n.get(t, Fi);
      if (!i)
        return e;
      var s = Array.isArray(i) ? i[0] : i;
      if (typeof s != "string")
        return e;
      var o = hT(s);
      if (!o)
        return e;
      o.isRemote = !0;
      var a = n.get(t, Lo);
      if (a) {
        var l = Array.isArray(a) ? a.join(",") : a;
        o.traceState = new sT(typeof l == "string" ? l : void 0);
      }
      return ee.setSpanContext(e, o);
    }, r.prototype.fields = function() {
      return [Fi, Lo];
    }, r;
  }()
), fT = "[object Object]", pT = "[object Null]", mT = "[object Undefined]", gT = Function.prototype, im = gT.toString, yT = im.call(Object), bT = vT(Object.getPrototypeOf, Object), sm = Object.prototype, om = sm.hasOwnProperty, kt = Symbol ? Symbol.toStringTag : void 0, am = sm.toString;
function vT(r, e) {
  return function(t) {
    return r(e(t));
  };
}
function zc(r) {
  if (!ST(r) || wT(r) !== fT)
    return !1;
  var e = bT(r);
  if (e === null)
    return !0;
  var t = om.call(e, "constructor") && e.constructor;
  return typeof t == "function" && t instanceof t && im.call(t) === yT;
}
function ST(r) {
  return r != null && typeof r == "object";
}
function wT(r) {
  return r == null ? r === void 0 ? mT : pT : kt && kt in Object(r) ? _T(r) : RT(r);
}
function _T(r) {
  var e = om.call(r, kt), t = r[kt], n = !1;
  try {
    r[kt] = void 0, n = !0;
  } catch (s) {
  }
  var i = am.call(r);
  return n && (e ? r[kt] = t : delete r[kt]), i;
}
function RT(r) {
  return am.call(r);
}
var IT = 20;
function TT() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  for (var t = r.shift(), n = /* @__PURE__ */ new WeakMap(); r.length > 0; )
    t = lm(t, r.shift(), 0, n);
  return t;
}
function No(r) {
  return ps(r) ? r.slice() : r;
}
function lm(r, e, t, n) {
  t === void 0 && (t = 0);
  var i;
  if (!(t > IT)) {
    if (t++, Hi(r) || Hi(e) || um(e))
      i = No(e);
    else if (ps(r)) {
      if (i = r.slice(), ps(e))
        for (var s = 0, o = e.length; s < o; s++)
          i.push(No(e[s]));
      else if (Jr(e))
        for (var a = Object.keys(e), s = 0, o = a.length; s < o; s++) {
          var l = a[s];
          i[l] = No(e[l]);
        }
    } else if (Jr(r))
      if (Jr(e)) {
        if (!ET(r, e))
          return e;
        i = Object.assign({}, r);
        for (var a = Object.keys(e), s = 0, o = a.length; s < o; s++) {
          var l = a[s], u = e[l];
          if (Hi(u))
            typeof u == "undefined" ? delete i[l] : i[l] = u;
          else {
            var c = i[l], d = u;
            if (jc(r, l, n) || jc(e, l, n))
              delete i[l];
            else {
              if (Jr(c) && Jr(d)) {
                var h = n.get(c) || [], f = n.get(d) || [];
                h.push({ obj: r, key: l }), f.push({ obj: e, key: l }), n.set(c, h), n.set(d, f);
              }
              i[l] = lm(i[l], u, t, n);
            }
          }
        }
      } else
        i = e;
    return i;
  }
}
function jc(r, e, t) {
  for (var n = t.get(r[e]) || [], i = 0, s = n.length; i < s; i++) {
    var o = n[i];
    if (o.key === e && o.obj === r)
      return !0;
  }
  return !1;
}
function ps(r) {
  return Array.isArray(r);
}
function um(r) {
  return typeof r == "function";
}
function Jr(r) {
  return !Hi(r) && !ps(r) && !um(r) && typeof r == "object";
}
function Hi(r) {
  return typeof r == "string" || typeof r == "number" || typeof r == "boolean" || typeof r == "undefined" || r instanceof Date || r instanceof RegExp || r === null;
}
function ET(r, e) {
  return !(!zc(r) || !zc(e));
}
var CT = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function cm(r, e) {
  return typeof e == "string" ? r === e : !!r.match(e);
}
function dm(r, e) {
  var t, n;
  if (!e)
    return !1;
  try {
    for (var i = CT(e), s = i.next(); !s.done; s = i.next()) {
      var o = s.value;
      if (cm(r, o))
        return !0;
    }
  } catch (a) {
    t = { error: a };
  } finally {
    try {
      s && !s.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !1;
}
var ZT = (
  /** @class */
  function() {
    function r() {
      var e = this;
      this._promise = new Promise(function(t, n) {
        e._resolve = t, e._reject = n;
      });
    }
    return Object.defineProperty(r.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.resolve = function(e) {
      this._resolve(e);
    }, r.prototype.reject = function(e) {
      this._reject(e);
    }, r;
  }()
), GT = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, LT = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, NT = (
  /** @class */
  function() {
    function r(e, t) {
      this._callback = e, this._that = t, this._isCalled = !1, this._deferred = new ZT();
    }
    return Object.defineProperty(r.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.call = function() {
      for (var e, t = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((e = this._callback).call.apply(e, LT([this._that], GT(n), !1))).then(function(s) {
            return t._deferred.resolve(s);
          }, function(s) {
            return t._deferred.reject(s);
          });
        } catch (s) {
          this._deferred.reject(s);
        }
      }
      return this._deferred.promise;
    }, r;
  }()
);
function VT(r, e) {
  return new Promise(function(t) {
    K.with(Kp(K.active()), function() {
      r.export(e, function(n) {
        t(n);
      });
    });
  });
}
var xT = {
  _export: VT
};
let hm = class {
  emit(e) {
  }
};
const OT = new hm();
let WT = class {
  getLogger(e, t, n) {
    return new hm();
  }
};
const fm = new WT();
let XT = class {
  constructor(e, t, n, i) {
    this._provider = e, this.name = t, this.version = n, this.options = i;
  }
  /**
   * Emit a log record. This method should only be used by log appenders.
   *
   * @param logRecord
   */
  emit(e) {
    this._getLogger().emit(e);
  }
  /**
   * Try to get a logger from the proxy logger provider.
   * If the proxy logger provider has no delegate, return a noop logger.
   */
  _getLogger() {
    if (this._delegate)
      return this._delegate;
    const e = this._provider.getDelegateLogger(this.name, this.version, this.options);
    return e ? (this._delegate = e, this._delegate) : OT;
  }
}, Qc = class {
  getLogger(e, t, n) {
    var i;
    return (i = this.getDelegateLogger(e, t, n)) !== null && i !== void 0 ? i : new XT(this, e, t, n);
  }
  getDelegate() {
    var e;
    return (e = this._delegate) !== null && e !== void 0 ? e : fm;
  }
  /**
   * Set the delegate logger provider
   */
  setDelegate(e) {
    this._delegate = e;
  }
  getDelegateLogger(e, t, n) {
    var i;
    return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(e, t, n);
  }
};
const kT = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, gi = Symbol.for("io.opentelemetry.js.api.logs"), Br = kT;
function PT(r, e, t) {
  return (n) => n === r ? e : t;
}
const $c = 1;
let MT = class pm {
  constructor() {
    this._proxyLoggerProvider = new Qc();
  }
  static getInstance() {
    return this._instance || (this._instance = new pm()), this._instance;
  }
  setGlobalLoggerProvider(e) {
    return Br[gi] ? this.getLoggerProvider() : (Br[gi] = PT($c, e, fm), this._proxyLoggerProvider.setDelegate(e), e);
  }
  /**
   * Returns the global logger provider.
   *
   * @returns LoggerProvider
   */
  getLoggerProvider() {
    var e, t;
    return (t = (e = Br[gi]) === null || e === void 0 ? void 0 : e.call(Br, $c)) !== null && t !== void 0 ? t : this._proxyLoggerProvider;
  }
  /**
   * Returns a logger from the global logger provider.
   *
   * @returns Logger
   */
  getLogger(e, t, n) {
    return this.getLoggerProvider().getLogger(e, t, n);
  }
  /** Remove the global logger provider */
  disable() {
    delete Br[gi], this._proxyLoggerProvider = new Qc();
  }
};
const mm = MT.getInstance();
function AT(r, e, t, n) {
  for (let i = 0, s = r.length; i < s; i++) {
    const o = r[i];
    e && o.setTracerProvider(e), t && o.setMeterProvider(t), n && o.setLoggerProvider && o.setLoggerProvider(n), o.getConfig().enabled || o.enable();
  }
}
function UT(r) {
  r.forEach((e) => e.disable());
}
function YT(r) {
  var s, o;
  const e = r.tracerProvider || ee.getTracerProvider(), t = r.meterProvider || Vr.getMeterProvider(), n = r.loggerProvider || mm.getLoggerProvider(), i = (o = (s = r.instrumentations) == null ? void 0 : s.flat()) != null ? o : [];
  return AT(i, e, t, n), () => {
    UT(i);
  };
}
function $a(r) {
  return typeof r == "function";
}
var Ce = console.error.bind(console);
function Dr(r, e, t) {
  var n = !!r[e] && r.propertyIsEnumerable(e);
  Object.defineProperty(r, e, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: t
  });
}
function Mn(r) {
  r && r.logger && ($a(r.logger) ? Ce = r.logger : Ce("new logger isn't a function, not replacing"));
}
function gm(r, e, t) {
  if (!r || !r[e]) {
    Ce("no original function " + e + " to wrap");
    return;
  }
  if (!t) {
    Ce("no wrapper function"), Ce(new Error().stack);
    return;
  }
  if (!$a(r[e]) || !$a(t)) {
    Ce("original object and wrapper must be functions");
    return;
  }
  var n = r[e], i = t(n, e);
  return Dr(i, "__original", n), Dr(i, "__unwrap", function() {
    r[e] === i && Dr(r, e, n);
  }), Dr(i, "__wrapped", !0), Dr(r, e, i), i;
}
function FT(r, e, t) {
  if (r)
    Array.isArray(r) || (r = [r]);
  else {
    Ce("must provide one or more modules to patch"), Ce(new Error().stack);
    return;
  }
  if (!(e && Array.isArray(e))) {
    Ce("must provide one or more functions to wrap on modules");
    return;
  }
  r.forEach(function(n) {
    e.forEach(function(i) {
      gm(n, i, t);
    });
  });
}
function ym(r, e) {
  if (!r || !r[e]) {
    Ce("no function to unwrap."), Ce(new Error().stack);
    return;
  }
  if (!r[e].__unwrap)
    Ce("no original to unwrap to -- has " + e + " already been unwrapped?");
  else
    return r[e].__unwrap();
}
function HT(r, e) {
  if (r)
    Array.isArray(r) || (r = [r]);
  else {
    Ce("must provide one or more modules to patch"), Ce(new Error().stack);
    return;
  }
  if (!(e && Array.isArray(e))) {
    Ce("must provide one or more functions to unwrap on modules");
    return;
  }
  r.forEach(function(t) {
    e.forEach(function(n) {
      ym(t, n);
    });
  });
}
Mn.wrap = gm;
Mn.massWrap = FT;
Mn.unwrap = ym;
Mn.massUnwrap = HT;
var we = Mn;
let JT = class {
  constructor(e, t, n) {
    T(this, "instrumentationName");
    T(this, "instrumentationVersion");
    T(this, "_config", {});
    T(this, "_tracer");
    T(this, "_meter");
    T(this, "_logger");
    T(this, "_diag");
    /* Api to wrap instrumented method */
    T(this, "_wrap", we.wrap);
    /* Api to unwrap instrumented methods */
    T(this, "_unwrap", we.unwrap);
    /* Api to mass wrap instrumented method */
    T(this, "_massWrap", we.massWrap);
    /* Api to mass unwrap instrumented methods */
    T(this, "_massUnwrap", we.massUnwrap);
    this.instrumentationName = e, this.instrumentationVersion = t, this.setConfig(n), this._diag = N.createComponentLogger({
      namespace: e
    }), this._tracer = ee.getTracer(e, t), this._meter = Vr.getMeter(e, t), this._logger = mm.getLogger(e, t), this._updateMetricInstruments();
  }
  /* Returns meter */
  get meter() {
    return this._meter;
  }
  /**
   * Sets MeterProvider to this plugin
   * @param meterProvider
   */
  setMeterProvider(e) {
    this._meter = e.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
  }
  /* Returns logger */
  get logger() {
    return this._logger;
  }
  /**
   * Sets LoggerProvider to this plugin
   * @param loggerProvider
   */
  setLoggerProvider(e) {
    this._logger = e.getLogger(this.instrumentationName, this.instrumentationVersion);
  }
  /**
   * @experimental
   *
   * Get module definitions defined by {@link init}.
   * This can be used for experimental compile-time instrumentation.
   *
   * @returns an array of {@link InstrumentationModuleDefinition}
   */
  getModuleDefinitions() {
    var t;
    const e = (t = this.init()) != null ? t : [];
    return Array.isArray(e) ? e : [e];
  }
  /**
   * Sets the new metric instruments with the current Meter.
   */
  _updateMetricInstruments() {
  }
  /* Returns InstrumentationConfig */
  getConfig() {
    return this._config;
  }
  /**
   * Sets InstrumentationConfig to this plugin
   * @param config
   */
  setConfig(e) {
    this._config = I({
      enabled: !0
    }, e);
  }
  /**
   * Sets TraceProvider to this plugin
   * @param tracerProvider
   */
  setTracerProvider(e) {
    this._tracer = e.getTracer(this.instrumentationName, this.instrumentationVersion);
  }
  /* Returns tracer */
  get tracer() {
    return this._tracer;
  }
  /**
   * Execute span customization hook, if configured, and log any errors.
   * Any semantics of the trigger and info are defined by the specific instrumentation.
   * @param hookHandler The optional hook handler which the user has configured via instrumentation config
   * @param triggerName The name of the trigger for executing the hook for logging purposes
   * @param span The span to which the hook should be applied
   * @param info The info object to be passed to the hook, with useful data the hook may use
   */
  _runSpanCustomizationHook(e, t, n, i) {
    if (e)
      try {
        e(n, i);
      } catch (s) {
        this._diag.error("Error running span customization hook due to exception in handler", { triggerName: t }, s);
      }
  }
}, BT = class extends JT {
  constructor(e, t, n) {
    super(e, t, n), this._config.enabled && this.enable();
  }
};
function _e(r) {
  return typeof r == "function" && typeof r.__original == "function" && typeof r.__unwrap == "function" && r.__wrapped === !0;
}
var DT = "exception.type", KT = "exception.message", zT = "exception.stacktrace", Vo = DT, xo = KT, jT = zT, QT = "exception", qa = function() {
  return qa = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, qa.apply(this, arguments);
}, $T = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qc = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, qT = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, eE = (
  /** @class */
  function() {
    function r(e, t, n, i, s, o, a, l, u, c) {
      a === void 0 && (a = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: Ka.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = o, this.kind = s, this.links = a;
      var d = Date.now();
      this._performanceStartTime = Me.now(), this._performanceOffset = d - (this._performanceStartTime + au()), this._startTimeProvided = l != null, this.startTime = this._getTime(l != null ? l : d), this.resource = e.resource, this.instrumentationLibrary = e.instrumentationLibrary, this._spanLimits = e.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, c != null && this.setAttributes(c), this._spanProcessor = e.getActiveSpanProcessor(), this._spanProcessor.onStart(this, t);
    }
    return r.prototype.spanContext = function() {
      return this._spanContext;
    }, r.prototype.setAttribute = function(e, t) {
      return t == null || this._isSpanEnded() ? this : e.length === 0 ? (N.warn("Invalid attribute key: " + e), this) : Qp(t) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, e) ? (this._droppedAttributesCount++, this) : (this.attributes[e] = this._truncateToSize(t), this) : (N.warn("Invalid attribute value set for key: " + e), this);
    }, r.prototype.setAttributes = function(e) {
      var t, n;
      try {
        for (var i = $T(Object.entries(e)), s = i.next(); !s.done; s = i.next()) {
          var o = qc(s.value, 2), a = o[0], l = o[1];
          this.setAttribute(a, l);
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          s && !s.done && (n = i.return) && n.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return this;
    }, r.prototype.addEvent = function(e, t, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return N.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && N.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Jc(t) && (Jc(n) || (n = t), t = void 0);
      var i = Ai(t);
      return this.events.push({
        name: e,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, r.prototype.addLink = function(e) {
      return this.links.push(e), this;
    }, r.prototype.addLinks = function(e) {
      var t;
      return (t = this.links).push.apply(t, qT([], qc(e), !1)), this;
    }, r.prototype.setStatus = function(e) {
      return this._isSpanEnded() ? this : (this.status = qa({}, e), this.status.message != null && typeof e.message != "string" && (N.warn("Dropping invalid status.message of type '" + typeof e.message + "', expected 'string'"), delete this.status.message), this);
    }, r.prototype.updateName = function(e) {
      return this._isSpanEnded() ? this : (this.name = e, this);
    }, r.prototype.end = function(e) {
      if (this._isSpanEnded()) {
        N.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(e), this._duration = zI(this.startTime, this.endTime), this._duration[0] < 0 && (N.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && N.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, r.prototype._getTime = function(e) {
      if (typeof e == "number" && e <= Me.now())
        return Jt(e + this._performanceOffset);
      if (typeof e == "number")
        return Pe(e);
      if (e instanceof Date)
        return Pe(e.getTime());
      if (lu(e))
        return e;
      if (this._startTimeProvided)
        return Pe(Date.now());
      var t = Me.now() - this._performanceStartTime;
      return tm(this.startTime, Pe(t));
    }, r.prototype.isRecording = function() {
      return this._ended === !1;
    }, r.prototype.recordException = function(e, t) {
      var n = {};
      typeof e == "string" ? n[xo] = e : e && (e.code ? n[Vo] = e.code.toString() : e.name && (n[Vo] = e.name), e.message && (n[xo] = e.message), e.stack && (n[jT] = e.stack)), n[Vo] || n[xo] ? this.addEvent(QT, n, t) : N.warn("Failed to record an exception " + e);
    }, Object.defineProperty(r.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._isSpanEnded = function() {
      return this._ended && N.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, r.prototype._truncateToLimitUtil = function(e, t) {
      return e.length <= t ? e : e.substring(0, t);
    }, r.prototype._truncateToSize = function(e) {
      var t = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (N.warn("Attribute value limit must be positive, got " + n), e) : typeof e == "string" ? this._truncateToLimitUtil(e, n) : Array.isArray(e) ? e.map(function(i) {
        return typeof i == "string" ? t._truncateToLimitUtil(i, n) : i;
      }) : e;
    }, r;
  }()
), Zr;
(function(r) {
  r[r.NOT_RECORD = 0] = "NOT_RECORD", r[r.RECORD = 1] = "RECORD", r[r.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Zr || (Zr = {}));
var ms = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.shouldSample = function() {
      return {
        decision: Zr.NOT_RECORD
      };
    }, r.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, r;
  }()
), yr = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.shouldSample = function() {
      return {
        decision: Zr.RECORD_AND_SAMPLED
      };
    }, r.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, r;
  }()
), Oo = (
  /** @class */
  function() {
    function r(e) {
      var t, n, i, s;
      this._root = e.root, this._root || (Lt(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new yr()), this._remoteParentSampled = (t = e.remoteParentSampled) !== null && t !== void 0 ? t : new yr(), this._remoteParentNotSampled = (n = e.remoteParentNotSampled) !== null && n !== void 0 ? n : new ms(), this._localParentSampled = (i = e.localParentSampled) !== null && i !== void 0 ? i : new yr(), this._localParentNotSampled = (s = e.localParentNotSampled) !== null && s !== void 0 ? s : new ms();
    }
    return r.prototype.shouldSample = function(e, t, n, i, s, o) {
      var a = ee.getSpanContext(e);
      return !a || !As(a) ? this._root.shouldSample(e, t, n, i, s, o) : a.isRemote ? a.traceFlags & yt.SAMPLED ? this._remoteParentSampled.shouldSample(e, t, n, i, s, o) : this._remoteParentNotSampled.shouldSample(e, t, n, i, s, o) : a.traceFlags & yt.SAMPLED ? this._localParentSampled.shouldSample(e, t, n, i, s, o) : this._localParentNotSampled.shouldSample(e, t, n, i, s, o);
    }, r.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, r;
  }()
), ed = (
  /** @class */
  function() {
    function r(e) {
      e === void 0 && (e = 0), this._ratio = e, this._ratio = this._normalize(e), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return r.prototype.shouldSample = function(e, t) {
      return {
        decision: Hp(t) && this._accumulate(t) < this._upperBound ? Zr.RECORD_AND_SAMPLED : Zr.NOT_RECORD
      };
    }, r.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, r.prototype._normalize = function(e) {
      return typeof e != "number" || isNaN(e) ? 0 : e >= 1 ? 1 : e <= 0 ? 0 : e;
    }, r.prototype._accumulate = function(e) {
      for (var t = 0, n = 0; n < e.length / 8; n++) {
        var i = n * 8, s = parseInt(e.slice(i, i + 8), 16);
        t = (t ^ s) >>> 0;
      }
      return t;
    }, r;
  }()
), tE = nt.AlwaysOn, sr = 1;
function bm() {
  var r = Cr();
  return {
    sampler: vm(r),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: r.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: r.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: r.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: r.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: r.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: r.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: r.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: r.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function vm(r) {
  switch (r === void 0 && (r = Cr()), r.OTEL_TRACES_SAMPLER) {
    case nt.AlwaysOn:
      return new yr();
    case nt.AlwaysOff:
      return new ms();
    case nt.ParentBasedAlwaysOn:
      return new Oo({
        root: new yr()
      });
    case nt.ParentBasedAlwaysOff:
      return new Oo({
        root: new ms()
      });
    case nt.TraceIdRatio:
      return new ed(td(r));
    case nt.ParentBasedTraceIdRatio:
      return new Oo({
        root: new ed(td(r))
      });
    default:
      return N.error('OTEL_TRACES_SAMPLER value "' + r.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + tE + '".'), new yr();
  }
}
function td(r) {
  if (r.OTEL_TRACES_SAMPLER_ARG === void 0 || r.OTEL_TRACES_SAMPLER_ARG === "")
    return N.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + sr + "."), sr;
  var e = Number(r.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(e) ? (N.error("OTEL_TRACES_SAMPLER_ARG=" + r.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + sr + "."), sr) : e < 0 || e > 1 ? (N.error("OTEL_TRACES_SAMPLER_ARG=" + r.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + sr + "."), sr) : e;
}
function rE(r) {
  var e = {
    sampler: vm()
  }, t = bm(), n = Object.assign({}, t, e, r);
  return n.generalLimits = Object.assign({}, t.generalLimits, r.generalLimits || {}), n.spanLimits = Object.assign({}, t.spanLimits, r.spanLimits || {}), n;
}
function nE(r) {
  var e, t, n, i, s, o, a, l, u, c, d, h, f = Object.assign({}, r.spanLimits), m = OI();
  return f.attributeCountLimit = (o = (s = (i = (t = (e = r.spanLimits) === null || e === void 0 ? void 0 : e.attributeCountLimit) !== null && t !== void 0 ? t : (n = r.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : m.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && s !== void 0 ? s : m.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : Yi, f.attributeValueLengthLimit = (h = (d = (c = (l = (a = r.spanLimits) === null || a === void 0 ? void 0 : a.attributeValueLengthLimit) !== null && l !== void 0 ? l : (u = r.generalLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : m.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : m.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && h !== void 0 ? h : Ui, Object.assign({}, r, { spanLimits: f });
}
var iE = (
  /** @class */
  function() {
    function r(e, t) {
      this._exporter = e, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = Cr();
      this._maxExportBatchSize = typeof (t == null ? void 0 : t.maxExportBatchSize) == "number" ? t.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (t == null ? void 0 : t.maxQueueSize) == "number" ? t.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (t == null ? void 0 : t.scheduledDelayMillis) == "number" ? t.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (t == null ? void 0 : t.exportTimeoutMillis) == "number" ? t.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new NT(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (N.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return r.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, r.prototype.onStart = function(e, t) {
    }, r.prototype.onEnd = function(e) {
      this._shutdownOnce.isCalled || e.spanContext().traceFlags & yt.SAMPLED && this._addToBuffer(e);
    }, r.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, r.prototype._shutdown = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.onShutdown();
      }).then(function() {
        return e._flushAll();
      }).then(function() {
        return e._exporter.shutdown();
      });
    }, r.prototype._addToBuffer = function(e) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && N.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (N.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(e), this._maybeStartTimer();
    }, r.prototype._flushAll = function() {
      var e = this;
      return new Promise(function(t, n) {
        for (var i = [], s = Math.ceil(e._finishedSpans.length / e._maxExportBatchSize), o = 0, a = s; o < a; o++)
          i.push(e._flushOneBatch());
        Promise.all(i).then(function() {
          t();
        }).catch(n);
      });
    }, r.prototype._flushOneBatch = function() {
      var e = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(t, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, e._exportTimeoutMillis);
        K.with(Kp(K.active()), function() {
          var s;
          e._finishedSpans.length <= e._maxExportBatchSize ? (s = e._finishedSpans, e._finishedSpans = []) : s = e._finishedSpans.splice(0, e._maxExportBatchSize);
          for (var o = function() {
            return e._exporter.export(s, function(d) {
              var h;
              clearTimeout(i), d.code === xe.SUCCESS ? t() : n((h = d.error) !== null && h !== void 0 ? h : new Error("BatchSpanProcessor: span export failed"));
            });
          }, a = null, l = 0, u = s.length; l < u; l++) {
            var c = s[l];
            c.resource.asyncAttributesPending && c.resource.waitForAsyncAttributes && (a != null || (a = []), a.push(c.resource.waitForAsyncAttributes()));
          }
          a === null ? o() : Promise.all(a).then(o, function(d) {
            Lt(d), n(d);
          });
        });
      });
    }, r.prototype._maybeStartTimer = function() {
      var e = this;
      if (!this._isExporting) {
        var t = function() {
          e._isExporting = !0, e._flushOneBatch().finally(function() {
            e._isExporting = !1, e._finishedSpans.length > 0 && (e._clearTimer(), e._maybeStartTimer());
          }).catch(function(n) {
            e._isExporting = !1, Lt(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return t();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return t();
        }, this._scheduledDelayMillis));
      }
    }, r.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, r;
  }()
), sE = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Sm = (
  /** @class */
  function(r) {
    sE(e, r);
    function e(t, n) {
      var i = r.call(this, t, n) || this;
      return i.onInit(n), i;
    }
    return e.prototype.onInit = function(t) {
      var n = this;
      (t == null ? void 0 : t.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          Lt(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          Lt(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, e.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, e;
  }(iE)
), oE = 8, aE = 16, lE = (
  /** @class */
  /* @__PURE__ */ function() {
    function r() {
      this.generateTraceId = rd(aE), this.generateSpanId = rd(oE);
    }
    return r;
  }()
), yi = Array(32);
function rd(r) {
  return function() {
    for (var t = 0; t < r * 2; t++)
      yi[t] = Math.floor(Math.random() * 16) + 48, yi[t] >= 58 && (yi[t] += 39);
    return String.fromCharCode.apply(null, yi.slice(0, r * 2));
  };
}
var uE = (
  /** @class */
  function() {
    function r(e, t, n) {
      this._tracerProvider = n;
      var i = rE(t);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = t.idGenerator || new lE(), this.resource = n.resource, this.instrumentationLibrary = e;
    }
    return r.prototype.startSpan = function(e, t, n) {
      var i, s, o;
      t === void 0 && (t = {}), n === void 0 && (n = K.active()), t.root && (n = ee.deleteSpan(n));
      var a = ee.getSpan(n);
      if (su(n)) {
        N.debug("Instrumentation suppressed, returning Noop Span");
        var l = ee.wrapSpanContext(Yp);
        return l;
      }
      var u = a == null ? void 0 : a.spanContext(), c = this._idGenerator.generateSpanId(), d, h, f;
      !u || !ee.isSpanContextValid(u) ? d = this._idGenerator.generateTraceId() : (d = u.traceId, h = u.traceState, f = u.spanId);
      var m = (i = t.kind) !== null && i !== void 0 ? i : Cn.INTERNAL, p = ((s = t.links) !== null && s !== void 0 ? s : []).map(function(L) {
        return {
          context: L.context,
          attributes: Ai(L.attributes)
        };
      }), g = Ai(t.attributes), y = this._sampler.shouldSample(n, d, e, m, g, p);
      h = (o = y.traceState) !== null && o !== void 0 ? o : h;
      var _ = y.decision === hs.RECORD_AND_SAMPLED ? yt.SAMPLED : yt.NONE, S = { traceId: d, spanId: c, traceFlags: _, traceState: h };
      if (y.decision === hs.NOT_RECORD) {
        N.debug("Recording is off, propagating context in a non-recording span");
        var l = ee.wrapSpanContext(S);
        return l;
      }
      var C = Ai(Object.assign(g, y.attributes)), R = new eE(this, n, e, S, m, f, p, t.startTime, void 0, C);
      return R;
    }, r.prototype.startActiveSpan = function(e, t, n, i) {
      var s, o, a;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? a = t : arguments.length === 3 ? (s = t, a = n) : (s = t, o = n, a = i);
        var l = o != null ? o : K.active(), u = this.startSpan(e, s, l), c = ee.setSpan(l, u);
        return K.with(c, a, void 0, u);
      }
    }, r.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, r.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, r.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, r;
  }()
), cE = "service.name", dE = "telemetry.sdk.name", hE = "telemetry.sdk.language", fE = "telemetry.sdk.version", pE = cE, nd = dE, id = hE, sd = fE;
function mE() {
  return "unknown_service";
}
var Rt = function() {
  return Rt = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Rt.apply(this, arguments);
}, gE = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, yE = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, bE = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, Zn = (
  /** @class */
  function() {
    function r(e, t) {
      var n = this, i;
      this._attributes = e, this.asyncAttributesPending = t != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = t == null ? void 0 : t.then(function(s) {
        return n._attributes = Object.assign({}, n._attributes, s), n.asyncAttributesPending = !1, s;
      }, function(s) {
        return N.debug("a resource's async attributes promise rejected: %s", s), n.asyncAttributesPending = !1, {};
      });
    }
    return r.empty = function() {
      return r.EMPTY;
    }, r.default = function() {
      var e;
      return new r((e = {}, e[pE] = mE(), e[id] = Go[id], e[nd] = Go[nd], e[sd] = Go[sd], e));
    }, Object.defineProperty(r.prototype, "attributes", {
      get: function() {
        var e;
        return this.asyncAttributesPending && N.error("Accessing resource attributes before async attributes settled"), (e = this._attributes) !== null && e !== void 0 ? e : {};
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.waitForAsyncAttributes = function() {
      return gE(this, void 0, void 0, function() {
        return yE(this, function(e) {
          switch (e.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              e.sent(), e.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.merge = function(e) {
      var t = this, n;
      if (!e)
        return this;
      var i = Rt(Rt({}, this._syncAttributes), (n = e._syncAttributes) !== null && n !== void 0 ? n : e.attributes);
      if (!this._asyncAttributesPromise && !e._asyncAttributesPromise)
        return new r(i);
      var s = Promise.all([
        this._asyncAttributesPromise,
        e._asyncAttributesPromise
      ]).then(function(o) {
        var a, l = bE(o, 2), u = l[0], c = l[1];
        return Rt(Rt(Rt(Rt({}, t._syncAttributes), u), (a = e._syncAttributes) !== null && a !== void 0 ? a : e.attributes), c);
      });
      return new r(i, s);
    }, r.EMPTY = new r({}), r;
  }()
), bi = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, od = (
  /** @class */
  function() {
    function r(e) {
      this._spanProcessors = e;
    }
    return r.prototype.forceFlush = function() {
      var e, t, n = [];
      try {
        for (var i = bi(this._spanProcessors), s = i.next(); !s.done; s = i.next()) {
          var o = s.value;
          n.push(o.forceFlush());
        }
      } catch (a) {
        e = { error: a };
      } finally {
        try {
          s && !s.done && (t = i.return) && t.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return new Promise(function(a) {
        Promise.all(n).then(function() {
          a();
        }).catch(function(l) {
          Lt(l || new Error("MultiSpanProcessor: forceFlush failed")), a();
        });
      });
    }, r.prototype.onStart = function(e, t) {
      var n, i;
      try {
        for (var s = bi(this._spanProcessors), o = s.next(); !o.done; o = s.next()) {
          var a = o.value;
          a.onStart(e, t);
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          o && !o.done && (i = s.return) && i.call(s);
        } finally {
          if (n) throw n.error;
        }
      }
    }, r.prototype.onEnd = function(e) {
      var t, n;
      try {
        for (var i = bi(this._spanProcessors), s = i.next(); !s.done; s = i.next()) {
          var o = s.value;
          o.onEnd(e);
        }
      } catch (a) {
        t = { error: a };
      } finally {
        try {
          s && !s.done && (n = i.return) && n.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
    }, r.prototype.shutdown = function() {
      var e, t, n = [];
      try {
        for (var i = bi(this._spanProcessors), s = i.next(); !s.done; s = i.next()) {
          var o = s.value;
          n.push(o.shutdown());
        }
      } catch (a) {
        e = { error: a };
      } finally {
        try {
          s && !s.done && (t = i.return) && t.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return new Promise(function(a, l) {
        Promise.all(n).then(function() {
          a();
        }, l);
      });
    }, r;
  }()
), vE = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.onStart = function(e, t) {
    }, r.prototype.onEnd = function(e) {
    }, r.prototype.shutdown = function() {
      return Promise.resolve();
    }, r.prototype.forceFlush = function() {
      return Promise.resolve();
    }, r;
  }()
), SE = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, wE = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, Pt;
(function(r) {
  r[r.resolved = 0] = "resolved", r[r.timeout = 1] = "timeout", r[r.error = 2] = "error", r[r.unresolved = 3] = "unresolved";
})(Pt || (Pt = {}));
var _E = (
  /** @class */
  function() {
    function r(e) {
      e === void 0 && (e = {});
      var t, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = TT({}, bm(), nE(e));
      if (this.resource = (t = i.resource) !== null && t !== void 0 ? t : Zn.empty(), i.mergeResourceWithDefaults && (this.resource = Zn.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = e.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = wE([], SE(e.spanProcessors), !1), this.activeSpanProcessor = new od(this._registeredSpanProcessors);
      else {
        var s = this._buildExporterFromEnv();
        if (s !== void 0) {
          var o = new Sm(s);
          this.activeSpanProcessor = o;
        } else
          this.activeSpanProcessor = new vE();
      }
    }
    return r.prototype.getTracer = function(e, t, n) {
      var i = e + "@" + (t || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new uE({ name: e, version: t, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, r.prototype.addSpanProcessor = function(e) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(t) {
        return N.error("Error while trying to shutdown current span processor", t);
      }), this._registeredSpanProcessors.push(e), this.activeSpanProcessor = new od(this._registeredSpanProcessors);
    }, r.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, r.prototype.register = function(e) {
      e === void 0 && (e = {}), ee.setGlobalTracerProvider(this), e.propagator === void 0 && (e.propagator = this._buildPropagatorFromEnv()), e.contextManager && K.setGlobalContextManager(e.contextManager), e.propagator && ke.setGlobalPropagator(e.propagator);
    }, r.prototype.forceFlush = function() {
      var e = this._config.forceFlushTimeoutMillis, t = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var s, o = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + e + " ms")), s = Pt.timeout;
          }, e);
          n.forceFlush().then(function() {
            clearTimeout(o), s !== Pt.timeout && (s = Pt.resolved, i(s));
          }).catch(function(a) {
            clearTimeout(o), s = Pt.error, i(a);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(t).then(function(s) {
          var o = s.filter(function(a) {
            return a !== Pt.resolved;
          });
          o.length > 0 ? i(o) : n();
        }).catch(function(s) {
          return i([s]);
        });
      });
    }, r.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, r.prototype._getPropagator = function(e) {
      var t;
      return (t = this.constructor._registeredPropagators.get(e)) === null || t === void 0 ? void 0 : t();
    }, r.prototype._getSpanExporter = function(e) {
      var t;
      return (t = this.constructor._registeredExporters.get(e)) === null || t === void 0 ? void 0 : t();
    }, r.prototype._buildPropagatorFromEnv = function() {
      var e = this, t = Array.from(new Set(Cr().OTEL_PROPAGATORS)), n = t.map(function(s) {
        var o = e._getPropagator(s);
        return o || N.warn('Propagator "' + s + '" requested through environment variable is unavailable.'), o;
      }), i = n.reduce(function(s, o) {
        return o && s.push(o), s;
      }, []);
      if (i.length !== 0)
        return t.length === 1 ? i[0] : new rm({
          propagators: i
        });
    }, r.prototype._buildExporterFromEnv = function() {
      var e = Cr().OTEL_TRACES_EXPORTER;
      if (!(e === "none" || e === "")) {
        var t = this._getSpanExporter(e);
        return t || N.error('Exporter "' + e + '" requested through environment variable is unavailable.'), t;
      }
    }, r._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new nm();
      }],
      ["baggage", function() {
        return new zp();
      }]
    ]), r._registeredExporters = /* @__PURE__ */ new Map(), r;
  }()
), RE = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, IE = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, wm = (
  /** @class */
  function() {
    function r() {
      this._enabled = !1, this._currentContext = Xt;
    }
    return r.prototype._bindFunction = function(e, t) {
      e === void 0 && (e = Xt);
      var n = this, i = function() {
        for (var s = this, o = [], a = 0; a < arguments.length; a++)
          o[a] = arguments[a];
        return n.with(e, function() {
          return t.apply(s, o);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: t.length
      }), i;
    }, r.prototype.active = function() {
      return this._currentContext;
    }, r.prototype.bind = function(e, t) {
      return e === void 0 && (e = this.active()), typeof t == "function" ? this._bindFunction(e, t) : t;
    }, r.prototype.disable = function() {
      return this._currentContext = Xt, this._enabled = !1, this;
    }, r.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = Xt, this);
    }, r.prototype.with = function(e, t, n) {
      for (var i = [], s = 3; s < arguments.length; s++)
        i[s - 3] = arguments[s];
      var o = this._currentContext;
      this._currentContext = e || Xt;
      try {
        return t.call.apply(t, IE([n], RE(i), !1));
      } finally {
        this._currentContext = o;
      }
    }, r;
  }()
), TE = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), EE = (
  /** @class */
  function(r) {
    TE(e, r);
    function e(t) {
      t === void 0 && (t = {});
      var n = r.call(this, t) || this;
      if (t.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (t.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return e.prototype.register = function(t) {
      t === void 0 && (t = {}), t.contextManager === void 0 && (t.contextManager = new wm()), t.contextManager && t.contextManager.enable(), r.prototype.register.call(this, t);
    }, e;
  }(_E)
), P;
(function(r) {
  r.CONNECT_END = "connectEnd", r.CONNECT_START = "connectStart", r.DECODED_BODY_SIZE = "decodedBodySize", r.DOM_COMPLETE = "domComplete", r.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", r.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", r.DOM_INTERACTIVE = "domInteractive", r.DOMAIN_LOOKUP_END = "domainLookupEnd", r.DOMAIN_LOOKUP_START = "domainLookupStart", r.ENCODED_BODY_SIZE = "encodedBodySize", r.FETCH_START = "fetchStart", r.LOAD_EVENT_END = "loadEventEnd", r.LOAD_EVENT_START = "loadEventStart", r.NAVIGATION_START = "navigationStart", r.REDIRECT_END = "redirectEnd", r.REDIRECT_START = "redirectStart", r.REQUEST_START = "requestStart", r.RESPONSE_END = "responseEnd", r.RESPONSE_START = "responseStart", r.SECURE_CONNECTION_START = "secureConnectionStart", r.UNLOAD_EVENT_END = "unloadEventEnd", r.UNLOAD_EVENT_START = "unloadEventStart";
})(P || (P = {}));
var CE = "http.response_content_length", ZE = "http.response_content_length_uncompressed", GE = CE, LE = ZE, Wo;
function NE() {
  return Wo || (Wo = document.createElement("a")), Wo;
}
function Nt(r, e) {
  return e in r;
}
function ye(r, e, t, n) {
  var i = void 0, s = void 0;
  Nt(t, e) && typeof t[e] == "number" && (i = t[e]);
  var o = P.FETCH_START;
  if (Nt(t, o) && typeof t[o] == "number" && (s = t[o]), i !== void 0 && s !== void 0 && i >= s)
    return r.addEvent(e, i), r;
}
function Gr(r, e, t) {
  t === void 0 && (t = !1), t || (ye(r, P.FETCH_START, e), ye(r, P.DOMAIN_LOOKUP_START, e), ye(r, P.DOMAIN_LOOKUP_END, e), ye(r, P.CONNECT_START, e), Nt(e, "name") && e.name.startsWith("https:") && ye(r, P.SECURE_CONNECTION_START, e), ye(r, P.CONNECT_END, e), ye(r, P.REQUEST_START, e), ye(r, P.RESPONSE_START, e), ye(r, P.RESPONSE_END, e));
  var n = e[P.ENCODED_BODY_SIZE];
  n !== void 0 && r.setAttribute(GE, n);
  var i = e[P.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && r.setAttribute(LE, i);
}
function VE(r) {
  return r.slice().sort(function(e, t) {
    var n = e[P.FETCH_START], i = t[P.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function _m() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function Rm(r, e, t, n, i, s) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var o = dt(r);
  r = o.toString();
  var a = OE(r, e, t, n, i, s);
  if (a.length === 0)
    return {
      mainRequest: void 0
    };
  if (a.length === 1)
    return {
      mainRequest: a[0]
    };
  var l = VE(a);
  if (o.origin !== _m() && l.length > 1) {
    var u = l[0], c = xE(l, u[P.RESPONSE_END], t), d = u[P.RESPONSE_END], h = c[P.FETCH_START];
    return h < d && (c = u, u = void 0), {
      corsPreFlightRequest: u,
      mainRequest: c
    };
  } else
    return {
      mainRequest: a[0]
    };
}
function xE(r, e, t) {
  for (var n = ht(t), i = ht(cn(e)), s = r[1], o, a = r.length, l = 1; l < a; l++) {
    var u = r[l], c = ht(cn(u[P.FETCH_START])), d = ht(cn(u[P.RESPONSE_END])), h = n - d;
    c >= i && (!o || h < o) && (o = h, s = u);
  }
  return s;
}
function OE(r, e, t, n, i, s) {
  var o = ht(e), a = ht(t), l = n.filter(function(u) {
    var c = ht(cn(u[P.FETCH_START])), d = ht(cn(u[P.RESPONSE_END]));
    return u.initiatorType.toLowerCase() === (s || "xmlhttprequest") && u.name === r && c >= o && d <= a;
  });
  return l.length > 0 && (l = l.filter(function(u) {
    return !i.has(u);
  })), l;
}
function dt(r) {
  if (typeof URL == "function")
    return new URL(r, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var e = NE();
  return e.href = r, e;
}
function Im(r, e) {
  if (r.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var t = XE(r, e);
  if (e && t.indexOf("@id") > 0)
    return t;
  var n = "";
  return r.parentNode && (n += Im(r.parentNode, !1)), n += t, n;
}
function WE(r) {
  if (!r.parentNode)
    return 0;
  var e = [r.nodeType];
  r.nodeType === Node.CDATA_SECTION_NODE && e.push(Node.TEXT_NODE);
  var t = Array.from(r.parentNode.childNodes);
  return t = t.filter(function(n) {
    var i = n.localName;
    return e.indexOf(n.nodeType) >= 0 && i === r.localName;
  }), t.length >= 1 ? t.indexOf(r) + 1 : 0;
}
function XE(r, e) {
  var t = r.nodeType, n = WE(r), i = "";
  if (t === Node.ELEMENT_NODE) {
    var s = r.getAttribute("id");
    if (e && s)
      return '//*[@id="' + s + '"]';
    i = r.localName;
  } else if (t === Node.TEXT_NODE || t === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (t === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function Tm(r, e) {
  var t = e || [];
  (typeof t == "string" || t instanceof RegExp) && (t = [t]);
  var n = dt(r);
  return n.origin === _m() ? !0 : t.some(function(i) {
    return cm(r, i);
  });
}
var Em = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.emit = function(e) {
    }, r;
  }()
), kE = new Em(), PE = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getLogger = function(e, t, n) {
      return new Em();
    }, r;
  }()
), Cm = new PE(), ME = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this._provider = e, this.name = t, this.version = n, this.options = i;
    }
    return r.prototype.emit = function(e) {
      this._getLogger().emit(e);
    }, r.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var e = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return e ? (this._delegate = e, this._delegate) : kE;
    }, r;
  }()
), ad = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getLogger = function(e, t, n) {
      var i;
      return (i = this.getDelegateLogger(e, t, n)) !== null && i !== void 0 ? i : new ME(this, e, t, n);
    }, r.prototype.getDelegate = function() {
      var e;
      return (e = this._delegate) !== null && e !== void 0 ? e : Cm;
    }, r.prototype.setDelegate = function(e) {
      this._delegate = e;
    }, r.prototype.getDelegateLogger = function(e, t, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(e, t, n);
    }, r;
  }()
), AE = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, vi = Symbol.for("io.opentelemetry.js.api.logs"), Kr = AE;
function UE(r, e, t) {
  return function(n) {
    return n === r ? e : t;
  };
}
var ld = 1, YE = (
  /** @class */
  function() {
    function r() {
      this._proxyLoggerProvider = new ad();
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalLoggerProvider = function(e) {
      return Kr[vi] ? this.getLoggerProvider() : (Kr[vi] = UE(ld, e, Cm), this._proxyLoggerProvider.setDelegate(e), e);
    }, r.prototype.getLoggerProvider = function() {
      var e, t;
      return (t = (e = Kr[vi]) === null || e === void 0 ? void 0 : e.call(Kr, ld)) !== null && t !== void 0 ? t : this._proxyLoggerProvider;
    }, r.prototype.getLogger = function(e, t, n) {
      return this.getLoggerProvider().getLogger(e, t, n);
    }, r.prototype.disable = function() {
      delete Kr[vi], this._proxyLoggerProvider = new ad();
    }, r;
  }()
), FE = YE.getInstance(), el = function() {
  return el = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, el.apply(this, arguments);
}, HE = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.instrumentationName = e, this.instrumentationVersion = t, this._config = {}, this._wrap = we.wrap, this._unwrap = we.unwrap, this._massWrap = we.massWrap, this._massUnwrap = we.massUnwrap, this.setConfig(n), this._diag = N.createComponentLogger({
        namespace: e
      }), this._tracer = ee.getTracer(e, t), this._meter = Vr.getMeter(e, t), this._logger = FE.getLogger(e, t), this._updateMetricInstruments();
    }
    return Object.defineProperty(r.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setMeterProvider = function(e) {
      this._meter = e.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(r.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setLoggerProvider = function(e) {
      this._logger = e.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, r.prototype.getModuleDefinitions = function() {
      var e, t = (e = this.init()) !== null && e !== void 0 ? e : [];
      return Array.isArray(t) ? t : [t];
    }, r.prototype._updateMetricInstruments = function() {
    }, r.prototype.getConfig = function() {
      return this._config;
    }, r.prototype.setConfig = function(e) {
      this._config = el({ enabled: !0 }, e);
    }, r.prototype.setTracerProvider = function(e) {
      this._tracer = e.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(r.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._runSpanCustomizationHook = function(e, t, n, i) {
      if (e)
        try {
          e(n, i);
        } catch (s) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: t }, s);
        }
    }, r;
  }()
), JE = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), BE = (
  /** @class */
  function(r) {
    JE(e, r);
    function e(t, n, i) {
      var s = r.call(this, t, n, i) || this;
      return s._config.enabled && s.enable(), s;
    }
    return e;
  }(HE)
);
function ud(r, e, t) {
  var n, i;
  try {
    i = r();
  } catch (s) {
    n = s;
  } finally {
    return e(n, i), i;
  }
}
var dn;
(function(r) {
  r.DOCUMENT_LOAD = "documentLoad", r.DOCUMENT_FETCH = "documentFetch", r.RESOURCE_FETCH = "resourceFetch";
})(dn || (dn = {}));
var DE = "0.44.0", KE = "@opentelemetry/instrumentation-document-load", zE = "http.url", jE = "http.user_agent", Xo = zE, QE = jE, $E = "deployment.environment", qE = $E, eC = "service.name", tC = "url.full", rC = "url.path", nC = "url.query", gs;
(function(r) {
  r.FIRST_PAINT = "firstPaint", r.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(gs || (gs = {}));
var iC = function() {
  var r, e, t = {}, n = (e = (r = Me).getEntriesByType) === null || e === void 0 ? void 0 : e.call(r, "navigation")[0];
  if (n) {
    var i = Object.values(P);
    i.forEach(function(a) {
      if (Nt(n, a)) {
        var l = n[a];
        typeof l == "number" && (t[a] = l);
      }
    });
  } else {
    var s = Me, o = s.timing;
    if (o) {
      var i = Object.values(P);
      i.forEach(function(l) {
        if (Nt(o, l)) {
          var u = o[l];
          typeof u == "number" && (t[l] = u);
        }
      });
    }
  }
  return t;
}, cd = {
  "first-paint": gs.FIRST_PAINT,
  "first-contentful-paint": gs.FIRST_CONTENTFUL_PAINT
}, sC = function(r) {
  var e, t, n = (t = (e = Me).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "paint");
  n && n.forEach(function(i) {
    var s = i.name, o = i.startTime;
    Nt(cd, s) && r.addEvent(cd[s], o);
  });
}, oC = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), aC = (
  /** @class */
  function(r) {
    oC(e, r);
    function e(t) {
      t === void 0 && (t = {});
      var n = r.call(this, KE, DE, t) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return e.prototype.init = function() {
    }, e.prototype._onDocumentLoaded = function() {
      var t = this;
      window.setTimeout(function() {
        t._collectPerformance();
      });
    }, e.prototype._addResourcesSpans = function(t) {
      var n = this, i, s, o = (s = (i = Me).getEntriesByType) === null || s === void 0 ? void 0 : s.call(i, "resource");
      o && o.forEach(function(a) {
        n._initResourceSpan(a, t);
      });
    }, e.prototype._collectPerformance = function() {
      var t = this, n = Array.from(document.getElementsByTagName("meta")).find(function(o) {
        return o.getAttribute("name") === Fi;
      }), i = iC(), s = n && n.content || "";
      K.with(ke.extract(Xt, { traceparent: s }), function() {
        var o, a = t._startSpan(dn.DOCUMENT_LOAD, P.FETCH_START, i);
        a && (K.with(ee.setSpan(K.active(), a), function() {
          var l = t._startSpan(dn.DOCUMENT_FETCH, P.FETCH_START, i);
          l && (l.setAttribute(Xo, location.href), K.with(ee.setSpan(K.active(), l), function() {
            var u;
            t.getConfig().ignoreNetworkEvents || Gr(l, i), t._addCustomAttributesOnSpan(l, (u = t.getConfig().applyCustomAttributesOnSpan) === null || u === void 0 ? void 0 : u.documentFetch), t._endSpan(l, P.RESPONSE_END, i);
          }));
        }), a.setAttribute(Xo, location.href), a.setAttribute(QE, navigator.userAgent), t._addResourcesSpans(a), t.getConfig().ignoreNetworkEvents || (ye(a, P.FETCH_START, i), ye(a, P.UNLOAD_EVENT_START, i), ye(a, P.UNLOAD_EVENT_END, i), ye(a, P.DOM_INTERACTIVE, i), ye(a, P.DOM_CONTENT_LOADED_EVENT_START, i), ye(a, P.DOM_CONTENT_LOADED_EVENT_END, i), ye(a, P.DOM_COMPLETE, i), ye(a, P.LOAD_EVENT_START, i), ye(a, P.LOAD_EVENT_END, i)), t.getConfig().ignorePerformancePaintEvents || sC(a), t._addCustomAttributesOnSpan(a, (o = t.getConfig().applyCustomAttributesOnSpan) === null || o === void 0 ? void 0 : o.documentLoad), t._endSpan(a, P.LOAD_EVENT_END, i));
      });
    }, e.prototype._endSpan = function(t, n, i) {
      t && (Nt(i, n) ? t.end(i[n]) : t.end());
    }, e.prototype._initResourceSpan = function(t, n) {
      var i, s = this._startSpan(dn.RESOURCE_FETCH, P.FETCH_START, t, n);
      s && (s.setAttribute(Xo, t.name), this.getConfig().ignoreNetworkEvents || Gr(s, t), this._addCustomAttributesOnResourceSpan(s, t, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(s, P.RESPONSE_END, t));
    }, e.prototype._startSpan = function(t, n, i, s) {
      if (Nt(i, n) && typeof i[n] == "number") {
        var o = this.tracer.startSpan(t, {
          startTime: i[n]
        }, s ? ee.setSpan(K.active(), s) : void 0);
        return o;
      }
    }, e.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, e.prototype._addCustomAttributesOnSpan = function(t, n) {
      var i = this;
      n && ud(function() {
        return n(t);
      }, function(s) {
        s && i._diag.error("addCustomAttributesOnSpan", s);
      });
    }, e.prototype._addCustomAttributesOnResourceSpan = function(t, n, i) {
      var s = this;
      i && ud(function() {
        return i(t, n);
      }, function(o) {
        o && s._diag.error("addCustomAttributesOnResourceSpan", o);
      });
    }, e.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, e.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, e;
  }(BE)
), Zm = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.emit = function(e) {
    }, r;
  }()
), lC = new Zm(), uC = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getLogger = function(e, t, n) {
      return new Zm();
    }, r;
  }()
), Gm = new uC(), cC = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this._provider = e, this.name = t, this.version = n, this.options = i;
    }
    return r.prototype.emit = function(e) {
      this._getLogger().emit(e);
    }, r.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var e = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return e ? (this._delegate = e, this._delegate) : lC;
    }, r;
  }()
), dd = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getLogger = function(e, t, n) {
      var i;
      return (i = this.getDelegateLogger(e, t, n)) !== null && i !== void 0 ? i : new cC(this, e, t, n);
    }, r.prototype.getDelegate = function() {
      var e;
      return (e = this._delegate) !== null && e !== void 0 ? e : Gm;
    }, r.prototype.setDelegate = function(e) {
      this._delegate = e;
    }, r.prototype.getDelegateLogger = function(e, t, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(e, t, n);
    }, r;
  }()
), dC = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Si = Symbol.for("io.opentelemetry.js.api.logs"), zr = dC;
function hC(r, e, t) {
  return function(n) {
    return n === r ? e : t;
  };
}
var hd = 1, fC = (
  /** @class */
  function() {
    function r() {
      this._proxyLoggerProvider = new dd();
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalLoggerProvider = function(e) {
      return zr[Si] ? this.getLoggerProvider() : (zr[Si] = hC(hd, e, Gm), this._proxyLoggerProvider.setDelegate(e), e);
    }, r.prototype.getLoggerProvider = function() {
      var e, t;
      return (t = (e = zr[Si]) === null || e === void 0 ? void 0 : e.call(zr, hd)) !== null && t !== void 0 ? t : this._proxyLoggerProvider;
    }, r.prototype.getLogger = function(e, t, n) {
      return this.getLoggerProvider().getLogger(e, t, n);
    }, r.prototype.disable = function() {
      delete zr[Si], this._proxyLoggerProvider = new dd();
    }, r;
  }()
), pC = fC.getInstance(), tl = function() {
  return tl = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, tl.apply(this, arguments);
}, mC = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.instrumentationName = e, this.instrumentationVersion = t, this._config = {}, this._wrap = we.wrap, this._unwrap = we.unwrap, this._massWrap = we.massWrap, this._massUnwrap = we.massUnwrap, this.setConfig(n), this._diag = N.createComponentLogger({
        namespace: e
      }), this._tracer = ee.getTracer(e, t), this._meter = Vr.getMeter(e, t), this._logger = pC.getLogger(e, t), this._updateMetricInstruments();
    }
    return Object.defineProperty(r.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setMeterProvider = function(e) {
      this._meter = e.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(r.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setLoggerProvider = function(e) {
      this._logger = e.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, r.prototype.getModuleDefinitions = function() {
      var e, t = (e = this.init()) !== null && e !== void 0 ? e : [];
      return Array.isArray(t) ? t : [t];
    }, r.prototype._updateMetricInstruments = function() {
    }, r.prototype.getConfig = function() {
      return this._config;
    }, r.prototype.setConfig = function(e) {
      this._config = tl({ enabled: !0 }, e);
    }, r.prototype.setTracerProvider = function(e) {
      this._tracer = e.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(r.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._runSpanCustomizationHook = function(e, t, n, i) {
      if (e)
        try {
          e(n, i);
        } catch (s) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: t }, s);
        }
    }, r;
  }()
), gC = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), yC = (
  /** @class */
  function(r) {
    gC(e, r);
    function e(t, n, i) {
      var s = r.call(this, t, n, i) || this;
      return s._config.enabled && s.enable(), s;
    }
    return e;
  }(mC)
);
function bC(r, e, t) {
  var n, i;
  try {
    i = r();
  } catch (s) {
    n = s;
  } finally {
    return e(n, i), i;
  }
}
function vC(r) {
  return typeof r == "function" && typeof r.__original == "function" && typeof r.__unwrap == "function" && r.__wrapped === !0;
}
var ys;
(function(r) {
  r.COMPONENT = "component", r.HTTP_ERROR_NAME = "http.error_name", r.HTTP_STATUS_TEXT = "http.status_text";
})(ys || (ys = {}));
var SC = "http.method", wC = "http.url", _C = "http.host", RC = "http.scheme", IC = "http.status_code", TC = "http.user_agent", EC = "http.request_content_length_uncompressed", CC = SC, ZC = wC, GC = _C, LC = RC, NC = IC, VC = TC, xC = EC, OC = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, WC = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, XC = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, kC = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, Lm = N.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function PC() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  if (r[0] instanceof URL || typeof r[0] == "string") {
    var t = r[1];
    if (!(t != null && t.body))
      return Promise.resolve();
    if (t.body instanceof ReadableStream) {
      var n = MC(t.body), i = n.body, s = n.length;
      return t.body = i, s;
    } else
      return Promise.resolve(AC(t.body));
  } else {
    var o = r[0];
    return o != null && o.body ? o.clone().text().then(function(a) {
      return rl(a);
    }) : Promise.resolve();
  }
}
function MC(r) {
  if (!r.pipeThrough)
    return Lm.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: r,
      length: Promise.resolve(void 0)
    };
  var e = 0, t, n = new Promise(function(s) {
    t = s;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(s, o) {
      return OC(this, void 0, void 0, function() {
        var a;
        return WC(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, s];
            case 1:
              return a = l.sent(), e += a.byteLength, o.enqueue(s), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      t(e);
    }
  });
  return {
    body: r.pipeThrough(i),
    length: n
  };
}
function AC(r) {
  if (typeof Document != "undefined" && r instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (r instanceof Blob)
    return r.size;
  if (r.byteLength !== void 0)
    return r.byteLength;
  if (r instanceof FormData)
    return YC(r);
  if (r instanceof URLSearchParams)
    return rl(r.toString());
  if (typeof r == "string")
    return rl(r);
  Lm.warn("unknown body type");
}
var UC = new TextEncoder();
function rl(r) {
  return UC.encode(r).byteLength;
}
function YC(r) {
  var e, t, n = 0;
  try {
    for (var i = XC(r.entries()), s = i.next(); !s.done; s = i.next()) {
      var o = kC(s.value, 2), a = o[0], l = o[1];
      n += a.length, l instanceof Blob ? n += l.size : n += l.length;
    }
  } catch (u) {
    e = { error: u };
  } finally {
    try {
      s && !s.done && (t = i.return) && t.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
var fd = "0.57.1", FC = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), HC = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, JC = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, ko, BC = 300, pd = typeof process == "object" && ((ko = process.release) === null || ko === void 0 ? void 0 : ko.name) === "node", DC = (
  /** @class */
  function(r) {
    FC(e, r);
    function e(t) {
      t === void 0 && (t = {});
      var n = r.call(this, "@opentelemetry/instrumentation-fetch", fd, t) || this;
      return n.component = "fetch", n.version = fd, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return e.prototype.init = function() {
    }, e.prototype._addChildSpan = function(t, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[P.FETCH_START]
      }, ee.setSpan(K.active(), t));
      Gr(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[P.RESPONSE_END]);
    }, e.prototype._addFinalSpanAttributes = function(t, n) {
      var i = dt(n.url);
      t.setAttribute(NC, n.status), n.statusText != null && t.setAttribute(ys.HTTP_STATUS_TEXT, n.statusText), t.setAttribute(GC, i.host), t.setAttribute(LC, i.protocol.replace(":", "")), typeof navigator != "undefined" && t.setAttribute(VC, navigator.userAgent);
    }, e.prototype._addHeaders = function(t, n) {
      if (!Tm(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        ke.inject(K.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (t instanceof Request)
        ke.inject(K.active(), t.headers, {
          set: function(s, o, a) {
            return s.set(o, typeof a == "string" ? a : String(a));
          }
        });
      else if (t.headers instanceof Headers)
        ke.inject(K.active(), t.headers, {
          set: function(s, o, a) {
            return s.set(o, typeof a == "string" ? a : String(a));
          }
        });
      else if (t.headers instanceof Map)
        ke.inject(K.active(), t.headers, {
          set: function(s, o, a) {
            return s.set(o, typeof a == "string" ? a : String(a));
          }
        });
      else {
        var i = {};
        ke.inject(K.active(), i), t.headers = Object.assign({}, i, t.headers || {});
      }
    }, e.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e.prototype._createSpan = function(t, n) {
      var i;
      if (n === void 0 && (n = {}), dm(t, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var s = (n.method || "GET").toUpperCase(), o = "HTTP " + s;
      return this.tracer.startSpan(o, {
        kind: Cn.CLIENT,
        attributes: (i = {}, i[ys.COMPONENT] = this.moduleName, i[CC] = s, i[ZC] = t, i)
      });
    }, e.prototype._findResourceAndAddNetworkEvents = function(t, n, i) {
      var s = n.entries;
      if (!s.length) {
        if (!performance.getEntriesByType)
          return;
        s = performance.getEntriesByType("resource");
      }
      var o = Rm(n.spanUrl, n.startTime, i, s, this._usedResources, "fetch");
      if (o.mainRequest) {
        var a = o.mainRequest;
        this._markResourceAsUsed(a);
        var l = o.corsPreFlightRequest;
        l && (this._addChildSpan(t, l), this._markResourceAsUsed(l)), Gr(t, a, this.getConfig().ignoreNetworkEvents);
      }
    }, e.prototype._markResourceAsUsed = function(t) {
      this._usedResources.add(t);
    }, e.prototype._endSpan = function(t, n, i) {
      var s = this, o = Pe(Date.now()), a = Jt();
      this._addFinalSpanAttributes(t, i), setTimeout(function() {
        var l;
        (l = n.observer) === null || l === void 0 || l.disconnect(), s._findResourceAndAddNetworkEvents(t, n, a), s._tasksCount--, s._clearResources(), t.end(o);
      }, BC);
    }, e.prototype._patchConstructor = function() {
      var t = this;
      return function(n) {
        var i = t;
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var l = this, u = dt(o[0] instanceof Request ? o[0].url : String(o[0])).href, c = o[0] instanceof Request ? o[0] : o[1] || {}, d = i._createSpan(u, c);
          if (!d)
            return n.apply(this, o);
          var h = i._prepareSpanData(u);
          i.getConfig().measureRequestSize && PC.apply(void 0, JC([], HC(o), !1)).then(function(y) {
            y && d.setAttribute(xC, y);
          }).catch(function(y) {
            i._diag.warn("getFetchBodyLength", y);
          });
          function f(y, _) {
            i._applyAttributesAfterFetch(y, c, _), i._endSpan(y, h, {
              status: _.status || 0,
              statusText: _.message,
              url: u
            });
          }
          function m(y, _) {
            i._applyAttributesAfterFetch(y, c, _), _.status >= 200 && _.status < 400 ? i._endSpan(y, h, _) : i._endSpan(y, h, {
              status: _.status,
              statusText: _.statusText,
              url: u
            });
          }
          function p(y, _, S) {
            try {
              var C = S.clone(), R = S.clone(), L = C.body;
              if (L) {
                var k = L.getReader(), x = function() {
                  k.read().then(function(E) {
                    var G = E.done;
                    G ? m(y, R) : x();
                  }, function(E) {
                    f(y, E);
                  });
                };
                x();
              } else
                m(y, S);
            } finally {
              _(S);
            }
          }
          function g(y, _, S) {
            try {
              f(y, S);
            } finally {
              _(S);
            }
          }
          return new Promise(function(y, _) {
            return K.with(ee.setSpan(K.active(), d), function() {
              return i._addHeaders(c, u), i._tasksCount++, n.apply(l, c instanceof Request ? [c] : [u, c]).then(p.bind(l, d, y), g.bind(l, d, _));
            });
          });
        };
      };
    }, e.prototype._applyAttributesAfterFetch = function(t, n, i) {
      var s = this, o = this.getConfig().applyCustomAttributesOnSpan;
      o && bC(function() {
        return o(t, n, i);
      }, function(a) {
        a && s._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, e.prototype._prepareSpanData = function(t) {
      var n = Jt(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: t };
      var s = new PerformanceObserver(function(o) {
        var a = o.getEntries();
        a.forEach(function(l) {
          l.initiatorType === "fetch" && l.name === t && i.push(l);
        });
      });
      return s.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: s, startTime: n, spanUrl: t };
    }, e.prototype.enable = function() {
      if (pd) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      vC(fetch) && (this._unwrap(un, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(un, "fetch", this._patchConstructor());
    }, e.prototype.disable = function() {
      pd || (this._unwrap(un, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e;
  }(yC)
), Nm = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.emit = function(e) {
    }, r;
  }()
), KC = new Nm(), zC = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getLogger = function(e, t, n) {
      return new Nm();
    }, r;
  }()
), Vm = new zC(), jC = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this._provider = e, this.name = t, this.version = n, this.options = i;
    }
    return r.prototype.emit = function(e) {
      this._getLogger().emit(e);
    }, r.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var e = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return e ? (this._delegate = e, this._delegate) : KC;
    }, r;
  }()
), md = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getLogger = function(e, t, n) {
      var i;
      return (i = this.getDelegateLogger(e, t, n)) !== null && i !== void 0 ? i : new jC(this, e, t, n);
    }, r.prototype.getDelegate = function() {
      var e;
      return (e = this._delegate) !== null && e !== void 0 ? e : Vm;
    }, r.prototype.setDelegate = function(e) {
      this._delegate = e;
    }, r.prototype.getDelegateLogger = function(e, t, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(e, t, n);
    }, r;
  }()
), QC = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, wi = Symbol.for("io.opentelemetry.js.api.logs"), jr = QC;
function $C(r, e, t) {
  return function(n) {
    return n === r ? e : t;
  };
}
var gd = 1, qC = (
  /** @class */
  function() {
    function r() {
      this._proxyLoggerProvider = new md();
    }
    return r.getInstance = function() {
      return this._instance || (this._instance = new r()), this._instance;
    }, r.prototype.setGlobalLoggerProvider = function(e) {
      return jr[wi] ? this.getLoggerProvider() : (jr[wi] = $C(gd, e, Vm), this._proxyLoggerProvider.setDelegate(e), e);
    }, r.prototype.getLoggerProvider = function() {
      var e, t;
      return (t = (e = jr[wi]) === null || e === void 0 ? void 0 : e.call(jr, gd)) !== null && t !== void 0 ? t : this._proxyLoggerProvider;
    }, r.prototype.getLogger = function(e, t, n) {
      return this.getLoggerProvider().getLogger(e, t, n);
    }, r.prototype.disable = function() {
      delete jr[wi], this._proxyLoggerProvider = new md();
    }, r;
  }()
), eZ = qC.getInstance(), nl = function() {
  return nl = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, nl.apply(this, arguments);
}, tZ = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.instrumentationName = e, this.instrumentationVersion = t, this._config = {}, this._wrap = we.wrap, this._unwrap = we.unwrap, this._massWrap = we.massWrap, this._massUnwrap = we.massUnwrap, this.setConfig(n), this._diag = N.createComponentLogger({
        namespace: e
      }), this._tracer = ee.getTracer(e, t), this._meter = Vr.getMeter(e, t), this._logger = eZ.getLogger(e, t), this._updateMetricInstruments();
    }
    return Object.defineProperty(r.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setMeterProvider = function(e) {
      this._meter = e.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(r.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.setLoggerProvider = function(e) {
      this._logger = e.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, r.prototype.getModuleDefinitions = function() {
      var e, t = (e = this.init()) !== null && e !== void 0 ? e : [];
      return Array.isArray(t) ? t : [t];
    }, r.prototype._updateMetricInstruments = function() {
    }, r.prototype.getConfig = function() {
      return this._config;
    }, r.prototype.setConfig = function(e) {
      this._config = nl({ enabled: !0 }, e);
    }, r.prototype.setTracerProvider = function(e) {
      this._tracer = e.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(r.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._runSpanCustomizationHook = function(e, t, n, i) {
      if (e)
        try {
          e(n, i);
        } catch (s) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: t }, s);
        }
    }, r;
  }()
), rZ = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), nZ = (
  /** @class */
  function(r) {
    rZ(e, r);
    function e(t, n, i) {
      var s = r.call(this, t, n, i) || this;
      return s._config.enabled && s.enable(), s;
    }
    return e;
  }(tZ)
);
function iZ(r, e, t) {
  var n, i;
  try {
    i = r();
  } catch (s) {
    n = s;
  } finally {
    return e(n, i), i;
  }
}
function yd(r) {
  return typeof r == "function" && typeof r.__original == "function" && typeof r.__unwrap == "function" && r.__wrapped === !0;
}
var sZ = "http.method", oZ = "http.url", aZ = "http.host", lZ = "http.scheme", uZ = "http.status_code", cZ = "http.user_agent", dZ = "http.request_content_length_uncompressed", hZ = sZ, fZ = oZ, pZ = aZ, mZ = lZ, gZ = uZ, yZ = cZ, bZ = dZ, ct;
(function(r) {
  r.METHOD_OPEN = "open", r.METHOD_SEND = "send", r.EVENT_ABORT = "abort", r.EVENT_ERROR = "error", r.EVENT_LOAD = "loaded", r.EVENT_TIMEOUT = "timeout";
})(ct || (ct = {}));
var vZ = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, SZ = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, wZ = N.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function _Z(r) {
  if (typeof Document != "undefined" && r instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (r instanceof Blob)
    return r.size;
  if (r.byteLength !== void 0)
    return r.byteLength;
  if (r instanceof FormData)
    return IZ(r);
  if (r instanceof URLSearchParams)
    return bd(r.toString());
  if (typeof r == "string")
    return bd(r);
  wZ.warn("unknown body type");
}
var RZ = new TextEncoder();
function bd(r) {
  return RZ.encode(r).byteLength;
}
function IZ(r) {
  var e, t, n = 0;
  try {
    for (var i = vZ(r.entries()), s = i.next(); !s.done; s = i.next()) {
      var o = SZ(s.value, 2), a = o[0], l = o[1];
      n += a.length, l instanceof Blob ? n += l.size : n += l.length;
    }
  } catch (u) {
    e = { error: u };
  } finally {
    try {
      s && !s.done && (t = i.return) && t.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
var vd = "0.57.1", il;
(function(r) {
  r.HTTP_STATUS_TEXT = "http.status_text";
})(il || (il = {}));
var TZ = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), EZ = 300, CZ = (
  /** @class */
  function(r) {
    TZ(e, r);
    function e(t) {
      t === void 0 && (t = {});
      var n = r.call(this, "@opentelemetry/instrumentation-xml-http-request", vd, t) || this;
      return n.component = "xml-http-request", n.version = vd, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return e.prototype.init = function() {
    }, e.prototype._addHeaders = function(t, n) {
      var i = dt(n).href;
      if (!Tm(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var s = {};
        ke.inject(K.active(), s), Object.keys(s).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var o = {};
      ke.inject(K.active(), o), Object.keys(o).forEach(function(a) {
        t.setRequestHeader(a, String(o[a]));
      });
    }, e.prototype._addChildSpan = function(t, n) {
      var i = this;
      K.with(ee.setSpan(K.active(), t), function() {
        var s = i.tracer.startSpan("CORS Preflight", {
          startTime: n[P.FETCH_START]
        });
        Gr(s, n, i.getConfig().ignoreNetworkEvents), s.end(n[P.RESPONSE_END]);
      });
    }, e.prototype._addFinalSpanAttributes = function(t, n, i) {
      if (typeof i == "string") {
        var s = dt(i);
        n.status !== void 0 && t.setAttribute(gZ, n.status), n.statusText !== void 0 && t.setAttribute(il.HTTP_STATUS_TEXT, n.statusText), t.setAttribute(pZ, s.host), t.setAttribute(mZ, s.protocol.replace(":", "")), t.setAttribute(yZ, navigator.userAgent);
      }
    }, e.prototype._applyAttributesAfterXHR = function(t, n) {
      var i = this, s = this.getConfig().applyCustomAttributesOnSpan;
      typeof s == "function" && iZ(function() {
        return s(t, n);
      }, function(o) {
        o && i._diag.error("applyCustomAttributesOnSpan", o);
      });
    }, e.prototype._addResourceObserver = function(t, n) {
      var i = this._xhrMem.get(t);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(s) {
          var o = s.getEntries(), a = dt(n);
          o.forEach(function(l) {
            l.initiatorType === "xmlhttprequest" && l.name === a.href && i.createdResources && i.createdResources.entries.push(l);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, e.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (Me.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, e.prototype._findResourceAndAddNetworkEvents = function(t, n, i, s, o) {
      if (!(!i || !s || !o || !t.createdResources)) {
        var a = t.createdResources.entries;
        (!a || !a.length) && (a = Me.getEntriesByType("resource"));
        var l = Rm(dt(i).href, s, o, a, this._usedResources);
        if (l.mainRequest) {
          var u = l.mainRequest;
          this._markResourceAsUsed(u);
          var c = l.corsPreFlightRequest;
          c && (this._addChildSpan(n, c), this._markResourceAsUsed(c)), Gr(n, u, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, e.prototype._cleanPreviousSpanInformation = function(t) {
      var n = this._xhrMem.get(t);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(t);
      }
    }, e.prototype._createSpan = function(t, n, i) {
      var s;
      if (dm(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = i.toUpperCase(), a = this.tracer.startSpan(o, {
        kind: Cn.CLIENT,
        attributes: (s = {}, s[hZ] = i, s[fZ] = dt(n).toString(), s)
      });
      return a.addEvent(ct.METHOD_OPEN), this._cleanPreviousSpanInformation(t), this._xhrMem.set(t, {
        span: a,
        spanUrl: n
      }), a;
    }, e.prototype._markResourceAsUsed = function(t) {
      this._usedResources.add(t);
    }, e.prototype._patchOpen = function() {
      var t = this;
      return function(n) {
        var i = t;
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var l = o[0], u = o[1];
          return i._createSpan(this, u, l), n.apply(this, o);
        };
      };
    }, e.prototype._patchSend = function() {
      var t = this;
      function n(c, d, h, f) {
        var m = d.callbackToRemoveEvents;
        typeof m == "function" && m();
        var p = d.span, g = d.spanUrl, y = d.sendStartTime;
        p && (t._findResourceAndAddNetworkEvents(d, p, g, y, h), p.addEvent(c, f), t._addFinalSpanAttributes(p, d, g), p.end(f), t._tasksCount--), t._clearResources();
      }
      function i(c, d) {
        var h = t._xhrMem.get(d);
        if (h) {
          h.status = d.status, h.statusText = d.statusText, t._xhrMem.delete(d), h.span && t._applyAttributesAfterXHR(h.span, d);
          var f = Jt(), m = Date.now();
          setTimeout(function() {
            n(c, h, f, m);
          }, EZ);
        }
      }
      function s() {
        i(ct.EVENT_ERROR, this);
      }
      function o() {
        i(ct.EVENT_ABORT, this);
      }
      function a() {
        i(ct.EVENT_TIMEOUT, this);
      }
      function l() {
        this.status < 299 ? i(ct.EVENT_LOAD, this) : i(ct.EVENT_ERROR, this);
      }
      function u(c) {
        c.removeEventListener("abort", o), c.removeEventListener("error", s), c.removeEventListener("load", l), c.removeEventListener("timeout", a);
        var d = t._xhrMem.get(c);
        d && (d.callbackToRemoveEvents = void 0);
      }
      return function(c) {
        return function() {
          for (var h = this, f = [], m = 0; m < arguments.length; m++)
            f[m] = arguments[m];
          var p = t._xhrMem.get(this);
          if (!p)
            return c.apply(this, f);
          var g = p.span, y = p.spanUrl;
          if (g && y) {
            if (t.getConfig().measureRequestSize && (f != null && f[0])) {
              var _ = f[0], S = _Z(_);
              S !== void 0 && g.setAttribute(bZ, S);
            }
            K.with(ee.setSpan(K.active(), g), function() {
              t._tasksCount++, p.sendStartTime = Jt(), g.addEvent(ct.METHOD_SEND), h.addEventListener("abort", o), h.addEventListener("error", s), h.addEventListener("load", l), h.addEventListener("timeout", a), p.callbackToRemoveEvents = function() {
                u(h), p.createdResources && p.createdResources.observer.disconnect();
              }, t._addHeaders(h, y), t._addResourceObserver(h, y);
            });
          }
          return c.apply(this, f);
        };
      };
    }, e.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), yd(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), yd(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, e.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, e;
  }(nZ)
);
const Sd = 1e3, ZZ = 1e3 * 2, GZ = 4 * 60 * 60 * 1e3, xm = 15 * 60 * 1e3, wd = {
  normal: {
    bytes: 1e7,
    time: 4 * 60 * 1e3
  },
  canvas: {
    bytes: 16e6,
    time: 5e3
  }
}, LZ = 100, sl = "app.highlight.io";
/*! js-cookie v3.0.5 | MIT */
function _i(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var n in t)
      r[n] = t[n];
  }
  return r;
}
var NZ = {
  read: function(r) {
    return r[0] === '"' && (r = r.slice(1, -1)), r.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(r) {
    return encodeURIComponent(r).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function ol(r, e) {
  function t(i, s, o) {
    if (typeof document != "undefined") {
      o = _i({}, e, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var l in o)
        o[l] && (a += "; " + l, o[l] !== !0 && (a += "=" + o[l].split(";")[0]));
      return document.cookie = i + "=" + r.write(s, i) + a;
    }
  }
  function n(i) {
    if (!(typeof document == "undefined" || arguments.length && !i)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], o = {}, a = 0; a < s.length; a++) {
        var l = s[a].split("="), u = l.slice(1).join("=");
        try {
          var c = decodeURIComponent(l[0]);
          if (o[c] = r.read(u, c), i === c)
            break;
        } catch (d) {
        }
      }
      return i ? o[i] : o;
    }
  }
  return Object.create(
    {
      set: t,
      get: n,
      remove: function(i, s) {
        t(
          i,
          "",
          _i({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return ol(this.converter, _i({}, this.attributes, i));
      },
      withConverter: function(i) {
        return ol(_i({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(r) }
    }
  );
}
var Po = ol(NZ, { path: "/" });
let uu = "localStorage", al = !0;
class VZ {
  constructor() {
    T(this, "storage", {});
  }
  getItem(e) {
    var t;
    return (t = this.storage[e]) != null ? t : "";
  }
  setItem(e, t) {
    this.storage[e] = t;
  }
  removeItem(e) {
    delete this.storage[e];
  }
}
class xZ {
  getItem(e) {
    var t;
    return (t = Po.get(e)) != null ? t : "";
  }
  setItem(e, t) {
    if (!al)
      return;
    const n = /* @__PURE__ */ new Date();
    n.setTime(n.getTime() + xm), Po.set(e, t, { expires: n });
  }
  removeItem(e) {
    al && Po.remove(e);
  }
}
let OZ = new VZ();
const bs = new xZ(), cu = () => {
  try {
    switch (uu) {
      case "localStorage":
        return window.localStorage;
      case "sessionStorage":
        return window.sessionStorage;
    }
  } catch (r) {
    return OZ;
  }
}, WZ = (r) => {
  uu = r;
}, Om = (r) => {
  al = r;
}, Ae = (r) => cu().getItem(r), pt = (r, e) => (bs.setItem(r, e), cu().setItem(r, e)), ll = (r) => (bs.removeItem(r), cu().removeItem(r)), XZ = (r) => {
  if (uu === "sessionStorage") {
    console.warn("highlight.io cannot use local storage; segment integration will not work");
    return;
  }
  const e = window.localStorage.setItem;
  window.localStorage.setItem = function() {
    const [t, n] = arguments;
    r({ keyName: t, keyValue: n }), e.apply(this, [t, n]);
  };
};
var Te;
(function(r) {
  r.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", r.SESSION_ID = "sessionID", r.SESSION_DATA = "sessionData", r.USER_IDENTIFIER = "highlightIdentifier", r.USER_OBJECT = "highlightUserObject";
})(Te || (Te = {}));
const Us = (r) => `${Te.SESSION_DATA}_${r}`;
let Wm = "";
const kZ = () => Wm, PZ = (r) => {
  r && (Wm = r);
}, MZ = () => {
  var r;
  return (r = Ae(Te.SESSION_ID)) != null ? r : "";
}, Ji = (r) => {
  pt(Te.SESSION_ID, r);
}, AZ = (r) => {
  const e = Us(r);
  return JSON.parse(Ae(e) || "{}");
}, br = (r) => {
  r || (r = MZ());
  let e = AZ(r);
  if (e && e.lastPushTime && Date.now() - e.lastPushTime < xm)
    return e;
  ll(Us(r));
}, ur = function(r) {
  if (!(r != null && r.sessionSecureID))
    return;
  const e = r.sessionSecureID;
  PZ(e), pt(Us(e), JSON.stringify(r));
}, UZ = function() {
  const r = bs.getItem(Te.SESSION_ID);
  Ji(r);
  const e = Us(r), t = bs.getItem(e);
  try {
    ur(JSON.parse(t));
  } catch (n) {
  }
}, _d = (r, e, t) => {
  const n = Xm(e, r.headers, t);
  return M(I({}, r), {
    headers: n
  });
}, Xm = (r, e, t) => {
  var i, s;
  const n = I({}, e);
  return t ? ((i = Object.keys(n)) == null || i.forEach((o) => {
    [...t].includes(o == null ? void 0 : o.toLowerCase()) || (n[o] = "[REDACTED]");
  }), n) : ((s = Object.keys(n)) == null || s.forEach((o) => {
    [...YZ, ...r].includes(o == null ? void 0 : o.toLowerCase()) && (n[o] = "[REDACTED]");
  }), n);
}, YZ = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], km = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], Pm = "X-Highlight-Request", Rd = (r) => {
  let e = r;
  return !r.startsWith("https://") && !r.startsWith("http://") && (e = `${window.location.origin}${e}`), e.replace(/\/+$/, "");
}, FZ = (r, { headersToRedact: e, headersToRecord: t, requestResponseSanitizer: n }) => {
  var l, u;
  let i = r;
  if (n) {
    let d = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (f) {
      d = !1;
    }
    let h = !0;
    try {
      i.response.body = JSON.parse(i.response.body);
    } catch (f) {
      h = !1;
    }
    try {
      i = n(i);
    } catch (f) {
    } finally {
      d = d && !!((l = i == null ? void 0 : i.request) != null && l.body), h = h && !!((u = i == null ? void 0 : i.response) != null && u.body), d && (i.request.body = JSON.stringify(i.request.body)), h && (i.response.body = JSON.stringify(i.response.body));
    }
    if (!i)
      return null;
  }
  const c = i, { request: s, response: o } = c, a = Ze(c, ["request", "response"]);
  return I({
    request: _d(s, e, t),
    response: _d(o, e, t)
  }, a);
}, Id = (r, e, t, n) => {
  r.sort((l, u) => l.responseEnd - u.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, s = r.reduce((l, u) => {
    const c = Rd(u.name);
    return u.initiatorType === t ? l[t][c] = [
      ...l[t][c] || [],
      u
    ] : l.others[c] = [
      ...l.others[c] || [],
      u
    ], l;
  }, i);
  let o = {};
  o = e.reduce((l, u) => {
    const c = Rd(u.request.url);
    return l[c] = [...l[c] || [], u], l;
  }, o);
  for (let l in s[t]) {
    const u = s[t][l], c = o[l];
    if (!c)
      continue;
    const d = Math.max(u.length - c.length, 0);
    for (let h = d; h < u.length; h++)
      u[h] && (u[h].requestResponsePair = c[h - d]);
  }
  let a = [];
  for (let l in s)
    for (let u in s[l])
      a = a.concat(s[l][u]);
  return a.sort((l, u) => l.fetchStart - u.fetchStart).reduce((l, u) => {
    let c = u.requestResponsePair;
    return c && (c = FZ(u.requestResponsePair, n), !c) || (u.toJSON = function() {
      const d = window.performance.timeOrigin;
      return {
        initiatorType: this.initiatorType,
        startTimeAbs: d + this.startTime,
        connectStartAbs: d + this.connectStart,
        connectEndAbs: d + this.connectEnd,
        domainLookupStartAbs: d + this.domainLookupStart,
        domainLookupEndAbs: d + this.domainLookupEnd,
        fetchStartAbs: d + this.fetchStart,
        redirectStartAbs: d + this.redirectStart,
        redirectEndAbs: d + this.redirectEnd,
        requestStartAbs: d + this.requestStart,
        responseStartAbs: d + this.responseStart,
        responseEndAbs: d + this.responseEnd,
        secureConnectionStartAbs: d + this.secureConnectionStart,
        workerStartAbs: d + this.workerStart,
        name: this.name,
        transferSize: this.transferSize,
        encodedBodySize: this.encodedBodySize,
        decodedBodySize: this.decodedBodySize,
        nextHopProtocol: this.nextHopProtocol,
        requestResponsePairs: c
      };
    }, l.push(u)), l;
  }, []);
}, HZ = (r, e) => e.some((t) => r.toLocaleLowerCase().includes(t)), Ys = (r, e, t) => !HZ(r, e), du = (r, e, t) => {
  var s;
  if (t.some((o) => r.toLowerCase().includes(o)))
    return !1;
  let n = [];
  e === !0 ? (n = ["localhost", /^\//], (s = window == null ? void 0 : window.location) != null && s.host && n.push(window.location.host)) : e instanceof Array && (n = e);
  let i = !1;
  return n.forEach((o) => {
    r.match(o) && (i = !0);
  }), i;
};
function JZ(r) {
  for (var e = "", t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = t.length, i = 0; i < r; i++)
    e += t.charAt(Math.floor(Math.random() * n));
  return e;
}
const hu = () => {
  const r = JZ(10), e = wV(), t = e == null ? void 0 : e.spanContext().traceId;
  return [kZ(), t != null ? t : r];
}, Mm = (r, e) => r + "/" + e, BZ = (r, e, t, n, i, s) => {
  const o = XMLHttpRequest.prototype, a = o.open, l = o.send, u = o.setRequestHeader;
  return o.open = function(c, d) {
    return typeof d == "string" ? this._url = d : this._url = d.toString(), this._method = c, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some((h) => this._url.toLowerCase().includes(h)), a.apply(this, arguments);
  }, o.setRequestHeader = function(c, d) {
    return this._requestHeaders[c] = d, u.apply(this, arguments);
  }, o.send = function(c) {
    if (!Ys(this._url, e))
      return l.apply(this, arguments);
    const [d, h] = hu();
    du(this._url, t, n) && this.setRequestHeader(Pm, Mm(d, h));
    const f = this._shouldRecordHeaderAndBody, m = {
      sessionSecureID: d,
      id: h,
      url: this._url,
      verb: this._method,
      headers: f ? this._requestHeaders : {},
      body: void 0
    };
    if (f && c) {
      const p = Td(c, m.url);
      p && (this._body = p, m.body = Tt(p, i, s, m.headers));
    }
    return this.addEventListener("load", function() {
      return $(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (f) {
          const _ = this.getAllResponseHeaders().trim().split(/[\r\n]+/), S = {};
          if (_.forEach(function(C) {
            const R = C.split(": "), L = R.shift();
            S[L] = R.join(": ");
          }), p.headers = S, c) {
            const C = Td(c, m.url);
            C && (m.body = Tt(C, i, s, p.headers));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = Tt(this.responseText, i, s, p.headers), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const C = yield this.response.text();
                p.body = Tt(C, i, s, p.headers), p.size = this.response.size;
              } catch (C) {
              }
          } else
            try {
              p.body = Tt(this.response, i, s, p.headers);
            } catch (C) {
            }
        }
        r({
          request: m,
          response: p,
          urlBlocked: !f
        });
      });
    }), this.addEventListener("error", function() {
      return $(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        r({
          request: m,
          response: p,
          urlBlocked: !1
        });
      });
    }), l.apply(this, arguments);
  }, () => {
    o.open = a, o.send = l, o.setRequestHeader = u;
  };
}, Td = (r, e) => {
  if (typeof r == "string") {
    if (!((e != null && e.includes("localhost") || e != null && e.includes("highlight.run")) && r.includes("pushPayload")))
      return r;
  } else if (typeof r == "object" || typeof r == "number" || typeof r == "boolean")
    return Ut(r);
  return null;
}, Ed = 64 * 1024, DZ = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, Tt = (r, e, t, n) => {
  var s, o, a;
  let i = Ed;
  if (n) {
    let l = "";
    typeof n.get == "function" ? l = (s = n.get("content-type")) != null ? s : "" : l = (o = n["content-type"]) != null ? o : "";
    try {
      l = l.split(";")[0];
    } catch (u) {
    }
    i = (a = DZ[l]) != null ? a : Ed;
  }
  if (r) {
    if (e)
      try {
        const l = JSON.parse(r);
        Array.isArray(l) ? l.forEach((u) => {
          Object.keys(u).forEach((c) => {
            e.includes(c.toLocaleLowerCase()) && (u[c] = "[REDACTED]");
          });
        }) : Object.keys(l).forEach((u) => {
          e.includes(u.toLocaleLowerCase()) && (l[u] = "[REDACTED]");
        }), r = JSON.stringify(l);
      } catch (l) {
      }
    if (t)
      try {
        const l = JSON.parse(r);
        Object.keys(l).forEach((u) => {
          t.includes(u.toLocaleLowerCase()) || (l[u] = "[REDACTED]");
        }), r = JSON.stringify(l);
      } catch (l) {
      }
  }
  try {
    r = r.slice(0, i);
  } catch (l) {
  }
  return r;
}, KZ = (r, e, t, n, i, s) => {
  const o = window._fetchProxy;
  return window._fetchProxy = function(a, l) {
    const { method: u, url: c } = zZ(a, l);
    if (!Ys(c, e))
      return o.call(this, a, l);
    const [d, h] = hu();
    if (du(c, t, n)) {
      l = l || {};
      let g = new Headers(l.headers);
      a instanceof Request && [...a.headers].forEach(([y, _]) => g.set(y, _)), g.set(Pm, Mm(d, h)), l.headers = Object.fromEntries(g.entries());
    }
    const f = {
      sessionSecureID: d,
      id: h,
      headers: {},
      body: void 0,
      url: c,
      verb: u
    }, m = !n.some((g) => c.toLowerCase().includes(g));
    m && (f.headers = Object.fromEntries(new Headers(l == null ? void 0 : l.headers).entries()), f.body = Tt(l == null ? void 0 : l.body, i, s, l == null ? void 0 : l.headers));
    let p = o.call(this, a, l);
    return jZ(p, f, r, m, i, s), p;
  }, () => {
    window._fetchProxy = o;
  };
}, zZ = (r, e) => {
  const t = e && e.method || typeof r == "object" && "method" in r && r.method || "GET";
  let n;
  return typeof r == "object" ? "url" in r && r.url ? n = r.url : n = r.toString() : n = r, {
    method: t,
    url: n
  };
}, jZ = (r, e, t, n, i, s) => {
  const o = (a) => $(void 0, null, function* () {
    let l = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, u = !1, c = !n;
    "stack" in a || a instanceof Error ? (l = M(I({}, l), {
      body: a.message,
      status: 0,
      size: void 0
    }), u = !0) : "status" in a && (l = M(I({}, l), {
      status: a.status
    }), n && (l.body = yield Am(a, s, i), l.headers = Object.fromEntries(a.headers.entries()), l.size = l.body.length * 8), (a.type === "opaque" || a.type === "opaqueredirect") && (c = !0, l = M(I({}, l), {
      body: "CORS blocked request"
    })), u = !0), u && t({
      request: e,
      response: l,
      urlBlocked: c
    });
  });
  r.then(o).catch(() => {
  });
}, Am = (r, e, t) => $(void 0, null, function* () {
  let n;
  try {
    const s = r.clone().body;
    if (s) {
      let o = s.getReader(), a = new TextDecoder(), l, u = "";
      for (; !(l = yield o.read()).done; ) {
        let c = l.value;
        u += a.decode(c);
      }
      n = u, n = Tt(n, t, e, r.headers);
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var Um = (
  /** @class */
  function() {
    function r(e) {
      this._delegate = e;
    }
    return r.prototype.export = function(e, t) {
      this._delegate.export(e, t);
    }, r.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, r.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, r;
  }()
), QZ = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Cd = (
  /** @class */
  function(r) {
    QZ(e, r);
    function e(t, n, i) {
      var s = r.call(this, t) || this;
      return s.name = "OTLPExporterError", s.data = i, s.code = n, s;
    }
    return e;
  }(Error)
);
function $Z(r) {
  if (!Number.isNaN(r) && Number.isFinite(r) && r > 0)
    return r;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + r + "')");
}
function qZ(r) {
  if (r != null)
    return function() {
      return r;
    };
}
function eG(r, e, t) {
  var n, i, s, o, a, l;
  return {
    timeoutMillis: $Z((i = (n = r.timeoutMillis) !== null && n !== void 0 ? n : e.timeoutMillis) !== null && i !== void 0 ? i : t.timeoutMillis),
    concurrencyLimit: (o = (s = r.concurrencyLimit) !== null && s !== void 0 ? s : e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit,
    compression: (l = (a = r.compression) !== null && a !== void 0 ? a : e.compression) !== null && l !== void 0 ? l : t.compression
  };
}
function tG() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var rG = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, nG = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, iG = (
  /** @class */
  function() {
    function r(e) {
      this._sendingPromises = [], this._concurrencyLimit = e;
    }
    return r.prototype.pushPromise = function(e) {
      var t = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(e);
      var n = function() {
        var i = t._sendingPromises.indexOf(e);
        t._sendingPromises.splice(i, 1);
      };
      e.then(n, n);
    }, r.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, r.prototype.awaitAll = function() {
      return rG(this, void 0, void 0, function() {
        return nG(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
);
function sG(r) {
  return new iG(r.concurrencyLimit);
}
function oG(r) {
  return Object.prototype.hasOwnProperty.call(r, "partialSuccess");
}
function aG() {
  return {
    handleResponse: function(r) {
      r == null || !oG(r) || r.partialSuccess == null || Object.keys(r.partialSuccess).length === 0 || N.warn("Received Partial Success response:", JSON.stringify(r.partialSuccess));
    }
  };
}
var lG = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, uG = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, cG = (
  /** @class */
  function() {
    function r(e, t, n, i, s) {
      this._transport = e, this._serializer = t, this._responseHandler = n, this._promiseQueue = i, this._timeout = s, this._diagLogger = N.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return r.prototype.export = function(e, t) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", e), this._promiseQueue.hasReachedLimit()) {
        t({
          code: xe.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(e);
      if (i == null) {
        t({
          code: xe.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(s) {
        if (s.status === "success") {
          if (s.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(s.data));
            } catch (o) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", o, s.data);
            }
          t({
            code: xe.SUCCESS
          });
          return;
        } else if (s.status === "failure" && s.error) {
          t({
            code: xe.FAILED,
            error: s.error
          });
          return;
        } else s.status === "retryable" ? t({
          code: xe.FAILED,
          error: new Cd("Export failed with retryable status")
        }) : t({
          code: xe.FAILED,
          error: new Cd("Export failed with unknown error")
        });
      }, function(s) {
        return t({
          code: xe.FAILED,
          error: s
        });
      }));
    }, r.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, r.prototype.shutdown = function() {
      return lG(this, void 0, void 0, function() {
        return uG(this, function(e) {
          switch (e.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return e.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
);
function dG(r, e) {
  return new cG(r.transport, r.serializer, aG(), r.promiseHandler, e.timeout);
}
function Ym(r, e, t) {
  return dG({
    transport: t,
    serializer: e,
    promiseHandler: sG(r)
  }, { timeout: r.timeoutMillis });
}
function Fm(r) {
  var e = BigInt(1e9);
  return BigInt(r[0]) * e + BigInt(r[1]);
}
function hG(r) {
  var e = Number(BigInt.asUintN(32, r)), t = Number(BigInt.asUintN(32, r >> BigInt(32)));
  return { low: e, high: t };
}
function Hm(r) {
  var e = Fm(r);
  return hG(e);
}
function fG(r) {
  var e = Fm(r);
  return e.toString();
}
var pG = typeof BigInt != "undefined" ? fG : ht;
function Zd(r) {
  return r;
}
function Jm(r) {
  if (r !== void 0)
    return ou(r);
}
var mG = {
  encodeHrTime: Hm,
  encodeSpanContext: ou,
  encodeOptionalSpanContext: Jm
};
function Bm(r) {
  var e, t;
  if (r === void 0)
    return mG;
  var n = (e = r.useLongBits) !== null && e !== void 0 ? e : !0, i = (t = r.useHex) !== null && t !== void 0 ? t : !1;
  return {
    encodeHrTime: n ? Hm : pG,
    encodeSpanContext: i ? Zd : ou,
    encodeOptionalSpanContext: i ? Zd : Jm
  };
}
var gG = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
};
function Dm(r) {
  return {
    attributes: $t(r.attributes),
    droppedAttributesCount: 0
  };
}
function Km(r) {
  return {
    name: r.name,
    version: r.version
  };
}
function $t(r) {
  return Object.keys(r).map(function(e) {
    return zm(e, r[e]);
  });
}
function zm(r, e) {
  return {
    key: r,
    value: jm(e)
  };
}
function jm(r) {
  var e = typeof r;
  return e === "string" ? { stringValue: r } : e === "number" ? Number.isInteger(r) ? { intValue: r } : { doubleValue: r } : e === "boolean" ? { boolValue: r } : r instanceof Uint8Array ? { bytesValue: r } : Array.isArray(r) ? { arrayValue: { values: r.map(jm) } } : e === "object" && r != null ? {
    kvlistValue: {
      values: Object.entries(r).map(function(t) {
        var n = gG(t, 2), i = n[0], s = n[1];
        return zm(i, s);
      })
    }
  } : {};
}
var Ke;
(function(r) {
  r[r.DELTA = 0] = "DELTA", r[r.CUMULATIVE = 1] = "CUMULATIVE";
})(Ke || (Ke = {}));
var ot;
(function(r) {
  r[r.HISTOGRAM = 0] = "HISTOGRAM", r[r.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", r[r.GAUGE = 2] = "GAUGE", r[r.SUM = 3] = "SUM";
})(ot || (ot = {}));
var yG = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Gd = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, Ld = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, bG = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, vG = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, SG = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function wG(r) {
  return r != null;
}
function Qm(r) {
  var e = Object.keys(r);
  return e.length === 0 ? "" : (e = e.sort(), JSON.stringify(e.map(function(t) {
    return [t, r[t]];
  })));
}
function _G(r) {
  var e, t;
  return r.name + ":" + ((e = r.version) !== null && e !== void 0 ? e : "") + ":" + ((t = r.schemaUrl) !== null && t !== void 0 ? t : "");
}
var $m = (
  /** @class */
  function(r) {
    yG(e, r);
    function e(t) {
      var n = r.call(this, t) || this;
      return Object.setPrototypeOf(n, e.prototype), n;
    }
    return e;
  }(Error)
);
function Gn(r, e) {
  var t, n = new Promise(function(s, o) {
    t = setTimeout(function() {
      o(new $m("Operation timed out."));
    }, e);
  });
  return Promise.race([r, n]).then(function(i) {
    return clearTimeout(t), i;
  }, function(i) {
    throw clearTimeout(t), i;
  });
}
function RG(r) {
  return Gd(this, void 0, void 0, function() {
    var e = this;
    return Ld(this, function(t) {
      return [2, Promise.all(r.map(function(n) {
        return Gd(e, void 0, void 0, function() {
          var i, s;
          return Ld(this, function(o) {
            switch (o.label) {
              case 0:
                return o.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = o.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return s = o.sent(), [2, {
                  status: "rejected",
                  reason: s
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function IG(r) {
  return r.status === "rejected";
}
function Nd(r, e) {
  var t = [];
  return r.forEach(function(n) {
    t.push.apply(t, vG([], bG(e(n)), !1));
  }), t;
}
function TG(r, e) {
  var t, n;
  if (r.size !== e.size)
    return !1;
  try {
    for (var i = SG(r), s = i.next(); !s.done; s = i.next()) {
      var o = s.value;
      if (!e.has(o))
        return !1;
    }
  } catch (a) {
    t = { error: a };
  } finally {
    try {
      s && !s.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function EG(r, e) {
  for (var t = 0, n = r.length - 1, i = r.length; n >= t; ) {
    var s = t + Math.trunc((n - t) / 2);
    r[s] < e ? t = s + 1 : (i = s, n = s - 1);
  }
  return i;
}
function CG(r, e) {
  return r.toLowerCase() === e.toLowerCase();
}
var Bt;
(function(r) {
  r[r.DROP = 0] = "DROP", r[r.SUM = 1] = "SUM", r[r.LAST_VALUE = 2] = "LAST_VALUE", r[r.HISTOGRAM = 3] = "HISTOGRAM", r[r.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(Bt || (Bt = {}));
var ZG = (
  /** @class */
  function() {
    function r() {
      this.kind = Bt.DROP;
    }
    return r.prototype.createAccumulation = function() {
    }, r.prototype.merge = function(e, t) {
    }, r.prototype.diff = function(e, t) {
    }, r.prototype.toMetricData = function(e, t, n, i) {
    }, r;
  }()
), Y;
(function(r) {
  r.COUNTER = "COUNTER", r.GAUGE = "GAUGE", r.HISTOGRAM = "HISTOGRAM", r.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", r.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", r.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", r.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(Y || (Y = {}));
function wt(r, e, t) {
  var n, i, s, o;
  return VG(r) || N.warn('Invalid metric name: "' + r + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: r,
    type: e,
    description: (n = t == null ? void 0 : t.description) !== null && n !== void 0 ? n : "",
    unit: (i = t == null ? void 0 : t.unit) !== null && i !== void 0 ? i : "",
    valueType: (s = t == null ? void 0 : t.valueType) !== null && s !== void 0 ? s : Gt.DOUBLE,
    advice: (o = t == null ? void 0 : t.advice) !== null && o !== void 0 ? o : {}
  };
}
function GG(r, e) {
  var t, n;
  return {
    name: (t = r.name) !== null && t !== void 0 ? t : e.name,
    description: (n = r.description) !== null && n !== void 0 ? n : e.description,
    type: e.type,
    unit: e.unit,
    valueType: e.valueType,
    advice: e.advice
  };
}
function LG(r, e) {
  return CG(r.name, e.name) && r.unit === e.unit && r.type === e.type && r.valueType === e.valueType;
}
var NG = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function VG(r) {
  return r.match(NG) != null;
}
var xG = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
};
function OG(r) {
  var e = r.map(function() {
    return 0;
  });
  return e.push(0), {
    buckets: {
      boundaries: r,
      counts: e
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var Mo = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = OG(t)), this.startTime = e, this._boundaries = t, this._recordMinMax = n, this._current = i;
    }
    return r.prototype.record = function(e) {
      if (!Number.isNaN(e)) {
        this._current.count += 1, this._current.sum += e, this._recordMinMax && (this._current.min = Math.min(e, this._current.min), this._current.max = Math.max(e, this._current.max), this._current.hasMinMax = !0);
        var t = EG(this._boundaries, e);
        this._current.buckets.counts[t] += 1;
      }
    }, r.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), qm = (
  /** @class */
  function() {
    function r(e, t) {
      this._boundaries = e, this._recordMinMax = t, this.kind = Bt.HISTOGRAM;
    }
    return r.prototype.createAccumulation = function(e) {
      return new Mo(e, this._boundaries, this._recordMinMax);
    }, r.prototype.merge = function(e, t) {
      for (var n = e.toPointValue(), i = t.toPointValue(), s = n.buckets.counts, o = i.buckets.counts, a = new Array(s.length), l = 0; l < s.length; l++)
        a[l] = s[l] + o[l];
      var u = 1 / 0, c = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (u = Math.min(n.min, i.min), c = Math.max(n.max, i.max)) : n.hasMinMax ? (u = n.min, c = n.max) : i.hasMinMax && (u = i.min, c = i.max)), new Mo(e.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: a
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: u,
        max: c
      });
    }, r.prototype.diff = function(e, t) {
      for (var n = e.toPointValue(), i = t.toPointValue(), s = n.buckets.counts, o = i.buckets.counts, a = new Array(s.length), l = 0; l < s.length; l++)
        a[l] = o[l] - s[l];
      return new Mo(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: a
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, r.prototype.toMetricData = function(e, t, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: t,
        dataPointType: ot.HISTOGRAM,
        dataPoints: n.map(function(s) {
          var o = xG(s, 2), a = o[0], l = o[1], u = l.toPointValue(), c = e.type === Y.GAUGE || e.type === Y.UP_DOWN_COUNTER || e.type === Y.OBSERVABLE_GAUGE || e.type === Y.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: a,
            startTime: l.startTime,
            endTime: i,
            value: {
              min: u.hasMinMax ? u.min : void 0,
              max: u.hasMinMax ? u.max : void 0,
              sum: c ? void 0 : u.sum,
              buckets: u.buckets,
              count: u.count
            }
          };
        })
      };
    }, r;
  }()
), Ao = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, Uo = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, Vd = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      e === void 0 && (e = new WG()), t === void 0 && (t = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = e, this.indexBase = t, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(r.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.counts = function() {
      var e = this;
      return Array.from({ length: this.length }, function(t, n) {
        return e.at(n);
      });
    }, r.prototype.at = function(e) {
      var t = this.indexBase - this.indexStart;
      return e < t && (e += this.backing.length), e -= t, this.backing.countAt(e);
    }, r.prototype.incrementBucket = function(e, t) {
      this.backing.increment(e, t);
    }, r.prototype.decrementBucket = function(e, t) {
      this.backing.decrement(e, t);
    }, r.prototype.trim = function() {
      for (var e = 0; e < this.length; e++)
        if (this.at(e) !== 0) {
          this.indexStart += e;
          break;
        } else if (e === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var e = this.length - 1; e >= 0; e--)
        if (this.at(e) !== 0) {
          this.indexEnd -= this.length - e - 1;
          break;
        }
      this._rotate();
    }, r.prototype.downscale = function(e) {
      this._rotate();
      for (var t = 1 + this.indexEnd - this.indexStart, n = 1 << e, i = 0, s = 0, o = this.indexStart; o <= this.indexEnd; ) {
        var a = o % n;
        a < 0 && (a += n);
        for (var l = a; l < n && i < t; l++)
          this._relocateBucket(s, i), i++, o++;
        s++;
      }
      this.indexStart >>= e, this.indexEnd >>= e, this.indexBase = this.indexStart;
    }, r.prototype.clone = function() {
      return new r(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, r.prototype._rotate = function() {
      var e = this.indexBase - this.indexStart;
      e !== 0 && (e > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, e), this.backing.reverse(e, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + e)), this.indexBase = this.indexStart);
    }, r.prototype._relocateBucket = function(e, t) {
      e !== t && this.incrementBucket(e, this.backing.emptyBucket(t));
    }, r;
  }()
), WG = (
  /** @class */
  function() {
    function r(e) {
      e === void 0 && (e = [0]), this._counts = e;
    }
    return Object.defineProperty(r.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.countAt = function(e) {
      return this._counts[e];
    }, r.prototype.growTo = function(e, t, n) {
      var i = new Array(e).fill(0);
      i.splice.apply(i, Uo([
        n,
        this._counts.length - t
      ], Ao(this._counts.slice(t)), !1)), i.splice.apply(i, Uo([0, t], Ao(this._counts.slice(0, t)), !1)), this._counts = i;
    }, r.prototype.reverse = function(e, t) {
      for (var n = Math.floor((e + t) / 2) - e, i = 0; i < n; i++) {
        var s = this._counts[e + i];
        this._counts[e + i] = this._counts[t - i - 1], this._counts[t - i - 1] = s;
      }
    }, r.prototype.emptyBucket = function(e) {
      var t = this._counts[e];
      return this._counts[e] = 0, t;
    }, r.prototype.increment = function(e, t) {
      this._counts[e] += t;
    }, r.prototype.decrement = function(e, t) {
      this._counts[e] >= t ? this._counts[e] -= t : this._counts[e] = 0;
    }, r.prototype.clone = function() {
      return new r(Uo([], Ao(this._counts), !1));
    }, r;
  }()
), XG = 52, kG = 2146435072, PG = 1048575, eg = 1023, tg = -1022, rg = eg, ul = Math.pow(2, -1022);
function ng(r) {
  var e = new DataView(new ArrayBuffer(8));
  e.setFloat64(0, r);
  var t = e.getUint32(0), n = (t & kG) >> 20;
  return n - eg;
}
function ig(r) {
  var e = new DataView(new ArrayBuffer(8));
  e.setFloat64(0, r);
  var t = e.getUint32(0), n = e.getUint32(4), i = (t & PG) * Math.pow(2, 32);
  return i + n;
}
function cl(r, e) {
  return r === 0 || r === Number.POSITIVE_INFINITY || r === Number.NEGATIVE_INFINITY || Number.isNaN(r) ? r : r * Math.pow(2, e);
}
function MG(r) {
  return r--, r |= r >> 1, r |= r >> 2, r |= r >> 4, r |= r >> 8, r |= r >> 16, r++, r;
}
var AG = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ln = (
  /** @class */
  function(r) {
    AG(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(Error)
), UG = (
  /** @class */
  function() {
    function r(e) {
      this._shift = -e;
    }
    return r.prototype.mapToIndex = function(e) {
      if (e < ul)
        return this._minNormalLowerBoundaryIndex();
      var t = ng(e), n = this._rightShift(ig(e) - 1, XG);
      return t + n >> this._shift;
    }, r.prototype.lowerBoundary = function(e) {
      var t = this._minNormalLowerBoundaryIndex();
      if (e < t)
        throw new Ln("underflow: " + e + " is < minimum lower boundary: " + t);
      var n = this._maxNormalLowerBoundaryIndex();
      if (e > n)
        throw new Ln("overflow: " + e + " is > maximum lower boundary: " + n);
      return cl(1, e << this._shift);
    }, Object.defineProperty(r.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._minNormalLowerBoundaryIndex = function() {
      var e = tg >> this._shift;
      return this._shift < 2 && e--, e;
    }, r.prototype._maxNormalLowerBoundaryIndex = function() {
      return rg >> this._shift;
    }, r.prototype._rightShift = function(e, t) {
      return Math.floor(e * Math.pow(2, -t));
    }, r;
  }()
), YG = (
  /** @class */
  function() {
    function r(e) {
      this._scale = e, this._scaleFactor = cl(Math.LOG2E, e), this._inverseFactor = cl(Math.LN2, -e);
    }
    return r.prototype.mapToIndex = function(e) {
      if (e <= ul)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (ig(e) === 0) {
        var t = ng(e);
        return (t << this._scale) - 1;
      }
      var n = Math.floor(Math.log(e) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, r.prototype.lowerBoundary = function(e) {
      var t = this._maxNormalLowerBoundaryIndex();
      if (e >= t) {
        if (e === t)
          return 2 * Math.exp((e - (1 << this._scale)) / this._scaleFactor);
        throw new Ln("overflow: " + e + " is > maximum lower boundary: " + t);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (e <= n) {
        if (e === n)
          return ul;
        if (e === n - 1)
          return Math.exp((e + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new Ln("overflow: " + e + " is < minimum lower boundary: " + n);
      }
      return Math.exp(e * this._inverseFactor);
    }, Object.defineProperty(r.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._minNormalLowerBoundaryIndex = function() {
      return tg << this._scale;
    }, r.prototype._maxNormalLowerBoundaryIndex = function() {
      return (rg + 1 << this._scale) - 1;
    }, r;
  }()
), xd = -10, Od = 20, FG = Array.from({ length: 31 }, function(r, e) {
  return e > 10 ? new YG(e - 10) : new UG(e - 10);
});
function Wd(r) {
  if (r > Od || r < xd)
    throw new Ln("expected scale >= " + xd + " && <= " + Od + ", got: " + r);
  return FG[r + 10];
}
var HG = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, Ri = (
  /** @class */
  function() {
    function r(e, t) {
      this.low = e, this.high = t;
    }
    return r.combine = function(e, t) {
      return new r(Math.min(e.low, t.low), Math.max(e.high, t.high));
    }, r;
  }()
), JG = 20, BG = 160, Yo = 2, DG = (
  /** @class */
  function() {
    function r(e, t, n, i, s, o, a, l, u, c, d) {
      e === void 0 && (e = e), t === void 0 && (t = BG), n === void 0 && (n = !0), i === void 0 && (i = 0), s === void 0 && (s = 0), o === void 0 && (o = 0), a === void 0 && (a = Number.POSITIVE_INFINITY), l === void 0 && (l = Number.NEGATIVE_INFINITY), u === void 0 && (u = new Vd()), c === void 0 && (c = new Vd()), d === void 0 && (d = Wd(JG)), this.startTime = e, this._maxSize = t, this._recordMinMax = n, this._sum = i, this._count = s, this._zeroCount = o, this._min = a, this._max = l, this._positive = u, this._negative = c, this._mapping = d, this._maxSize < Yo && (N.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Yo), this._maxSize = Yo);
    }
    return r.prototype.record = function(e) {
      this.updateByIncrement(e, 1);
    }, r.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, r.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(r.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.updateByIncrement = function(e, t) {
      if (!Number.isNaN(e)) {
        if (e > this._max && (this._max = e), e < this._min && (this._min = e), this._count += t, e === 0) {
          this._zeroCount += t;
          return;
        }
        this._sum += e * t, e > 0 ? this._updateBuckets(this._positive, e, t) : this._updateBuckets(this._negative, -e, t);
      }
    }, r.prototype.merge = function(e) {
      this._count === 0 ? (this._min = e.min, this._max = e.max) : e.count !== 0 && (e.min < this.min && (this._min = e.min), e.max > this.max && (this._max = e.max)), this.startTime = e.startTime, this._sum += e.sum, this._count += e.count, this._zeroCount += e.zeroCount;
      var t = this._minScale(e);
      this._downscale(this.scale - t), this._mergeBuckets(this.positive, e, e.positive, t), this._mergeBuckets(this.negative, e, e.negative, t);
    }, r.prototype.diff = function(e) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= e.sum, this._count -= e.count, this._zeroCount -= e.zeroCount;
      var t = this._minScale(e);
      this._downscale(this.scale - t), this._diffBuckets(this.positive, e, e.positive, t), this._diffBuckets(this.negative, e, e.negative, t);
    }, r.prototype.clone = function() {
      return new r(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, r.prototype._updateBuckets = function(e, t, n) {
      var i = this._mapping.mapToIndex(t), s = !1, o = 0, a = 0;
      if (e.length === 0 ? (e.indexStart = i, e.indexEnd = e.indexStart, e.indexBase = e.indexStart) : i < e.indexStart && e.indexEnd - i >= this._maxSize ? (s = !0, a = i, o = e.indexEnd) : i > e.indexEnd && i - e.indexStart >= this._maxSize && (s = !0, a = e.indexStart, o = i), s) {
        var l = this._changeScale(o, a);
        this._downscale(l), i = this._mapping.mapToIndex(t);
      }
      this._incrementIndexBy(e, i, n);
    }, r.prototype._incrementIndexBy = function(e, t, n) {
      if (n !== 0) {
        if (e.length === 0 && (e.indexStart = e.indexEnd = e.indexBase = t), t < e.indexStart) {
          var i = e.indexEnd - t;
          i >= e.backing.length && this._grow(e, i + 1), e.indexStart = t;
        } else if (t > e.indexEnd) {
          var i = t - e.indexStart;
          i >= e.backing.length && this._grow(e, i + 1), e.indexEnd = t;
        }
        var s = t - e.indexBase;
        s < 0 && (s += e.backing.length), e.incrementBucket(s, n);
      }
    }, r.prototype._grow = function(e, t) {
      var n = e.backing.length, i = e.indexBase - e.indexStart, s = n - i, o = MG(t);
      o > this._maxSize && (o = this._maxSize);
      var a = o - i;
      e.backing.growTo(o, s, a);
    }, r.prototype._changeScale = function(e, t) {
      for (var n = 0; e - t >= this._maxSize; )
        e >>= 1, t >>= 1, n++;
      return n;
    }, r.prototype._downscale = function(e) {
      if (e !== 0) {
        if (e < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var t = this._mapping.scale - e;
        this._positive.downscale(e), this._negative.downscale(e), this._mapping = Wd(t);
      }
    }, r.prototype._minScale = function(e) {
      var t = Math.min(this.scale, e.scale), n = Ri.combine(this._highLowAtScale(this.positive, this.scale, t), this._highLowAtScale(e.positive, e.scale, t)), i = Ri.combine(this._highLowAtScale(this.negative, this.scale, t), this._highLowAtScale(e.negative, e.scale, t));
      return Math.min(t - this._changeScale(n.high, n.low), t - this._changeScale(i.high, i.low));
    }, r.prototype._highLowAtScale = function(e, t, n) {
      if (e.length === 0)
        return new Ri(0, -1);
      var i = t - n;
      return new Ri(e.indexStart >> i, e.indexEnd >> i);
    }, r.prototype._mergeBuckets = function(e, t, n, i) {
      for (var s = n.offset, o = t.scale - i, a = 0; a < n.length; a++)
        this._incrementIndexBy(e, s + a >> o, n.at(a));
    }, r.prototype._diffBuckets = function(e, t, n, i) {
      for (var s = n.offset, o = t.scale - i, a = 0; a < n.length; a++) {
        var l = s + a >> o, u = l - e.indexBase;
        u < 0 && (u += e.backing.length), e.decrementBucket(u, n.at(a));
      }
      e.trim();
    }, r;
  }()
), KG = (
  /** @class */
  function() {
    function r(e, t) {
      this._maxSize = e, this._recordMinMax = t, this.kind = Bt.EXPONENTIAL_HISTOGRAM;
    }
    return r.prototype.createAccumulation = function(e) {
      return new DG(e, this._maxSize, this._recordMinMax);
    }, r.prototype.merge = function(e, t) {
      var n = t.clone();
      return n.merge(e), n;
    }, r.prototype.diff = function(e, t) {
      var n = t.clone();
      return n.diff(e), n;
    }, r.prototype.toMetricData = function(e, t, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: t,
        dataPointType: ot.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(s) {
          var o = HG(s, 2), a = o[0], l = o[1], u = l.toPointValue(), c = e.type === Y.GAUGE || e.type === Y.UP_DOWN_COUNTER || e.type === Y.OBSERVABLE_GAUGE || e.type === Y.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: a,
            startTime: l.startTime,
            endTime: i,
            value: {
              min: u.hasMinMax ? u.min : void 0,
              max: u.hasMinMax ? u.max : void 0,
              sum: c ? void 0 : u.sum,
              positive: {
                offset: u.positive.offset,
                bucketCounts: u.positive.bucketCounts
              },
              negative: {
                offset: u.negative.offset,
                bucketCounts: u.negative.bucketCounts
              },
              count: u.count,
              scale: u.scale,
              zeroCount: u.zeroCount
            }
          };
        })
      };
    }, r;
  }()
), zG = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, Fo = (
  /** @class */
  function() {
    function r(e, t, n) {
      t === void 0 && (t = 0), n === void 0 && (n = [0, 0]), this.startTime = e, this._current = t, this.sampleTime = n;
    }
    return r.prototype.record = function(e) {
      this._current = e, this.sampleTime = Pe(Date.now());
    }, r.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), jG = (
  /** @class */
  function() {
    function r() {
      this.kind = Bt.LAST_VALUE;
    }
    return r.prototype.createAccumulation = function(e) {
      return new Fo(e);
    }, r.prototype.merge = function(e, t) {
      var n = mi(t.sampleTime) >= mi(e.sampleTime) ? t : e;
      return new Fo(e.startTime, n.toPointValue(), n.sampleTime);
    }, r.prototype.diff = function(e, t) {
      var n = mi(t.sampleTime) >= mi(e.sampleTime) ? t : e;
      return new Fo(t.startTime, n.toPointValue(), n.sampleTime);
    }, r.prototype.toMetricData = function(e, t, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: t,
        dataPointType: ot.GAUGE,
        dataPoints: n.map(function(s) {
          var o = zG(s, 2), a = o[0], l = o[1];
          return {
            attributes: a,
            startTime: l.startTime,
            endTime: i,
            value: l.toPointValue()
          };
        })
      };
    }, r;
  }()
), QG = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, Qr = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = e, this.monotonic = t, this._current = n, this.reset = i;
    }
    return r.prototype.record = function(e) {
      this.monotonic && e < 0 || (this._current += e);
    }, r.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), Xd = (
  /** @class */
  function() {
    function r(e) {
      this.monotonic = e, this.kind = Bt.SUM;
    }
    return r.prototype.createAccumulation = function(e) {
      return new Qr(e, this.monotonic);
    }, r.prototype.merge = function(e, t) {
      var n = e.toPointValue(), i = t.toPointValue();
      return t.reset ? new Qr(t.startTime, this.monotonic, i, t.reset) : new Qr(e.startTime, this.monotonic, n + i);
    }, r.prototype.diff = function(e, t) {
      var n = e.toPointValue(), i = t.toPointValue();
      return this.monotonic && n > i ? new Qr(t.startTime, this.monotonic, i, !0) : new Qr(t.startTime, this.monotonic, i - n);
    }, r.prototype.toMetricData = function(e, t, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: t,
        dataPointType: ot.SUM,
        dataPoints: n.map(function(s) {
          var o = QG(s, 2), a = o[0], l = o[1];
          return {
            attributes: a,
            startTime: l.startTime,
            endTime: i,
            value: l.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, r;
  }()
), qt = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), bt = (
  /** @class */
  function() {
    function r() {
    }
    return r.Drop = function() {
      return sg;
    }, r.Sum = function() {
      return og;
    }, r.LastValue = function() {
      return ag;
    }, r.Histogram = function() {
      return lg;
    }, r.ExponentialHistogram = function() {
      return sL;
    }, r.Default = function() {
      return oL;
    }, r;
  }()
), $G = (
  /** @class */
  function(r) {
    qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(t) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new ZG(), e;
  }(bt)
), qG = (
  /** @class */
  function(r) {
    qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(t) {
      switch (t.type) {
        case Y.COUNTER:
        case Y.OBSERVABLE_COUNTER:
        case Y.HISTOGRAM:
          return e.MONOTONIC_INSTANCE;
        default:
          return e.NON_MONOTONIC_INSTANCE;
      }
    }, e.MONOTONIC_INSTANCE = new Xd(!0), e.NON_MONOTONIC_INSTANCE = new Xd(!1), e;
  }(bt)
), eL = (
  /** @class */
  function(r) {
    qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(t) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new jG(), e;
  }(bt)
), tL = (
  /** @class */
  function(r) {
    qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(t) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new qm([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), e;
  }(bt)
), rL = (
  /** @class */
  function(r) {
    qt(e, r);
    function e(t, n) {
      n === void 0 && (n = !0);
      var i = r.call(this) || this;
      if (i._recordMinMax = n, t == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      t = t.concat(), t = t.sort(function(a, l) {
        return a - l;
      });
      var s = t.lastIndexOf(-1 / 0), o = t.indexOf(1 / 0);
      return o === -1 && (o = void 0), i._boundaries = t.slice(s + 1, o), i;
    }
    return e.prototype.createAggregator = function(t) {
      return new qm(this._boundaries, this._recordMinMax);
    }, e;
  }(bt)
), nL = (
  /** @class */
  function(r) {
    qt(e, r);
    function e(t, n) {
      t === void 0 && (t = 160), n === void 0 && (n = !0);
      var i = r.call(this) || this;
      return i._maxSize = t, i._recordMinMax = n, i;
    }
    return e.prototype.createAggregator = function(t) {
      return new KG(this._maxSize, this._recordMinMax);
    }, e;
  }(bt)
), iL = (
  /** @class */
  function(r) {
    qt(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype._resolve = function(t) {
      switch (t.type) {
        case Y.COUNTER:
        case Y.UP_DOWN_COUNTER:
        case Y.OBSERVABLE_COUNTER:
        case Y.OBSERVABLE_UP_DOWN_COUNTER:
          return og;
        case Y.GAUGE:
        case Y.OBSERVABLE_GAUGE:
          return ag;
        case Y.HISTOGRAM:
          return t.advice.explicitBucketBoundaries ? new rL(t.advice.explicitBucketBoundaries) : lg;
      }
      return N.warn("Unable to recognize instrument type: " + t.type), sg;
    }, e.prototype.createAggregator = function(t) {
      return this._resolve(t).createAggregator(t);
    }, e;
  }(bt)
), sg = new $G(), og = new qG(), ag = new eL(), lg = new tL(), sL = new nL(), oL = new iL(), aL = function(r) {
  return bt.Default();
}, lL = function(r) {
  return Ke.CUMULATIVE;
}, Ho = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, Jo = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, kd = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, uL = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, cL = (
  /** @class */
  function() {
    function r(e) {
      var t, n, i;
      this._shutdown = !1, this._aggregationSelector = (t = e == null ? void 0 : e.aggregationSelector) !== null && t !== void 0 ? t : aL, this._aggregationTemporalitySelector = (n = e == null ? void 0 : e.aggregationTemporalitySelector) !== null && n !== void 0 ? n : lL, this._metricProducers = (i = e == null ? void 0 : e.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = e == null ? void 0 : e.cardinalitySelector;
    }
    return r.prototype.setMetricProducer = function(e) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = e, this.onInitialized();
    }, r.prototype.selectAggregation = function(e) {
      return this._aggregationSelector(e);
    }, r.prototype.selectAggregationTemporality = function(e) {
      return this._aggregationTemporalitySelector(e);
    }, r.prototype.selectCardinalityLimit = function(e) {
      return this._cardinalitySelector ? this._cardinalitySelector(e) : 2e3;
    }, r.prototype.onInitialized = function() {
    }, r.prototype.collect = function(e) {
      return Ho(this, void 0, void 0, function() {
        var t, n, i, s, o, a;
        return Jo(this, function(l) {
          switch (l.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(uL([
                this._sdkMetricProducer.collect({
                  timeoutMillis: e == null ? void 0 : e.timeoutMillis
                })
              ], kd(this._metricProducers.map(function(u) {
                return u.collect({
                  timeoutMillis: e == null ? void 0 : e.timeoutMillis
                });
              })), !1))];
            case 1:
              return t = kd.apply(void 0, [l.sent()]), n = t[0], i = t.slice(1), s = n.errors.concat(Nd(i, function(u) {
                return u.errors;
              })), o = n.resourceMetrics.resource, a = n.resourceMetrics.scopeMetrics.concat(Nd(i, function(u) {
                return u.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: o,
                  scopeMetrics: a
                },
                errors: s
              }];
          }
        });
      });
    }, r.prototype.shutdown = function(e) {
      return Ho(this, void 0, void 0, function() {
        return Jo(this, function(t) {
          switch (t.label) {
            case 0:
              return this._shutdown ? (N.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (e == null ? void 0 : e.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return t.sent(), [3, 4];
            case 2:
              return [4, Gn(this.onShutdown(), e.timeoutMillis)];
            case 3:
              t.sent(), t.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.forceFlush = function(e) {
      return Ho(this, void 0, void 0, function() {
        return Jo(this, function(t) {
          switch (t.label) {
            case 0:
              return this._shutdown ? (N.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (e == null ? void 0 : e.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, Gn(this.onForceFlush(), e.timeoutMillis)];
            case 3:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
), dL = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ii = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, Ti = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, hL = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, fL = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, pL = (
  /** @class */
  function(r) {
    dL(e, r);
    function e(t) {
      var n, i, s, o, a = r.call(this, {
        aggregationSelector: (n = t.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(t.exporter),
        aggregationTemporalitySelector: (i = t.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(t.exporter),
        metricProducers: t.metricProducers
      }) || this;
      if (t.exportIntervalMillis !== void 0 && t.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (t.exportTimeoutMillis !== void 0 && t.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (t.exportTimeoutMillis !== void 0 && t.exportIntervalMillis !== void 0 && t.exportIntervalMillis < t.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return a._exportInterval = (s = t.exportIntervalMillis) !== null && s !== void 0 ? s : 6e4, a._exportTimeout = (o = t.exportTimeoutMillis) !== null && o !== void 0 ? o : 3e4, a._exporter = t.exporter, a;
    }
    return e.prototype._runOnce = function() {
      return Ii(this, void 0, void 0, function() {
        var t;
        return Ti(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, Gn(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return t = n.sent(), t instanceof $m ? (N.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (Lt(t), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._doRun = function() {
      var t, n;
      return Ii(this, void 0, void 0, function() {
        var i, s, o, a, l, u;
        return Ti(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = c.sent(), s = i.resourceMetrics, o = i.errors, o.length > 0 && (u = N).error.apply(u, fL(["PeriodicExportingMetricReader: metrics collection errors"], hL(o), !1)), !s.resource.asyncAttributesPending) return [3, 5];
              c.label = 2;
            case 2:
              return c.trys.push([2, 4, , 5]), [4, (n = (t = s.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(t)];
            case 3:
              return c.sent(), [3, 5];
            case 4:
              return a = c.sent(), N.debug("Error while resolving async portion of resource: ", a), Lt(a), [3, 5];
            case 5:
              return s.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, xT._export(this._exporter, s)];
            case 6:
              if (l = c.sent(), l.code !== xe.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + l.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onInitialized = function() {
      var t = this;
      this._interval = setInterval(function() {
        t._runOnce();
      }, this._exportInterval);
    }, e.prototype.onForceFlush = function() {
      return Ii(this, void 0, void 0, function() {
        return Ti(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return t.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onShutdown = function() {
      return Ii(this, void 0, void 0, function() {
        return Ti(this, function(t) {
          switch (t.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return t.sent(), [4, this._exporter.shutdown()];
            case 2:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }(cL)
), mL = (
  /** @class */
  function() {
    function r() {
      this._registeredViews = [];
    }
    return r.prototype.addView = function(e) {
      this._registeredViews.push(e);
    }, r.prototype.findViews = function(e, t) {
      var n = this, i = this._registeredViews.filter(function(s) {
        return n._matchInstrument(s.instrumentSelector, e) && n._matchMeter(s.meterSelector, t);
      });
      return i;
    }, r.prototype._matchInstrument = function(e, t) {
      return (e.getType() === void 0 || t.type === e.getType()) && e.getNameFilter().match(t.name) && e.getUnitFilter().match(t.unit);
    }, r.prototype._matchMeter = function(e, t) {
      return e.getNameFilter().match(t.name) && (t.version === void 0 || e.getVersionFilter().match(t.version)) && (t.schemaUrl === void 0 || e.getSchemaUrlFilter().match(t.schemaUrl));
    }, r;
  }()
), er = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Fs = (
  /** @class */
  function() {
    function r(e, t) {
      this._writableMetricStorage = e, this._descriptor = t;
    }
    return r.prototype._record = function(e, t, n) {
      if (t === void 0 && (t = {}), n === void 0 && (n = K.active()), typeof e != "number") {
        N.warn("non-number value provided to metric " + this._descriptor.name + ": " + e);
        return;
      }
      this._descriptor.valueType === Gt.INT && !Number.isInteger(e) && (N.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), e = Math.trunc(e), !Number.isInteger(e)) || this._writableMetricStorage.record(e, t, n, Pe(Date.now()));
    }, r;
  }()
), gL = (
  /** @class */
  function(r) {
    er(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.add = function(t, n, i) {
      this._record(t, n, i);
    }, e;
  }(Fs)
), yL = (
  /** @class */
  function(r) {
    er(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.add = function(t, n, i) {
      if (t < 0) {
        N.warn("negative value provided to counter " + this._descriptor.name + ": " + t);
        return;
      }
      this._record(t, n, i);
    }, e;
  }(Fs)
), bL = (
  /** @class */
  function(r) {
    er(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.record = function(t, n, i) {
      this._record(t, n, i);
    }, e;
  }(Fs)
), vL = (
  /** @class */
  function(r) {
    er(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.record = function(t, n, i) {
      if (t < 0) {
        N.warn("negative value provided to histogram " + this._descriptor.name + ": " + t);
        return;
      }
      this._record(t, n, i);
    }, e;
  }(Fs)
), Hs = (
  /** @class */
  function() {
    function r(e, t, n) {
      this._observableRegistry = n, this._descriptor = e, this._metricStorages = t;
    }
    return r.prototype.addCallback = function(e) {
      this._observableRegistry.addCallback(e, this);
    }, r.prototype.removeCallback = function(e) {
      this._observableRegistry.removeCallback(e, this);
    }, r;
  }()
), SL = (
  /** @class */
  function(r) {
    er(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(Hs)
), wL = (
  /** @class */
  function(r) {
    er(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(Hs)
), _L = (
  /** @class */
  function(r) {
    er(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(Hs)
);
function dl(r) {
  return r instanceof Hs;
}
var RL = (
  /** @class */
  function() {
    function r(e) {
      this._meterSharedState = e;
    }
    return r.prototype.createGauge = function(e, t) {
      var n = wt(e, Y.GAUGE, t), i = this._meterSharedState.registerMetricStorage(n);
      return new bL(i, n);
    }, r.prototype.createHistogram = function(e, t) {
      var n = wt(e, Y.HISTOGRAM, t), i = this._meterSharedState.registerMetricStorage(n);
      return new vL(i, n);
    }, r.prototype.createCounter = function(e, t) {
      var n = wt(e, Y.COUNTER, t), i = this._meterSharedState.registerMetricStorage(n);
      return new yL(i, n);
    }, r.prototype.createUpDownCounter = function(e, t) {
      var n = wt(e, Y.UP_DOWN_COUNTER, t), i = this._meterSharedState.registerMetricStorage(n);
      return new gL(i, n);
    }, r.prototype.createObservableGauge = function(e, t) {
      var n = wt(e, Y.OBSERVABLE_GAUGE, t), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new wL(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.createObservableCounter = function(e, t) {
      var n = wt(e, Y.OBSERVABLE_COUNTER, t), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new SL(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.createObservableUpDownCounter = function(e, t) {
      var n = wt(e, Y.OBSERVABLE_UP_DOWN_COUNTER, t), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new _L(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.addBatchObservableCallback = function(e, t) {
      this._meterSharedState.observableRegistry.addBatchCallback(e, t);
    }, r.prototype.removeBatchObservableCallback = function(e, t) {
      this._meterSharedState.observableRegistry.removeBatchCallback(e, t);
    }, r;
  }()
), ug = (
  /** @class */
  function() {
    function r(e) {
      this._instrumentDescriptor = e;
    }
    return r.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, r.prototype.updateDescription = function(e) {
      this._instrumentDescriptor = wt(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: e,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, r;
  }()
), IL = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Pd = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, TL = (
  /** @class */
  function() {
    function r(e) {
      this._hash = e, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return r.prototype.get = function(e, t) {
      return t != null || (t = this._hash(e)), this._valueMap.get(t);
    }, r.prototype.getOrDefault = function(e, t) {
      var n = this._hash(e);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = t();
      return this._keyMap.has(n) || this._keyMap.set(n, e), this._valueMap.set(n, i), i;
    }, r.prototype.set = function(e, t, n) {
      n != null || (n = this._hash(e)), this._keyMap.has(n) || this._keyMap.set(n, e), this._valueMap.set(n, t);
    }, r.prototype.has = function(e, t) {
      return t != null || (t = this._hash(e)), this._valueMap.has(t);
    }, r.prototype.keys = function() {
      var e, t;
      return Pd(this, function(n) {
        switch (n.label) {
          case 0:
            e = this._keyMap.entries(), t = e.next(), n.label = 1;
          case 1:
            return t.done === !0 ? [3, 3] : [4, [t.value[1], t.value[0]]];
          case 2:
            return n.sent(), t = e.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, r.prototype.entries = function() {
      var e, t;
      return Pd(this, function(n) {
        switch (n.label) {
          case 0:
            e = this._valueMap.entries(), t = e.next(), n.label = 1;
          case 1:
            return t.done === !0 ? [3, 3] : [4, [this._keyMap.get(t.value[0]), t.value[1], t.value[0]]];
          case 2:
            return n.sent(), t = e.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(r.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
), Yt = (
  /** @class */
  function(r) {
    IL(e, r);
    function e() {
      return r.call(this, Qm) || this;
    }
    return e;
  }(TL)
), EL = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, cg = (
  /** @class */
  function() {
    function r(e, t) {
      this._aggregator = e, this._activeCollectionStorage = new Yt(), this._cumulativeMemoStorage = new Yt(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (t != null ? t : 2e3) - 1, this._overflowHashCode = Qm(this._overflowAttributes);
    }
    return r.prototype.record = function(e, t, n, i) {
      var s = this, o = this._activeCollectionStorage.get(t);
      if (!o) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var a = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return s._aggregator.createAccumulation(i);
          });
          a == null || a.record(e);
          return;
        }
        o = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(t, o);
      }
      o == null || o.record(e);
    }, r.prototype.batchCumulate = function(e, t) {
      var n = this;
      Array.from(e.entries()).forEach(function(i) {
        var s = EL(i, 3), o = s[0], a = s[1], l = s[2], u = n._aggregator.createAccumulation(t);
        u == null || u.record(a);
        var c = u;
        if (n._cumulativeMemoStorage.has(o, l)) {
          var d = n._cumulativeMemoStorage.get(o, l);
          c = n._aggregator.diff(d, u);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (o = n._overflowAttributes, l = n._overflowHashCode, n._cumulativeMemoStorage.has(o, l))) {
          var d = n._cumulativeMemoStorage.get(o, l);
          c = n._aggregator.diff(d, u);
        }
        if (n._activeCollectionStorage.has(o, l)) {
          var h = n._activeCollectionStorage.get(o, l);
          c = n._aggregator.merge(h, c);
        }
        n._cumulativeMemoStorage.set(o, u, l), n._activeCollectionStorage.set(o, c, l);
      });
    }, r.prototype.collect = function() {
      var e = this._activeCollectionStorage;
      return this._activeCollectionStorage = new Yt(), e;
    }, r;
  }()
), Bo = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Md = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, dg = (
  /** @class */
  function() {
    function r(e, t) {
      var n = this;
      this._aggregator = e, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), t.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return r.prototype.buildMetrics = function(e, t, n, i) {
      this._stashAccumulations(n);
      var s = this._getMergedUnreportedAccumulations(e), o = s, a;
      if (this._reportHistory.has(e)) {
        var l = this._reportHistory.get(e), u = l.collectionTime;
        a = l.aggregationTemporality, a === Ke.CUMULATIVE ? o = r.merge(l.accumulations, s, this._aggregator) : o = r.calibrateStartTime(l.accumulations, s, u);
      } else
        a = e.selectAggregationTemporality(t.type);
      this._reportHistory.set(e, {
        accumulations: o,
        collectionTime: i,
        aggregationTemporality: a
      });
      var c = CL(o);
      if (c.length !== 0)
        return this._aggregator.toMetricData(
          t,
          a,
          c,
          /* endTime */
          i
        );
    }, r.prototype._stashAccumulations = function(e) {
      var t, n, i = this._unreportedAccumulations.keys();
      try {
        for (var s = Bo(i), o = s.next(); !o.done; o = s.next()) {
          var a = o.value, l = this._unreportedAccumulations.get(a);
          l === void 0 && (l = [], this._unreportedAccumulations.set(a, l)), l.push(e);
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (n = s.return) && n.call(s);
        } finally {
          if (t) throw t.error;
        }
      }
    }, r.prototype._getMergedUnreportedAccumulations = function(e) {
      var t, n, i = new Yt(), s = this._unreportedAccumulations.get(e);
      if (this._unreportedAccumulations.set(e, []), s === void 0)
        return i;
      try {
        for (var o = Bo(s), a = o.next(); !a.done; a = o.next()) {
          var l = a.value;
          i = r.merge(i, l, this._aggregator);
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (t) throw t.error;
        }
      }
      return i;
    }, r.merge = function(e, t, n) {
      for (var i = e, s = t.entries(), o = s.next(); o.done !== !0; ) {
        var a = Md(o.value, 3), l = a[0], u = a[1], c = a[2];
        if (e.has(l, c)) {
          var d = e.get(l, c), h = n.merge(d, u);
          i.set(l, h, c);
        } else
          i.set(l, u, c);
        o = s.next();
      }
      return i;
    }, r.calibrateStartTime = function(e, t, n) {
      var i, s;
      try {
        for (var o = Bo(e.keys()), a = o.next(); !a.done; a = o.next()) {
          var l = Md(a.value, 2), u = l[0], c = l[1], d = t.get(u, c);
          d == null || d.setStartTime(n);
        }
      } catch (h) {
        i = { error: h };
      } finally {
        try {
          a && !a.done && (s = o.return) && s.call(o);
        } finally {
          if (i) throw i.error;
        }
      }
      return t;
    }, r;
  }()
);
function CL(r) {
  return Array.from(r.entries());
}
var ZL = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), GL = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, LL = (
  /** @class */
  function(r) {
    ZL(e, r);
    function e(t, n, i, s, o) {
      var a = r.call(this, t) || this;
      return a._attributesProcessor = i, a._aggregationCardinalityLimit = o, a._deltaMetricStorage = new cg(n, a._aggregationCardinalityLimit), a._temporalMetricStorage = new dg(n, s), a;
    }
    return e.prototype.record = function(t, n) {
      var i = this, s = new Yt();
      Array.from(t.entries()).forEach(function(o) {
        var a = GL(o, 2), l = a[0], u = a[1];
        s.set(i._attributesProcessor.process(l), u);
      }), this._deltaMetricStorage.batchCumulate(s, n);
    }, e.prototype.collect = function(t, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(t, this._instrumentDescriptor, i, n);
    }, e;
  }(ug)
);
function Ad(r, e) {
  var t = "";
  return r.unit !== e.unit && (t += "	- Unit '" + r.unit + "' does not match '" + e.unit + `'
`), r.type !== e.type && (t += "	- Type '" + r.type + "' does not match '" + e.type + `'
`), r.valueType !== e.valueType && (t += "	- Value Type '" + r.valueType + "' does not match '" + e.valueType + `'
`), r.description !== e.description && (t += "	- Description '" + r.description + "' does not match '" + e.description + `'
`), t;
}
function NL(r, e) {
  return "	- use valueType '" + r.valueType + "' on instrument creation or use an instrument name other than '" + e.name + "'";
}
function VL(r, e) {
  return "	- use unit '" + r.unit + "' on instrument creation or use an instrument name other than '" + e.name + "'";
}
function xL(r, e) {
  var t = {
    name: e.name,
    type: e.type,
    unit: e.unit
  }, n = JSON.stringify(t);
  return "	- create a new view with a name other than '" + r.name + "' and InstrumentSelector '" + n + "'";
}
function OL(r, e) {
  var t = {
    name: e.name,
    type: e.type,
    unit: e.unit
  }, n = JSON.stringify(t);
  return "	- create a new view with a name other than '" + r.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + r.name + " and description '" + r.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + e.name + " and description '" + r.description + "' and InstrumentSelector " + n;
}
function Ud(r, e) {
  return r.valueType !== e.valueType ? NL(r, e) : r.unit !== e.unit ? VL(r, e) : r.type !== e.type ? xL(r, e) : r.description !== e.description ? OL(r, e) : "";
}
var Do = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, WL = (
  /** @class */
  function() {
    function r() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return r.create = function() {
      return new r();
    }, r.prototype.getStorages = function(e) {
      var t, n, i, s, o = [];
      try {
        for (var a = Do(this._sharedRegistry.values()), l = a.next(); !l.done; l = a.next()) {
          var u = l.value;
          o = o.concat(u);
        }
      } catch (f) {
        t = { error: f };
      } finally {
        try {
          l && !l.done && (n = a.return) && n.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      var c = this._perCollectorRegistry.get(e);
      if (c != null)
        try {
          for (var d = Do(c.values()), h = d.next(); !h.done; h = d.next()) {
            var u = h.value;
            o = o.concat(u);
          }
        } catch (f) {
          i = { error: f };
        } finally {
          try {
            h && !h.done && (s = d.return) && s.call(d);
          } finally {
            if (i) throw i.error;
          }
        }
      return o;
    }, r.prototype.register = function(e) {
      this._registerStorage(e, this._sharedRegistry);
    }, r.prototype.registerForCollector = function(e, t) {
      var n = this._perCollectorRegistry.get(e);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(e, n)), this._registerStorage(t, n);
    }, r.prototype.findOrUpdateCompatibleStorage = function(e) {
      var t = this._sharedRegistry.get(e.name);
      return t === void 0 ? null : this._findOrUpdateCompatibleStorage(e, t);
    }, r.prototype.findOrUpdateCompatibleCollectorStorage = function(e, t) {
      var n = this._perCollectorRegistry.get(e);
      if (n === void 0)
        return null;
      var i = n.get(t.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(t, i);
    }, r.prototype._registerStorage = function(e, t) {
      var n = e.getInstrumentDescriptor(), i = t.get(n.name);
      if (i === void 0) {
        t.set(n.name, [e]);
        return;
      }
      i.push(e);
    }, r.prototype._findOrUpdateCompatibleStorage = function(e, t) {
      var n, i, s = null;
      try {
        for (var o = Do(t), a = o.next(); !a.done; a = o.next()) {
          var l = a.value, u = l.getInstrumentDescriptor();
          LG(u, e) ? (u.description !== e.description && (e.description.length > u.description.length && l.updateDescription(e.description), N.warn("A view or instrument with the name ", e.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, Ad(u, e), `The longer description will be used.
To resolve the conflict:`, Ud(u, e))), s = l) : N.warn("A view or instrument with the name ", e.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, Ad(u, e), `To resolve the conflict:
`, Ud(u, e));
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
      return s;
    }, r;
  }()
), XL = (
  /** @class */
  function() {
    function r(e) {
      this._backingStorages = e;
    }
    return r.prototype.record = function(e, t, n, i) {
      this._backingStorages.forEach(function(s) {
        s.record(e, t, n, i);
      });
    }, r;
  }()
), kL = (
  /** @class */
  function() {
    function r(e, t) {
      this._instrumentName = e, this._valueType = t, this._buffer = new Yt();
    }
    return r.prototype.observe = function(e, t) {
      if (t === void 0 && (t = {}), typeof e != "number") {
        N.warn("non-number value provided to metric " + this._instrumentName + ": " + e);
        return;
      }
      this._valueType === Gt.INT && !Number.isInteger(e) && (N.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), e = Math.trunc(e), !Number.isInteger(e)) || this._buffer.set(t, e);
    }, r;
  }()
), PL = (
  /** @class */
  function() {
    function r() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return r.prototype.observe = function(e, t, n) {
      if (n === void 0 && (n = {}), !!dl(e)) {
        var i = this._buffer.get(e);
        if (i == null && (i = new Yt(), this._buffer.set(e, i)), typeof t != "number") {
          N.warn("non-number value provided to metric " + e._descriptor.name + ": " + t);
          return;
        }
        e._descriptor.valueType === Gt.INT && !Number.isInteger(t) && (N.warn("INT value type cannot accept a floating-point value for " + e._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || i.set(n, t);
      }
    }, r;
  }()
), Ko = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, zo = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Yd = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, Fd = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, ML = (
  /** @class */
  function() {
    function r() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return r.prototype.addCallback = function(e, t) {
      var n = this._findCallback(e, t);
      n >= 0 || this._callbacks.push({ callback: e, instrument: t });
    }, r.prototype.removeCallback = function(e, t) {
      var n = this._findCallback(e, t);
      n < 0 || this._callbacks.splice(n, 1);
    }, r.prototype.addBatchCallback = function(e, t) {
      var n = new Set(t.filter(dl));
      if (n.size === 0) {
        N.error("BatchObservableCallback is not associated with valid instruments", t);
        return;
      }
      var i = this._findBatchCallback(e, n);
      i >= 0 || this._batchCallbacks.push({ callback: e, instruments: n });
    }, r.prototype.removeBatchCallback = function(e, t) {
      var n = new Set(t.filter(dl)), i = this._findBatchCallback(e, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, r.prototype.observe = function(e, t) {
      return Ko(this, void 0, void 0, function() {
        var n, i, s, o;
        return zo(this, function(a) {
          switch (a.label) {
            case 0:
              return n = this._observeCallbacks(e, t), i = this._observeBatchCallbacks(e, t), [4, RG(Fd(Fd([], Yd(n), !1), Yd(i), !1))];
            case 1:
              return s = a.sent(), o = s.filter(IG).map(function(l) {
                return l.reason;
              }), [2, o];
          }
        });
      });
    }, r.prototype._observeCallbacks = function(e, t) {
      var n = this;
      return this._callbacks.map(function(i) {
        var s = i.callback, o = i.instrument;
        return Ko(n, void 0, void 0, function() {
          var a, l;
          return zo(this, function(u) {
            switch (u.label) {
              case 0:
                return a = new kL(o._descriptor.name, o._descriptor.valueType), l = Promise.resolve(s(a)), t != null && (l = Gn(l, t)), [4, l];
              case 1:
                return u.sent(), o._metricStorages.forEach(function(c) {
                  c.record(a._buffer, e);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, r.prototype._observeBatchCallbacks = function(e, t) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var s = i.callback, o = i.instruments;
        return Ko(n, void 0, void 0, function() {
          var a, l;
          return zo(this, function(u) {
            switch (u.label) {
              case 0:
                return a = new PL(), l = Promise.resolve(s(a)), t != null && (l = Gn(l, t)), [4, l];
              case 1:
                return u.sent(), o.forEach(function(c) {
                  var d = a._buffer.get(c);
                  d != null && c._metricStorages.forEach(function(h) {
                    h.record(d, e);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, r.prototype._findCallback = function(e, t) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === e && n.instrument === t;
      });
    }, r.prototype._findBatchCallback = function(e, t) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === e && TG(n.instruments, t);
      });
    }, r;
  }()
), AL = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), UL = (
  /** @class */
  function(r) {
    AL(e, r);
    function e(t, n, i, s, o) {
      var a = r.call(this, t) || this;
      return a._attributesProcessor = i, a._aggregationCardinalityLimit = o, a._deltaMetricStorage = new cg(n, a._aggregationCardinalityLimit), a._temporalMetricStorage = new dg(n, s), a;
    }
    return e.prototype.record = function(t, n, i, s) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(t, n, i, s);
    }, e.prototype.collect = function(t, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(t, this._instrumentDescriptor, i, n);
    }, e;
  }(ug)
), hg = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), fu = (
  /** @class */
  function() {
    function r() {
    }
    return r.Noop = function() {
      return FL;
    }, r;
  }()
), YL = (
  /** @class */
  function(r) {
    hg(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.process = function(t, n) {
      return t;
    }, e;
  }(fu)
);
(function(r) {
  hg(e, r);
  function e(t) {
    var n = r.call(this) || this;
    return n._allowedAttributeNames = t, n;
  }
  return e.prototype.process = function(t, n) {
    var i = this, s = {};
    return Object.keys(t).filter(function(o) {
      return i._allowedAttributeNames.includes(o);
    }).forEach(function(o) {
      return s[o] = t[o];
    }), s;
  }, e;
})(fu);
var FL = new YL(), HL = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, JL = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, BL = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, DL = (
  /** @class */
  function() {
    function r(e, t) {
      this._meterProviderSharedState = e, this._instrumentationScope = t, this.metricStorageRegistry = new WL(), this.observableRegistry = new ML(), this.meter = new RL(this);
    }
    return r.prototype.registerMetricStorage = function(e) {
      var t = this._registerMetricStorage(e, UL);
      return t.length === 1 ? t[0] : new XL(t);
    }, r.prototype.registerAsyncMetricStorage = function(e) {
      var t = this._registerMetricStorage(e, LL);
      return t;
    }, r.prototype.collect = function(e, t, n) {
      return HL(this, void 0, void 0, function() {
        var i, s, o;
        return JL(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.observableRegistry.observe(t, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = a.sent(), s = this.metricStorageRegistry.getStorages(e), s.length === 0 ? [2, null] : (o = s.map(function(l) {
                return l.collect(e, t);
              }).filter(wG), o.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: o
                },
                errors: i
              }]);
          }
        });
      });
    }, r.prototype._registerMetricStorage = function(e, t) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(e, this._instrumentationScope), s = i.map(function(l) {
        var u = GG(l, e), c = n.metricStorageRegistry.findOrUpdateCompatibleStorage(u);
        if (c != null)
          return c;
        var d = l.aggregation.createAggregator(u), h = new t(u, d, l.attributesProcessor, n._meterProviderSharedState.metricCollectors, l.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(h), h;
      });
      if (s.length === 0) {
        var o = this._meterProviderSharedState.selectAggregations(e.type), a = o.map(function(l) {
          var u = BL(l, 2), c = u[0], d = u[1], h = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(c, e);
          if (h != null)
            return h;
          var f = d.createAggregator(e), m = c.selectCardinalityLimit(e.type), p = new t(e, f, fu.Noop(), [c], m);
          return n.metricStorageRegistry.registerForCollector(c, p), p;
        });
        s = s.concat(a);
      }
      return s;
    }, r;
  }()
), KL = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, zL = (
  /** @class */
  function() {
    function r(e) {
      this.resource = e, this.viewRegistry = new mL(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return r.prototype.getMeterSharedState = function(e) {
      var t = _G(e), n = this.meterSharedStates.get(t);
      return n == null && (n = new DL(this, e), this.meterSharedStates.set(t, n)), n;
    }, r.prototype.selectAggregations = function(e) {
      var t, n, i = [];
      try {
        for (var s = KL(this.metricCollectors), o = s.next(); !o.done; o = s.next()) {
          var a = o.value;
          i.push([a, a.selectAggregation(e)]);
        }
      } catch (l) {
        t = { error: l };
      } finally {
        try {
          o && !o.done && (n = s.return) && n.call(s);
        } finally {
          if (t) throw t.error;
        }
      }
      return i;
    }, r;
  }()
), Ei = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, Ci = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, jL = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, QL = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, s; n < i; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}, $L = (
  /** @class */
  function() {
    function r(e, t) {
      this._sharedState = e, this._metricReader = t;
    }
    return r.prototype.collect = function(e) {
      return Ei(this, void 0, void 0, function() {
        var t, n, i, s, o = this;
        return Ci(this, function(a) {
          switch (a.label) {
            case 0:
              return t = Pe(Date.now()), n = [], i = [], s = Array.from(this._sharedState.meterSharedStates.values()).map(function(l) {
                return Ei(o, void 0, void 0, function() {
                  var u;
                  return Ci(this, function(c) {
                    switch (c.label) {
                      case 0:
                        return [4, l.collect(this, t, e)];
                      case 1:
                        return u = c.sent(), (u == null ? void 0 : u.scopeMetrics) != null && n.push(u.scopeMetrics), (u == null ? void 0 : u.errors) != null && i.push.apply(i, QL([], jL(u.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(s)];
            case 1:
              return a.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, r.prototype.forceFlush = function(e) {
      return Ei(this, void 0, void 0, function() {
        return Ci(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this._metricReader.forceFlush(e)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.shutdown = function(e) {
      return Ei(this, void 0, void 0, function() {
        return Ci(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this._metricReader.shutdown(e)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.selectAggregationTemporality = function(e) {
      return this._metricReader.selectAggregationTemporality(e);
    }, r.prototype.selectAggregation = function(e) {
      return this._metricReader.selectAggregation(e);
    }, r.prototype.selectCardinalityLimit = function(e) {
      var t, n, i;
      return (i = (n = (t = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(t, e)) !== null && i !== void 0 ? i : 2e3;
    }, r;
  }()
), Hd = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, Jd = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Bd = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function qL(r, e) {
  var t = e != null ? e : Zn.empty();
  return r ? Zn.default().merge(t) : t;
}
var eN = (
  /** @class */
  function() {
    function r(e) {
      var t, n, i, s, o;
      if (this._shutdown = !1, this._sharedState = new zL(qL((o = e == null ? void 0 : e.mergeResourceWithDefaults) !== null && o !== void 0 ? o : !0, e == null ? void 0 : e.resource)), (e == null ? void 0 : e.views) != null && e.views.length > 0)
        try {
          for (var a = Bd(e.views), l = a.next(); !l.done; l = a.next()) {
            var u = l.value;
            this._sharedState.viewRegistry.addView(u);
          }
        } catch (f) {
          t = { error: f };
        } finally {
          try {
            l && !l.done && (n = a.return) && n.call(a);
          } finally {
            if (t) throw t.error;
          }
        }
      if ((e == null ? void 0 : e.readers) != null && e.readers.length > 0)
        try {
          for (var c = Bd(e.readers), d = c.next(); !d.done; d = c.next()) {
            var h = d.value;
            this.addMetricReader(h);
          }
        } catch (f) {
          i = { error: f };
        } finally {
          try {
            d && !d.done && (s = c.return) && s.call(c);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return r.prototype.getMeter = function(e, t, n) {
      return t === void 0 && (t = ""), n === void 0 && (n = {}), this._shutdown ? (N.warn("A shutdown MeterProvider cannot provide a Meter"), ZR()) : this._sharedState.getMeterSharedState({
        name: e,
        version: t,
        schemaUrl: n.schemaUrl
      }).meter;
    }, r.prototype.addMetricReader = function(e) {
      var t = new $L(this._sharedState, e);
      e.setMetricProducer(t), this._sharedState.metricCollectors.push(t);
    }, r.prototype.shutdown = function(e) {
      return Hd(this, void 0, void 0, function() {
        return Jd(this, function(t) {
          switch (t.label) {
            case 0:
              return this._shutdown ? (N.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(e);
              }))]);
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.forceFlush = function(e) {
      return Hd(this, void 0, void 0, function() {
        return Jd(this, function(t) {
          switch (t.label) {
            case 0:
              return this._shutdown ? (N.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(e);
              }))];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
);
function tN(r, e) {
  var t = Bm(e);
  return {
    resource: Dm(r.resource),
    schemaUrl: void 0,
    scopeMetrics: rN(r.scopeMetrics, t)
  };
}
function rN(r, e) {
  return Array.from(r.map(function(t) {
    return {
      scope: Km(t.scope),
      metrics: t.metrics.map(function(n) {
        return nN(n, e);
      }),
      schemaUrl: t.scope.schemaUrl
    };
  }));
}
function nN(r, e) {
  var t = {
    name: r.descriptor.name,
    description: r.descriptor.description,
    unit: r.descriptor.unit
  }, n = aN(r.aggregationTemporality);
  switch (r.dataPointType) {
    case ot.SUM:
      t.sum = {
        aggregationTemporality: n,
        isMonotonic: r.isMonotonic,
        dataPoints: Dd(r, e)
      };
      break;
    case ot.GAUGE:
      t.gauge = {
        dataPoints: Dd(r, e)
      };
      break;
    case ot.HISTOGRAM:
      t.histogram = {
        aggregationTemporality: n,
        dataPoints: sN(r, e)
      };
      break;
    case ot.EXPONENTIAL_HISTOGRAM:
      t.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: oN(r, e)
      };
      break;
  }
  return t;
}
function iN(r, e, t) {
  var n = {
    attributes: $t(r.attributes),
    startTimeUnixNano: t.encodeHrTime(r.startTime),
    timeUnixNano: t.encodeHrTime(r.endTime)
  };
  switch (e) {
    case Gt.INT:
      n.asInt = r.value;
      break;
    case Gt.DOUBLE:
      n.asDouble = r.value;
      break;
  }
  return n;
}
function Dd(r, e) {
  return r.dataPoints.map(function(t) {
    return iN(t, r.descriptor.valueType, e);
  });
}
function sN(r, e) {
  return r.dataPoints.map(function(t) {
    var n = t.value;
    return {
      attributes: $t(t.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: e.encodeHrTime(t.startTime),
      timeUnixNano: e.encodeHrTime(t.endTime)
    };
  });
}
function oN(r, e) {
  return r.dataPoints.map(function(t) {
    var n = t.value;
    return {
      attributes: $t(t.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: e.encodeHrTime(t.startTime),
      timeUnixNano: e.encodeHrTime(t.endTime)
    };
  });
}
function aN(r) {
  switch (r) {
    case Ke.DELTA:
      return 1;
    case Ke.CUMULATIVE:
      return 2;
  }
}
function lN(r, e) {
  return {
    resourceMetrics: r.map(function(t) {
      return tN(t, e);
    })
  };
}
var uN = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, cN = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
};
function dN(r, e) {
  var t, n = r.spanContext(), i = r.status;
  return {
    traceId: e.encodeSpanContext(n.traceId),
    spanId: e.encodeSpanContext(n.spanId),
    parentSpanId: e.encodeOptionalSpanContext(r.parentSpanId),
    traceState: (t = n.traceState) === null || t === void 0 ? void 0 : t.serialize(),
    name: r.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: r.kind == null ? 0 : r.kind + 1,
    startTimeUnixNano: e.encodeHrTime(r.startTime),
    endTimeUnixNano: e.encodeHrTime(r.endTime),
    attributes: $t(r.attributes),
    droppedAttributesCount: r.droppedAttributesCount,
    events: r.events.map(function(s) {
      return fN(s, e);
    }),
    droppedEventsCount: r.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: r.links.map(function(s) {
      return hN(s, e);
    }),
    droppedLinksCount: r.droppedLinksCount
  };
}
function hN(r, e) {
  var t;
  return {
    attributes: r.attributes ? $t(r.attributes) : [],
    spanId: e.encodeSpanContext(r.context.spanId),
    traceId: e.encodeSpanContext(r.context.traceId),
    traceState: (t = r.context.traceState) === null || t === void 0 ? void 0 : t.serialize(),
    droppedAttributesCount: r.droppedAttributesCount || 0
  };
}
function fN(r, e) {
  return {
    attributes: r.attributes ? $t(r.attributes) : [],
    name: r.name,
    timeUnixNano: e.encodeHrTime(r.time),
    droppedAttributesCount: r.droppedAttributesCount || 0
  };
}
function pN(r, e) {
  var t = Bm(e);
  return {
    resourceSpans: gN(r, t)
  };
}
function mN(r) {
  var e, t, n = /* @__PURE__ */ new Map();
  try {
    for (var i = uN(r), s = i.next(); !s.done; s = i.next()) {
      var o = s.value, a = n.get(o.resource);
      a || (a = /* @__PURE__ */ new Map(), n.set(o.resource, a));
      var l = o.instrumentationLibrary.name + "@" + (o.instrumentationLibrary.version || "") + ":" + (o.instrumentationLibrary.schemaUrl || ""), u = a.get(l);
      u || (u = [], a.set(l, u)), u.push(o);
    }
  } catch (c) {
    e = { error: c };
  } finally {
    try {
      s && !s.done && (t = i.return) && t.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return n;
}
function gN(r, e) {
  for (var t = mN(r), n = [], i = t.entries(), s = i.next(); !s.done; ) {
    for (var o = cN(s.value, 2), a = o[0], l = o[1], u = [], c = l.values(), d = c.next(); !d.done; ) {
      var h = d.value;
      if (h.length > 0) {
        var f = h.map(function(p) {
          return dN(p, e);
        });
        u.push({
          scope: Km(h[0].instrumentationLibrary),
          spans: f,
          schemaUrl: h[0].instrumentationLibrary.schemaUrl
        });
      }
      d = c.next();
    }
    var m = {
      resource: Dm(a),
      scopeSpans: u,
      schemaUrl: void 0
    };
    n.push(m), s = i.next();
  }
  return n;
}
var yN = {
  serializeRequest: function(r) {
    var e = lN([r], {
      useLongBits: !1
    }), t = new TextEncoder();
    return t.encode(JSON.stringify(e));
  },
  deserializeResponse: function(r) {
    var e = new TextDecoder();
    return JSON.parse(e.decode(r));
  }
}, bN = {
  serializeRequest: function(r) {
    var e = pN(r, {
      useHex: !0,
      useLongBits: !1
    }), t = new TextEncoder();
    return t.encode(JSON.stringify(e));
  },
  deserializeResponse: function(r) {
    var e = new TextDecoder();
    return JSON.parse(e.decode(r));
  }
}, vN = function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(c) {
      try {
        u(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? s(c.value) : i(c.value).then(a, l);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, SN = function(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done) return s;
      switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
        case 0:
        case 1:
          s = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = u;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(u);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = e.call(r, t);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      n = s = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, wN = 5, _N = 1e3, RN = 5e3, IN = 1.5, Kd = 0.2;
function TN() {
  return Math.random() * (2 * Kd) - Kd;
}
var EN = (
  /** @class */
  function() {
    function r(e) {
      this._transport = e;
    }
    return r.prototype.retry = function(e, t, n) {
      var i = this;
      return new Promise(function(s, o) {
        setTimeout(function() {
          i._transport.send(e, t).then(s, o);
        }, n);
      });
    }, r.prototype.send = function(e, t) {
      var n;
      return vN(this, void 0, void 0, function() {
        var i, s, o, a, l, u, c;
        return SN(this, function(d) {
          switch (d.label) {
            case 0:
              return i = Date.now() + t, [4, this._transport.send(e, t)];
            case 1:
              s = d.sent(), o = wN, a = _N, d.label = 2;
            case 2:
              return s.status === "retryable" && o > 0 ? (o--, l = Math.max(Math.min(a, RN) + TN(), 0), a = a * IN, u = (n = s.retryInMillis) !== null && n !== void 0 ? n : l, c = i - Date.now(), u > c ? [2, s] : [4, this.retry(e, c, u)]) : [3, 4];
            case 3:
              return s = d.sent(), [3, 2];
            case 4:
              return [2, s];
          }
        });
      });
    }, r.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, r;
  }()
);
function fg(r) {
  return new EN(r.transport);
}
function CN(r) {
  var e = [429, 502, 503, 504];
  return e.includes(r);
}
function ZN(r) {
  if (r != null) {
    var e = Number.parseInt(r, 10);
    if (Number.isInteger(e))
      return e > 0 ? e * 1e3 : -1;
    var t = new Date(r).getTime() - Date.now();
    return t >= 0 ? t : 0;
  }
}
var GN = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
}, LN = (
  /** @class */
  function() {
    function r(e) {
      this._parameters = e;
    }
    return r.prototype.send = function(e, t) {
      var n = this;
      return new Promise(function(i) {
        var s = new XMLHttpRequest();
        s.timeout = t, s.open("POST", n._parameters.url);
        var o = n._parameters.headers();
        Object.entries(o).forEach(function(a) {
          var l = GN(a, 2), u = l[0], c = l[1];
          s.setRequestHeader(u, c);
        }), s.ontimeout = function(a) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, s.onreadystatechange = function() {
          s.status >= 200 && s.status <= 299 ? (N.debug("XHR success"), i({
            status: "success"
          })) : s.status && CN(s.status) ? i({
            status: "retryable",
            retryInMillis: ZN(s.getResponseHeader("Retry-After"))
          }) : s.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, s.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, s.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, s.send(e);
      });
    }, r.prototype.shutdown = function() {
    }, r;
  }()
);
function NN(r) {
  return new LN(r);
}
var VN = (
  /** @class */
  function() {
    function r(e) {
      this._params = e;
    }
    return r.prototype.send = function(e) {
      var t = this;
      return new Promise(function(n) {
        navigator.sendBeacon(t._params.url, new Blob([e], { type: t._params.blobType })) ? (N.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, r.prototype.shutdown = function() {
    }, r;
  }()
);
function xN(r) {
  return new VN(r);
}
function ON(r, e) {
  return Ym(r, e, fg({
    transport: NN(r)
  }));
}
function WN(r, e) {
  return Ym(r, e, fg({
    transport: xN({
      url: r.url,
      blobType: r.headers()["Content-Type"]
    })
  }));
}
var XN = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, s = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return s;
};
function kN(r) {
  return function() {
    var e, t = {};
    return Object.entries((e = r == null ? void 0 : r()) !== null && e !== void 0 ? e : {}).forEach(function(n) {
      var i = XN(n, 2), s = i[0], o = i[1];
      typeof o != "undefined" ? t[s] = String(o) : N.warn('Header "' + s + '" has invalid value (' + o + ") and will be ignored");
    }), t;
  };
}
var Dt = function() {
  return Dt = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Dt.apply(this, arguments);
};
function PN(r, e, t) {
  var n = Dt({}, t()), i = {};
  return function() {
    return e != null && Object.assign(i, e()), r != null && Object.assign(i, r()), Object.assign(i, n);
  };
}
function MN(r) {
  if (r != null)
    try {
      return new URL(r), r;
    } catch (e) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + r + "'");
    }
}
function AN(r, e, t) {
  var n, i, s, o;
  return Dt(Dt({}, eG(r, e, t)), { headers: PN(kN(r.headers), e.headers, t.headers), url: (i = (n = MN(r.url)) !== null && n !== void 0 ? n : e.url) !== null && i !== void 0 ? i : t.url, agentOptions: (o = (s = r.agentOptions) !== null && s !== void 0 ? s : e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions });
}
function UN(r, e) {
  return Dt(Dt({}, tG()), { headers: function() {
    return r;
  }, url: "http://localhost:4318/" + e, agentOptions: { keepAlive: !0 } });
}
function YN(r, e, t) {
  return AN(
    {
      url: r.url,
      timeoutMillis: r.timeoutMillis,
      headers: qZ(r.headers),
      concurrencyLimit: r.concurrencyLimit
    },
    {},
    // no fallback for browser case
    UN(t, e)
  );
}
function pg(r, e, t, n) {
  var i = !!r.headers || typeof navigator.sendBeacon != "function", s = YN(r, t, n);
  return i ? ON(s, e) : WN(s, e);
}
var FN = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), zd = (
  /** @class */
  function(r) {
    FN(e, r);
    function e(t) {
      return t === void 0 && (t = {}), r.call(this, pg(t, bN, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return e;
  }(Um)
), vs;
(function(r) {
  r[r.DELTA = 0] = "DELTA", r[r.CUMULATIVE = 1] = "CUMULATIVE", r[r.LOWMEMORY = 2] = "LOWMEMORY";
})(vs || (vs = {}));
var HN = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), hl = function() {
  return Ke.CUMULATIVE;
}, mg = function(r) {
  switch (r) {
    case Y.COUNTER:
    case Y.OBSERVABLE_COUNTER:
    case Y.GAUGE:
    case Y.HISTOGRAM:
    case Y.OBSERVABLE_GAUGE:
      return Ke.DELTA;
    case Y.UP_DOWN_COUNTER:
    case Y.OBSERVABLE_UP_DOWN_COUNTER:
      return Ke.CUMULATIVE;
  }
}, gg = function(r) {
  switch (r) {
    case Y.COUNTER:
    case Y.HISTOGRAM:
      return Ke.DELTA;
    case Y.GAUGE:
    case Y.UP_DOWN_COUNTER:
    case Y.OBSERVABLE_UP_DOWN_COUNTER:
    case Y.OBSERVABLE_COUNTER:
    case Y.OBSERVABLE_GAUGE:
      return Ke.CUMULATIVE;
  }
};
function JN() {
  var r = Cr(), e = r.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return e === "cumulative" ? hl : e === "delta" ? mg : e === "lowmemory" ? gg : (N.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + r.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), hl);
}
function BN(r) {
  return r != null ? r === vs.DELTA ? mg : r === vs.LOWMEMORY ? gg : hl : JN();
}
function DN(r) {
  return r != null && r.aggregationPreference ? r.aggregationPreference : function(e) {
    return bt.Default();
  };
}
var KN = (
  /** @class */
  function(r) {
    HN(e, r);
    function e(t, n) {
      var i = r.call(this, t) || this;
      return i._aggregationSelector = DN(n), i._aggregationTemporalitySelector = BN(n == null ? void 0 : n.temporalityPreference), i;
    }
    return e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e;
  }(Um)
), zN = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), jd = (
  /** @class */
  function(r) {
    zN(e, r);
    function e(t) {
      return r.call(this, pg(t != null ? t : {}, yN, "v1/metrics", { "Content-Type": "application/json" }), t) || this;
    }
    return e;
  }(KN)
), fl;
(function(r) {
  r.BillingQuotaExceeded = "BillingQuotaExceeded";
})(fl || (fl = {}));
const pu = 10, jN = 1e3, QN = 500, $N = [fl.BillingQuotaExceeded.toString()], qN = (r) => {
  var t;
  return ((t = r.response.errors) == null ? void 0 : t.find((n) => $N.includes(n.message))) === void 0;
}, eV = (r) => {
  const e = (t, n, i, s, o = 0) => $(void 0, null, function* () {
    try {
      return yield t();
    } catch (a) {
      if (a instanceof gr && !qN(a))
        throw a;
      if (o < pu)
        return yield new Promise((l) => setTimeout(l, jN + QN * Math.pow(2, o))), yield e(t, n, i, s, o + 1);
      throw console.error(`highlight.io: [${r || r}] data request failed after ${o} retries`), a;
    }
  });
  return e;
};
class tV extends zd {
  constructor(t) {
    super(t);
    T(this, "xhrTraceExporter");
    this.xhrTraceExporter = new zd(M(I({}, t != null ? t : {}), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
  }
  export(t, n) {
    let i = 0;
    const s = (o) => {
      var a;
      i++, i > pu ? (console.error(`[highlight.io] failed to export OTeL traces: ${(a = o.error) == null ? void 0 : a.message}`, o.error), n({
        code: xe.FAILED,
        error: o.error
      })) : this.xhrTraceExporter.export(t, n);
    };
    super.export(t, s);
  }
}
class rV extends jd {
  constructor(t) {
    super(t);
    T(this, "xhrMeterExporter");
    this.xhrMeterExporter = new jd(M(I({}, t != null ? t : {}), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
  }
  export(t, n) {
    let i = 0;
    const s = (o) => {
      var a;
      i++, i > pu ? (console.error(`[highlight.io] failed to export OTeL metrics: ${(a = o.error) == null ? void 0 : a.message}`, o.error), n({
        code: xe.FAILED,
        error: o.error
      })) : this.xhrMeterExporter.export(t, n);
    };
    super.export(t, s);
  }
}
const nV = "OT_ZONE_CONTEXT", iV = "Navigation:";
function sV() {
  return !1;
}
const tt = class tt extends BT {
  constructor(t = {}) {
    super(tt.moduleName, tt.version, t);
    T(this, "_spansData", /* @__PURE__ */ new WeakMap());
    T(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    T(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    T(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    T(this, "_shouldPreventSpanCreation");
    this._shouldPreventSpanCreation = typeof (t == null ? void 0 : t.shouldPreventSpanCreation) == "function" ? t.shouldPreventSpanCreation : sV;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(t, n) {
    const i = this._spansData.get(n);
    i && (t.source === "setTimeout" ? i.hrTimeLastTimeout = Jt() : t.source !== "Promise.then" && t.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(t) {
    return !0;
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(t, n) {
    var a;
    const i = t == null ? void 0 : t.target, s = t == null ? void 0 : t.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(s))
      return;
    const o = Im(i, !0);
    try {
      const l = this.tracer.startSpan(s, {
        attributes: {
          "event.type": s,
          "event.tag": i.tagName,
          "event.xpath": o,
          "event.id": i.id,
          "event.text": (a = i.textContent) != null ? a : "",
          "event.url": window.location.href,
          "viewport.width": window.innerWidth,
          "viewport.height": window.innerHeight
        }
      }, n ? ee.setSpan(K.active(), n) : void 0);
      return t instanceof MouseEvent && (l.setAttribute("event.x", t.clientX), l.setAttribute("event.y", t.clientY), l.setAttribute("event.relativeX", t.clientX / window.innerWidth), l.setAttribute("event.relativeY", t.clientY / window.innerHeight), s === "scroll" && (l.setAttribute("event.scrollX", window.scrollX), l.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(s, i, l) === !0 ? void 0 : (this._spansData.set(l, {
        taskCount: 0
      }), l);
    } catch (l) {
      this._diag.error("failed to start create new user interaction span", l);
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(t) {
    const n = this._spansData.get(t);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(t, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(t) {
    const n = t.get(nV);
    return n && ee.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(t) {
    const n = this._spansData.get(t);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(t, n, i, s) {
    let o = this._wrappedListeners.get(i);
    o || (o = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, o));
    let a = o.get(n);
    return a || (a = /* @__PURE__ */ new Map(), o.set(n, a)), a.has(t) ? !1 : (a.set(t, s), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(t, n, i) {
    const s = this._wrappedListeners.get(i);
    if (!s)
      return;
    const o = s.get(n);
    if (!o)
      return;
    const a = o.get(t);
    return a && (o.delete(t), o.size === 0 && (s.delete(n), s.size === 0 && this._wrappedListeners.delete(i))), a;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(t, n, i) {
    return typeof t == "function" ? t.apply(n, i) : t.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const t = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(o, a, l) {
      if (!a)
        return i.call(this, o, a, l);
      const u = l && typeof l == "object" && l.once, c = function(...d) {
        var p;
        let h;
        const f = d[0];
        if (!(f != null && f.type))
          return t._invokeListener(a, this, d);
        if (Date.now() - ((p = n.get(f.type)) != null ? p : 0) < 1e3 / 60)
          return t._invokeListener(a, this, d);
        n.set(f.type, Date.now()), f && (h = t._eventsSpanMap.get(f)), u && t.removePatchedListener(this, o, a);
        const m = t._createSpan(f, h);
        return m ? (f && t._eventsSpanMap.set(f, m), K.with(ee.setSpan(K.active(), m), () => {
          const g = t._invokeListener(a, this, d);
          return m.end(), g;
        })) : t._invokeListener(a, this, d);
      };
      if (t.addPatchedListener(this, o, a, c))
        return i.call(this, o, c, l);
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const t = this;
    return (n) => function(s, o, a) {
      const l = t.removePatchedListener(this, s, o);
      return l ? n.call(this, s, l, a) : n.call(this, s, o, a);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const t = this;
    return (n) => function(...s) {
      const o = `${location.pathname}${location.hash}${location.search}`, a = n.apply(this, s), l = `${location.pathname}${location.hash}${location.search}`;
      return o !== l && t._updateInteractionName(l), a;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    _e(history.replaceState) && this._unwrap(history, "replaceState"), _e(history.pushState) && this._unwrap(history, "pushState"), _e(history.back) && this._unwrap(history, "back"), _e(history.forward) && this._unwrap(history, "forward"), _e(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(t) {
    const n = ee.getSpan(K.active());
    n && typeof n.updateName == "function" && n.updateName(`${iV} ${t}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const t = this;
    return (n) => function(s) {
      const o = Zone.current, a = t._getCurrentSpan(o);
      return a && t._shouldCountTask(s, o) && t._decrementTask(a), n.call(this, s);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const t = this;
    return (n) => function(s) {
      const o = Zone.current, a = t._getCurrentSpan(o);
      return a && t._shouldCountTask(s, o) && (t._incrementTask(a), t._checkForTimeout(s, a)), n.call(this, s);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const t = this;
    return (n) => function(s, o, a) {
      const l = Array.isArray(a) && a[0] instanceof Event ? a[0] : void 0, u = l == null ? void 0 : l.target;
      let c;
      const d = this;
      if (u) {
        if (c = t._createSpan(l), c)
          return t._incrementTask(c), d.run(() => {
            try {
              return K.with(ee.setSpan(K.active(), c), () => {
                const h = Zone.current;
                return s._zone = h, n.call(h, s, o, a);
              });
            } finally {
              t._decrementTask(c);
            }
          });
      } else
        c = t._getCurrentSpan(d);
      try {
        return n.call(d, s, o, a);
      } finally {
        c && t._shouldCountTask(s, d) && t._decrementTask(c);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(t, n) {
    if (t._zone && (n = t._zone), !n || !t.data || t.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : t.type === "macroTask" || t.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(t, n) {
    t && this._spansData.get(t) && (t.end(n), this._spansData.delete(t));
  }
  /**
   * implements enable function
   */
  enable() {
    const t = this._getZoneWithPrototype();
    this._diag.debug("applying patch to", tt.moduleName, tt.version, "zone:", !!t), t ? (_e(t.prototype.runTask) && (this._unwrap(t.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), _e(t.prototype.scheduleTask) && (this._unwrap(t.prototype, "scheduleTask"), this._diag.debug("removing previous patch from method scheduleTask")), _e(t.prototype.cancelTask) && (this._unwrap(t.prototype, "cancelTask"), this._diag.debug("removing previous patch from method cancelTask")), this._zonePatched = !0, this._wrap(t.prototype, "runTask", this._patchZoneRunTask()), this._wrap(t.prototype, "scheduleTask", this._patchZoneScheduleTask()), this._wrap(t.prototype, "cancelTask", this._patchZoneCancelTask())) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      _e(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug("removing previous patch from method addEventListener")), _e(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug("removing previous patch from method removeEventListener")), this._wrap(i, "addEventListener", this._patchAddEventListener()), this._wrap(i, "removeEventListener", this._patchRemoveEventListener());
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const t = this._getZoneWithPrototype();
    this._diag.debug("removing patch from", tt.moduleName, tt.version, "zone:", !!t), t && this._zonePatched ? (_e(t.prototype.runTask) && this._unwrap(t.prototype, "runTask"), _e(t.prototype.scheduleTask) && this._unwrap(t.prototype, "scheduleTask"), _e(t.prototype.cancelTask) && this._unwrap(t.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      _e(i.addEventListener) && this._unwrap(i, "addEventListener"), _e(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
T(tt, "version", "0.1.0"), T(tt, "moduleName", "user-interaction");
let pl = tt;
const Lr = "feature_flag", oV = `${Lr}.key`, aV = `${Lr}.provider.name`, lV = `${Lr}.context.key`, uV = `${Lr}.result.variant`, ml = "evaluation", cV = "$ld:telemetry:session:init", dV = "$ld:telemetry:error", Qd = "$ld:telemetry:track", hV = "$ld:telemetry:metric", yg = "document_load";
function fV(r) {
  return r.includes("%") || r.includes(":") ? r.replace(/%/g, "%25").replace(/:/g, "%3A") : r;
}
function pV(r) {
  return r.kind === "multi";
}
function $d(r) {
  return pV(r) ? Object.keys(r).sort().filter((e) => e !== "kind").map((e) => `${e}:${fV(r[e].key)}`).join(":") : r.key;
}
function mV(r, e) {
  e.addHook({
    getMetadata: () => ({
      name: "HighlightHook"
    }),
    afterIdentify: (t, n, i) => (r.identify($d(t.context), t.context, "LaunchDarkly"), n),
    afterEvaluation: (t, n, i) => {
      const s = {
        [oV]: t.flagKey,
        [aV]: "LaunchDarkly",
        [uV]: JSON.stringify(i.value)
      };
      t.context && (s[lV] = $d(t.context));
      let o = ee.getActiveSpan();
      return o ? o.addEvent(Lr, s) : r.startSpan(ml, (a) => {
        a && a.addEvent(Lr, s);
      }), r.track(ml, s), n;
    }
  });
}
class bg {
  constructor(e) {
    T(this, "client");
    this.client = e;
  }
  init(e) {
    this.client.track(cV, {
      sessionSecureID: e
    });
  }
  recordGauge(e, t) {
    t.category !== Ne.WebVital && t.name !== yg || t.name !== "Jank" && this.client.track(`${hV}:${t.name.toLowerCase()}`, M(I({}, t), {
      sessionSecureID: e
    }), t.value);
  }
  identify(e, t, n = {}, i) {
  }
  error(e, t) {
    this.client.track(dV, M(I({}, t), {
      sessionSecureID: e
    }));
  }
  track(e, t) {
    const n = t.event;
    n !== ml && this.client.track(n ? `${Qd}:${n}` : Qd, M(I({}, t), {
      sessionSecureID: e
    }));
  }
}
let Ve = {}, lt;
const Ss = "highlight.record", gV = (r) => {
  var m, p, g, y, _, S, C, R, L;
  if (Ve.tracerProvider !== void 0) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  lt = r;
  const e = r.backendUrl || void 0 || "https://pub.highlight.io", t = [
    ...(p = (m = r.networkRecordingOptions) == null ? void 0 : m.urlBlocklist) != null ? p : [],
    ...km
  ], n = (g = r.environment) != null ? g : "production", i = {
    url: r.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 100,
    timeoutMillis: 5e3,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 5e3,
      keepAlive: !0
    }
  }, s = new tV(i), o = new yV(s, {
    maxExportBatchSize: 100,
    maxQueueSize: 1e3,
    exportTimeoutMillis: i.timeoutMillis,
    scheduledDelayMillis: i.timeoutMillis
  }), a = new Zn({
    [eC]: (y = r.serviceName) != null ? y : "highlight-browser",
    [qE]: n,
    "highlight.project_id": r.projectId,
    "highlight.session_id": r.sessionSecureId
  });
  Ve.tracerProvider = new EE({
    resource: a,
    spanProcessors: [o]
  }), ee.setGlobalTracerProvider(Ve.tracerProvider);
  const l = new rV(M(I({}, i), {
    url: r.otlpEndpoint + "/v1/metrics"
  })), u = new pL({
    exporter: l,
    exportIntervalMillis: i.timeoutMillis,
    exportTimeoutMillis: i.timeoutMillis
  });
  Ve.meterProvider = new eN({ resource: a, readers: [u] }), Vr.setGlobalMeterProvider(Ve.meterProvider);
  let c = [];
  ((_ = r.instrumentations) == null ? void 0 : _["@opentelemetry/instrumentation-document-load"]) !== !1 && c.push(new aC({
    applyCustomAttributesOnSpan: {
      documentLoad: th,
      documentFetch: th,
      resourceFetch: IV
    }
  })), ((S = r.instrumentations) == null ? void 0 : S["@opentelemetry/instrumentation-user-interaction"]) !== !1 && c.push(new pl()), (C = r.networkRecordingOptions) != null && C.enabled && (((R = r.instrumentations) == null ? void 0 : R["@opentelemetry/instrumentation-fetch"]) !== !1 && c.push(new DC({
    propagateTraceHeaderCorsUrls: rh(r.tracingOrigins),
    applyCustomAttributesOnSpan: (E, G, O) => $(void 0, null, function* () {
      var W, re, z;
      if (!E.attributes)
        return;
      const q = E;
      if (q.attributes[Ss] === !1)
        return;
      const le = q.attributes["http.url"], b = (W = G.method) != null ? W : "GET";
      if (E.updateName(qd(le, b, G.body)), !(O instanceof Response)) {
        E.setAttributes({
          "http.response.error": O.message,
          "http.response.status": O.status
        });
        return;
      }
      eh(E, G.body, G.headers, r.networkRecordingOptions);
      const v = yield Am(O, (re = r.networkRecordingOptions) == null ? void 0 : re.bodyKeysToRecord, (z = r.networkRecordingOptions) == null ? void 0 : z.networkBodyKeysToRedact);
      E.setAttribute("http.response.body", v);
    })
  })), ((L = r.instrumentations) == null ? void 0 : L["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && c.push(new CZ({
    propagateTraceHeaderCorsUrls: rh(r.tracingOrigins),
    applyCustomAttributesOnSpan: (E, G) => {
      var v, W;
      const O = G;
      if (!E.attributes || E.attributes[Ss] === !1)
        return;
      const le = qd(O._url, O._method, G.responseText);
      E.updateName(le), eh(E, O._body, O._requestHeaders, r.networkRecordingOptions);
      const b = Tt(O._body, (v = r.networkRecordingOptions) == null ? void 0 : v.networkBodyKeysToRedact, (W = r.networkRecordingOptions) == null ? void 0 : W.bodyKeysToRecord, O._requestHeaders);
      E.setAttribute("http.request.body", b);
    }
  }))), YT({ instrumentations: c });
  const f = new wm();
  f.enable(), Ve.tracerProvider.register({
    contextManager: f,
    propagator: new rm({
      propagators: [
        new zp(),
        new bV({
          backendUrl: e,
          otlpEndpoint: r.otlpEndpoint,
          tracingOrigins: r.tracingOrigins,
          urlBlocklist: t
        })
      ]
    })
  });
};
class yV extends Sm {
  onEnd(e) {
    e.attributes[Ss] !== !1 && super.onEnd(e);
  }
}
class bV extends nm {
  constructor(t) {
    super();
    T(this, "highlightEndpoints");
    T(this, "tracingOrigins");
    T(this, "urlBlocklist");
    this.highlightEndpoints = [
      t.backendUrl,
      `${t.otlpEndpoint}/v1/traces`,
      `${t.otlpEndpoint}/v1/logs`,
      `${t.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = t.tracingOrigins, this.urlBlocklist = t.urlBlocklist;
  }
  inject(t, n, i) {
    var a;
    const s = ee.getSpan(t);
    if (!s || !s.attributes)
      return;
    const o = s.attributes["http.url"];
    typeof o == "string" && (RV(o, this.highlightEndpoints, this.tracingOrigins, this.urlBlocklist) || s.setAttribute(Ss, !1), !du(o, (a = this.tracingOrigins) != null ? a : [], this.urlBlocklist)) || super.inject(t, n, i);
  }
}
const vg = "highlight-browser", vV = vg, SV = () => {
  var r;
  return (r = Ve.tracerProvider) == null ? void 0 : r.getTracer(vg);
}, ut = () => {
  var r;
  return (r = Ve.meterProvider) == null ? void 0 : r.getMeter(vV);
}, wV = () => ee.getActiveSpan(), _V = () => $(void 0, null, function* () {
  Ve.tracerProvider ? (yield Ve.tracerProvider.forceFlush(), yield Ve.tracerProvider.shutdown()) : console.warn("OTEL shutdown called without initialized tracerProvider."), Ve.meterProvider ? (yield Ve.meterProvider.forceFlush(), yield Ve.meterProvider.shutdown()) : console.warn("OTEL shutdown called without initialized meterProvider.");
}), qd = (r, e, t) => {
  var a, l, u;
  let n;
  const i = new URL(r), s = i.pathname;
  let o = `${e.toUpperCase()} - ${s}`;
  try {
    if (n = typeof t == "string" ? JSON.parse(t) : t, n && n.query) {
      const c = Il(n.query), d = ((a = c.definitions[0]) == null ? void 0 : a.kind) === "OperationDefinition" ? (u = (l = c.definitions[0]) == null ? void 0 : l.name) == null ? void 0 : u.value : void 0;
      d && (o = `${d} (GraphQL: ${i.host + i.pathname})`);
    }
  } catch (c) {
  }
  return o;
}, eh = (r, e, t, n) => {
  var c;
  const i = typeof e == "string" ? e : String(e);
  if (!r.attributes)
    return;
  const o = r.attributes["http.url"], a = new URL(o);
  let l;
  try {
    l = e ? JSON.parse(i) : void 0, l.operationName && r.setAttribute("graphql.operation.name", l.operationName);
  } catch (d) {
  }
  const u = Xm((c = n == null ? void 0 : n.networkHeadersToRedact) != null ? c : [], t, n == null ? void 0 : n.headerKeysToRecord);
  r.setAttributes({
    "highlight.type": "http.request",
    "http.request.headers": JSON.stringify(u),
    "http.request.body": i,
    [tC]: o,
    [rC]: a.pathname,
    [nC]: a.search
  }), a.searchParams.size > 0 && r.setAttributes({
    // Custom attribute that displays query string params as an object.
    "url.query_params": JSON.stringify(Object.fromEntries(a.searchParams))
  });
}, RV = (r, e, t, n) => n != null && n.some((s) => r.toLowerCase().includes(s)) ? !1 : Ys(r, e), th = (r) => {
  var i, s, o;
  if (!r.events)
    return;
  const t = r.events, n = {
    unload: Xe("unloadEventStart", "unloadEventEnd", t),
    dom_interactive: Xe("fetchStart", "domInteractive", t),
    dom_content_loaded: Xe("domContentLoadedEventStart", "domContentLoadedEventEnd", t),
    dom_complete: Xe("fetchStart", "domComplete", t),
    load_event: Xe("loadEventStart", "loadEventEnd", t),
    document_load: Xe("fetchStart", "loadEventEnd", t),
    first_paint: Xe("fetchStart", "firstPaint", t),
    first_contentful_paint: Xe("fetchStart", "firstContentfulPaint", t),
    domain_lookup: Xe("domainLookupStart", "domainLookupEnd", t),
    connect: Xe("connectStart", "connectEnd", t),
    request: Xe("requestStart", "requestEnd", t),
    response: Xe("responseStart", "responseEnd", t)
  };
  for (const a of (s = (i = lt == null ? void 0 : lt.getIntegrations) == null ? void 0 : i.call(lt)) != null ? s : [])
    n.document_load > 0 && a.recordGauge((o = lt == null ? void 0 : lt.sessionSecureId) != null ? o : "", {
      name: yg,
      value: n.document_load / 1e6
    });
  Object.entries(n).forEach(([a, l]) => {
    l > 0 && (r.setAttribute(`timings.${a}.ns`, l), r.setAttribute(`timings.${a}.readable`, Sg(l)));
  });
};
function Xe(r, e, t) {
  const n = t.find((a) => a.name === r), i = t.find((a) => a.name === e);
  if (!n || !i)
    return 0;
  const s = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - s;
}
const IV = (r, e) => {
  const t = {
    domain_lookup: (e.domainLookupEnd - e.domainLookupStart) * 1e6,
    connect: (e.connectEnd - e.connectStart) * 1e6,
    request: (e.responseEnd - e.requestStart) * 1e6,
    response: (e.responseEnd - e.responseStart) * 1e6
  };
  Object.entries(t).forEach(([n, i]) => {
    i > 0 && (r.setAttribute(`timings.${n}.ns`, i), r.setAttribute(`timings.${n}.readable`, Sg(i)));
  });
}, Sg = (r) => {
  if (r >= 36e11) {
    const o = r / 36e11;
    return `${Number(o.toFixed(1))}h`;
  } else if (r >= 6e10) {
    const o = r / 6e10;
    return `${Number(o.toFixed(1))}m`;
  } else if (r >= 1e9) {
    const o = r / 1e9;
    return `${Number(o.toFixed(1))}s`;
  } else if (r >= 1e6) {
    const o = r / 1e6;
    return `${Number(o.toFixed(1))}ms`;
  } else if (r >= 1e3) {
    const o = r / 1e3;
    return `${Number(o.toFixed(1))}µs`;
  } else
    return `${Number(r.toFixed(1))}ns`;
}, rh = (r) => r === !0 ? [/localhost/, /^\//, new RegExp(window.location.host)] : Array.isArray(r) ? r.map((e) => typeof e == "string" ? new RegExp(e) : e) : /^$/, TV = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var It;
(function(r) {
  r.DeviceMemory = "DeviceMemory", r.ViewportHeight = "ViewportHeight", r.ViewportWidth = "ViewportWidth", r.ScreenHeight = "ScreenHeight", r.ScreenWidth = "ScreenWidth", r.ViewportArea = "ViewportArea";
})(It || (It = {}));
var Ne;
(function(r) {
  r.Device = "Device", r.WebVital = "WebVital", r.Performance = "Performance", r.Frontend = "Frontend", r.Backend = "Backend";
})(Ne || (Ne = {}));
const EV = (r, e, t) => {
  const n = window._highlightWebSocketRequestCallback;
  window._highlightWebSocketRequestCallback = r;
  const i = window._highlightWebSocketEventCallback;
  return window._highlightWebSocketEventCallback = (s) => {
    const d = s, { message: o, size: a } = d, l = Ze(d, ["message", "size"]), c = t.some((h) => s.name.toLowerCase().includes(h)) ? l : s;
    e(c);
  }, () => {
    window._highlightWebSocketRequestCallback = n, window._highlightWebSocketEventCallback = i;
  };
}, CV = ({ xhrCallback: r, fetchCallback: e, webSocketRequestCallback: t, webSocketEventCallback: n, disableWebSocketRecording: i, bodyKeysToRedact: s, highlightEndpoints: o, tracingOrigins: a, urlBlocklist: l, bodyKeysToRecord: u }) => {
  const c = BZ(r, o, a, l, s, u), d = KZ(e, o, a, l, s, u), h = i ? () => {
  } : EV(t, n, l);
  return () => {
    c(), d(), h();
  };
};
class it {
  constructor(e) {
    T(this, "disableConsoleRecording");
    T(this, "reportConsoleErrors");
    T(this, "enablePromisePatch");
    T(this, "consoleMethodsToRecord");
    T(this, "listeners");
    T(this, "errors");
    T(this, "messages");
    // The properties below were added in 4.0.0 (Feb 2022), and are patched in by client via setupNetworkListeners()
    T(this, "options");
    T(this, "hasNetworkRecording", !0);
    T(this, "disableNetworkRecording");
    T(this, "enableRecordingNetworkContents");
    T(this, "xhrNetworkContents");
    T(this, "fetchNetworkContents");
    T(this, "disableRecordingWebSocketContents");
    T(this, "webSocketNetworkContents");
    T(this, "webSocketEventContents");
    T(this, "tracingOrigins");
    T(this, "networkHeadersToRedact");
    T(this, "networkBodyKeysToRedact");
    T(this, "networkBodyKeysToRecord");
    T(this, "networkHeaderKeysToRecord");
    T(this, "lastNetworkRequestTimestamp");
    T(this, "urlBlocklist");
    T(this, "highlightEndpoints");
    T(this, "requestResponseSanitizer");
    var t, n;
    this.options = e, this.disableConsoleRecording = !!e.disableConsoleRecording, this.reportConsoleErrors = (t = e.reportConsoleErrors) != null ? t : !1, this.enablePromisePatch = (n = e.enablePromisePatch) != null ? n : !1, this.consoleMethodsToRecord = e.consoleMethodsToRecord || [
      ...TV
    ], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
  }
  isListening() {
    return this.listeners.length > 0;
  }
  startListening() {
    if (this.isListening())
      return;
    const e = this;
    this.disableConsoleRecording || this.listeners.push(J_((t) => {
      var n, i, s;
      if (this.reportConsoleErrors && (t.type === "Error" || t.type === "error") && t.value && t.trace) {
        const o = Ut(t.value);
        if (Ac.includes(o) || Uc.some((a) => o.includes(a)))
          return;
        e.errors.push({
          event: o,
          type: "console.error",
          url: window.location.href,
          source: (n = t.trace[0]) != null && n.fileName ? t.trace[0].fileName : "",
          lineNumber: (i = t.trace[0]) != null && i.lineNumber ? t.trace[0].lineNumber : 0,
          columnNumber: (s = t.trace[0]) != null && s.columnNumber ? t.trace[0].columnNumber : 0,
          stackTrace: t.trace,
          timestamp: (/* @__PURE__ */ new Date()).toISOString()
        });
      }
      e.messages.push(t);
    }, {
      level: this.consoleMethodsToRecord,
      logger: "console",
      stringifyOptions: {
        depthOfLimit: 10,
        numOfKeysLimit: 100,
        stringLengthLimit: 1e3
      }
    })), this.listeners.push(B_((t) => {
      Ac.includes(t.event) || Uc.some((n) => t.event.includes(n)) || e.errors.push(t);
    }, { enablePromisePatch: this.enablePromisePatch })), this.listeners.push(_V), it.setupNetworkListener(this, this.options);
  }
  stopListening() {
    this.listeners.forEach((e) => e()), this.listeners = [];
  }
  // We define this as a static method because versions earlier than 4.0.0 (Feb 2022) don't have this code.
  // For those versions, calling this from client will monkey-patch the network listeners onto the old FirstLoadListener object.
  static setupNetworkListener(e, t) {
    var s, o, a, l, u, c, d, h, f, m, p, g;
    const n = (t == null ? void 0 : t.backendUrl) || void 0 || "https://pub.highlight.io", i = t.otlpEndpoint || "https://otel.highlight.io";
    e.highlightEndpoints = [
      n,
      `${i}/v1/traces`,
      `${i}/v1/logs`,
      `${i}/v1/metrics`
    ], e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], e.networkHeadersToRedact = [], e.urlBlocklist = [], e.tracingOrigins = t.tracingOrigins || [], (t == null ? void 0 : t.disableNetworkRecording) !== void 0 ? (e.disableNetworkRecording = t == null ? void 0 : t.disableNetworkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = [], e.networkBodyKeysToRecord = []) : typeof (t == null ? void 0 : t.networkRecording) == "boolean" ? (e.disableNetworkRecording = !t.networkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = []) : (((s = t.networkRecording) == null ? void 0 : s.enabled) !== void 0 ? e.disableNetworkRecording = !t.networkRecording.enabled : e.disableNetworkRecording = !1, e.enableRecordingNetworkContents = ((o = t.networkRecording) == null ? void 0 : o.recordHeadersAndBody) || !1, e.disableRecordingWebSocketContents = ((a = t.networkRecording) == null ? void 0 : a.disableWebSocketEventRecordings) || !1, e.networkHeadersToRedact = ((u = (l = t.networkRecording) == null ? void 0 : l.networkHeadersToRedact) == null ? void 0 : u.map((y) => y.toLowerCase())) || [], e.networkBodyKeysToRedact = ((d = (c = t.networkRecording) == null ? void 0 : c.networkBodyKeysToRedact) == null ? void 0 : d.map((y) => y.toLowerCase())) || [], e.urlBlocklist = ((f = (h = t.networkRecording) == null ? void 0 : h.urlBlocklist) == null ? void 0 : f.map((y) => y.toLowerCase())) || [], e.urlBlocklist = [
      ...e.urlBlocklist,
      ...km
    ], e.requestResponseSanitizer = (m = t.networkRecording) == null ? void 0 : m.requestResponseSanitizer, e.networkHeaderKeysToRecord = (p = t.networkRecording) == null ? void 0 : p.headerKeysToRecord, e.networkHeaderKeysToRecord && (e.networkHeadersToRedact = [], e.networkHeaderKeysToRecord = e.networkHeaderKeysToRecord.map((y) => y.toLocaleLowerCase())), e.networkBodyKeysToRecord = (g = t.networkRecording) == null ? void 0 : g.bodyKeysToRecord, e.networkBodyKeysToRecord && (e.networkBodyKeysToRedact = [], e.networkBodyKeysToRecord = e.networkBodyKeysToRecord.map((y) => y.toLocaleLowerCase()))), !e.disableNetworkRecording && e.enableRecordingNetworkContents && e.listeners.push(CV({
      xhrCallback: (y) => {
        e.xhrNetworkContents.push(y);
      },
      fetchCallback: (y) => {
        e.fetchNetworkContents.push(y);
      },
      webSocketRequestCallback: (y) => {
        e.webSocketNetworkContents && e.webSocketNetworkContents.push(y);
      },
      webSocketEventCallback: (y) => {
        e.webSocketEventContents.push(y);
      },
      disableWebSocketRecording: e.disableRecordingWebSocketContents,
      bodyKeysToRedact: e.networkBodyKeysToRedact,
      highlightEndpoints: e.highlightEndpoints,
      tracingOrigins: e.tracingOrigins,
      urlBlocklist: e.urlBlocklist,
      bodyKeysToRecord: e.networkBodyKeysToRecord
    }));
  }
  static getRecordedNetworkResources(e, t) {
    var s, o;
    let n = [], i = [];
    if (!e.disableNetworkRecording) {
      const a = ((s = window == null ? void 0 : window.performance) == null ? void 0 : s.timeOrigin) || 0;
      n = performance.getEntriesByType("resource");
      const l = (t - a) * 2;
      if (n = n.filter((u) => u.responseEnd < e.lastNetworkRequestTimestamp ? !1 : Ys(u.name, e.highlightEndpoints)).map((u) => M(I({}, u.toJSON()), {
        offsetStartTime: u.startTime - l,
        offsetResponseEnd: u.responseEnd - l,
        offsetFetchStart: u.fetchStart - l
      })), e.lastNetworkRequestTimestamp = ((o = n.at(-1)) == null ? void 0 : o.responseEnd) || e.lastNetworkRequestTimestamp, e.enableRecordingNetworkContents) {
        const u = {
          headersToRedact: e.networkHeadersToRedact,
          headersToRecord: e.networkHeaderKeysToRecord,
          requestResponseSanitizer: e.requestResponseSanitizer
        };
        n = Id(n, e.xhrNetworkContents, "xmlhttprequest", u), n = Id(n, e.fetchNetworkContents, "fetch", u);
      }
    }
    return e.disableRecordingWebSocketContents || (i = e.webSocketNetworkContents || []), [...n, ...i];
  }
  static getRecordedWebSocketEvents(e) {
    let t = [];
    return !e.disableNetworkRecording && !e.disableRecordingWebSocketContents && (t = e.webSocketEventContents), t;
  }
  static clearRecordedNetworkResources(e) {
    e.disableNetworkRecording || (e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], performance.clearResourceTimings());
  }
}
const ZV = (r) => {
  r(window.location.href);
  const e = history.pushState;
  history.pushState = /* @__PURE__ */ ((s) => function() {
    var a = s.apply(this, arguments);
    return window.dispatchEvent(new Event("pushstate")), window.dispatchEvent(new Event("locationchange")), a;
  })(history.pushState);
  const t = history.replaceState;
  history.replaceState = /* @__PURE__ */ ((s) => function() {
    var a = s.apply(this, arguments);
    return window.dispatchEvent(new Event("replacestate")), window.dispatchEvent(new Event("locationchange")), a;
  })(history.replaceState);
  const n = () => {
    window.dispatchEvent(new Event("locationchange"));
  };
  window.addEventListener("popstate", n);
  const i = function() {
    r(window.location.href);
  };
  return window.addEventListener("locationchange", i), () => {
    window.removeEventListener("popstate", n), window.removeEventListener("locationchange", i), history.pushState = e, history.replaceState = t;
  };
}, GV = (r) => {
  switch (r) {
    case "strict":
      return [!0, void 0];
    case "default":
      return [!0, void 0];
    case "none":
      return [!1, { password: !0 }];
  }
};
var Ct;
(function(r) {
  r[r.All = 0] = "All", r[r.Two = 1] = "Two", r[r.One = 2] = "One";
})(Ct || (Ct = {}));
let Ue, mu;
function wg(r, e) {
  return r.nodeType, Node.ELEMENT_NODE, gl(r);
  return LV(r, e);
}
function _g(r) {
  if (r.id.length)
    return `#${r.id}`;
  if (r.classList.length) {
    let e = [];
    for (const t of r.classList)
      e.push(`.${t}`);
    return `${r.nodeName.toLowerCase()}${e.join(",")}`;
  }
  return r.nodeName.toLowerCase();
}
function LV(r, e) {
  if (r.tagName.toLowerCase() === "html")
    return "html";
  try {
    const t = {
      root: document.body,
      idName: (i) => !0,
      className: (i) => !0,
      tagName: (i) => !0,
      attr: (i, s) => !1,
      seedMinLength: 1,
      optimizedMinLength: 2,
      threshold: 50,
      maxNumberOfTries: 1e3,
      optimized: !0
    };
    Ue = I(I({}, t), e), mu = NV(Ue.root, t);
    let n = jo(r, Ct.All, () => jo(r, Ct.Two, () => jo(r, Ct.One)));
    if (n) {
      if (Ue.optimized) {
        const i = Tg(Eg(n, r));
        i.length > 0 && (n = i[0]);
      }
      return Js(n);
    } else
      return gl(r);
  } catch (t) {
    return gl(r);
  }
}
function NV(r, e) {
  return r.nodeType === Node.DOCUMENT_NODE ? r : r === e.root ? r.ownerDocument : r;
}
function jo(r, e, t) {
  let n = null, i = [], s = r, o = 0;
  for (; s && s !== Ue.root.parentElement; ) {
    let a = Zi(VV(s)) || Zi(...xV(s)) || Zi(...OV(s)) || Zi(WV(s)) || [XV()];
    const l = kV(s);
    if (e === Ct.All)
      l && (a = a.concat(a.filter($o).map((u) => Qo(u, l))));
    else if (e === Ct.Two)
      a = a.slice(0, 1), l && (a = a.concat(a.filter($o).map((u) => Qo(u, l))));
    else if (e === Ct.One) {
      const [u] = a = a.slice(0, 1);
      l && $o(u) && (a = [Qo(u, l)]);
    }
    for (let u of a)
      u.level = o;
    if (i.push(a), i.length >= Ue.seedMinLength && (n = nh(i, t), n))
      break;
    s = s.parentElement, o++;
  }
  return n || (n = nh(i, t)), n;
}
function nh(r, e) {
  const t = Tg(Ig(r));
  if (t.length > Ue.threshold)
    return e ? e() : null;
  for (let n of t)
    if (Rg(n))
      return n;
  return null;
}
function Js(r) {
  let e = r[0], t = e.name;
  for (let n = 1; n < r.length; n++) {
    const i = r[n].level || 0;
    e.level === i - 1 ? t = `${r[n].name} > ${t}` : t = `${r[n].name} ${t}`, e = r[n];
  }
  return t;
}
function ih(r) {
  return r.map((e) => e.penalty).reduce((e, t) => e + t, 0);
}
function Rg(r) {
  switch (mu.querySelectorAll(Js(r)).length) {
    case 0:
      return !0;
    case 1:
      return !0;
    default:
      return !1;
  }
}
function VV(r) {
  const e = r.getAttribute("id");
  return e && Ue.idName(e) ? {
    name: "#" + ws(e, { isIdentifier: !0 }),
    penalty: 0
  } : null;
}
function xV(r) {
  return Array.from(r.attributes).filter((t) => Ue.attr(t.name, t.value)).map((t) => ({
    name: "[" + ws(t.name, { isIdentifier: !0 }) + '="' + ws(t.value) + '"]',
    penalty: 0.5
  }));
}
function OV(r) {
  return Array.from(r.classList).filter(Ue.className).map((t) => ({
    name: "." + ws(t, { isIdentifier: !0 }),
    penalty: 1
  }));
}
function WV(r) {
  const e = r.tagName.toLowerCase();
  return Ue.tagName(e) ? {
    name: e,
    penalty: 2
  } : null;
}
function XV() {
  return {
    name: "*",
    penalty: 3
  };
}
function kV(r) {
  const e = r.parentNode;
  if (!e)
    return null;
  let t = e.firstChild;
  if (!t)
    return null;
  let n = 0;
  for (; t && (t.nodeType === Node.ELEMENT_NODE && n++, t !== r); )
    t = t.nextSibling;
  return n;
}
function Qo(r, e) {
  return {
    name: r.name + `:nth-child(${e})`,
    penalty: r.penalty + 1
  };
}
function $o(r) {
  return r.name !== "html" && !r.name.startsWith("#");
}
function Zi(...r) {
  const e = r.filter(PV);
  return e.length > 0 ? e : null;
}
function PV(r) {
  return r != null;
}
function* Ig(r, e = []) {
  if (r.length > 0)
    for (let t of r[0])
      yield* to(Ig(r.slice(1, r.length), e.concat(t)));
  else
    yield e;
}
function Tg(r) {
  return Array.from(r).sort((e, t) => ih(e) - ih(t));
}
function* Eg(r, e, t = {
  counter: 0,
  visited: /* @__PURE__ */ new Map()
}) {
  if (r.length > 2 && r.length > Ue.optimizedMinLength)
    for (let n = 1; n < r.length - 1; n++) {
      if (t.counter > Ue.maxNumberOfTries)
        return;
      t.counter += 1;
      const i = [...r];
      i.splice(n, 1);
      const s = Js(i);
      if (t.visited.has(s))
        return;
      Rg(i) && MV(i, e) && (yield i, t.visited.set(s, !0), yield* to(Eg(i, e, t)));
    }
}
function MV(r, e) {
  return mu.querySelector(Js(r)) === e;
}
const AV = /[ -,\.\/:-@\[-\^`\{-~]/, UV = /[ -,\.\/:-@\[\]\^`\{-~]/, YV = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, FV = {
  escapeEverything: !1,
  isIdentifier: !1,
  quotes: "single",
  wrap: !1
};
function ws(r, e = {}) {
  const t = I(I({}, FV), e);
  t.quotes != "single" && t.quotes != "double" && (t.quotes = "single");
  const n = t.quotes == "double" ? '"' : "'", i = t.isIdentifier, s = r.charAt(0);
  let o = "", a = 0;
  const l = r.length;
  for (; a < l; ) {
    const u = r.charAt(a++);
    let c = u.charCodeAt(0), d;
    if (c < 32 || c > 126) {
      if (c >= 55296 && c <= 56319 && a < l) {
        const h = r.charCodeAt(a++);
        (h & 64512) == 56320 ? c = ((c & 1023) << 10) + (h & 1023) + 65536 : a--;
      }
      d = "\\" + c.toString(16).toUpperCase() + " ";
    } else
      t.escapeEverything ? AV.test(u) ? d = "\\" + u : d = "\\" + c.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(u) ? d = "\\" + c.toString(16).toUpperCase() + " " : u == "\\" || !i && (u == '"' && n == u || u == "'" && n == u) || i && UV.test(u) ? d = "\\" + u : d = u;
    o += d;
  }
  return i && (/^-[-\d]/.test(o) ? o = "\\-" + o.slice(1) : /\d/.test(s) && (o = "\\3" + s + " " + o.slice(1))), o = o.replace(YV, function(u, c, d) {
    return c && c.length % 2 ? u : (c || "") + d;
  }), !i && t.wrap ? n + o + n : o;
}
const gl = (r) => {
  let e = "";
  const t = r.getAttribute("class"), n = r.getAttribute("id");
  return n && (e = e.concat(sh(n, "#"))), t && (e = e.concat(sh(t, "."))), e === "" && (e = e.concat(r.tagName.toLowerCase())), e;
}, sh = (r, e) => `${e}${r.trim().split(" ").join(e)}`, HV = (r) => {
  const e = (t) => {
    if (t.target) {
      const n = t.target, i = wg(n);
      r(i, t);
    }
  };
  return window.addEventListener("click", e), () => window.removeEventListener("click", e);
}, JV = (r) => {
  const e = (t) => {
    if (t.target) {
      const n = wg(t.target);
      r(n);
    }
  };
  return window.addEventListener("focusin", e), () => window.removeEventListener("focusin", e);
}, BV = 30, DV = () => new Promise((r) => requestAnimationFrame((e) => requestAnimationFrame((t) => r(t - e)))), KV = () => $(void 0, null, function* () {
  const r = [];
  for (let e = 0; e < BV; e++)
    r.push(yield DV());
  return r.reduce((e, t) => e + t, 0) / r.length;
}), zV = (r, e) => {
  let t = {}, n = 16.666666666666668;
  KV().then((l) => n = l);
  const i = (l) => {
    var u;
    t != null && t.event || (t = {
      event: l,
      location: window.location.href,
      timerStart: (u = window.performance) == null ? void 0 : u.now()
    }, window.requestAnimationFrame(s));
  }, s = () => {
    if (!(t != null && t.timerStart))
      return;
    const l = window.performance.now() - t.timerStart - n;
    o(l), t = {};
  }, o = (l) => {
    const u = ((/* @__PURE__ */ new Date()).getTime() - e) / 1e3;
    r({
      relativeTimestamp: u,
      jankAmount: l,
      querySelector: a(),
      newLocation: window.location.href != t.location ? window.location.href : void 0
    });
  }, a = () => {
    var l;
    return (l = t == null ? void 0 : t.event) != null && l.target ? _g(t.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, jV = (r) => {
  let e, t;
  if (typeof document.hidden != "undefined" ? (e = "hidden", t = "visibilitychange") : typeof document.msHidden != "undefined" ? (e = "msHidden", t = "msvisibilitychange") : typeof document.webkitHidden != "undefined" && (e = "webkitHidden", t = "webkitvisibilitychange"), t === void 0)
    return () => {
    };
  if (e === void 0)
    return () => {
    };
  const n = e, i = () => {
    const o = document[n];
    r(!!o);
  };
  document.addEventListener(t, i);
  const s = t;
  return () => document.removeEventListener(s, i);
}, QV = typeof window != "undefined", oh = QV && "performance" in window && "memory" in performance ? performance : { memory: {} }, $V = (r, e) => {
  let t = 0, n = 0;
  const i = () => {
    const c = ((/* @__PURE__ */ new Date()).getTime() - e) / 1e3, d = oh.memory.jsHeapSizeLimit || 0, h = oh.memory.usedJSHeapSize || 0;
    r({
      jsHeapSizeLimit: d,
      usedJSHeapSize: h,
      relativeTimestamp: c,
      fps: t
    });
  };
  i();
  let s;
  s = setInterval(() => {
    i();
  }, 1e3);
  let o = 0, a = Date.now();
  const l = function() {
    var u = Date.now();
    o++, u > 1e3 + a && (t = Math.round(o * 1e3 / (u - a)), o = 0, a = u), n = requestAnimationFrame(l);
  };
  return l(), () => {
    clearInterval(s), cancelAnimationFrame(n);
  };
};
var Zt;
(function(r) {
  r.USER_ID = "ajs_user_id", r.USER_TRAITS = "ajs_user_traits", r.ANONYMOUS_ID = "ajs_anonymous_id";
})(Zt || (Zt = {}));
const qV = (r) => {
  r(window.location.href);
  var e = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(s) {
    setTimeout(() => {
      var a;
      var o;
      try {
        o = JSON.parse((a = s == null ? void 0 : s.toString()) != null ? a : "");
      } catch (l) {
        return;
      }
      (o.type === "track" || o.type === "identify") && qo(o) && r(o);
    }, 100), e.call(this, s);
  };
  const t = (s) => {
    if (s.key === Zt.USER_ID || s.key === Zt.ANONYMOUS_ID || s.key === Zt.USER_TRAITS) {
      const { userId: o, userTraits: a } = ah();
      if (o) {
        let l = {};
        a && (l = JSON.parse(a));
        const u = {
          type: "identify",
          userId: o.toString(),
          traits: l
        };
        qo(u) && r(u);
      }
    }
  }, { userId: n, userTraits: i } = ah();
  if (n) {
    let s = {};
    i && (s = JSON.parse(i));
    const o = {
      type: "identify",
      userId: n.toString(),
      traits: s
    };
    qo(o) && r(o);
  }
  return window.addEventListener("storage", t), XZ(({ keyName: s }) => {
    t({
      key: s
    });
  }), () => {
    window.removeEventListener("storage", t), XMLHttpRequest.prototype.send = e;
  };
}, ah = () => {
  const r = Ae(Zt.USER_ID), e = Ae(Zt.USER_TRAITS), t = Ae(Zt.ANONYMOUS_ID);
  return {
    userId: r,
    userTraits: e,
    anonymousId: t
  };
}, qo = (r) => {
  if (!r)
    return !1;
  let e = "";
  try {
    e = JSON.stringify(r);
  } catch (i) {
    return !1;
  }
  const t = ex(e), n = Ae(Te.SEGMENT_LAST_SENT_HASH_KEY);
  return n === void 0 || t !== n ? (pt(Te.SEGMENT_LAST_SENT_HASH_KEY, t), !0) : !1;
}, ex = (r) => {
  var e = 0, t = r.length, n = 0;
  if (t > 0)
    for (; n < t; )
      e = (e << 5) - e + r.charCodeAt(n++) | 0;
  return e.toString();
}, tx = (r, e) => {
  const t = rx(r);
  let n = [];
  const i = !1, s = !0;
  for (let o = 0; o < t.length; o++) {
    let a = t[o].split("+");
    n = [], a.length > 1 && (n = sx(Cg, a)), a = a[a.length - 1], a = a === "*" ? "*" : ix(a), a in rt || (rt[a] = []), rt[a].push({
      mods: n,
      shortcut: t[o],
      key: t[o],
      method: e,
      keyup: i,
      keydown: s,
      scope: "all",
      splitKey: "+"
    });
  }
  ox(document, "keydown", (o) => {
    lx(o);
  });
};
let Re = [];
function rx(r) {
  typeof r != "string" && (r = ""), r = r.replace(/\s/g, "");
  const e = r.split(",");
  let t = e.lastIndexOf("");
  for (; t >= 0; )
    e[t - 1] += ",", e.splice(t, 1), t = e.lastIndexOf("");
  return e;
}
const rt = {}, ea = typeof navigator != "undefined" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1, nx = {
  backspace: 8,
  tab: 9,
  clear: 12,
  enter: 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": ea ? 173 : 189,
  "=": ea ? 61 : 187,
  ";": ea ? 59 : 186,
  "'": 222,
  "[": 219,
  "]": 221,
  "\\": 220
}, lh = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, Ie = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, Cg = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  command: 91
}, ix = (r) => (
  // @ts-expect-error
  nx[r.toLowerCase()] || // @ts-expect-error
  Cg[r.toLowerCase()] || r.toUpperCase().charCodeAt(0)
);
function sx(r, e) {
  const t = e.slice(0, e.length - 1);
  for (let n = 0; n < t.length; n++)
    t[n] = r[t[n].toLowerCase()];
  return t;
}
function ox(r, e, t) {
  r.addEventListener ? r.addEventListener(e, t, !1) : r.attachEvent && r.attachEvent(`on${e}`, () => {
    t(window.event);
  });
}
function ax(r, e, t) {
  let n;
  if (e.scope === t || e.scope === "all") {
    n = e.mods.length > 0;
    for (const i in Ie)
      Object.prototype.hasOwnProperty.call(Ie, i) && // @ts-expect-error
      (!Ie[i] && e.mods.indexOf(+i) > -1 || // @ts-expect-error
      Ie[i] && e.mods.indexOf(+i) === -1) && (n = !1);
    (e.mods.length === 0 && !Ie[16] && !Ie[18] && !Ie[17] && !Ie[91] || n || e.shortcut === "*") && e.method(r, e) === !1 && (r.preventDefault ? r.preventDefault() : r.returnValue = !1, r.stopPropagation && r.stopPropagation(), r.cancelBubble && (r.cancelBubble = !0));
  }
}
function lx(r) {
  const e = rt["*"];
  let t = r.keyCode || r.which || r.charCode;
  if ((t === 93 || t === 224) && (t = 91), Re.indexOf(t) === -1 && t !== 229 && Re.push(t), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach((n) => {
    const i = lh[n];
    r[n] && Re.indexOf(i) === -1 ? Re.push(i) : !r[n] && Re.indexOf(i) > -1 ? Re.splice(Re.indexOf(i), 1) : n === "metaKey" && r[n] && Re.length === 3 && (r.ctrlKey || r.shiftKey || r.altKey || (Re = Re.slice(Re.indexOf(i))));
  }), !(t in Ie && (Ie[t] = !0, !e))) {
    for (const n in Ie)
      Object.prototype.hasOwnProperty.call(Ie, n) && (Ie[n] = r[lh[n]]);
    if (r.getModifierState && !(r.altKey && !r.ctrlKey) && r.getModifierState("AltGraph") && (Re.indexOf(17) === -1 && Re.push(17), Re.indexOf(18) === -1 && Re.push(18), Ie[17] = !0, Ie[18] = !0), t in rt) {
      for (let n = 0; n < rt[t].length; n++)
        if (
          // @ts-expect-error
          (r.type === "keydown" && rt[t][n].keydown || // @ts-expect-error
          r.type === "keyup" && rt[t][n].keyup) && rt[t][n].key
        ) {
          const i = rt[t][n];
          ax(r, i, "all");
        }
    }
  }
}
const ux = (r) => {
  let e;
  const n = () => {
    clearTimeout(e), e = setTimeout(() => {
      var i, s;
      r({
        height: window.innerHeight,
        width: window.innerWidth,
        availHeight: window.screen.availHeight,
        availWidth: window.screen.availWidth,
        colorDepth: window.screen.colorDepth,
        pixelDepth: window.screen.pixelDepth,
        orientation: (s = (i = window.screen.orientation) == null ? void 0 : i.angle) != null ? s : 0
      });
    }, 500);
  };
  return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
};
var Et, hn, Zg, _s, yl, Gg = -1, tr = function(r) {
  addEventListener("pageshow", function(e) {
    e.persisted && (Gg = e.timeStamp, r(e));
  }, !0);
}, gu = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, Bs = function() {
  var r = gu();
  return r && r.activationStart || 0;
}, Ye = function(r, e) {
  var t = gu(), n = "navigate";
  return Gg >= 0 ? n = "back-forward-cache" : t && (document.prerendering || Bs() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : t.type && (n = t.type.replace(/_/g, "-"))), { name: r, value: e === void 0 ? -1 : e, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, xr = function(r, e, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(r)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          e(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: r, buffered: !0 }, t || {})), n;
    }
  } catch (i) {
  }
}, Fe = function(r, e, t, n) {
  var i, s;
  return function(o) {
    e.value >= 0 && (o || n) && ((s = e.value - (i || 0)) || i === void 0) && (i = e.value, e.delta = s, e.rating = function(a, l) {
      return a > l[1] ? "poor" : a > l[0] ? "needs-improvement" : "good";
    }(e.value, t), r(e));
  };
}, yu = function(r) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return r();
    });
  });
}, Ds = function(r) {
  var e = function(t) {
    t.type !== "pagehide" && document.visibilityState !== "hidden" || r(t);
  };
  addEventListener("visibilitychange", e, !0), addEventListener("pagehide", e, !0);
}, bu = function(r) {
  var e = !1;
  return function(t) {
    e || (r(t), e = !0);
  };
}, mr = -1, uh = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Rs = function(r) {
  document.visibilityState === "hidden" && mr > -1 && (mr = r.type === "visibilitychange" ? r.timeStamp : 0, cx());
}, ch = function() {
  addEventListener("visibilitychange", Rs, !0), addEventListener("prerenderingchange", Rs, !0);
}, cx = function() {
  removeEventListener("visibilitychange", Rs, !0), removeEventListener("prerenderingchange", Rs, !0);
}, vu = function() {
  return mr < 0 && (mr = uh(), ch(), tr(function() {
    setTimeout(function() {
      mr = uh(), ch();
    }, 0);
  })), { get firstHiddenTime() {
    return mr;
  } };
}, An = function(r) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return r();
  }, !0) : r();
}, dh = [1800, 3e3], Lg = function(r, e) {
  e = e || {}, An(function() {
    var t, n = vu(), i = Ye("FCP"), s = xr("paint", function(o) {
      o.forEach(function(a) {
        a.name === "first-contentful-paint" && (s.disconnect(), a.startTime < n.firstHiddenTime && (i.value = Math.max(a.startTime - Bs(), 0), i.entries.push(a), t(!0)));
      });
    });
    s && (t = Fe(r, i, dh, e.reportAllChanges), tr(function(o) {
      i = Ye("FCP"), t = Fe(r, i, dh, e.reportAllChanges), yu(function() {
        i.value = performance.now() - o.timeStamp, t(!0);
      });
    }));
  });
}, hh = [0.1, 0.25], dx = function(r, e) {
  e = e || {}, Lg(bu(function() {
    var t, n = Ye("CLS", 0), i = 0, s = [], o = function(l) {
      l.forEach(function(u) {
        if (!u.hadRecentInput) {
          var c = s[0], d = s[s.length - 1];
          i && u.startTime - d.startTime < 1e3 && u.startTime - c.startTime < 5e3 ? (i += u.value, s.push(u)) : (i = u.value, s = [u]);
        }
      }), i > n.value && (n.value = i, n.entries = s, t());
    }, a = xr("layout-shift", o);
    a && (t = Fe(r, n, hh, e.reportAllChanges), Ds(function() {
      o(a.takeRecords()), t(!0);
    }), tr(function() {
      i = 0, n = Ye("CLS", 0), t = Fe(r, n, hh, e.reportAllChanges), yu(function() {
        return t();
      });
    }), setTimeout(t, 0));
  }));
}, en = { passive: !0, capture: !0 }, hx = /* @__PURE__ */ new Date(), fh = function(r, e) {
  Et || (Et = e, hn = r, Zg = /* @__PURE__ */ new Date(), Vg(removeEventListener), Ng());
}, Ng = function() {
  if (hn >= 0 && hn < Zg - hx) {
    var r = { entryType: "first-input", name: Et.type, target: Et.target, cancelable: Et.cancelable, startTime: Et.timeStamp, processingStart: Et.timeStamp + hn };
    _s.forEach(function(e) {
      e(r);
    }), _s = [];
  }
}, fx = function(r) {
  if (r.cancelable) {
    var e = (r.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - r.timeStamp;
    r.type == "pointerdown" ? function(t, n) {
      var i = function() {
        fh(t, n), o();
      }, s = function() {
        o();
      }, o = function() {
        removeEventListener("pointerup", i, en), removeEventListener("pointercancel", s, en);
      };
      addEventListener("pointerup", i, en), addEventListener("pointercancel", s, en);
    }(e, r) : fh(e, r);
  }
}, Vg = function(r) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(e) {
    return r(e, fx, en);
  });
}, ph = [100, 300], px = function(r, e) {
  e = e || {}, An(function() {
    var t, n = vu(), i = Ye("FID"), s = function(l) {
      l.startTime < n.firstHiddenTime && (i.value = l.processingStart - l.startTime, i.entries.push(l), t(!0));
    }, o = function(l) {
      l.forEach(s);
    }, a = xr("first-input", o);
    t = Fe(r, i, ph, e.reportAllChanges), a && Ds(bu(function() {
      o(a.takeRecords()), a.disconnect();
    })), a && tr(function() {
      var l;
      i = Ye("FID"), t = Fe(r, i, ph, e.reportAllChanges), _s = [], hn = -1, Et = null, Vg(addEventListener), l = s, _s.push(l), Ng();
    });
  });
}, xg = 0, ta = 1 / 0, Gi = 0, mx = function(r) {
  r.forEach(function(e) {
    e.interactionId && (ta = Math.min(ta, e.interactionId), Gi = Math.max(Gi, e.interactionId), xg = Gi ? (Gi - ta) / 7 + 1 : 0);
  });
}, Og = function() {
  return yl ? xg : performance.interactionCount || 0;
}, gx = function() {
  "interactionCount" in performance || yl || (yl = xr("event", mx, { type: "event", buffered: !0, durationThreshold: 0 }));
}, mh = [200, 500], Wg = 0, gh = function() {
  return Og() - Wg;
}, st = [], ra = {}, yh = function(r) {
  var e = st[st.length - 1], t = ra[r.interactionId];
  if (t || st.length < 10 || r.duration > e.latency) {
    if (t) t.entries.push(r), t.latency = Math.max(t.latency, r.duration);
    else {
      var n = { id: r.interactionId, latency: r.duration, entries: [r] };
      ra[n.id] = n, st.push(n);
    }
    st.sort(function(i, s) {
      return s.latency - i.latency;
    }), st.splice(10).forEach(function(i) {
      delete ra[i.id];
    });
  }
}, yx = function(r, e) {
  e = e || {}, An(function() {
    var t;
    gx();
    var n, i = Ye("INP"), s = function(a) {
      a.forEach(function(c) {
        c.interactionId && yh(c), c.entryType === "first-input" && !st.some(function(d) {
          return d.entries.some(function(h) {
            return c.duration === h.duration && c.startTime === h.startTime;
          });
        }) && yh(c);
      });
      var l, u = (l = Math.min(st.length - 1, Math.floor(gh() / 50)), st[l]);
      u && u.latency !== i.value && (i.value = u.latency, i.entries = u.entries, n());
    }, o = xr("event", s, { durationThreshold: (t = e.durationThreshold) !== null && t !== void 0 ? t : 40 });
    n = Fe(r, i, mh, e.reportAllChanges), o && ("interactionId" in PerformanceEventTiming.prototype && o.observe({ type: "first-input", buffered: !0 }), Ds(function() {
      s(o.takeRecords()), i.value < 0 && gh() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), tr(function() {
      st = [], Wg = Og(), i = Ye("INP"), n = Fe(r, i, mh, e.reportAllChanges);
    }));
  });
}, bh = [2500, 4e3], na = {}, bx = function(r, e) {
  e = e || {}, An(function() {
    var t, n = vu(), i = Ye("LCP"), s = function(l) {
      var u = l[l.length - 1];
      u && u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - Bs(), 0), i.entries = [u], t());
    }, o = xr("largest-contentful-paint", s);
    if (o) {
      t = Fe(r, i, bh, e.reportAllChanges);
      var a = bu(function() {
        na[i.id] || (s(o.takeRecords()), o.disconnect(), na[i.id] = !0, t(!0));
      });
      ["keydown", "click"].forEach(function(l) {
        addEventListener(l, function() {
          return setTimeout(a, 0);
        }, !0);
      }), Ds(a), tr(function(l) {
        i = Ye("LCP"), t = Fe(r, i, bh, e.reportAllChanges), yu(function() {
          i.value = performance.now() - l.timeStamp, na[i.id] = !0, t(!0);
        });
      });
    }
  });
}, vh = [800, 1800], vx = function r(e) {
  document.prerendering ? An(function() {
    return r(e);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return r(e);
  }, !0) : setTimeout(e, 0);
}, Sx = function(r, e) {
  e = e || {};
  var t = Ye("TTFB"), n = Fe(r, t, vh, e.reportAllChanges);
  vx(function() {
    var i = gu();
    if (i) {
      var s = i.responseStart;
      if (s <= 0 || s > performance.now()) return;
      t.value = Math.max(s - Bs(), 0), t.entries = [i], n(!0), tr(function() {
        t = Ye("TTFB", 0), (n = Fe(r, t, vh, e.reportAllChanges))(!0);
      });
    }
  });
};
const wx = (r) => (dx(r), Lg(r), px(r), bx(r), Sx(r), yx(r), () => {
}), or = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, _x = (r, e) => {
  const t = () => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - e) / 1e3;
    r({
      relativeTimestamp: s,
      downlink: or.downlink,
      downlinkMax: or.downlinkMax,
      effectiveType: or.effectiveType,
      rtt: or.rtt,
      saveData: or.saveData,
      type: or.type
    });
  };
  t();
  let n;
  return n = setInterval(() => {
    t();
  }, 1e3), () => {
    clearInterval(n);
  };
};
class Rx {
  constructor(e, t) {
    T(this, "debug");
    T(this, "name");
    this.debug = e, this.name = t;
  }
  log(...e) {
    if (this.debug) {
      let t = `[${Date.now()}]`;
      this.name && (t += ` - ${this.name}`), console.log.apply(console, [t, ...e]);
    }
  }
}
const Sh = "iframe parent ready", wh = "iframe ok", Nn = "highlightLogs", Ix = (r) => {
  let e = Ae(Nn) || "";
  e = e + "[" + (/* @__PURE__ */ new Date()).getTime() + "] " + r + `
`, pt(Nn, e);
}, Tx = () => Ae(Nn) || "", Ex = (r) => {
  if (!r)
    return;
  let e = Ae(Nn) || "";
  e && (e.startsWith(r) ? (e = e.slice(r.length), pt(Nn, e)) : Ix("Unable to clear logs " + r.replace(`
`, " ") + " from " + e.replace(`
`, " ")));
}, Cx = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const r = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: Zx(navigator.deviceMemory || 0)
    }),
    getCurrentDeviceDetails: () => {
      const n = ia(r.memory.jsHeapSizeLimit), i = ia(r.memory.totalJSHeapSize), s = ia(r.memory.usedJSHeapSize);
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: i,
        usedJSHeapSize: s
      };
    }
  };
}, ia = (r) => r / Math.pow(1e3, 2), Zx = (r) => 1024 * r, fn = () => {
  var s;
  const e = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var t = "";
  const n = typeof window != "undefined" && ((s = window.crypto) == null ? void 0 : s.getRandomValues), i = new Uint32Array(28);
  n && window.crypto.getRandomValues(i);
  for (let o = 0; o < 28; o++)
    n ? t += e.charAt(i[o] % e.length) : t += e.charAt(Math.floor(Math.random() * e.length));
  return t;
}, Xg = "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", Gx = (r) => Uint8Array.from(atob(r), (e) => e.charCodeAt(0)), _h = typeof self != "undefined" && self.Blob && new Blob([Gx(Xg)], { type: "text/javascript;charset=utf-8" });
function Lx(r) {
  let e;
  try {
    if (e = _h && (self.URL || self.webkitURL).createObjectURL(_h), !e) throw "";
    const t = new Worker(e, {
      name: r == null ? void 0 : r.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), t;
  } catch (t) {
    return new Worker(
      "data:text/javascript;base64," + Xg,
      {
        name: r == null ? void 0 : r.name
      }
    );
  } finally {
    e && (self.URL || self.webkitURL).revokeObjectURL(e);
  }
}
var et;
(function(r) {
  r[r.Initialize = 0] = "Initialize", r[r.AsyncEvents = 1] = "AsyncEvents", r[r.Identify = 2] = "Identify", r[r.Properties = 3] = "Properties", r[r.Metrics = 4] = "Metrics", r[r.Feedback = 5] = "Feedback", r[r.CustomEvent = 6] = "CustomEvent", r[r.Stop = 7] = "Stop";
})(et || (et = {}));
const cr = (r, e) => {
  console.warn(`Highlight Warning: (${r}): `, { output: e });
};
var Is;
(function(r) {
  r.CLIENT_ID = "highlightClientID";
})(Is || (Is = {}));
class Su {
  constructor(e, t) {
    T(this, "options");
    /** Determines if the client is running on a Highlight property (e.g. frontend). */
    T(this, "isRunningOnHighlight");
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    T(this, "organizationID");
    T(this, "graphqlSDK");
    T(this, "events");
    T(this, "sessionData");
    T(this, "ready");
    T(this, "manualStopped");
    T(this, "state");
    T(this, "logger");
    T(this, "enableSegmentIntegration");
    T(this, "privacySetting");
    T(this, "enableCanvasRecording");
    T(this, "enablePerformanceRecording");
    T(this, "samplingStrategy");
    T(this, "inlineImages");
    T(this, "inlineVideos");
    T(this, "inlineStylesheet");
    T(this, "debugOptions");
    T(this, "listeners");
    T(this, "firstloadVersion");
    T(this, "environment");
    T(this, "sessionShortcut");
    /** The end-user's app version. This isn't Highlight's version. */
    T(this, "appVersion");
    T(this, "serviceName");
    T(this, "_worker");
    T(this, "_optionsInternal");
    T(this, "_backendUrl");
    T(this, "_recordingStartTime");
    T(this, "_isOnLocalHost");
    T(this, "_onToggleFeedbackFormVisibility");
    T(this, "_firstLoadListeners");
    T(this, "_isCrossOriginIframe");
    T(this, "_eventBytesSinceSnapshot");
    T(this, "_lastSnapshotTime");
    T(this, "_lastVisibilityChangeTime");
    T(this, "pushPayloadTimerId");
    T(this, "hasSessionUnloaded");
    T(this, "hasPushedData");
    T(this, "reloaded");
    T(this, "_hasPreviouslyInitialized");
    T(this, "_recordStop");
    T(this, "_gauges", /* @__PURE__ */ new Map());
    T(this, "_counters", /* @__PURE__ */ new Map());
    T(this, "_histograms", /* @__PURE__ */ new Map());
    T(this, "_up_down_counters", /* @__PURE__ */ new Map());
    T(this, "_integrations", []);
    var i, s, o, a, l;
    e.sessionSecureID || (e.sessionSecureID = fn()), this.options = e, typeof ((i = this.options) == null ? void 0 : i.debug) == "boolean" ? this.debugOptions = this.options.debug ? { clientInteractions: !0 } : {} : this.debugOptions = (o = (s = this.options) == null ? void 0 : s.debug) != null ? o : {}, this.logger = new Rx(this.debugOptions.clientInteractions), e.storageMode && (this.logger.log(`initializing in ${e.storageMode} session mode`), WZ(e.storageMode)), Om(!!(e != null && e.sessionCookie)), this._worker = new Lx(), this._worker.onmessage = (u) => {
      var c, d, h;
      ((c = u.data.response) == null ? void 0 : c.type) === et.AsyncEvents ? (this._eventBytesSinceSnapshot += u.data.response.eventsSize, this.logger.log(`Web worker sent payloadID ${u.data.response.id} size ${u.data.response.eventsSize} bytes, compression ratio ${u.data.response.eventsSize / u.data.response.compressedSize}.
                Total since snapshot: ${(this._eventBytesSinceSnapshot / 1e6).toFixed(1)}MB`)) : ((d = u.data.response) == null ? void 0 : d.type) === et.CustomEvent ? this.addCustomEvent(u.data.response.tag, u.data.response.payload) : ((h = u.data.response) == null ? void 0 : h.type) === et.Stop && (cr("Stopping recording due to worker failure", u.data.response), this.stopRecording(!1));
    };
    let n = br();
    if (this.reloaded = !1, !((a = this.sessionData) != null && a.sessionSecureID) && (n != null && n.sessionSecureID))
      this.sessionData = n, this.options.sessionSecureID = n.sessionSecureID, this.reloaded = !0, this.logger.log(`Tab reloaded, continuing previous session: ${this.sessionData.sessionSecureID}`);
    else {
      for (const u of Object.values(Te))
        ll(u);
      this.sessionData = {
        sessionSecureID: this.options.sessionSecureID,
        projectID: 0,
        payloadID: 1,
        sessionStartTime: Date.now()
      };
    }
    this._hasPreviouslyInitialized = !1, this._firstLoadListeners = t || new it(this.options);
    try {
      window.parent.document && (this._isCrossOriginIframe = !1);
    } catch (u) {
      this._isCrossOriginIframe = (l = this.options.recordCrossOriginIframe) != null ? l : !0;
    }
    this._initMembers(this.options);
  }
  static create(e) {
    return new Su(e);
  }
  // Start a new session
  _reset(t) {
    return $(this, arguments, function* ({ forceNew: e }) {
      this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      let n, i;
      if (!e)
        try {
          n = Ae(Te.USER_IDENTIFIER);
          const s = Ae(Te.USER_OBJECT);
          s && (i = JSON.parse(s));
        } catch (s) {
        }
      for (const s of Object.values(Te))
        ll(s);
      this.sessionData.sessionSecureID = fn(), this.sessionData.sessionStartTime = Date.now(), this.options.sessionSecureID = this.sessionData.sessionSecureID, this.stopRecording(), this._firstLoadListeners = new it(this.options), yield this.initialize(), n && i && this.identify(n, i);
    });
  }
  _initMembers(e) {
    var s, o, a, l, u, c, d, h, f, m, p, g;
    this.sessionShortcut = !1, this._recordingStartTime = 0, this._isOnLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", this.ready = !1, this.state = "NotRecording", this.manualStopped = !1, this.enableSegmentIntegration = !!e.enableSegmentIntegration, this.privacySetting = (s = e.privacySetting) != null ? s : "default", this.enableCanvasRecording = (o = e.enableCanvasRecording) != null ? o : !1, this.enablePerformanceRecording = (a = e.enablePerformanceRecording) != null ? a : !0, this.inlineImages = (l = e.inlineImages) != null ? l : this._isOnLocalHost, this.inlineVideos = (u = e.inlineVideos) != null ? u : this._isOnLocalHost, this.inlineStylesheet = (c = e.inlineStylesheet) != null ? c : this._isOnLocalHost, this.samplingStrategy = I({
      canvasFactor: 0.5,
      canvasMaxSnapshotDimension: 360,
      canvasClearWebGLBuffer: !0,
      dataUrlOptions: Y_()
    }, (d = e.samplingStrategy) != null ? d : {
      canvas: 2
    }), this._backendUrl = (h = e == null ? void 0 : e.backendUrl) != null ? h : "https://pub.highlight.io", this._backendUrl[0] === "/" && (this._backendUrl = new URL(this._backendUrl, document.baseURI).href);
    const t = new Fy(`${this._backendUrl}`, {
      headers: {}
    });
    this.graphqlSDK = P_(t, eV(((f = this.sessionData) == null ? void 0 : f.sessionSecureID) || ((m = this.options) == null ? void 0 : m.sessionSecureID))), this.environment = (p = e.environment) != null ? p : "production", this.appVersion = e.appVersion, this.serviceName = (g = e.serviceName) != null ? g : "", typeof e.organizationID == "string" ? this.organizationID = e.organizationID : this.organizationID = e.organizationID.toString(), this.isRunningOnHighlight = this.organizationID === "1" || this.organizationID === "1jdkoe52", this.firstloadVersion = e.firstloadVersion || "unknown", this.sessionShortcut = e.sessionShortcut || !1, this._onToggleFeedbackFormVisibility = () => {
    };
    const y = e, { firstloadVersion: n } = y, i = Ze(y, ["firstloadVersion"]);
    this._optionsInternal = i, this.listeners = [], this.events = [], this.hasSessionUnloaded = !1, this.hasPushedData = !1, window.Intercom && window.Intercom("onShow", () => {
      window.Intercom("update", {
        highlightSessionURL: this.getCurrentSessionURLWithTimestamp()
      }), this.addProperties({ event: "Intercom onShow" });
    }), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime(), this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime();
  }
  identify(e, t = {}, n) {
    if (!e || e === "") {
      console.warn("Highlight's identify() call was passed an empty identifier.", { user_identifier: e, user_object: t });
      return;
    }
    this.sessionData.userIdentifier = e.toString(), this.sessionData.userObject = t, pt(Te.USER_IDENTIFIER, e.toString()), pt(Te.USER_OBJECT, JSON.stringify(t)), this._worker.postMessage({
      message: {
        type: et.Identify,
        userIdentifier: e,
        userObject: t,
        source: n
      }
    });
    for (const i of this._integrations)
      i.identify(this.sessionData.sessionSecureID, e, t, n);
  }
  pushCustomError(e, t) {
    return this.consumeCustomError(new Error(e), void 0, t);
  }
  consumeCustomError(e, t, n) {
    let i = {};
    if (n)
      try {
        i = I(I({}, JSON.parse(n)), i);
      } catch (s) {
      }
    return this.consumeError(e, {
      message: t,
      payload: i
    });
  }
  consumeError(e, { message: t, payload: n, source: i, type: s }) {
    var u, c, d, h;
    e.cause && (n = M(I({}, n), { "exception.cause": e.cause }));
    let o = t ? t + ":" + e.message : e.message;
    s === "React.ErrorBoundary" && (o = "ErrorBoundary: " + o);
    const a = ds(e), l = {
      event: o,
      type: s != null ? s : "custom",
      url: window.location.href,
      source: i != null ? i : "",
      lineNumber: (u = a[0]) != null && u.lineNumber ? (c = a[0]) == null ? void 0 : c.lineNumber : 0,
      columnNumber: (d = a[0]) != null && d.columnNumber ? (h = a[0]) == null ? void 0 : h.columnNumber : 0,
      stackTrace: a,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      payload: JSON.stringify(n)
    };
    this._firstLoadListeners.errors.push(l);
    for (const f of this._integrations)
      f.error(this.sessionData.sessionSecureID, l);
  }
  addProperties(e = {}, t) {
    const n = I({}, e);
    Object.entries(n).forEach(([i, s]) => {
      try {
        structuredClone(s);
      } catch (o) {
        delete n[i];
      }
    });
    for (const i of this._integrations)
      i.track(this.sessionData.sessionSecureID, I({
        sessionSecureID: this.sessionData.sessionSecureID,
        propertyType: t
      }, e));
    this._worker.postMessage({
      message: {
        type: et.Properties,
        propertiesObject: n,
        propertyType: t
      }
    });
  }
  initialize(e) {
    return $(this, null, function* () {
      var t, n, i, s, o, a, l, u, c;
      if (navigator != null && navigator.webdriver && !window.Cypress || (t = navigator == null ? void 0 : navigator.userAgent) != null && t.includes("Googlebot") || (n = navigator == null ? void 0 : navigator.userAgent) != null && n.includes("AdsBot")) {
        (i = this._firstLoadListeners) == null || i.stopListening();
        return;
      }
      try {
        if (e != null && e.forceNew) {
          yield this._reset(e);
          return;
        }
        this.logger.log("Initializing...", e, this.sessionData, this.options), this.sessionData = (s = br(this.sessionData.sessionSecureID)) != null ? s : this.sessionData, (o = this.sessionData) != null && o.sessionStartTime ? this._recordingStartTime = (a = this.sessionData) == null ? void 0 : a.sessionStartTime : (this._recordingStartTime = (/* @__PURE__ */ new Date()).getTime(), this.sessionData.sessionStartTime = this._recordingStartTime), Ji(""), ur(this.sessionData);
        let d = Ae(Is.CLIENT_ID);
        d || (d = fn(), pt(Is.CLIENT_ID, d));
        let h;
        this.options.disableSessionRecording || this.options.disableNetworkRecording !== void 0 || typeof this.options.networkRecording == "boolean" ? h = !1 : h = ((l = this.options.networkRecording) == null ? void 0 : l.recordHeadersAndBody) || !1;
        let f = [];
        if (typeof this.options.networkRecording == "object" && ((u = this.options.networkRecording.destinationDomains) != null && u.length) && (f = this.options.networkRecording.destinationDomains), this._isCrossOriginIframe)
          yield this._setupCrossOriginIframe();
        else {
          const S = yield this.graphqlSDK.initializeSession({
            organization_verbose_id: this.organizationID,
            enable_strict_privacy: this.privacySetting === "strict",
            privacy_setting: this.privacySetting,
            enable_recording_network_contents: h,
            clientVersion: this.firstloadVersion,
            firstloadVersion: this.firstloadVersion,
            clientConfig: JSON.stringify(this._optionsInternal),
            environment: this.environment,
            id: d,
            appVersion: this.appVersion,
            serviceName: this.serviceName,
            session_secure_id: this.sessionData.sessionSecureID,
            client_id: d,
            network_recording_domains: f,
            disable_session_recording: this.options.disableSessionRecording
          });
          if (S.initializeSession.secure_id !== this.sessionData.sessionSecureID && this.logger.log(`Unexpected secure id returned by initializeSession: ${S.initializeSession.secure_id}, expected ${this.sessionData.sessionSecureID}`), this.sessionData.sessionSecureID = S.initializeSession.secure_id, this.sessionData.projectID = parseInt(((c = S == null ? void 0 : S.initializeSession) == null ? void 0 : c.project_id) || "0"), !this.sessionData.projectID || !this.sessionData.sessionSecureID) {
            console.error("Failed to initialize Highlight; an error occurred on our end.", this.sessionData);
            return;
          }
        }
        this.logger.log(`Loaded Highlight
Remote: ${this._backendUrl}
Project ID: ${this.sessionData.projectID}
SessionSecureID: ${this.sessionData.sessionSecureID}`), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._worker.postMessage({
          message: {
            type: et.Initialize,
            sessionSecureID: this.sessionData.sessionSecureID,
            backend: this._backendUrl,
            debug: !!this.debugOptions.clientInteractions,
            recordingStartTime: this._recordingStartTime
          }
        });
        for (const S of this._integrations)
          S.init(this.sessionData.sessionSecureID);
        if (this.sessionData.userIdentifier && this.identify(this.sessionData.userIdentifier, this.sessionData.userObject), this._firstLoadListeners.isListening() ? this._firstLoadListeners.hasNetworkRecording || it.setupNetworkListener(this._firstLoadListeners, this.options) : this._firstLoadListeners.startListening(), this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this._isCrossOriginIframe || (this.pushPayloadTimerId = setTimeout(() => {
          this._save();
        }, Sd)), this.options.disableSessionRecording) {
          this.logger.log("Highlight is NOT RECORDING a session replay per H.init setting."), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
          return;
        }
        const { getDeviceDetails: m } = Cx();
        m && this.recordGauge({
          name: It.DeviceMemory,
          value: m().deviceMemory,
          category: Ne.Device,
          group: window.location.href
        });
        const p = (S, C) => {
          C && this.logger.log("received isCheckout emit", { event: S }), this.events.push(S);
        };
        p.bind(this);
        const g = !!this._recordStop;
        this._recordStop && (this._recordStop(), this._recordStop = void 0);
        const [y, _] = GV(this.privacySetting);
        this._recordStop = ft({
          ignoreClass: "highlight-ignore",
          blockClass: "highlight-block",
          emit: p,
          recordCrossOriginIframes: this.options.recordCrossOriginIframe,
          privacySetting: this.privacySetting,
          maskAllInputs: y,
          maskInputOptions: _,
          recordCanvas: this.enableCanvasRecording,
          sampling: {
            canvas: {
              fps: this.samplingStrategy.canvas,
              fpsManual: this.samplingStrategy.canvasManualSnapshot,
              resizeFactor: this.samplingStrategy.canvasFactor,
              clearWebGLBuffer: this.samplingStrategy.canvasClearWebGLBuffer,
              initialSnapshotDelay: this.samplingStrategy.canvasInitialSnapshotDelay,
              dataURLOptions: this.samplingStrategy.dataUrlOptions,
              maxSnapshotDimension: this.samplingStrategy.canvasMaxSnapshotDimension
            }
          },
          keepIframeSrcFn: (S) => !this.options.recordCrossOriginIframe,
          inlineImages: this.inlineImages,
          inlineVideos: this.inlineVideos,
          collectFonts: this.inlineImages,
          inlineStylesheet: this.inlineStylesheet,
          plugins: [Kg()],
          logger: typeof this.options.debug == "boolean" && this.options.debug || typeof this.options.debug == "object" && this.options.debug.domRecording ? {
            debug: this.logger.log,
            warn: cr
          } : void 0
        }), g || this.options.recordCrossOriginIframe && this._setupCrossOriginIframeParent(), document.referrer && (window && document.referrer.includes(window.location.origin) || (this.addCustomEvent("Referrer", document.referrer), this.addProperties({ referrer: document.referrer }, { type: "session" }))), this._setupWindowListeners(), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
      } catch (d) {
        this._isOnLocalHost && (console.error(d), cr("initializeSession", d));
      }
    });
  }
  _visibilityHandler(e) {
    return $(this, null, function* () {
      if (this.manualStopped) {
        this.logger.log("Ignoring visibility event due to manual stop.");
        return;
      }
      (/* @__PURE__ */ new Date()).getTime() - this._lastVisibilityChangeTime < LZ || (this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this.logger.log(`Detected window ${e ? "hidden" : "visible"}.`), e ? (this.addCustomEvent("TabHidden", !0), this.options.disableBackgroundRecording && this.stopRecording()) : (this.options.disableBackgroundRecording && (yield this.initialize()), this.addCustomEvent("TabHidden", !1)));
    });
  }
  _setupCrossOriginIframe() {
    return $(this, null, function* () {
      this.logger.log("highlight in cross-origin iframe is waiting "), yield new Promise((e) => {
        const t = (n) => {
          if (n.data.highlight === Sh) {
            const i = n.data;
            this.logger.log("highlight got window message ", i), this.sessionData.projectID = i.projectID, this.sessionData.sessionSecureID = i.sessionSecureID, window.parent.postMessage({
              highlight: wh
            }, "*"), window.removeEventListener("message", t), e();
          }
        };
        window.addEventListener("message", t);
      });
    });
  }
  _setupCrossOriginIframeParent() {
    this.logger.log("highlight setting up cross origin iframe parent notification"), setInterval(() => {
      window.document.querySelectorAll("iframe").forEach((e) => {
        var t;
        (t = e.contentWindow) == null || t.postMessage({
          highlight: Sh,
          projectID: this.sessionData.projectID,
          sessionSecureID: this.sessionData.sessionSecureID
        }, "*");
      });
    }, Sd), window.addEventListener("message", (e) => {
      e.data.highlight === wh && this.logger.log("highlight got response from initialized iframe");
    });
  }
  _setupWindowListeners() {
    var n;
    try {
      const i = this;
      this.enableSegmentIntegration && this.listeners.push(qV((o) => {
        if (o.type === "track") {
          const a = {};
          a["segment-event"] = o.event, i.addProperties(a, {
            type: "track",
            source: "segment"
          });
        } else if (o.type === "identify") {
          const a = o.userId.replace(/^"(.*)"$/, "$1");
          i.identify(a, o.traits, "segment");
        }
      })), this.listeners.push(ZV((o) => {
        this.reloaded ? (this.addCustomEvent("Reload", o), this.reloaded = !1, i.addProperties({ reload: !0 }, { type: "session" })) : this.addCustomEvent("Navigate", o);
      })), this.listeners.push(ux((o) => {
        this.addCustomEvent("Viewport", o), this.submitViewportMetrics(o);
      })), this.listeners.push(HV((o, a) => {
        let l = null, u = null;
        if (a && a.target) {
          const c = a.target;
          l = _g(c), u = c.textContent, u && u.length > 2e3 && (u = u.substring(0, 2e3));
        }
        this.addCustomEvent("Click", {
          clickTarget: o,
          clickTextContent: u,
          clickSelector: l
        });
      })), this.listeners.push(JV((o) => {
        o && this.addCustomEvent("Focus", o);
      })), this.listeners.push(wx((o) => {
        const { name: a, value: l } = o;
        this.recordGauge({
          name: a,
          value: l,
          group: window.location.href,
          category: Ne.WebVital
        });
      })), this.listeners.push(_x((o) => {
        const a = [];
        o.saveData !== void 0 && a.push({
          name: "saveData",
          value: o.saveData.toString()
        }), o.effectiveType !== void 0 && a.push({
          name: "effectiveType",
          value: o.effectiveType.toString()
        }), o.type !== void 0 && a.push({
          name: "type",
          value: o.type.toString()
        }), Object.entries(o).forEach(([l, u]) => u && typeof u == "number" && this.recordGauge({
          name: l,
          value: u,
          category: Ne.Performance,
          group: window.location.href,
          tags: a
        }));
      }, this._recordingStartTime)), this.sessionShortcut && tx(this.sessionShortcut, () => {
        window.open(this.getCurrentSessionURLWithTimestamp(), "_blank");
      }), this.enablePerformanceRecording && (this.listeners.push($V((o) => {
        this.addCustomEvent("Performance", Ut(o)), Object.entries(o).filter(([a]) => a !== "relativeTimestamp").forEach(([a, l]) => l && this.recordGauge({
          name: a,
          value: l,
          category: Ne.Performance,
          group: window.location.href
        }));
      }, this._recordingStartTime)), this.listeners.push(zV((o) => {
        this.addCustomEvent("Jank", Ut(o)), this.recordGauge({
          name: "Jank",
          value: o.jankAmount,
          category: Ne.WebVital,
          group: o.querySelector
        });
      }, this._recordingStartTime))), this._hasPreviouslyInitialized || ((n = window.electron) != null && n.ipcRenderer ? (window.electron.ipcRenderer.on("highlight.run", ({ visible: o }) => {
        this._visibilityHandler(!o);
      }), this.logger.log("Set up Electron highlight.run events.")) : (jV((o) => this._visibilityHandler(o)), this.logger.log("Set up document visibility listener.")), this._hasPreviouslyInitialized = !0);
      const s = () => {
        this.hasSessionUnloaded = !0, this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      };
      window.addEventListener("beforeunload", s), this.listeners.push(() => window.removeEventListener("beforeunload", s));
    } catch (i) {
      this._isOnLocalHost && (console.error(i), cr("initializeSession _setupWindowListeners", i));
    }
    const e = () => {
      this.addCustomEvent("Page Unload", ""), Ji(this.sessionData.sessionSecureID), ur(this.sessionData);
    };
    if (window.addEventListener("beforeunload", e), this.listeners.push(() => window.removeEventListener("beforeunload", e)), navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
      const i = () => {
        this.addCustomEvent("Page Unload", ""), Ji(this.sessionData.sessionSecureID), ur(this.sessionData);
      };
      window.addEventListener("pagehide", i), this.listeners.push(() => window.removeEventListener("beforeunload", i));
    }
  }
  submitViewportMetrics({ height: e, width: t, availHeight: n, availWidth: i }) {
    this.recordGauge({
      name: It.ViewportHeight,
      value: e,
      category: Ne.Device,
      group: window.location.href
    }), this.recordGauge({
      name: It.ViewportWidth,
      value: t,
      category: Ne.Device,
      group: window.location.href
    }), this.recordGauge({
      name: It.ScreenHeight,
      value: n,
      category: Ne.Device,
      group: window.location.href
    }), this.recordGauge({
      name: It.ScreenWidth,
      value: i,
      category: Ne.Device,
      group: window.location.href
    }), this.recordGauge({
      name: It.ViewportArea,
      value: e * t,
      category: Ne.Device,
      group: window.location.href
    });
  }
  recordGauge(e) {
    var i;
    const t = typeof ut == "function" ? ut() : void 0;
    if (!t)
      return;
    let n = this._gauges.get(e.name);
    n || (n = t.createGauge(e.name), this._gauges.set(e.name, n)), n.record(e.value, M(I({}, (i = e.tags) == null ? void 0 : i.reduce((s, o) => M(I({}, s), { [o.name]: o.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
    for (const s of this._integrations)
      s.recordGauge(this.sessionData.sessionSecureID, e);
  }
  recordCount(e) {
    var i;
    const t = typeof ut == "function" ? ut() : void 0;
    if (!t)
      return;
    let n = this._counters.get(e.name);
    n || (n = t.createCounter(e.name), this._counters.set(e.name, n)), n.add(e.value, M(I({}, (i = e.tags) == null ? void 0 : i.reduce((s, o) => M(I({}, s), { [o.name]: o.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  recordIncr(e) {
    this.recordCount(M(I({}, e), { value: 1 }));
  }
  recordHistogram(e) {
    var i;
    const t = typeof ut == "function" ? ut() : void 0;
    if (!t)
      return;
    let n = this._histograms.get(e.name);
    n || (n = t.createHistogram(e.name), this._histograms.set(e.name, n)), n.record(e.value, M(I({}, (i = e.tags) == null ? void 0 : i.reduce((s, o) => M(I({}, s), { [o.name]: o.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  recordUpDownCounter(e) {
    var i;
    const t = typeof ut == "function" ? ut() : void 0;
    if (!t)
      return;
    let n = this._up_down_counters.get(e.name);
    n || (n = t.createUpDownCounter(e.name), this._up_down_counters.set(e.name, n)), n.add(e.value, M(I({}, (i = e.tags) == null ? void 0 : i.reduce((s, o) => M(I({}, s), { [o.name]: o.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  /**
   * Stops Highlight from recording.
   * @param manual The end user requested to stop recording.
   */
  stopRecording(e) {
    this.manualStopped = !!e, this.manualStopped && this.addCustomEvent("Stop", "H.stop() was called which stops Highlight from recording."), this.state = "NotRecording", e && this._recordStop && (this._recordStop(), this._recordStop = void 0), this.listeners.forEach((t) => t()), this.listeners = [];
  }
  getCurrentSessionTimestamp() {
    return this._recordingStartTime;
  }
  /**
   * Returns the current timestamp for the current session.
   */
  getCurrentSessionURLWithTimestamp() {
    const e = (/* @__PURE__ */ new Date()).getTime(), { projectID: t, sessionSecureID: n } = this.sessionData, i = (e - this._recordingStartTime) / 1e3;
    return `https://${sl}/${t}/sessions/${n}?ts=${i}`;
  }
  getCurrentSessionURL() {
    const e = this.sessionData.projectID, t = this.sessionData.sessionSecureID;
    return e && t ? `https://${sl}/${e}/sessions/${t}` : null;
  }
  snapshot(e) {
    return $(this, null, function* () {
      yield ft.snapshotCanvas(e);
    });
  }
  addSessionFeedback({ timestamp: e, verbatim: t, user_email: n, user_name: i }) {
    var s;
    this._worker.postMessage({
      message: {
        type: et.Feedback,
        verbatim: t,
        timestamp: e,
        userName: i || this.sessionData.userIdentifier,
        userEmail: n || ((s = this.sessionData.userObject) == null ? void 0 : s.name)
      }
    });
  }
  // Reset the events array and push to a backend.
  _save() {
    return $(this, null, function* () {
      var e;
      try {
        this.state === "Recording" && this.listeners && this.sessionData.sessionStartTime && Date.now() - this.sessionData.sessionStartTime > GZ && (this.logger.log("Resetting session", {
          start: this.sessionData.sessionStartTime
        }), yield this._reset({}));
        let t;
        ((e = this.options) == null ? void 0 : e.sendMode) === "local" && (t = (n) => $(this, null, function* () {
          let i = new Blob([
            JSON.stringify({
              query: Wh(Xp),
              variables: n
            })
          ], {
            type: "application/json"
          });
          return yield window.fetch(`${this._backendUrl}`, {
            method: "POST",
            body: i
          }), 0;
        })), yield this._sendPayload({ sendFn: t }), this.hasPushedData = !0, this.sessionData.lastPushTime = Date.now(), ur(this.sessionData);
      } catch (t) {
        this._isOnLocalHost && (console.error(t), cr("_save", t));
      }
      this.state === "Recording" && (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this.pushPayloadTimerId = setTimeout(() => {
        this._save();
      }, ZZ));
    });
  }
  /**
   * This proxy should be used instead of rrweb's native addCustomEvent.
   * The proxy makes sure recording has started before emitting a custom event.
   */
  addCustomEvent(e, t) {
    if (this.state === "NotRecording") {
      let n;
      const i = () => {
        clearInterval(n), this.state === "Recording" && this.events.length > 0 ? Xc(e, t) : n = setTimeout(i, 500);
      };
      n = setTimeout(i, 500);
    } else this.state === "Recording" && (this.events.length > 0 || this.hasPushedData) && Xc(e, t);
  }
  _sendPayload(t) {
    return $(this, arguments, function* ({ sendFn: e }) {
      const n = it.getRecordedNetworkResources(this._firstLoadListeners, this._recordingStartTime), i = it.getRecordedWebSocketEvents(this._firstLoadListeners), s = [...this.events], o = [...this._firstLoadListeners.messages], a = [...this._firstLoadListeners.errors], { bytes: l, time: u } = this.enableCanvasRecording ? wd.canvas : wd.normal;
      this._eventBytesSinceSnapshot >= l && (/* @__PURE__ */ new Date()).getTime() - this._lastSnapshotTime >= u && this.takeFullSnapshot(), this.logger.log(`Sending: ${s.length} events, ${o.length} messages, ${n.length} network resources, ${a.length} errors 
To: ${this._backendUrl}
Org: ${this.organizationID}
SessionSecureID: ${this.sessionData.sessionSecureID}`);
      const c = Tx();
      e ? yield e({
        session_secure_id: this.sessionData.sessionSecureID,
        payload_id: (this.sessionData.payloadID++).toString(),
        events: { events: s },
        messages: Ut({ messages: o }),
        resources: JSON.stringify({ resources: n }),
        web_socket_events: JSON.stringify({
          webSocketEvents: i
        }),
        errors: a,
        is_beacon: !1,
        has_session_unloaded: this.hasSessionUnloaded,
        highlight_logs: c || void 0
      }) : this._worker.postMessage({
        message: {
          type: et.AsyncEvents,
          id: this.sessionData.payloadID++,
          events: s,
          messages: o,
          errors: a,
          resourcesString: JSON.stringify({ resources: n }),
          webSocketEventsString: JSON.stringify({
            webSocketEvents: i
          }),
          hasSessionUnloaded: this.hasSessionUnloaded,
          highlightLogs: c
        }
      }), ur(this.sessionData), it.clearRecordedNetworkResources(this._firstLoadListeners), this.events = this.events.slice(s.length), this._firstLoadListeners.messages = this._firstLoadListeners.messages.slice(o.length), this._firstLoadListeners.errors = this._firstLoadListeners.errors.slice(a.length), Ex(c);
    });
  }
  takeFullSnapshot() {
    if (!this._recordStop) {
      this.logger.log("skipping full snapshot as rrweb is not running");
      return;
    }
    this.logger.log("taking full snapshot", {
      bytesSinceSnapshot: this._eventBytesSinceSnapshot,
      lastSnapshotTime: this._lastSnapshotTime
    }), ft.takeFullSnapshot(), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime();
  }
  registerLD(e) {
    this._integrations.length || this._integrations.push(new bg(e));
  }
}
const Nx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FirstLoadListeners: it,
  GenerateSecureID: fn,
  Highlight: Su,
  HighlightWarning: cr,
  get MetricCategory() {
    return Ne;
  },
  getMeter: ut,
  getPreviousSessionData: br,
  getTracer: SV,
  setupBrowserTracing: gV
}, Symbol.toStringTag, { value: "Module" })), Vx = ({ apiKey: r }) => {
  (function(e, t) {
    var n = e.amplitude || { _q: [], _iq: {} }, i = t.createElement("script");
    i.type = "text/javascript", i.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", i.crossOrigin = "anonymous", i.async = !0, i.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", i.onload = function() {
      e.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(r);
    };
    var s = t.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(i, s);
    function o(p, g) {
      p.prototype[g] = function() {
        return this._q.push([g].concat(Array.prototype.slice.call(arguments, 0))), this;
      };
    }
    for (var a = function() {
      return this._q = [], this;
    }, l = [
      "add",
      "append",
      "clearAll",
      "prepend",
      "set",
      "setOnce",
      "unset",
      "preInsert",
      "postInsert",
      "remove"
    ], u = 0; u < l.length; u++)
      o(a, l[u]);
    n.Identify = a;
    for (var c = function() {
      return this._q = [], this;
    }, d = [
      "setProductId",
      "setQuantity",
      "setPrice",
      "setRevenueType",
      "setEventProperties"
    ], h = 0; h < d.length; h++)
      o(c, d[h]);
    n.Revenue = c;
    var f = [
      "init",
      "logEvent",
      "logRevenue",
      "setUserId",
      "setUserProperties",
      "setOptOut",
      "setVersionName",
      "setDomain",
      "setDeviceId",
      "enableTracking",
      "setGlobalUserProperties",
      "identify",
      "clearUserProperties",
      "setGroup",
      "logRevenueV2",
      "regenerateDeviceId",
      "groupIdentify",
      "onInit",
      "logEventWithTimestamp",
      "logEventWithGroups",
      "setSessionId",
      "resetSessionId"
    ];
    function m(p) {
      function g(_) {
        p[_] = function() {
          p._q.push([_].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      for (var y = 0; y < f.length; y++)
        g(f[y]);
    }
    m(n), n.getInstance = function(p) {
      return p = (!p || p.length === 0 ? "$default_instance" : p).toLowerCase(), Object.prototype.hasOwnProperty.call(n._iq, p) || (n._iq[p] = { _q: [] }, m(n._iq[p])), n._iq[p];
    }, e.amplitude = n;
  })(window, document);
}, xx = ({ projectToken: r }) => {
  if (window.mixpanel)
    return;
  (function(t, n) {
    if (!n.__SV) {
      var i, s;
      window.mixpanel = n, n._i = [], n.init = function(o, a, l) {
        function u(h, f) {
          var m = f.split(".");
          m.length == 2 && (h = h[m[0]], f = m[1]), h[f] = function() {
            h.push([f].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var c = n;
        for (typeof l != "undefined" ? c = n[l] = [] : l = "mixpanel", c.people = c.people || [], c.toString = function(h) {
          var f = "mixpanel";
          return l !== "mixpanel" && (f += "." + l), h || (f += " (stub)"), f;
        }, c.people.toString = function() {
          return c.toString(1) + ".people (stub)";
        }, i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "), s = 0; s < i.length; s++)
          u(c, i[s]);
        var d = "set set_once union unset remove delete".split(" ");
        c.get_group = function() {
          function h(g) {
            f[g] = function() {
              call2_args = arguments, call2 = [g].concat(Array.prototype.slice.call(call2_args, 0)), c.push([m, call2]);
            };
          }
          for (var f = {}, m = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), p = 0; p < d.length; p++)
            h(d[p]);
          return f;
        }, n._i.push([o, a, l]);
      }, n.__SV = 1.2;
    }
  })(document, window.mixpanel || []);
  const e = document.createElement("script");
  e.src = Ox, document.head.appendChild(e), e.addEventListener("load", () => {
    var t;
    (t = window.mixpanel) == null || t.init(r);
  });
}, Ox = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js", Wx = "9.15.0", Xx = () => {
  var r, e;
  typeof chrome != "undefined" && ((r = chrome == null ? void 0 : chrome.runtime) != null && r.onMessage) && ((e = chrome == null ? void 0 : chrome.runtime) == null || e.onMessage.addListener((t, n, i) => {
    const s = t.action;
    switch (console.log(`[highlight] received '${s}' event from extension.`), s) {
      case "init": {
        ne.init(1, {
          debug: !0
        }), ne.getSessionURL().then((o) => {
          i({ url: o });
        });
        break;
      }
      case "stop": {
        ne.stop(), i({ success: !0 });
        break;
      }
    }
    return !0;
  }));
};
function IO(r) {
  var e;
  r.on && ((e = r.webContents) != null && e.send) && (r.on("focus", () => {
    r.webContents.send("highlight.run", { visible: !0 });
  }), r.on("blur", () => {
    r.webContents.send("highlight.run", { visible: !1 });
  }), r.on("close", () => {
    r.webContents.send("highlight.run", { visible: !1 });
  }));
}
const TO = ({ next: r, payload: e }) => {
  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (e.obj.type === "track") {
      const t = e.obj.event, n = e.obj.properties;
      window.H.track(t, n);
    } else if (e.obj.type === "identify") {
      const t = e.obj.userId;
      if (t != null && t.length) {
        const n = e.obj.traits;
        window.H.identify(t, n);
      }
    }
  }
  r(e);
}, bl = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightFetchPatch != "undefined")
      return;
    window._originalFetch = window.fetch, window._fetchProxy = (r, e) => window._originalFetch(r, e), window._highlightFetchPatch = (r, e) => window._fetchProxy.call(window || global, r, e), window.fetch = window._highlightFetchPatch;
  }
}, Rh = () => null, vl = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightWebSocketRequestCallback != "undefined")
      return;
    window._highlightWebSocketRequestCallback = Rh, window._highlightWebSocketEventCallback = Rh;
    const r = new Proxy(window.WebSocket, {
      construct(e, t) {
        const [, n] = hu(), i = new e(...t), s = (c) => {
          window._highlightWebSocketRequestCallback({
            socketId: n,
            initiatorType: "websocket",
            type: "open",
            name: i.url,
            startTimeAbs: performance.timeOrigin + c.timeStamp
          });
        }, o = (c) => {
          window._highlightWebSocketRequestCallback({
            socketId: n,
            initiatorType: "websocket",
            type: "close",
            name: i.url,
            responseEndAbs: performance.timeOrigin + c.timeStamp
          }), i.removeEventListener("open", s), i.removeEventListener("error", l), i.removeEventListener("message", a), i.removeEventListener("close", o);
        }, a = (c) => {
          const { data: d } = c, h = typeof d == "string" ? c.data : void 0;
          let f;
          typeof d == "string" ? f = d.length : d instanceof Blob ? f = d.size : f = d.byteLength || 0, window._highlightWebSocketEventCallback({
            socketId: n,
            type: "received",
            name: i.url,
            timeStamp: performance.timeOrigin + c.timeStamp,
            size: f,
            message: h
          });
        }, l = (c) => {
          window._highlightWebSocketEventCallback({
            socketId: n,
            type: "error",
            name: i.url,
            timeStamp: performance.timeOrigin + c.timeStamp,
            size: 0
          });
        };
        i.addEventListener("open", s), i.addEventListener("error", l), i.addEventListener("message", a), i.addEventListener("close", o);
        const u = new Proxy(i.send, {
          apply: function(c, d, h) {
            const f = h[0], m = typeof f == "string" ? f : void 0;
            let p;
            typeof f == "string" ? p = f.length : f instanceof Blob ? p = f.size : p = f.byteLength || 0, window._highlightWebSocketEventCallback({
              socketId: n,
              type: "sent",
              name: i.url,
              timeStamp: performance.timeOrigin + performance.now(),
              size: p,
              message: m
            }), c.apply(d, h);
          }
        });
        return i.send = u, i;
      }
    });
    window.WebSocket = r;
  }
}, Ih = () => {
  const r = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (e, t) => r,
    setAttributes: (e) => r,
    addEvent: (e, t, n) => r,
    addLinks: (e) => r,
    setStatus: (e) => r,
    recordException: () => {
    },
    addLink: () => r,
    updateName: () => r,
    isRecording: () => !1
  };
  return r;
};
var Sl;
(function(r) {
  r.Device = "Device", r.WebVital = "WebVital", r.Frontend = "Frontend", r.Backend = "Backend";
})(Sl || (Sl = {}));
const Ge = (r, e) => {
  console.warn(`highlight.run warning: (${r}): `, e);
}, kx = 200;
let tn = [], Bi, H, rn, sa = [], wl = !1, $r;
const ne = {
  options: void 0,
  init: (r, e) => {
    var t, n, i, s, o, a, l, u;
    try {
      if (ne.options = e, typeof window == "undefined" || typeof document == "undefined")
        return;
      if (!r) {
        console.info("Highlight is not initializing because projectID was passed undefined.");
        return;
      }
      e != null && e.sessionCookie ? UZ() : Om(!1);
      let c = br(), d = fn();
      if (c != null && c.sessionSecureID && (d = c.sessionSecureID), wl)
        return { sessionSecureID: d };
      wl = !0, bl(), vl(), Promise.resolve().then(() => Nx).then((g) => $(void 0, [g], function* ({ Highlight: f, setupBrowserTracing: m, getTracer: p }) {
        var y, _, S, C, R;
        m({
          backendUrl: (y = e == null ? void 0 : e.backendUrl) != null ? y : "https://pub.highlight.io",
          otlpEndpoint: (_ = e == null ? void 0 : e.otlpEndpoint) != null ? _ : "https://otel.highlight.io",
          projectId: r,
          sessionSecureId: d,
          environment: (S = e == null ? void 0 : e.environment) != null ? S : "production",
          networkRecordingOptions: typeof (e == null ? void 0 : e.networkRecording) == "object" ? e.networkRecording : void 0,
          tracingOrigins: e == null ? void 0 : e.tracingOrigins,
          serviceName: (C = e == null ? void 0 : e.serviceName) != null ? C : "highlight-browser",
          instrumentations: (R = e == null ? void 0 : e.otel) == null ? void 0 : R.instrumentations,
          getIntegrations: () => [...sa]
        }), $r = p, H = new f(h, rn), bl(), vl(), e != null && e.manualStart || (yield H.initialize());
      }));
      const h = M(I({}, e), {
        organizationID: r,
        firstloadVersion: Wx,
        environment: (e == null ? void 0 : e.environment) || "production",
        appVersion: e == null ? void 0 : e.version,
        sessionSecureID: d
      });
      return rn = new it(h), e != null && e.manualStart || rn.startListening(), !((n = (t = e == null ? void 0 : e.integrations) == null ? void 0 : t.mixpanel) != null && n.disabled) && ((s = (i = e == null ? void 0 : e.integrations) == null ? void 0 : i.mixpanel) != null && s.projectToken) && xx(e.integrations.mixpanel), !((a = (o = e == null ? void 0 : e.integrations) == null ? void 0 : o.amplitude) != null && a.disabled) && ((u = (l = e == null ? void 0 : e.integrations) == null ? void 0 : l.amplitude) != null && u.apiKey) && Vx(e.integrations.amplitude), { sessionSecureID: d };
    } catch (c) {
      Ge("init", c);
    }
  },
  snapshot: (r) => $(void 0, null, function* () {
    try {
      if (H && H.ready)
        return yield H.snapshot(r);
    } catch (e) {
      Ge("snapshot", e);
    }
  }),
  addSessionFeedback: ({ verbatim: r, userName: e, userEmail: t, timestampOverride: n }) => {
    try {
      ne.onHighlightReady(() => H.addSessionFeedback({
        verbatim: r,
        timestamp: n || (/* @__PURE__ */ new Date()).toISOString(),
        user_email: t,
        user_name: e
      }));
    } catch (i) {
      Ge("error", i);
    }
  },
  consumeError: (r, e, t) => {
    try {
      ne.onHighlightReady(() => H.consumeCustomError(r, e, JSON.stringify(t)));
    } catch (n) {
      Ge("error", n);
    }
  },
  consume: (r, e) => {
    try {
      ne.onHighlightReady(() => H.consumeError(r, e));
    } catch (t) {
      Ge("error", t);
    }
  },
  error: (r, e) => {
    try {
      ne.onHighlightReady(() => H.pushCustomError(r, JSON.stringify(e)));
    } catch (t) {
      Ge("error", t);
    }
  },
  track: (r, e = {}) => {
    var t, n, i, s, o, a, l, u, c, d, h;
    try {
      ne.onHighlightReady(() => H.addProperties(M(I({}, e), { event: r })));
      const f = H == null ? void 0 : H.getCurrentSessionURL();
      (i = (n = (t = ne.options) == null ? void 0 : t.integrations) == null ? void 0 : n.mixpanel) != null && i.disabled || (s = window.mixpanel) != null && s.track && window.mixpanel.track(r, M(I({}, e), {
        highlightSessionURL: f
      })), (l = (a = (o = ne.options) == null ? void 0 : o.integrations) == null ? void 0 : a.amplitude) != null && l.disabled || (u = window.amplitude) != null && u.getInstance && window.amplitude.getInstance().logEvent(r, M(I({}, e), {
        highlightSessionURL: f
      })), (h = (d = (c = ne.options) == null ? void 0 : c.integrations) == null ? void 0 : d.intercom) != null && h.disabled || window.Intercom && window.Intercom("trackEvent", r, e);
    } catch (f) {
      Ge("track", f);
    }
  },
  start: (r) => {
    (H == null ? void 0 : H.state) === "Recording" && !(r != null && r.forceNew) ? r != null && r.silent || console.warn("Highlight is already recording. Please `H.stop()` the current session before starting a new one.") : (rn.startListening(), ne.onHighlightReady(() => $(void 0, null, function* () {
      yield H.initialize(r);
    }), { waitForReady: !1 }));
  },
  stop: (r) => {
    (H == null ? void 0 : H.state) !== "Recording" ? r != null && r.silent || console.warn("Highlight is already stopped. Please call `H.start()`.") : ne.onHighlightReady(() => H.stopRecording(!0));
  },
  identify: (r, e = {}, t) => {
    var n, i, s, o, a, l, u, c;
    try {
      ne.onHighlightReady(() => H.identify(r, e, t));
    } catch (d) {
      Ge("identify", d);
    }
    if ((s = (i = (n = ne.options) == null ? void 0 : n.integrations) == null ? void 0 : i.mixpanel) != null && s.disabled || (o = window.mixpanel) != null && o.identify && (window.mixpanel.identify(typeof (e == null ? void 0 : e.email) == "string" ? e == null ? void 0 : e.email : r), e && (window.mixpanel.track("identify", e), window.mixpanel.people.set(e))), !((u = (l = (a = ne.options) == null ? void 0 : a.integrations) == null ? void 0 : l.amplitude) != null && u.disabled) && (c = window.amplitude) != null && c.getInstance && (window.amplitude.getInstance().setUserId(r), Object.keys(e).length > 0)) {
      const d = Object.keys(e).reduce((h, f) => (h.set(f, e[f]), h), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(d);
    }
  },
  metrics: (r) => {
    try {
      for (const e of r)
        ne.recordMetric(e);
    } catch (e) {
      Ge("metrics", e);
    }
  },
  recordMetric: (r) => {
    try {
      ne.onHighlightReady(() => {
        var e;
        H.recordGauge(M(I({}, r), {
          tags: (e = r.tags) != null ? e : [],
          group: window.location.href,
          category: Sl.Frontend
        }));
      });
    } catch (e) {
      Ge("recordMetric", e);
    }
  },
  recordCount: (r) => {
    try {
      ne.onHighlightReady(() => {
        H.recordCount(r);
      });
    } catch (e) {
      Ge("recordCount", e);
    }
  },
  recordIncr: (r) => {
    try {
      ne.onHighlightReady(() => {
        H.recordIncr(r);
      });
    } catch (e) {
      Ge("recordIncr", e);
    }
  },
  recordHistogram: (r) => {
    try {
      ne.onHighlightReady(() => {
        H.recordHistogram(r);
      });
    } catch (e) {
      Ge("recordHistogram", e);
    }
  },
  recordUpDownCounter: (r) => {
    try {
      ne.onHighlightReady(() => {
        H.recordUpDownCounter(r);
      });
    } catch (e) {
      Ge("recordUpDownCounter", e);
    }
  },
  startSpan: (r, e, t, n) => {
    const i = typeof $r == "function" ? $r() : void 0;
    if (!i) {
      const o = Ih();
      return n === void 0 && t === void 0 ? e(o) : n === void 0 ? t(o) : n(o);
    }
    const s = (o, a) => {
      const l = a(o);
      return l instanceof Promise ? l.finally(() => o.end()) : (o.end(), l);
    };
    return n === void 0 && t === void 0 ? i.startActiveSpan(r, (o) => s(o, e)) : n === void 0 ? i.startActiveSpan(r, e, (o) => s(o, t)) : i.startActiveSpan(r, e, t, (o) => s(o, n));
  },
  startManualSpan: (r, e, t, n) => {
    const i = typeof $r == "function" ? $r() : void 0;
    if (!i) {
      const s = Ih();
      return n === void 0 && t === void 0 ? e(s) : n === void 0 ? t(s) : n(s);
    }
    return n === void 0 && t === void 0 ? i.startActiveSpan(r, e) : n === void 0 ? i.startActiveSpan(r, e, t) : i.startActiveSpan(r, e, t, n);
  },
  getSessionURL: () => new Promise((r, e) => {
    ne.onHighlightReady(() => {
      const t = H.sessionData.sessionSecureID, n = br(t);
      n ? r(`https://${sl}/${n.projectID}/sessions/${t}`) : e(new Error(`Unable to get session URL: ${t}`));
    });
  }),
  getSessionDetails: () => new Promise((r, e) => {
    ne.onHighlightReady(() => $(void 0, null, function* () {
      try {
        const t = yield ne.getSessionURL();
        if (!t)
          throw new Error("Could not get session URL");
        const n = H.sessionData.sessionSecureID, i = br(n), s = i == null ? void 0 : i.sessionStartTime;
        if (!s)
          throw new Error("Could not get session start timestamp");
        const o = (/* @__PURE__ */ new Date()).getTime(), a = new URL(t), l = new URL(t);
        l.searchParams.set("ts", ((o - s) / 1e3).toString()), r({
          url: a.toString(),
          urlWithTimestamp: l.toString(),
          sessionSecureID: n
        });
      } catch (t) {
        e(t);
      }
    }));
  }),
  getRecordingState: () => {
    var r;
    return (r = H == null ? void 0 : H.state) != null ? r : "NotRecording";
  },
  onHighlightReady: (r, e) => {
    if (H && H.ready) {
      r();
      return;
    }
    if (tn.push({ options: e, func: r }), Bi !== void 0)
      return;
    const t = () => {
      tn = tn.filter((i) => {
        var s;
        return !H || ((s = i.options) == null ? void 0 : s.waitForReady) !== !1 && !H.ready ? !0 : (i.func(), !1);
      }), Bi = void 0, tn.length > 0 && (Bi = setTimeout(t, kx));
    };
    t();
  },
  registerLD(r) {
    sa.length || (ne.onHighlightReady(() => {
      H.registerLD(r);
    }), mV(this, r), sa.push(new bg(r)));
  }
};
typeof window != "undefined" && (window.H = ne);
Xx();
bl();
vl();
const EO = {
  reset: () => {
    wl = !1, H = void 0, tn = [], Bi = void 0, rn = void 0;
  },
  setHighlightObj: (r) => {
    H = r;
  }
};
export {
  fn as GenerateSecureID,
  ne as H,
  TO as HighlightSegmentMiddleware,
  Sl as MetricCategory,
  EO as __testing,
  IO as configureElectronHighlight
};
//# sourceMappingURL=index.js.map
